import { api } from './emptyApi'

export const addTagTypes = [
  'Workplace Charging',
  'Tax Rates',
  'Tax Profiles',
  'Tax Jurisdiction Decisions',
  'Products',
  'Marketplace Visibility',
  'OCPI Organization Profile',
  'OCPI Locations',
  'Mobile Reservations',
  'Meters',
  'Marketplace Offerings',
  'InvoicesV2',
  'Invoice Artifact Access',
  'ConnectedAccountV1',
  'AssistantBillingV1',
  'Agreements',
  'User',
  'OCPI',
  'Invoices',
  'Billing Operations',
  'Billing',
  'Tax Preview',
  'Tax Registrations',
  'Tax Applications',
  'StripeWebhook',
  'StripeTerminalV1',
  'Transaction Redrive',
  'Payments',
  'OCPI Connections',
  'OCPI Connection Requests',
  'Mobile Payout Account',
  'Mobile Home Chargers',
  'Mobile Charging Schedules',
  'Marketplace Subscription Requests',
  'Marketplace Agreements',
  'InvoiceTemplates',
  'Public Charging Rate Migration',
  'HardwareOrders',
  'Customers',
  'Connected Account Tax Sync',
  'BillingConfigurationV1',
  'Balance Transactions',
  'Agreement OCPI Records',
  'Reimbursements',
  'Organizations',
  'Merchant Tax Settings',
  'Mobile Reimbursement Users',
  'Metadata Requirements',
  'WalletV1',
  'Time-of-use rates',
  'Tax Codes',
  'Start Attempts',
  'Settlements',
  'Mobile Line Items',
  'Marketplace Map',
  'HardwareProducts',
  'Payouts',
  'Billing Overview',
  'Quotas',
  'Cost Explorer',
  'Chargers',
  'Customer',
  'Mobile Sessions'
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getWorkplaceUser: build.query<GetWorkplaceUserResponse, GetWorkplaceUserArgs>({
        query: (queryArg) => ({ url: `/api/workplace-users/${queryArg.workplaceUserId}` }),
        providesTags: ['Workplace Charging']
      }),
      updateWorkplaceUser: build.mutation<UpdateWorkplaceUserResponse, UpdateWorkplaceUserArgs>({
        query: (queryArg) => ({
          url: `/api/workplace-users/${queryArg.workplaceUserId}`,
          method: 'PUT',
          body: queryArg.workplaceChargingUserModel
        }),
        invalidatesTags: ['Workplace Charging']
      }),
      deleteWorkplaceUser: build.mutation<DeleteWorkplaceUserResponse, DeleteWorkplaceUserArgs>({
        query: (queryArg) => ({ url: `/api/workplace-users/${queryArg.workplaceUserId}`, method: 'DELETE' }),
        invalidatesTags: ['Workplace Charging']
      }),
      updateTaxRate: build.mutation<UpdateTaxRateResponse, UpdateTaxRateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-rates/${queryArg.taxId}`,
          method: 'PUT',
          body: queryArg.taxRateUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Rates']
      }),
      getUserTaxProfile: build.query<GetUserTaxProfileResponse, GetUserTaxProfileArgs>({
        query: () => ({ url: `/api/v1/tax-profiles/user` }),
        providesTags: ['Tax Profiles']
      }),
      upsertUserTaxProfile: build.mutation<UpsertUserTaxProfileResponse, UpsertUserTaxProfileArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-profiles/user`,
          method: 'PUT',
          body: queryArg.taxProfilePatchParams
        }),
        invalidatesTags: ['Tax Profiles']
      }),
      getOrganizationTaxProfile: build.query<GetOrganizationTaxProfileResponse, GetOrganizationTaxProfileArgs>({
        query: () => ({ url: `/api/v1/tax-profiles/organization` }),
        providesTags: ['Tax Profiles']
      }),
      upsertOrganizationTaxProfile: build.mutation<
        UpsertOrganizationTaxProfileResponse,
        UpsertOrganizationTaxProfileArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/tax-profiles/organization`,
          method: 'PUT',
          body: queryArg.taxProfilePatchParams
        }),
        invalidatesTags: ['Tax Profiles']
      }),
      getAgreementTaxOverride: build.query<GetAgreementTaxOverrideResponse, GetAgreementTaxOverrideArgs>({
        query: (queryArg) => ({ url: `/api/v1/tax-profiles/agreements/${queryArg.agreementId}` }),
        providesTags: ['Tax Profiles']
      }),
      upsertAgreementTaxOverride: build.mutation<UpsertAgreementTaxOverrideResponse, UpsertAgreementTaxOverrideArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-profiles/agreements/${queryArg.agreementId}`,
          method: 'PUT',
          body: queryArg.taxProfilePatchParams
        }),
        invalidatesTags: ['Tax Profiles']
      }),
      listDecisions: build.query<ListDecisionsResponse, ListDecisionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-jurisdiction-decisions`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            connectedAccountId: queryArg.connectedAccountId
          }
        }),
        providesTags: ['Tax Jurisdiction Decisions']
      }),
      upsertDecision: build.mutation<UpsertDecisionResponse, UpsertDecisionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-jurisdiction-decisions`,
          method: 'PUT',
          body: queryArg.taxJurisdictionDecisionUpsertParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            connectedAccountId: queryArg.connectedAccountId
          }
        }),
        invalidatesTags: ['Tax Jurisdiction Decisions']
      }),
      getProduct: build.query<GetProductResponse, GetProductArgs>({
        query: (queryArg) => ({
          url: `/api/v1/products/${queryArg.productId}`,
          params: {
            scheduleFrom: queryArg.scheduleFrom,
            scheduleTo: queryArg.scheduleTo
          }
        }),
        providesTags: ['Products']
      }),
      updateProduct: build.mutation<UpdateProductResponse, UpdateProductArgs>({
        query: (queryArg) => ({
          url: `/api/v1/products/${queryArg.productId}`,
          method: 'PUT',
          body: queryArg.updateProductRequest
        }),
        invalidatesTags: ['Products']
      }),
      deleteProduct: build.mutation<DeleteProductResponse, DeleteProductArgs>({
        query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}`, method: 'DELETE' }),
        invalidatesTags: ['Products']
      }),
      getVisibility: build.query<GetVisibilityResponse, GetVisibilityArgs>({
        query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.organizationId}/marketplace-visibility` }),
        providesTags: ['Marketplace Visibility']
      }),
      updateVisibility: build.mutation<UpdateVisibilityResponse, UpdateVisibilityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/organizations/${queryArg.organizationId}/marketplace-visibility`,
          method: 'PUT',
          body: queryArg.marketplaceVisibilityUpdateParams
        }),
        invalidatesTags: ['Marketplace Visibility']
      }),
      clearVisibility: build.mutation<ClearVisibilityResponse, ClearVisibilityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/organizations/${queryArg.organizationId}/marketplace-visibility`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Marketplace Visibility']
      }),
      getProfile: build.query<GetProfileResponse, GetProfileArgs>({
        query: () => ({ url: `/api/v1/ocpi-organization-profile` }),
        providesTags: ['OCPI Organization Profile']
      }),
      updateProfile: build.mutation<UpdateProfileResponse, UpdateProfileArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-organization-profile`,
          method: 'PUT',
          body: queryArg.marketplaceOrganizationProfileUpdateParams
        }),
        invalidatesTags: ['OCPI Organization Profile']
      }),
      updatePresentation: build.mutation<UpdatePresentationResponse, UpdatePresentationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-locations/${queryArg.id}/presentation`,
          method: 'PUT',
          body: queryArg.marketplaceLocationPresentationParams
        }),
        invalidatesTags: ['OCPI Locations']
      }),
      getReservationConfiguration: build.query<GetReservationConfigurationResponse, GetReservationConfigurationArgs>({
        query: (queryArg) => ({ url: `/api/v1/mobile/reservations/config/${queryArg.siteId}` }),
        providesTags: ['Mobile Reservations']
      }),
      updateReservationConfiguration: build.mutation<
        UpdateReservationConfigurationResponse,
        UpdateReservationConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reservations/config/${queryArg.siteId}`,
          method: 'PUT',
          body: queryArg.reservationConfigurationUpdateParams
        }),
        invalidatesTags: ['Mobile Reservations']
      }),
      getReservation: build.query<GetReservationResponse, GetReservationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reservations/chargers/${queryArg.chargerId}/events/${queryArg.eventId}`
        }),
        providesTags: ['Mobile Reservations']
      }),
      updateReservation: build.mutation<UpdateReservationResponse, UpdateReservationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reservations/chargers/${queryArg.chargerId}/events/${queryArg.eventId}`,
          method: 'PUT',
          body: queryArg.reservationUpdateRequest,
          params: {
            isRecurrence: queryArg.isRecurrence
          }
        }),
        invalidatesTags: ['Mobile Reservations']
      }),
      cancelReservation: build.mutation<CancelReservationResponse, CancelReservationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reservations/chargers/${queryArg.chargerId}/events/${queryArg.eventId}`,
          method: 'DELETE',
          params: {
            isRecurrence: queryArg.isRecurrence
          }
        }),
        invalidatesTags: ['Mobile Reservations']
      }),
      getMeter: build.query<GetMeterResponse, GetMeterArgs>({
        query: (queryArg) => ({
          url: `/api/v1/meters/${queryArg.id}`,
          params: {
            expand: queryArg.expand
          }
        }),
        providesTags: ['Meters']
      }),
      updateMeter: build.mutation<UpdateMeterResponse, UpdateMeterArgs>({
        query: (queryArg) => ({
          url: `/api/v1/meters/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.meterUpdateParams
        }),
        invalidatesTags: ['Meters']
      }),
      deleteMeter: build.mutation<DeleteMeterResponse, DeleteMeterArgs>({
        query: (queryArg) => ({ url: `/api/v1/meters/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Meters']
      }),
      getOffering: build.query<GetOfferingResponse, GetOfferingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings/${queryArg.id}`,
          params: {
            accessCode: queryArg.accessCode
          }
        }),
        providesTags: ['Marketplace Offerings']
      }),
      updateOffering: build.mutation<UpdateOfferingResponse, UpdateOfferingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.marketplaceOfferingUpdateParams
        }),
        invalidatesTags: ['Marketplace Offerings']
      }),
      getInvoiceDetail: build.query<GetInvoiceDetailResponse, GetInvoiceDetailArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoicesV2']
      }),
      updateInvoice: build.mutation<UpdateInvoiceResponse, UpdateInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}`,
          method: 'PUT',
          body: queryArg.synopInvoiceUpdateParams,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      deleteInvoice: build.mutation<DeleteInvoiceResponse, DeleteInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}`,
          method: 'DELETE',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      updateLineItem: build.mutation<UpdateLineItemResponse, UpdateLineItemArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/line-items/${queryArg.lineItemId}`,
          method: 'PUT',
          body: queryArg.lineItemUpdateParams,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      deleteLineItem: build.mutation<DeleteLineItemResponse, DeleteLineItemArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/line-items/${queryArg.lineItemId}`,
          method: 'DELETE',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      updateArtifactPickup: build.mutation<UpdateArtifactPickupResponse, UpdateArtifactPickupArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-artifacts/pickup-artifacts`,
          method: 'PUT',
          body: queryArg.artifactPickupParams
        }),
        invalidatesTags: ['Invoice Artifact Access']
      }),
      deleteArtifactPickup: build.mutation<DeleteArtifactPickupResponse, DeleteArtifactPickupArgs>({
        query: () => ({ url: `/api/v1/invoice-artifacts/pickup-artifacts`, method: 'DELETE' }),
        invalidatesTags: ['Invoice Artifact Access']
      }),
      updateArtifactAccessAllowedSources: build.mutation<
        UpdateArtifactAccessAllowedSourcesResponse,
        UpdateArtifactAccessAllowedSourcesArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/invoice-artifacts/access/allowed-sources`,
          method: 'PUT',
          body: queryArg.artifactAccessAllowedSourcesParams
        }),
        invalidatesTags: ['Invoice Artifact Access']
      }),
      getInvoicePaymentOptionsV1: build.query<GetInvoicePaymentOptionsV1Response, GetInvoicePaymentOptionsV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/${queryArg.accountId}/invoice-payment-options`,
          params: {
            currency: queryArg.currency
          }
        }),
        providesTags: ['ConnectedAccountV1']
      }),
      updateInvoicePaymentOptionsV1: build.mutation<
        UpdateInvoicePaymentOptionsV1Response,
        UpdateInvoicePaymentOptionsV1Args
      >({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/${queryArg.accountId}/invoice-payment-options`,
          method: 'PUT',
          body: queryArg.invoicePaymentOptionsUpdateParams
        }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      updateAutoReloadV1: build.mutation<UpdateAutoReloadV1Response, UpdateAutoReloadV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/auto-reload`,
          method: 'PUT',
          body: queryArg.assistantAutoReloadRequest
        }),
        invalidatesTags: ['AssistantBillingV1']
      }),
      getAgreement: build.query<GetAgreementResponse, GetAgreementArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}`,
          params: {
            includeInactive: queryArg.includeInactive
          }
        }),
        providesTags: ['Agreements']
      }),
      updateAgreement: build.mutation<UpdateAgreementResponse, UpdateAgreementArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.agreementUpdateParams
        }),
        invalidatesTags: ['Agreements']
      }),
      updatePushNotification: build.mutation<UpdatePushNotificationResponse, UpdatePushNotificationArgs>({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/push-token`,
          method: 'PUT',
          body: queryArg.createUserPushParams
        }),
        invalidatesTags: ['User']
      }),
      setDefaultPaymentMethod: build.mutation<SetDefaultPaymentMethodResponse, SetDefaultPaymentMethodArgs>({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/payment-method/${queryArg.paymentMethodId}/default`,
          method: 'PUT'
        }),
        invalidatesTags: ['User']
      }),
      updateUserTags: build.mutation<UpdateUserTagsResponse, UpdateUserTagsArgs>({
        query: (queryArg) => ({ url: `/api/users/${queryArg.id}/auth-tags`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['User']
      }),
      getSessions1: build.query<GetSessions1Response, GetSessions1Args>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/sessions`,
          params: {
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            offset: queryArg.offset,
            limit: queryArg.limit
          }
        }),
        providesTags: ['OCPI']
      }),
      putChargingPreferences: build.mutation<PutChargingPreferencesResponse, PutChargingPreferencesArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/sessions`,
          method: 'PUT',
          body: queryArg.chargingPreferences,
          params: {
            session_id: queryArg.sessionId
          }
        }),
        invalidatesTags: ['OCPI']
      }),
      getSession: build.query<GetSessionResponse, GetSessionArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/cpo/2.2.1/sessions/${queryArg.sessionId}` }),
        providesTags: ['OCPI']
      }),
      updateSession: build.mutation<UpdateSessionResponse, UpdateSessionArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/sessions/${queryArg.sessionId}`,
          method: 'PUT',
          body: queryArg.updateSessionRequest
        }),
        invalidatesTags: ['OCPI']
      }),
      getLocation: build.query<GetLocationResponse, GetLocationArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/cpo/2.2.1/locations/${queryArg.locationId}` }),
        providesTags: ['OCPI']
      }),
      updateLocation: build.mutation<UpdateLocationResponse, UpdateLocationArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/locations/${queryArg.locationId}`,
          method: 'PUT',
          body: queryArg.location
        }),
        invalidatesTags: ['OCPI']
      }),
      getInvoice: build.query<GetInvoiceResponse, GetInvoiceArgs>({
        query: (queryArg) => ({ url: `/api/invoices/${queryArg.invoiceId}` }),
        providesTags: ['Invoices']
      }),
      updateInvoice1: build.mutation<UpdateInvoice1Response, UpdateInvoice1Args>({
        query: (queryArg) => ({
          url: `/api/invoices/${queryArg.invoiceId}`,
          method: 'PUT',
          body: queryArg.updateInvoiceModel
        }),
        invalidatesTags: ['Invoices']
      }),
      deleteInvoice1: build.mutation<DeleteInvoice1Response, DeleteInvoice1Args>({
        query: (queryArg) => ({ url: `/api/invoices/${queryArg.invoiceId}`, method: 'DELETE' }),
        invalidatesTags: ['Invoices']
      }),
      getWorkplaceUsers: build.query<GetWorkplaceUsersResponse, GetWorkplaceUsersArgs>({
        query: (queryArg) => ({
          url: `/api/workplace-users`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Workplace Charging']
      }),
      saveWorkplaceUser: build.mutation<SaveWorkplaceUserResponse, SaveWorkplaceUserArgs>({
        query: (queryArg) => ({
          url: `/api/workplace-users`,
          method: 'POST',
          body: queryArg.createWorkplaceChargingUser
        }),
        invalidatesTags: ['Workplace Charging']
      }),
      getWorkplaceChargingConfiguration: build.query<
        GetWorkplaceChargingConfigurationResponse,
        GetWorkplaceChargingConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/workplace-charging-configuration`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Workplace Charging']
      }),
      saveWorkplaceChargingConfiguration: build.mutation<
        SaveWorkplaceChargingConfigurationResponse,
        SaveWorkplaceChargingConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/workplace-charging-configuration`,
          method: 'POST',
          body: queryArg.workplaceConfiguration
        }),
        invalidatesTags: ['Workplace Charging']
      }),
      rebaselineWallet: build.mutation<RebaselineWalletResponse, RebaselineWalletArgs>({
        query: (queryArg) => ({
          url: `/api/v1/wallet-rebaselines`,
          method: 'POST',
          body: queryArg.walletRebaselineParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      startTwilioChargingSession: build.mutation<StartTwilioChargingSessionResponse, StartTwilioChargingSessionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/twilio/start-session`,
          method: 'POST',
          body: queryArg.twilioStartSessionRequest
        }),
        invalidatesTags: ['Billing']
      }),
      backfillTouRecurrence: build.mutation<BackfillTouRecurrenceResponse, BackfillTouRecurrenceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tou-recurrence-backfills`,
          method: 'POST',
          body: queryArg.touRecurrenceBackfillParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      repairTopUpLinks: build.mutation<RepairTopUpLinksResponse, RepairTopUpLinksArgs>({
        query: (queryArg) => ({
          url: `/api/v1/top-up-link-repairs`,
          method: 'POST',
          body: queryArg.topUpLinkRepairParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      previewTax: build.mutation<PreviewTaxResponse, PreviewTaxArgs>({
        query: (queryArg) => ({
          url: `/api/v1/taxes/preview`,
          method: 'POST',
          body: queryArg.taxPreviewParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Preview']
      }),
      listRegistrations: build.query<ListRegistrationsResponse, ListRegistrationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-registrations`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Tax Registrations']
      }),
      createRegistration: build.mutation<CreateRegistrationResponse, CreateRegistrationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-registrations`,
          method: 'POST',
          body: queryArg.taxRegistrationCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Registrations']
      }),
      listTaxRates: build.query<ListTaxRatesResponse, ListTaxRatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-rates`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            taxId: queryArg.taxId,
            name: queryArg.name,
            taxType: queryArg.taxType,
            active: queryArg.active,
            page: queryArg.page,
            pageSize: queryArg.pageSize
          }
        }),
        providesTags: ['Tax Rates']
      }),
      createTaxRate: build.mutation<CreateTaxRateResponse, CreateTaxRateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-rates`,
          method: 'POST',
          body: queryArg.taxRateCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Rates']
      }),
      listTaxApplications: build.query<ListTaxApplicationsResponse, ListTaxApplicationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-applications`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            id: queryArg.id,
            scopeType: queryArg.scopeType,
            scopeId: queryArg.scopeId,
            taxId: queryArg.taxId,
            active: queryArg.active,
            page: queryArg.page,
            pageSize: queryArg.pageSize
          }
        }),
        providesTags: ['Tax Applications']
      }),
      createTaxApplication: build.mutation<CreateTaxApplicationResponse, CreateTaxApplicationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-applications`,
          method: 'POST',
          body: queryArg.taxApplicationCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Applications']
      }),
      handleStripeWebhook: build.mutation<HandleStripeWebhookResponse, HandleStripeWebhookArgs>({
        query: (queryArg) => ({
          url: `/api/v1/stripe/webhook`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'Stripe-Signature': queryArg['Stripe-Signature']
          }
        }),
        invalidatesTags: ['StripeWebhook']
      }),
      listTerminalsV1: build.query<ListTerminalsV1Response, ListTerminalsV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals`,
          params: {
            pageable: queryArg.pageable,
            expand: queryArg.expand
          }
        }),
        providesTags: ['StripeTerminalV1']
      }),
      registerTerminalV1: build.mutation<RegisterTerminalV1Response, RegisterTerminalV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals`,
          method: 'POST',
          body: queryArg.stripeTerminalCreateParams
        }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      refreshTerminalV1: build.mutation<RefreshTerminalV1Response, RefreshTerminalV1Args>({
        query: (queryArg) => ({ url: `/api/v1/stripe-terminals/${queryArg.readerId}/refresh`, method: 'POST' }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      pushRatesV1: build.mutation<PushRatesV1Response, PushRatesV1Args>({
        query: (queryArg) => ({ url: `/api/v1/stripe-terminals/${queryArg.readerId}/push-rates`, method: 'POST' }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      cancelReaderActionV1: build.mutation<CancelReaderActionV1Response, CancelReaderActionV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/reader/${queryArg.readerId}/cancel-action`,
          method: 'POST',
          params: {
            merchantOrganizationId: queryArg.merchantOrganizationId
          }
        }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      createConnectionTokenV1: build.mutation<CreateConnectionTokenV1Response, CreateConnectionTokenV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/connection-token`,
          method: 'POST',
          params: {
            merchantOrganizationId: queryArg.merchantOrganizationId
          }
        }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      collectPaymentV1: build.mutation<CollectPaymentV1Response, CollectPaymentV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/collect-payment`,
          method: 'POST',
          body: queryArg.collectPaymentParamsV1
        }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      cancelPaymentV1: build.mutation<CancelPaymentV1Response, CancelPaymentV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/cancel-payment`,
          method: 'POST',
          body: queryArg.cancelPaymentParamsV1
        }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      syncStripeLedger: build.mutation<SyncStripeLedgerResponse, SyncStripeLedgerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-ledger-syncs`,
          method: 'POST',
          body: queryArg.stripeLedgerSyncParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      listTransactionRedrives: build.query<ListTransactionRedrivesResponse, ListTransactionRedrivesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/redrive-transactions`,
          params: {
            organizationId: queryArg.organizationId,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Transaction Redrive']
      }),
      createTransactionRedrive: build.mutation<CreateTransactionRedriveResponse, CreateTransactionRedriveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/redrive-transactions`,
          method: 'POST',
          body: queryArg.createTransactionRedriveRequest
        }),
        invalidatesTags: ['Transaction Redrive']
      }),
      redriveReimbursements: build.mutation<RedriveReimbursementsResponse, RedriveReimbursementsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/redrive-reimbursements`,
          method: 'POST',
          body: queryArg.reimbursementRedriveRequest
        }),
        invalidatesTags: ['Billing Operations']
      }),
      createPublicCheckoutSession: build.mutation<CreatePublicCheckoutSessionResponse, CreatePublicCheckoutSessionArgs>(
        {
          query: (queryArg) => ({
            url: `/api/v1/public/invoices/${queryArg.invoiceId}/checkout-session`,
            method: 'POST'
          }),
          invalidatesTags: ['Billing']
        }
      ),
      listProducts: build.query<ListProductsResponse, ListProductsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/products`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            status: queryArg.status,
            organizationId: queryArg.organizationId,
            agreementId: queryArg.agreementId,
            visibility: queryArg.visibility
          }
        }),
        providesTags: ['Products']
      }),
      createProduct: build.mutation<CreateProductResponse, CreateProductArgs>({
        query: (queryArg) => ({ url: `/api/v1/products`, method: 'POST', body: queryArg.createProductRequest }),
        invalidatesTags: ['Products']
      }),
      unarchiveProduct: build.mutation<UnarchiveProductResponse, UnarchiveProductArgs>({
        query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}/unarchive`, method: 'POST' }),
        invalidatesTags: ['Products']
      }),
      archiveProduct: build.mutation<ArchiveProductResponse, ArchiveProductArgs>({
        query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}/archive`, method: 'POST' }),
        invalidatesTags: ['Products']
      }),
      refundPayment: build.mutation<RefundPaymentResponse, RefundPaymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/payments/${queryArg.paymentId}/refund`,
          method: 'POST',
          body: queryArg.paymentRefundParams
        }),
        invalidatesTags: ['Payments']
      }),
      capturePayment: build.mutation<CapturePaymentResponse, CapturePaymentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/payments/${queryArg.paymentId}/capture`,
          method: 'POST',
          body: queryArg.paymentCaptureParams
        }),
        invalidatesTags: ['Payments']
      }),
      cancelPaymentHold: build.mutation<CancelPaymentHoldResponse, CancelPaymentHoldArgs>({
        query: (queryArg) => ({
          url: `/api/v1/payments/${queryArg.paymentId}/cancel`,
          method: 'POST',
          body: queryArg.paymentCancelParams
        }),
        invalidatesTags: ['Payments']
      }),
      backfillPaymentCustomerNames: build.mutation<
        BackfillPaymentCustomerNamesResponse,
        BackfillPaymentCustomerNamesArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/payment-customer-name-backfills`,
          method: 'POST',
          body: queryArg.paymentCustomerNameBackfillParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      listConnections: build.query<ListConnectionsResponse, ListConnectionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connections`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            includeUsage: queryArg.includeUsage
          }
        }),
        providesTags: ['OCPI Connections']
      }),
      createConnection: build.mutation<CreateConnectionResponse, CreateConnectionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connections`,
          method: 'POST',
          body: queryArg.ocpiConnectionCreateParams
        }),
        invalidatesTags: ['OCPI Connections']
      }),
      createConnectionRequest: build.mutation<CreateConnectionRequestResponse, CreateConnectionRequestArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connection-requests`,
          method: 'POST',
          body: queryArg.ocpiConnectionRequestCreateParams
        }),
        invalidatesTags: ['OCPI Connection Requests']
      }),
      listReservations: build.query<ListReservationsResponse, ListReservationsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reservations`,
          params: {
            siteId: queryArg.siteId,
            chargerId: queryArg.chargerId,
            connectorId: queryArg.connectorId,
            vehicleId: queryArg.vehicleId,
            ocppTag: queryArg.ocppTag,
            eventType: queryArg.eventType,
            startsBefore: queryArg.startsBefore,
            startsAfter: queryArg.startsAfter,
            endsBefore: queryArg.endsBefore,
            endsAfter: queryArg.endsAfter,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Mobile Reservations']
      }),
      createReservation: build.mutation<CreateReservationResponse, CreateReservationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reservations`,
          method: 'POST',
          body: queryArg.reservationCreateRequest
        }),
        invalidatesTags: ['Mobile Reservations']
      }),
      createMyPayoutOnboardingLink: build.mutation<
        CreateMyPayoutOnboardingLinkResponse,
        CreateMyPayoutOnboardingLinkArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/mobile/payout-account/onboarding-link`,
          method: 'POST',
          body: queryArg.connectedAccountLinkCreateParams
        }),
        invalidatesTags: ['Mobile Payout Account']
      }),
      createHomeCharger: build.mutation<CreateHomeChargerResponse, CreateHomeChargerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/home-chargers`,
          method: 'POST',
          body: queryArg.homeChargerCreateParams
        }),
        invalidatesTags: ['Mobile Home Chargers']
      }),
      listChargingSchedules: build.query<ListChargingSchedulesResponse, ListChargingSchedulesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/charging-schedules`,
          params: {
            startsBefore: queryArg.startsBefore,
            startsAfter: queryArg.startsAfter,
            endsBefore: queryArg.endsBefore,
            endsAfter: queryArg.endsAfter,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order
          }
        }),
        providesTags: ['Mobile Charging Schedules']
      }),
      createChargingSchedule: build.mutation<CreateChargingScheduleResponse, CreateChargingScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/charging-schedules`,
          method: 'POST',
          body: queryArg.chargingScheduleCreateParams
        }),
        invalidatesTags: ['Mobile Charging Schedules']
      }),
      listMeters1: build.query<ListMeters1Response, ListMeters1Args>({
        query: (queryArg) => ({
          url: `/api/v1/meters`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            expand: queryArg.expand,
            assetId: queryArg.assetId,
            assetType: queryArg.assetType
          }
        }),
        providesTags: ['Meters']
      }),
      createMeter: build.mutation<CreateMeterResponse, CreateMeterArgs>({
        query: (queryArg) => ({ url: `/api/v1/meters`, method: 'POST', body: queryArg.meterCreateParams }),
        invalidatesTags: ['Meters']
      }),
      deny: build.mutation<DenyResponse, DenyArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-subscription-requests/${queryArg.id}/deny`,
          method: 'POST',
          body: queryArg.marketplaceSubscriptionRequestDenyParams
        }),
        invalidatesTags: ['Marketplace Subscription Requests']
      }),
      cancel: build.mutation<CancelResponse, CancelArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-subscription-requests/${queryArg.id}/cancel`,
          method: 'POST'
        }),
        invalidatesTags: ['Marketplace Subscription Requests']
      }),
      approve: build.mutation<ApproveResponse, ApproveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-subscription-requests/${queryArg.id}/approve`,
          method: 'POST',
          body: queryArg.marketplaceSubscriptionRequestApproveParams
        }),
        invalidatesTags: ['Marketplace Subscription Requests']
      }),
      getOfferings: build.query<GetOfferingsResponse, GetOfferingsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings`,
          params: {
            browse: queryArg.browse,
            accessCode: queryArg.accessCode,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Marketplace Offerings']
      }),
      createOffering: build.mutation<CreateOfferingResponse, CreateOfferingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings`,
          method: 'POST',
          body: queryArg.marketplaceOfferingCreateParams
        }),
        invalidatesTags: ['Marketplace Offerings']
      }),
      createSubscriptionRequest: build.mutation<CreateSubscriptionRequestResponse, CreateSubscriptionRequestArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings/${queryArg.id}/subscription-requests`,
          method: 'POST',
          body: queryArg.marketplaceSubscriptionRequestCreateParams
        }),
        invalidatesTags: ['Marketplace Offerings']
      }),
      subscribeToOffering: build.mutation<SubscribeToOfferingResponse, SubscribeToOfferingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings/${queryArg.id}/subscribe`,
          method: 'POST',
          body: queryArg.subscribeToOfferingParams
        }),
        invalidatesTags: ['Marketplace Offerings']
      }),
      regenerateAccessCode: build.mutation<RegenerateAccessCodeResponse, RegenerateAccessCodeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings/${queryArg.id}/regenerate-access-code`,
          method: 'POST'
        }),
        invalidatesTags: ['Marketplace Offerings']
      }),
      redeemAccessCode: build.mutation<RedeemAccessCodeResponse, RedeemAccessCodeArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-offerings/redeem-access-code`,
          method: 'POST',
          body: queryArg.redeemAccessCodeParams
        }),
        invalidatesTags: ['Marketplace Offerings']
      }),
      createPaymentSetupSession: build.mutation<CreatePaymentSetupSessionResponse, CreatePaymentSetupSessionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-agreements/${queryArg.id}/payment-setup-session`,
          method: 'POST',
          body: queryArg.marketplacePaymentSetupSessionParams
        }),
        invalidatesTags: ['Marketplace Agreements']
      }),
      listInvoices: build.query<ListInvoicesResponse, ListInvoicesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices`,
          params: {
            organizationId: queryArg.organizationId,
            requestType: queryArg.requestType,
            payorId: queryArg.payorId,
            agreementId: queryArg.agreementId,
            payorType: queryArg.payorType,
            payorSegment: queryArg.payorSegment,
            productType: queryArg.productType,
            payorEmail: queryArg.payorEmail,
            connectedAccountId: queryArg.connectedAccountId,
            vehicleId: queryArg.vehicleId,
            authTag: queryArg.authTag,
            lineItemPayorId: queryArg.lineItemPayorId,
            payorOrgId: queryArg.payorOrgId,
            status: queryArg.status,
            page: queryArg.page,
            size: queryArg.size,
            from: queryArg['from'],
            to: queryArg.to,
            dateField: queryArg.dateField,
            sort: queryArg.sort,
            expand: queryArg.expand
          }
        }),
        providesTags: ['InvoicesV2']
      }),
      createInvoice: build.mutation<CreateInvoiceResponse, CreateInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices`,
          method: 'POST',
          body: queryArg.synopInvoiceCreateParams,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      voidInvoice: build.mutation<VoidInvoiceResponse, VoidInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/void`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      sendInvoice: build.mutation<SendInvoiceResponse, SendInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/send`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      releaseInvoice: build.mutation<ReleaseInvoiceResponse, ReleaseInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/release`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId,
            force: queryArg.force
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      markPaid: build.mutation<MarkPaidResponse, MarkPaidArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/mark-paid`,
          method: 'POST',
          body: queryArg.markPaidRequest,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      addLineItem: build.mutation<AddLineItemResponse, AddLineItemArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/line-items`,
          method: 'POST',
          body: queryArg.lineItemCreateParams,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      finalizeInvoice: build.mutation<FinalizeInvoiceResponse, FinalizeInvoiceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/finalize`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      getDraftInvoiceArtifacts: build.query<GetDraftInvoiceArtifactsResponse, GetDraftInvoiceArtifactsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/draft-artifacts`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoicesV2']
      }),
      generateDraftInvoiceArtifacts: build.mutation<
        GenerateDraftInvoiceArtifactsResponse,
        GenerateDraftInvoiceArtifactsArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/draft-artifacts`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      createCheckoutSession: build.mutation<CreateCheckoutSessionResponse, CreateCheckoutSessionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/checkout-session`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoicesV2']
      }),
      backfillInvoiceWalletApplied: build.mutation<
        BackfillInvoiceWalletAppliedResponse,
        BackfillInvoiceWalletAppliedArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/invoice-wallet-applied-backfills`,
          method: 'POST',
          body: queryArg.invoiceWalletAppliedBackfillParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      listTemplates: build.query<ListTemplatesResponse, ListTemplatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates`,
          params: {
            organizationId: queryArg.organizationId,
            status: queryArg.status,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['InvoiceTemplates']
      }),
      createTemplate: build.mutation<CreateTemplateResponse, CreateTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates`,
          method: 'POST',
          body: queryArg.invoiceTemplateCreateParams,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoiceTemplates']
      }),
      previewTemplate: build.mutation<PreviewTemplateResponse, PreviewTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates/${queryArg.templateId}/preview`,
          method: 'POST',
          params: {
            sampleInvoiceId: queryArg.sampleInvoiceId,
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoiceTemplates']
      }),
      archiveTemplate: build.mutation<ArchiveTemplateResponse, ArchiveTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates/${queryArg.templateId}/archive`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoiceTemplates']
      }),
      backfillInvoices: build.mutation<BackfillInvoicesResponse, BackfillInvoicesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-backfills`,
          method: 'POST',
          body: queryArg.invoiceBackfillParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      createArtifactAccessKey: build.mutation<CreateArtifactAccessKeyResponse, CreateArtifactAccessKeyArgs>({
        query: () => ({ url: `/api/v1/invoice-artifacts/access-keys`, method: 'POST' }),
        invalidatesTags: ['Invoice Artifact Access']
      }),
      decommission: build.mutation<DecommissionResponse, DecommissionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/internal/public-rate-migrations/decommission`,
          method: 'POST',
          body: queryArg.decommissionRequest
        }),
        invalidatesTags: ['Public Charging Rate Migration']
      }),
      backfill: build.mutation<BackfillResponse, BackfillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/internal/public-rate-migrations/backfill`,
          method: 'POST',
          body: queryArg.migrationRequest
        }),
        invalidatesTags: ['Public Charging Rate Migration']
      }),
      createCheckoutSession1: build.mutation<CreateCheckoutSession1Response, CreateCheckoutSession1Args>({
        query: (queryArg) => ({
          url: `/api/v1/hardware-orders/checkout-session`,
          method: 'POST',
          body: queryArg.hardwareCheckoutSessionParams
        }),
        invalidatesTags: ['HardwareOrders']
      }),
      backfillCustomers: build.mutation<BackfillCustomersResponse, BackfillCustomersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers/backfill`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Customers']
      }),
      backfillAddresses: build.mutation<BackfillAddressesResponse, BackfillAddressesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers/backfill-addresses`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Customers']
      }),
      listConnectedAccountsV1: build.query<ListConnectedAccountsV1Response, ListConnectedAccountsV1Args>({
        query: () => ({ url: `/api/v1/connected-accounts` }),
        providesTags: ['ConnectedAccountV1']
      }),
      createConnectedAccountV1: build.mutation<CreateConnectedAccountV1Response, CreateConnectedAccountV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts`,
          method: 'POST',
          body: queryArg.connectedAccountCreateParams
        }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      shareConnectedAccountWithOrganizationV1: build.mutation<
        ShareConnectedAccountWithOrganizationV1Response,
        ShareConnectedAccountWithOrganizationV1Args
      >({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/${queryArg.accountId}/organization-links`,
          method: 'POST',
          body: queryArg.connectedAccountOrganizationLinkParams
        }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      createLoginLinkV1: build.mutation<CreateLoginLinkV1Response, CreateLoginLinkV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/${queryArg.accountId}/login-link`,
          method: 'POST',
          body: queryArg.connectedAccountLinkCreateParams
        }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      createAccountLinkV1: build.mutation<CreateAccountLinkV1Response, CreateAccountLinkV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/${queryArg.accountId}/account-link`,
          method: 'POST',
          body: queryArg.connectedAccountLinkCreateParams
        }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      syncConnectedAccountTypes: build.mutation<SyncConnectedAccountTypesResponse, SyncConnectedAccountTypesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connected-account-type-syncs`,
          method: 'POST',
          body: queryArg.connectedAccountTypeSyncParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      listRegistrations1: build.query<ListRegistrations1Response, ListRegistrations1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-account-tax-sync/registrations`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            accountId: queryArg.accountId
          }
        }),
        providesTags: ['Connected Account Tax Sync']
      }),
      createRegistration1: build.mutation<CreateRegistration1Response, CreateRegistration1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-account-tax-sync/registrations`,
          method: 'POST',
          body: queryArg.taxRegistrationCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            accountId: queryArg.accountId
          }
        }),
        invalidatesTags: ['Connected Account Tax Sync']
      }),
      closeReimbursements: build.mutation<CloseReimbursementsResponse, CloseReimbursementsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/close-reimbursements`,
          method: 'POST',
          body: queryArg.reimbursementRedriveRequest
        }),
        invalidatesTags: ['Billing Operations']
      }),
      backfillChargeReceiptNumbers: build.mutation<
        BackfillChargeReceiptNumbersResponse,
        BackfillChargeReceiptNumbersArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/charge-receipt-number-backfills`,
          method: 'POST',
          body: queryArg.chargeReceiptNumberBackfillParams
        }),
        invalidatesTags: ['Billing Operations']
      }),
      createBillingConfiguration: build.mutation<CreateBillingConfigurationResponse, CreateBillingConfigurationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/billing-configurations`,
          method: 'POST',
          body: queryArg.billingConfigurationCreateParams
        }),
        invalidatesTags: ['BillingConfigurationV1']
      }),
      createRevenueShareRule: build.mutation<CreateRevenueShareRuleResponse, CreateRevenueShareRuleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/billing-configurations/${queryArg.configurationId}/revenue-share-rules`,
          method: 'POST',
          body: queryArg.billingRevenueShareRuleCreateParams
        }),
        invalidatesTags: ['BillingConfigurationV1']
      }),
      backfillBalanceTransactions: build.mutation<BackfillBalanceTransactionsResponse, BackfillBalanceTransactionsArgs>(
        {
          query: (queryArg) => ({
            url: `/api/v1/balance-transactions/backfill`,
            method: 'POST',
            headers: {
              'X-Organization-Id': queryArg['X-Organization-Id']
            },
            params: {
              from: queryArg['from'],
              to: queryArg.to
            }
          }),
          invalidatesTags: ['Balance Transactions']
        }
      ),
      ingestUsageV1: build.mutation<IngestUsageV1Response, IngestUsageV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/usage-events`,
          method: 'POST',
          body: queryArg.assistantUsageIngestRequest
        }),
        invalidatesTags: ['AssistantBillingV1']
      }),
      topUpV1: build.mutation<TopUpV1Response, TopUpV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/credits/top-ups`,
          method: 'POST',
          body: queryArg.assistantTopUpRequest
        }),
        invalidatesTags: ['AssistantBillingV1']
      }),
      refreshGrantsV1: build.mutation<RefreshGrantsV1Response, RefreshGrantsV1Args>({
        query: () => ({ url: `/api/v1/assistant-billing/credits/grants/refresh`, method: 'POST' }),
        invalidatesTags: ['AssistantBillingV1']
      }),
      upsertConfigV1: build.mutation<UpsertConfigV1Response, UpsertConfigV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/config`,
          method: 'POST',
          body: queryArg.assistantBillingConfigRequest
        }),
        invalidatesTags: ['AssistantBillingV1']
      }),
      getAgreements: build.query<GetAgreementsResponse, GetAgreementsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements`,
          params: {
            payorId: queryArg.payorId,
            payeeId: queryArg.payeeId,
            entityType: queryArg.entityType,
            entityId: queryArg.entityId,
            page: queryArg.page,
            size: queryArg.size,
            includeArchived: queryArg.includeArchived,
            includeInactive: queryArg.includeInactive,
            inEffect: queryArg.inEffect,
            asOf: queryArg.asOf,
            expand: queryArg.expand
          }
        }),
        providesTags: ['Agreements']
      }),
      createAgreement: build.mutation<CreateAgreementResponse, CreateAgreementArgs>({
        query: (queryArg) => ({ url: `/api/v1/agreements`, method: 'POST', body: queryArg.agreementCreateParams }),
        invalidatesTags: ['Agreements']
      }),
      unarchiveAgreement: build.mutation<UnarchiveAgreementResponse, UnarchiveAgreementArgs>({
        query: (queryArg) => ({ url: `/api/v1/agreements/${queryArg.id}/unarchive`, method: 'POST' }),
        invalidatesTags: ['Agreements']
      }),
      acknowledgeReconciliationException: build.mutation<
        AcknowledgeReconciliationExceptionResponse,
        AcknowledgeReconciliationExceptionArgs
      >({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/reconciliation/${queryArg.exceptionId}/acknowledge`,
          method: 'POST'
        }),
        invalidatesTags: ['Agreement OCPI Records']
      }),
      getAgreementProducts: build.query<GetAgreementProductsResponse, GetAgreementProductsArgs>({
        query: (queryArg) => ({ url: `/api/v1/agreements/${queryArg.id}/products` }),
        providesTags: ['Agreements']
      }),
      addAgreementProduct: build.mutation<AddAgreementProductResponse, AddAgreementProductArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/products`,
          method: 'POST',
          body: queryArg.addAgreementProductRequest
        }),
        invalidatesTags: ['Agreements']
      }),
      getAuthorizedEntities: build.query<GetAuthorizedEntitiesResponse, GetAuthorizedEntitiesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/products/${queryArg.productId}/authorized-entities`
        }),
        providesTags: ['Agreements']
      }),
      addAuthorizedEntity: build.mutation<AddAuthorizedEntityResponse, AddAuthorizedEntityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/products/${queryArg.productId}/authorized-entities`,
          method: 'POST',
          body: queryArg.addAgreementAuthorizedEntityRequest
        }),
        invalidatesTags: ['Agreements']
      }),
      archiveAgreement: build.mutation<ArchiveAgreementResponse, ArchiveAgreementArgs>({
        query: (queryArg) => ({ url: `/api/v1/agreements/${queryArg.id}/archive`, method: 'POST' }),
        invalidatesTags: ['Agreements']
      }),
      updateWorkplaceChargingRecordStatuses: build.mutation<
        UpdateWorkplaceChargingRecordStatusesResponse,
        UpdateWorkplaceChargingRecordStatusesArgs
      >({
        query: (queryArg) => ({
          url: `/api/update-workplace-charging-records-status`,
          method: 'POST',
          body: queryArg.updateWorkplaceChargingRecordStatus,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['Workplace Charging']
      }),
      getReimbursementUsers: build.query<GetReimbursementUsersResponse, GetReimbursementUsersArgs>({
        query: (queryArg) => ({
          url: `/api/reimbursement-users`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Reimbursements']
      }),
      saveReimbursementUser: build.mutation<SaveReimbursementUserResponse, SaveReimbursementUserArgs>({
        query: (queryArg) => ({
          url: `/api/reimbursement-users`,
          method: 'POST',
          body: queryArg.reimbursementUserUpsertParams
        }),
        invalidatesTags: ['Reimbursements']
      }),
      getReimbursementConfiguration: build.query<
        GetReimbursementConfigurationResponse,
        GetReimbursementConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/reimbursement-configuration`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Reimbursements']
      }),
      saveReimbursementConfiguration: build.mutation<
        SaveReimbursementConfigurationResponse,
        SaveReimbursementConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/reimbursement-configuration`,
          method: 'POST',
          body: queryArg.reimbursementConfiguration
        }),
        invalidatesTags: ['Reimbursements']
      }),
      onboardOrganizationToStripe: build.mutation<OnboardOrganizationToStripeResponse, OnboardOrganizationToStripeArgs>(
        {
          query: (queryArg) => ({
            url: `/api/organizations/${queryArg.id}/onboard`,
            method: 'POST',
            body: queryArg.urlRedirectModel
          }),
          invalidatesTags: ['Organizations']
        }
      ),
      stopSession: build.mutation<StopSessionResponse, StopSessionArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/commands/stop_session`,
          method: 'POST',
          body: queryArg.stopTransactionRequest
        }),
        invalidatesTags: ['OCPI']
      }),
      startSession: build.mutation<StartSessionResponse, StartSessionArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/commands/start_session`,
          method: 'POST',
          body: queryArg.startSessionRequest
        }),
        invalidatesTags: ['OCPI']
      }),
      getInvoices: build.query<GetInvoicesResponse, GetInvoicesArgs>({
        query: (queryArg) => ({
          url: `/api/invoices`,
          params: {
            page: queryArg.page,
            count: queryArg.count,
            status: queryArg.status,
            organizationId: queryArg.organizationId,
            requestType: queryArg.requestType
          }
        }),
        providesTags: ['Invoices']
      }),
      createInvoice1: build.mutation<CreateInvoice1Response, CreateInvoice1Args>({
        query: (queryArg) => ({ url: `/api/invoices`, method: 'POST', body: queryArg.createInvoiceModel }),
        invalidatesTags: ['Invoices']
      }),
      voidInvoice1: build.mutation<VoidInvoice1Response, VoidInvoice1Args>({
        query: (queryArg) => ({
          url: `/api/invoices/${queryArg.invoiceId}/void`,
          method: 'POST',
          body: queryArg.invoiceOperationRequest
        }),
        invalidatesTags: ['Invoices']
      }),
      sendInvoice1: build.mutation<SendInvoice1Response, SendInvoice1Args>({
        query: (queryArg) => ({
          url: `/api/invoices/${queryArg.invoiceId}/send`,
          method: 'POST',
          body: queryArg.invoiceOperationRequest
        }),
        invalidatesTags: ['Invoices']
      }),
      markInvoicePaid: build.mutation<MarkInvoicePaidResponse, MarkInvoicePaidArgs>({
        query: (queryArg) => ({
          url: `/api/invoices/${queryArg.invoiceId}/mark-paid`,
          method: 'POST',
          body: queryArg.invoiceOperationRequest
        }),
        invalidatesTags: ['Invoices']
      }),
      enrichLineItems: build.mutation<EnrichLineItemsResponse, EnrichLineItemsArgs>({
        query: (queryArg) => ({
          url: `/api/enrich-line-items`,
          method: 'POST',
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        invalidatesTags: ['Billing']
      }),
      enrichLineItemsByPayout: build.mutation<EnrichLineItemsByPayoutResponse, EnrichLineItemsByPayoutArgs>({
        query: (queryArg) => ({
          url: `/api/enrich-line-items-by-payout`,
          method: 'POST',
          params: {
            organizationId: queryArg.organizationId,
            payoutId: queryArg.payoutId,
            createMissingLineItems: queryArg.createMissingLineItems
          }
        }),
        invalidatesTags: ['Billing']
      }),
      bulkUpdateReimbursementUsers: build.mutation<
        BulkUpdateReimbursementUsersResponse,
        BulkUpdateReimbursementUsersArgs
      >({
        query: (queryArg) => ({
          url: `/api/bulk-reimbursement-users`,
          method: 'POST',
          body: queryArg.bulkReimbursementConfiguration
        }),
        invalidatesTags: ['Reimbursements']
      }),
      authorizePublicSession: build.mutation<AuthorizePublicSessionResponse, AuthorizePublicSessionArgs>({
        query: (queryArg) => ({
          url: `/api/authorize-public-session`,
          method: 'POST',
          body: queryArg.authorizePublicSessionRequest
        }),
        invalidatesTags: ['Billing']
      }),
      getSettings: build.query<GetSettingsResponse, GetSettingsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-settings`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Merchant Tax Settings']
      }),
      patchSettings: build.mutation<PatchSettingsResponse, PatchSettingsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-settings`,
          method: 'PATCH',
          body: queryArg.merchantTaxSettingsPatchParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Merchant Tax Settings']
      }),
      deleteTaxApplication: build.mutation<DeleteTaxApplicationResponse, DeleteTaxApplicationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-applications/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Applications']
      }),
      updateTaxApplication: build.mutation<UpdateTaxApplicationResponse, UpdateTaxApplicationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-applications/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.taxApplicationUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Applications']
      }),
      getTerminalV1: build.query<GetTerminalV1Response, GetTerminalV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/${queryArg.readerId}`,
          params: {
            expand: queryArg.expand
          }
        }),
        providesTags: ['StripeTerminalV1']
      }),
      deleteTerminalV1: build.mutation<DeleteTerminalV1Response, DeleteTerminalV1Args>({
        query: (queryArg) => ({ url: `/api/v1/stripe-terminals/${queryArg.readerId}`, method: 'DELETE' }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      assignTerminalV1: build.mutation<AssignTerminalV1Response, AssignTerminalV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/${queryArg.readerId}`,
          method: 'PATCH',
          body: queryArg.stripeTerminalUpdateParams
        }),
        invalidatesTags: ['StripeTerminalV1']
      }),
      updateMyGridEnrollment: build.mutation<UpdateMyGridEnrollmentResponse, UpdateMyGridEnrollmentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/reimbursement-users/me/grid-enrollment`,
          method: 'PATCH',
          body: queryArg.gridEnrollmentUpdateParams
        }),
        invalidatesTags: ['Mobile Reimbursement Users']
      }),
      getRequirements: build.query<GetRequirementsResponse, GetRequirementsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/metadata-requirements`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Metadata Requirements']
      }),
      patchRequirements: build.mutation<PatchRequirementsResponse, PatchRequirementsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/metadata-requirements`,
          method: 'PATCH',
          body: queryArg.organizationMetadataRequirementsPatchParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Metadata Requirements']
      }),
      getTemplate: build.query<GetTemplateResponse, GetTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates/${queryArg.templateId}`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoiceTemplates']
      }),
      updateTemplate: build.mutation<UpdateTemplateResponse, UpdateTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates/${queryArg.templateId}`,
          method: 'PATCH',
          body: queryArg.invoiceTemplateUpdateParams,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        invalidatesTags: ['InvoiceTemplates']
      }),
      deleteArtifactAccessKey: build.mutation<DeleteArtifactAccessKeyResponse, DeleteArtifactAccessKeyArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-artifacts/access-keys/${queryArg.accessKeyId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Invoice Artifact Access']
      }),
      updateArtifactAccessKey: build.mutation<UpdateArtifactAccessKeyResponse, UpdateArtifactAccessKeyArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-artifacts/access-keys/${queryArg.accessKeyId}`,
          method: 'PATCH',
          body: queryArg.artifactAccessKeyUpdateParams
        }),
        invalidatesTags: ['Invoice Artifact Access']
      }),
      getCustomer: build.query<GetCustomerResponse, GetCustomerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers/${queryArg.id}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Customers']
      }),
      updateCustomer: build.mutation<UpdateCustomerResponse, UpdateCustomerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.customerUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Customers']
      }),
      updateConnectedAccountV1: build.mutation<UpdateConnectedAccountV1Response, UpdateConnectedAccountV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/${queryArg.accountId}`,
          method: 'PATCH',
          body: queryArg.connectedAccountUpdateParams
        }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      setDefaultConnectedAccountV1: build.mutation<
        SetDefaultConnectedAccountV1Response,
        SetDefaultConnectedAccountV1Args
      >({
        query: (queryArg) => ({ url: `/api/v1/connected-accounts/${queryArg.accountId}/default`, method: 'PATCH' }),
        invalidatesTags: ['ConnectedAccountV1']
      }),
      getSync: build.query<GetSyncResponse, GetSyncArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connected-account-tax-sync`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            accountId: queryArg.accountId
          }
        }),
        providesTags: ['Connected Account Tax Sync']
      }),
      patchSync: build.mutation<PatchSyncResponse, PatchSyncArgs>({
        query: (queryArg) => ({
          url: `/api/v1/connected-account-tax-sync`,
          method: 'PATCH',
          body: queryArg.connectedAccountTaxSyncPatchParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            accountId: queryArg.accountId
          }
        }),
        invalidatesTags: ['Connected Account Tax Sync']
      }),
      getBillingConfiguration: build.query<GetBillingConfigurationResponse, GetBillingConfigurationArgs>({
        query: (queryArg) => ({ url: `/api/v1/billing-configurations/${queryArg.configurationId}` }),
        providesTags: ['BillingConfigurationV1']
      }),
      updateBillingConfiguration: build.mutation<UpdateBillingConfigurationResponse, UpdateBillingConfigurationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/billing-configurations/${queryArg.configurationId}`,
          method: 'PATCH',
          body: queryArg.billingConfigurationUpdateParams
        }),
        invalidatesTags: ['BillingConfigurationV1']
      }),
      updateRevenueShareRule: build.mutation<UpdateRevenueShareRuleResponse, UpdateRevenueShareRuleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/billing-configurations/${queryArg.configurationId}/revenue-share-rules/${queryArg.ruleId}`,
          method: 'PATCH',
          body: queryArg.billingRevenueShareRuleUpdateParams
        }),
        invalidatesTags: ['BillingConfigurationV1']
      }),
      removeAgreementProduct: build.mutation<RemoveAgreementProductResponse, RemoveAgreementProductArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/products/${queryArg.productId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Agreements']
      }),
      updateAgreementProduct: build.mutation<UpdateAgreementProductResponse, UpdateAgreementProductArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/products/${queryArg.productId}`,
          method: 'PATCH',
          body: queryArg.updateAgreementProductRequest
        }),
        invalidatesTags: ['Agreements']
      }),
      getWorkplaceSummary: build.query<GetWorkplaceSummaryResponse, GetWorkplaceSummaryArgs>({
        query: (queryArg) => ({
          url: `/api/workplace-charging-summary`,
          params: {
            billingMonth: queryArg.billingMonth,
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Workplace Charging']
      }),
      getWorkplaceChargingRecords: build.query<GetWorkplaceChargingRecordsResponse, GetWorkplaceChargingRecordsArgs>({
        query: (queryArg) => ({
          url: `/api/workplace-charging-records`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Workplace Charging']
      }),
      listWalletTransactionsV1: build.query<ListWalletTransactionsV1Response, ListWalletTransactionsV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/wallets/transactions`,
          params: {
            agreementId: queryArg.agreementId
          }
        }),
        providesTags: ['WalletV1']
      }),
      getWalletBalanceV1: build.query<GetWalletBalanceV1Response, GetWalletBalanceV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/wallets/balance`,
          params: {
            agreementId: queryArg.agreementId
          }
        }),
        providesTags: ['WalletV1']
      }),
      validatePublicCharger: build.query<ValidatePublicChargerResponse, ValidatePublicChargerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/twilio/validate-public-charger`,
          params: {
            evseId: queryArg.evseId,
            connectorName: queryArg.connectorName
          }
        }),
        providesTags: ['Billing']
      }),
      getTimeOfUseRate: build.query<GetTimeOfUseRateResponse, GetTimeOfUseRateArgs>({
        query: (queryArg) => ({ url: `/api/v1/time-of-use-rates/${queryArg.timeOfUseRateId}` }),
        providesTags: ['Time-of-use rates']
      }),
      listTaxCodes: build.query<ListTaxCodesResponse, ListTaxCodesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-codes`,
          params: {
            query: queryArg.query,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Tax Codes']
      }),
      getReaderMetadataV1: build.query<GetReaderMetadataV1Response, GetReaderMetadataV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/reader/${queryArg.readerId}/metadata`,
          params: {
            merchantOrganizationId: queryArg.merchantOrganizationId
          }
        }),
        providesTags: ['StripeTerminalV1']
      }),
      getPaymentStatusV1: build.query<GetPaymentStatusV1Response, GetPaymentStatusV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/stripe-terminals/payment-status/${queryArg.paymentIntentId}`,
          params: {
            merchantOrganizationId: queryArg.merchantOrganizationId
          }
        }),
        providesTags: ['StripeTerminalV1']
      }),
      listStartAttempts: build.query<ListStartAttemptsResponse, ListStartAttemptsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/start-attempts`,
          params: {
            organizationId: queryArg.organizationId,
            page: queryArg.page,
            size: queryArg.size,
            outcome: queryArg.outcome,
            identityType: queryArg.identityType,
            siteId: queryArg.siteId,
            chargerId: queryArg.chargerId,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Start Attempts']
      }),
      startAttemptTimeseries: build.query<StartAttemptTimeseriesResponse, StartAttemptTimeseriesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/start-attempts/timeseries`,
          params: {
            organizationId: queryArg.organizationId,
            outcome: queryArg.outcome,
            identityType: queryArg.identityType,
            siteId: queryArg.siteId,
            chargerId: queryArg.chargerId,
            from: queryArg['from'],
            to: queryArg.to,
            granularity: queryArg.granularity,
            timezone: queryArg.timezone
          }
        }),
        providesTags: ['Start Attempts']
      }),
      summarizeStartAttempts: build.query<SummarizeStartAttemptsResponse, SummarizeStartAttemptsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/start-attempts/summary`,
          params: {
            organizationId: queryArg.organizationId,
            outcome: queryArg.outcome,
            identityType: queryArg.identityType,
            siteId: queryArg.siteId,
            chargerId: queryArg.chargerId,
            from: queryArg['from'],
            to: queryArg.to,
            granularity: queryArg.granularity,
            timezone: queryArg.timezone
          }
        }),
        providesTags: ['Start Attempts']
      }),
      getTimeline: build.query<GetTimelineResponse, GetTimelineArgs>({
        query: (queryArg) => ({
          url: `/api/v1/settlements/${queryArg.transactionId}/timeline`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Settlements']
      }),
      getTransactionRedrive: build.query<GetTransactionRedriveResponse, GetTransactionRedriveArgs>({
        query: (queryArg) => ({ url: `/api/v1/redrive-transactions/${queryArg.requestId}` }),
        providesTags: ['Transaction Redrive']
      }),
      getReceipt: build.query<GetReceiptResponse, GetReceiptArgs>({
        query: (queryArg) => ({ url: `/api/v1/public/receipts/${queryArg.transactionId}` }),
        providesTags: ['Billing']
      }),
      getMeterValues: build.query<GetMeterValuesResponse, GetMeterValuesArgs>({
        query: (queryArg) => ({ url: `/api/v1/public/receipts/${queryArg.transactionId}/meter-values` }),
        providesTags: ['Billing']
      }),
      downloadMeterValues: build.query<DownloadMeterValuesResponse, DownloadMeterValuesArgs>({
        query: (queryArg) => ({ url: `/api/v1/public/receipts/${queryArg.transactionId}/meter-values/download` }),
        providesTags: ['Billing']
      }),
      getPublicInvoice: build.query<GetPublicInvoiceResponse, GetPublicInvoiceArgs>({
        query: (queryArg) => ({ url: `/api/v1/public/invoices/${queryArg.invoiceId}` }),
        providesTags: ['Billing']
      }),
      downloadPublicInvoicePdf: build.query<DownloadPublicInvoicePdfResponse, DownloadPublicInvoicePdfArgs>({
        query: (queryArg) => ({ url: `/api/v1/public/invoices/${queryArg.invoiceId}/pdf` }),
        providesTags: ['Billing']
      }),
      getPublicInvoiceArtifacts: build.query<GetPublicInvoiceArtifactsResponse, GetPublicInvoiceArtifactsArgs>({
        query: (queryArg) => ({ url: `/api/v1/public/invoices/${queryArg.invoiceId}/artifacts` }),
        providesTags: ['Billing']
      }),
      downloadPublicInvoiceArchive: build.query<DownloadPublicInvoiceArchiveResponse, DownloadPublicInvoiceArchiveArgs>(
        {
          query: (queryArg) => ({ url: `/api/v1/public/invoices/${queryArg.invoiceId}/archive` }),
          providesTags: ['Billing']
        }
      ),
      getActiveAgreementsUsingProduct: build.query<
        GetActiveAgreementsUsingProductResponse,
        GetActiveAgreementsUsingProductArgs
      >({
        query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}/active-agreements` }),
        providesTags: ['Products']
      }),
      listPayments: build.query<ListPaymentsResponse, ListPaymentsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/payments`,
          params: {
            organizationId: queryArg.organizationId,
            status: queryArg.status,
            customerId: queryArg.customerId,
            from: queryArg['from'],
            to: queryArg.to,
            sort: queryArg.sort,
            page: queryArg.page,
            size: queryArg.size,
            excludeCancelled: queryArg.excludeCancelled
          }
        }),
        providesTags: ['Payments']
      }),
      getPayment: build.query<GetPaymentResponse, GetPaymentArgs>({
        query: (queryArg) => ({ url: `/api/v1/payments/${queryArg.paymentId}` }),
        providesTags: ['Payments']
      }),
      listBillingConfigurations: build.query<ListBillingConfigurationsResponse, ListBillingConfigurationsArgs>({
        query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.organizationId}/billing-configurations` }),
        providesTags: ['BillingConfigurationV1']
      }),
      listLocations: build.query<ListLocationsResponse, ListLocationsArgs>({
        query: () => ({ url: `/api/v1/ocpi-locations` }),
        providesTags: ['OCPI Locations']
      }),
      getConnection: build.query<GetConnectionResponse, GetConnectionArgs>({
        query: (queryArg) => ({ url: `/api/v1/ocpi-connections/${queryArg.id}` }),
        providesTags: ['OCPI Connections']
      }),
      getRequestLogs: build.query<GetRequestLogsResponse, GetRequestLogsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connections/${queryArg.id}/request-logs`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['OCPI Connections']
      }),
      getRequestLog: build.query<GetRequestLogResponse, GetRequestLogArgs>({
        query: (queryArg) => ({ url: `/api/v1/ocpi-connections/${queryArg.id}/request-logs/${queryArg.requestId}` }),
        providesTags: ['OCPI Connections']
      }),
      getUsageSummary: build.query<GetUsageSummaryResponse, GetUsageSummaryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connections/${queryArg.id}/ocpi-usage-summary`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['OCPI Connections']
      }),
      getSessions: build.query<GetSessionsResponse, GetSessionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connections/${queryArg.id}/ocpi-sessions`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit
          }
        }),
        providesTags: ['OCPI Connections']
      }),
      getCdrs: build.query<GetCdrsResponse, GetCdrsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpi-connections/${queryArg.id}/ocpi-cdrs`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit
          }
        }),
        providesTags: ['OCPI Connections']
      }),
      listJoinableConnections: build.query<ListJoinableConnectionsResponse, ListJoinableConnectionsArgs>({
        query: () => ({ url: `/api/v1/ocpi-connections/joinable` }),
        providesTags: ['OCPI Connections']
      }),
      getMyReimbursementUsers: build.query<GetMyReimbursementUsersResponse, GetMyReimbursementUsersArgs>({
        query: () => ({ url: `/api/v1/mobile/reimbursement-users/me` }),
        providesTags: ['Mobile Reimbursement Users']
      }),
      getMyPayoutAccountStatus: build.query<GetMyPayoutAccountStatusResponse, GetMyPayoutAccountStatusArgs>({
        query: () => ({ url: `/api/v1/mobile/payout-account` }),
        providesTags: ['Mobile Payout Account']
      }),
      getMyLineItems: build.query<GetMyLineItemsResponse, GetMyLineItemsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/line-items`,
          params: {
            productType: queryArg.productType,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Mobile Line Items']
      }),
      listRequests: build.query<ListRequestsResponse, ListRequestsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-subscription-requests`,
          params: {
            direction: queryArg.direction,
            status: queryArg.status,
            requestType: queryArg.requestType,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Marketplace Subscription Requests']
      }),
      getFeePreview: build.query<GetFeePreviewResponse, GetFeePreviewArgs>({
        query: (queryArg) => ({ url: `/api/v1/marketplace-offerings/${queryArg.id}/fee-preview` }),
        providesTags: ['Marketplace Offerings']
      }),
      getMapSites: build.query<GetMapSitesResponse, GetMapSitesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/marketplace-map/sites`,
          params: {
            coveredOnly: queryArg.coveredOnly,
            availableToSignup: queryArg.availableToSignup,
            connectorStandard: queryArg.connectorStandard,
            minPowerKw: queryArg.minPowerKw,
            maxPowerKw: queryArg.maxPowerKw,
            minLat: queryArg.minLat,
            minLng: queryArg.minLng,
            maxLat: queryArg.maxLat,
            maxLng: queryArg.maxLng,
            includeMissingCoordinates: queryArg.includeMissingCoordinates,
            expand: queryArg.expand
          }
        }),
        providesTags: ['Marketplace Map']
      }),
      getBillingStatus: build.query<GetBillingStatusResponse, GetBillingStatusArgs>({
        query: (queryArg) => ({ url: `/api/v1/marketplace-agreements/${queryArg.id}/billing-status` }),
        providesTags: ['Marketplace Agreements']
      }),
      downloadInvoicePdf: build.query<DownloadInvoicePdfResponse, DownloadInvoicePdfArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/pdf`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoicesV2']
      }),
      getInvoiceArtifacts: build.query<GetInvoiceArtifactsResponse, GetInvoiceArtifactsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/artifacts`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoicesV2']
      }),
      downloadInvoiceArchive: build.query<DownloadInvoiceArchiveResponse, DownloadInvoiceArchiveArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoices/${queryArg.invoiceId}/archive`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoicesV2']
      }),
      attributeCatalog: build.query<AttributeCatalogResponse, AttributeCatalogArgs>({
        query: (queryArg) => ({
          url: `/api/v1/invoice-templates/attribute-catalog`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['InvoiceTemplates']
      }),
      getArtifactStorageAccess: build.query<GetArtifactStorageAccessResponse, GetArtifactStorageAccessArgs>({
        query: () => ({ url: `/api/v1/invoice-artifacts/access` }),
        providesTags: ['Invoice Artifact Access']
      }),
      listLegacyRates: build.query<ListLegacyRatesResponse, ListLegacyRatesArgs>({
        query: () => ({ url: `/api/v1/internal/public-rate-migrations/legacy-rates` }),
        providesTags: ['Public Charging Rate Migration']
      }),
      listHardwareProducts: build.query<ListHardwareProductsResponse, ListHardwareProductsArgs>({
        query: () => ({ url: `/api/v1/hardware-products` }),
        providesTags: ['HardwareProducts']
      }),
      listHardwareOrders: build.query<ListHardwareOrdersResponse, ListHardwareOrdersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/hardware-orders`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            sessionId: queryArg.sessionId
          }
        }),
        providesTags: ['HardwareOrders']
      }),
      getHardwareOrder: build.query<GetHardwareOrderResponse, GetHardwareOrderArgs>({
        query: (queryArg) => ({ url: `/api/v1/hardware-orders/${queryArg.id}` }),
        providesTags: ['HardwareOrders']
      }),
      listCustomers: build.query<ListCustomersResponse, ListCustomersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            page: queryArg.page,
            size: queryArg.size,
            type: queryArg['type'],
            status: queryArg.status,
            search: queryArg.search
          }
        }),
        providesTags: ['Customers']
      }),
      getCustomerBalance: build.query<GetCustomerBalanceResponse, GetCustomerBalanceArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers/${queryArg.id}/balance`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Customers']
      }),
      getCustomerWalletBalances: build.query<GetCustomerWalletBalancesResponse, GetCustomerWalletBalancesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/customers/wallet-balances`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            customerIds: queryArg.customerIds
          }
        }),
        providesTags: ['Customers']
      }),
      getSuggestedCapabilitiesV1: build.query<GetSuggestedCapabilitiesV1Response, GetSuggestedCapabilitiesV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/suggested-capabilities`,
          params: {
            currency: queryArg.currency,
            country: queryArg.country
          }
        }),
        providesTags: ['ConnectedAccountV1']
      }),
      getOverviewV1: build.query<GetOverviewV1Response, GetOverviewV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-accounts/overview`,
          params: {
            accountId: queryArg.accountId,
            periodFrom: queryArg.periodFrom,
            periodTo: queryArg.periodTo,
            topCustomersLimit: queryArg.topCustomersLimit,
            granularity: queryArg.granularity,
            compare: queryArg.compare
          }
        }),
        providesTags: ['ConnectedAccountV1']
      }),
      listConnectedAccountsLinkedToOrganizationV1: build.query<
        ListConnectedAccountsLinkedToOrganizationV1Response,
        ListConnectedAccountsLinkedToOrganizationV1Args
      >({
        query: (queryArg) => ({ url: `/api/v1/connected-accounts/linked-to/${queryArg.organizationId}` }),
        providesTags: ['ConnectedAccountV1']
      }),
      listBalanceTransactions: build.query<ListBalanceTransactionsResponse, ListBalanceTransactionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/balance-transactions`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            payorId: queryArg.payorId,
            customerId: queryArg.customerId,
            accountId: queryArg.accountId,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Balance Transactions']
      }),
      listSessionsV1: build.query<ListSessionsV1Response, ListSessionsV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/sessions`,
          params: {
            pageable: queryArg.pageable
          }
        }),
        providesTags: ['AssistantBillingV1']
      }),
      gateV1: build.query<GateV1Response, GateV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/gate`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['AssistantBillingV1']
      }),
      getCreditsV1: build.query<GetCreditsV1Response, GetCreditsV1Args>({
        query: () => ({ url: `/api/v1/assistant-billing/credits` }),
        providesTags: ['AssistantBillingV1']
      }),
      getBreakdownV1: build.query<GetBreakdownV1Response, GetBreakdownV1Args>({
        query: (queryArg) => ({
          url: `/api/v1/assistant-billing/breakdown`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['AssistantBillingV1']
      }),
      getReconciliationExceptions: build.query<GetReconciliationExceptionsResponse, GetReconciliationExceptionsArgs>({
        query: (queryArg) => ({ url: `/api/v1/agreements/${queryArg.id}/reconciliation` }),
        providesTags: ['Agreement OCPI Records']
      }),
      getAgreementProductHistory: build.query<GetAgreementProductHistoryResponse, GetAgreementProductHistoryArgs>({
        query: (queryArg) => ({ url: `/api/v1/agreements/${queryArg.id}/products/history` }),
        providesTags: ['Agreements']
      }),
      getOcpiUsageSummary: build.query<GetOcpiUsageSummaryResponse, GetOcpiUsageSummaryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/ocpi-usage-summary`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Agreement OCPI Records']
      }),
      getOcpiSessions: build.query<GetOcpiSessionsResponse, GetOcpiSessionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/ocpi-sessions`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Agreement OCPI Records']
      }),
      getOcpiCdrs: build.query<GetOcpiCdrsResponse, GetOcpiCdrsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/ocpi-cdrs`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            offset: queryArg.offset,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Agreement OCPI Records']
      }),
      getPayoutsByCursor: build.query<GetPayoutsByCursorResponse, GetPayoutsByCursorArgs>({
        query: (queryArg) => ({
          url: `/api/v0/payouts`,
          params: {
            organizationId: queryArg.organizationId,
            count: queryArg.count,
            after: queryArg.after,
            before: queryArg.before,
            from: queryArg['from'],
            to: queryArg.to,
            status: queryArg.status
          }
        }),
        providesTags: ['Payouts']
      }),
      getPayoutById: build.query<GetPayoutByIdResponse, GetPayoutByIdArgs>({
        query: (queryArg) => ({
          url: `/api/v0/payouts/${queryArg.payoutId}`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Payouts']
      }),
      getInvoicesByCursor: build.query<GetInvoicesByCursorResponse, GetInvoicesByCursorArgs>({
        query: (queryArg) => ({
          url: `/api/v0/invoices`,
          params: {
            organizationId: queryArg.organizationId,
            payorId: queryArg.payorId,
            count: queryArg.count,
            after: queryArg.after,
            before: queryArg.before,
            requestType: queryArg.requestType,
            from: queryArg['from'],
            to: queryArg.to,
            status: queryArg.status
          }
        }),
        providesTags: ['Invoices']
      }),
      getInvoiceById: build.query<GetInvoiceByIdResponse, GetInvoiceByIdArgs>({
        query: (queryArg) => ({
          url: `/api/v0/invoices/${queryArg.invoiceId}`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Invoices']
      }),
      billingOverviewGetPayouts: build.query<BillingOverviewGetPayoutsResponse, BillingOverviewGetPayoutsArgs>({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/payouts`,
          params: {
            organizationId: queryArg.organizationId,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Billing Overview']
      }),
      billingOverviewGetPayments: build.query<BillingOverviewGetPaymentsResponse, BillingOverviewGetPaymentsArgs>({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/payments`,
          params: {
            organizationId: queryArg.organizationId,
            filter: queryArg.filter,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Billing Overview']
      }),
      billingOverviewGetInvoices: build.query<BillingOverviewGetInvoicesResponse, BillingOverviewGetInvoicesArgs>({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/invoices`,
          params: {
            organizationId: queryArg.organizationId,
            filter: queryArg.filter,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Billing Overview']
      }),
      billingOverviewGetCustomers: build.query<BillingOverviewGetCustomersResponse, BillingOverviewGetCustomersArgs>({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/customers`,
          params: {
            organizationId: queryArg.organizationId,
            limit: queryArg.limit
          }
        }),
        providesTags: ['Billing Overview']
      }),
      billingOverviewGetVolumeChart: build.query<
        BillingOverviewGetVolumeChartResponse,
        BillingOverviewGetVolumeChartArgs
      >({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/charts/volume`,
          params: {
            organizationId: queryArg.organizationId,
            type: queryArg['type'],
            dateRange: queryArg.dateRange,
            granularity: queryArg.granularity,
            comparison: queryArg.comparison,
            currency: queryArg.currency,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Billing Overview']
      }),
      billingOverviewGetPaymentsChart: build.query<
        BillingOverviewGetPaymentsChartResponse,
        BillingOverviewGetPaymentsChartArgs
      >({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/charts/payments`,
          params: {
            organizationId: queryArg.organizationId,
            dateRange: queryArg.dateRange,
            granularity: queryArg.granularity,
            comparison: queryArg.comparison,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Billing Overview']
      }),
      billingOverviewGetCustomersChart: build.query<
        BillingOverviewGetCustomersChartResponse,
        BillingOverviewGetCustomersChartArgs
      >({
        query: (queryArg) => ({
          url: `/api/v0/billing-overview/charts/customers`,
          params: {
            organizationId: queryArg.organizationId,
            metric: queryArg.metric,
            dateRange: queryArg.dateRange,
            granularity: queryArg.granularity,
            comparison: queryArg.comparison,
            currency: queryArg.currency,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Billing Overview']
      }),
      getStripeIntentDetail: build.query<GetStripeIntentDetailResponse, GetStripeIntentDetailArgs>({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/stripe-secret`,
          params: {
            apiVersion: queryArg.apiVersion,
            forceNewSetupIntent: queryArg.forceNewSetupIntent
          }
        }),
        providesTags: ['User']
      }),
      getPaymentMethod: build.query<GetPaymentMethodResponse, GetPaymentMethodArgs>({
        query: (queryArg) => ({ url: `/api/users/${queryArg.id}/payment-method` }),
        providesTags: ['User']
      }),
      getPortalLogin: build.query<GetPortalLoginResponse, GetPortalLoginArgs>({
        query: (queryArg) => ({ url: `/api/users/${queryArg.id}/manage-billing` }),
        providesTags: ['User']
      }),
      getUserInvoices: build.query<GetUserInvoicesResponse, GetUserInvoicesArgs>({
        query: (queryArg) => ({ url: `/api/users/${queryArg.id}/invoices` }),
        providesTags: ['User']
      }),
      getCheckoutSession: build.query<GetCheckoutSessionResponse, GetCheckoutSessionArgs>({
        query: (queryArg) => ({ url: `/api/users/${queryArg.id}/checkout-session` }),
        providesTags: ['User']
      }),
      getUserBalance: build.query<GetUserBalanceResponse, GetUserBalanceArgs>({
        query: (queryArg) => ({ url: `/api/users/${queryArg.id}/balances` }),
        providesTags: ['User']
      }),
      getReimbursements: build.query<GetReimbursementsResponse, GetReimbursementsArgs>({
        query: (queryArg) => ({
          url: `/api/reimbursements`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Reimbursements']
      }),
      getReimbursementUser: build.query<GetReimbursementUserResponse, GetReimbursementUserArgs>({
        query: (queryArg) => ({ url: `/api/reimbursement-users/${queryArg.reimbursementUserId}` }),
        providesTags: ['Reimbursements']
      }),
      deleteReimbursementUser: build.mutation<DeleteReimbursementUserResponse, DeleteReimbursementUserArgs>({
        query: (queryArg) => ({ url: `/api/reimbursement-users/${queryArg.reimbursementUserId}`, method: 'DELETE' }),
        invalidatesTags: ['Reimbursements']
      }),
      getReimbursementSummary: build.query<GetReimbursementSummaryResponse, GetReimbursementSummaryArgs>({
        query: (queryArg) => ({
          url: `/api/reimbursement-summary`,
          params: {
            billingMonth: queryArg.billingMonth,
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Reimbursements']
      }),
      getQuotas: build.query<GetQuotasResponse, GetQuotasArgs>({
        query: (queryArg) => ({
          url: `/api/quotas`,
          params: {
            organizationId: queryArg.organizationId,
            month: queryArg.month
          }
        }),
        providesTags: ['Quotas']
      }),
      getReimbursements1: build.query<GetReimbursements1Response, GetReimbursements1Args>({
        query: (queryArg) => ({
          url: `/api/organizations/${queryArg.id}/reimbursements`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Organizations']
      }),
      getPortal: build.query<GetPortalResponse, GetPortalArgs>({
        query: (queryArg) => ({ url: `/api/organizations/${queryArg.id}/manage-billing` }),
        providesTags: ['Organizations']
      }),
      getLoginSession: build.query<GetLoginSessionResponse, GetLoginSessionArgs>({
        query: (queryArg) => ({ url: `/api/organizations/${queryArg.id}/manage-account` }),
        providesTags: ['Organizations']
      }),
      getOrganizationBalance: build.query<GetOrganizationBalanceResponse, GetOrganizationBalanceArgs>({
        query: (queryArg) => ({ url: `/api/organizations/${queryArg.id}/balance` }),
        providesTags: ['Organizations']
      }),
      getMeterValues1: build.query<GetMeterValues1Response, GetMeterValues1Args>({
        query: (queryArg) => ({ url: `/api/ocpi/cpo/2.2.1/sessions/${queryArg.sessionId}/meter_values` }),
        providesTags: ['OCPI']
      }),
      getLocations: build.query<GetLocationsResponse, GetLocationsArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/locations`,
          params: {
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            offset: queryArg.offset,
            limit: queryArg.limit,
            source: queryArg.source
          }
        }),
        providesTags: ['OCPI']
      }),
      getEvse: build.query<GetEvseResponse, GetEvseArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/cpo/2.2.1/locations/${queryArg.locationId}/${queryArg.evseUid}` }),
        providesTags: ['OCPI']
      }),
      getConnector: build.query<GetConnectorResponse, GetConnectorArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/locations/${queryArg.locationId}/${queryArg.evseUid}/${queryArg.connectorId}`
        }),
        providesTags: ['OCPI']
      }),
      getCdr: build.query<GetCdrResponse, GetCdrArgs>({
        query: (queryArg) => ({
          url: `/api/ocpi/cpo/2.2.1/cdr`,
          params: {
            authTag: queryArg.authTag,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            offset: queryArg.offset,
            limit: queryArg.limit
          }
        }),
        providesTags: ['OCPI']
      }),
      getCdrById: build.query<GetCdrByIdResponse, GetCdrByIdArgs>({
        query: (queryArg) => ({ url: `/api/ocpi/cpo/2.2.1/cdr/${queryArg.sessionId}` }),
        providesTags: ['OCPI']
      }),
      getLineItems: build.query<GetLineItemsResponse, GetLineItemsArgs>({
        query: (queryArg) => ({
          url: `/api/line-items`,
          params: {
            productType: queryArg.productType,
            productId: queryArg.productId,
            chargerId: queryArg.chargerId,
            vehicleId: queryArg.vehicleId,
            vehicleIds: queryArg.vehicleIds,
            authTag: queryArg.authTag,
            fleetId: queryArg.fleetId,
            siteId: queryArg.siteId,
            payeeId: queryArg.payeeId,
            payorId: queryArg.payorId,
            payorOrgId: queryArg.payorOrgId,
            agreementId: queryArg.agreementId,
            payoutId: queryArg.payoutId,
            usageSourceId: queryArg.usageSourceId,
            invoiceId: queryArg.invoiceId,
            balanceTransactionId: queryArg.balanceTransactionId,
            from: queryArg['from'],
            to: queryArg.to,
            status: queryArg.status,
            search: queryArg.search,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Billing']
      }),
      getLineItemById: build.query<GetLineItemByIdResponse, GetLineItemByIdArgs>({
        query: (queryArg) => ({ url: `/api/line-items/${queryArg.id}` }),
        providesTags: ['Billing']
      }),
      getCostExplorer: build.query<GetCostExplorerResponse, GetCostExplorerArgs>({
        query: (queryArg) => ({
          url: `/api/cost-explorer`,
          params: {
            groupBy: queryArg.groupBy,
            productType: queryArg.productType,
            granularity: queryArg.granularity,
            from: queryArg['from'],
            to: queryArg.to,
            organizationId: queryArg.organizationId,
            vehicleIds: queryArg.vehicleIds
          }
        }),
        providesTags: ['Cost Explorer']
      }),
      getChargingRates: build.query<GetChargingRatesResponse, GetChargingRatesArgs>({
        query: (queryArg) => ({
          url: `/api/charging-rates`,
          params: {
            organizationId: queryArg.organizationId,
            productType: queryArg.productType
          }
        }),
        providesTags: ['Billing']
      }),
      getChargingRateById: build.query<GetChargingRateByIdResponse, GetChargingRateByIdArgs>({
        query: (queryArg) => ({
          url: `/api/charging-rates/${queryArg.rateMappingId}`,
          params: {
            organizationId: queryArg.organizationId
          }
        }),
        providesTags: ['Billing']
      }),
      getChargesForOrganization: build.query<GetChargesForOrganizationResponse, GetChargesForOrganizationArgs>({
        query: (queryArg) => ({
          url: `/api/charges`,
          params: {
            organizationId: queryArg.organizationId,
            size: queryArg.size,
            after: queryArg.after,
            before: queryArg.before,
            payorId: queryArg.payorId,
            status: queryArg.status,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Billing']
      }),
      getBootEvents: build.query<GetBootEventsResponse, GetBootEventsArgs>({
        query: (queryArg) => ({
          url: `/api/charger-boot-events`,
          params: {
            chargerId: queryArg.chargerId,
            siteId: queryArg.siteId,
            from: queryArg['from'],
            to: queryArg.to,
            includeRawEvents: queryArg.includeRawEvents,
            bucket: queryArg.bucket
          }
        }),
        providesTags: ['Chargers']
      }),
      getBalance: build.query<GetBalanceResponse, GetBalanceArgs>({
        query: (queryArg) => ({
          url: `/api/balance`,
          params: {
            accountType: queryArg.accountType,
            organizationId: queryArg.organizationId,
            userId: queryArg.userId
          }
        }),
        providesTags: ['Customer']
      }),
      deleteRegistration: build.mutation<DeleteRegistrationResponse, DeleteRegistrationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-registrations/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tax Registrations']
      }),
      deleteDecision: build.mutation<DeleteDecisionResponse, DeleteDecisionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tax-jurisdiction-decisions/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            connectedAccountId: queryArg.connectedAccountId
          }
        }),
        invalidatesTags: ['Tax Jurisdiction Decisions']
      }),
      disablePeakSaver: build.mutation<DisablePeakSaverResponse, DisablePeakSaverArgs>({
        query: (queryArg) => ({ url: `/api/v1/mobile/sessions/${queryArg.sessionId}/peak-saver`, method: 'DELETE' }),
        invalidatesTags: ['Mobile Sessions']
      }),
      cancelChargingSchedule: build.mutation<CancelChargingScheduleResponse, CancelChargingScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/mobile/charging-schedules/${queryArg.eventId}`,
          method: 'DELETE',
          params: {
            includeRecurring: queryArg.includeRecurring
          }
        }),
        invalidatesTags: ['Mobile Charging Schedules']
      }),
      deleteRegistration1: build.mutation<DeleteRegistration1Response, DeleteRegistration1Args>({
        query: (queryArg) => ({
          url: `/api/v1/connected-account-tax-sync/registrations/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            accountId: queryArg.accountId
          }
        }),
        invalidatesTags: ['Connected Account Tax Sync']
      }),
      removeAuthorizedEntity: build.mutation<RemoveAuthorizedEntityResponse, RemoveAuthorizedEntityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agreements/${queryArg.id}/products/${queryArg.productId}/authorized-entities/${queryArg.entityId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Agreements']
      }),
      removePaymentMethod: build.mutation<RemovePaymentMethodResponse, RemovePaymentMethodArgs>({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/payment-method/${queryArg.paymentMethodId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['User']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type GetWorkplaceUserResponse = /** status 200 Workplace user retrieved. */ WorkplaceChargingUserModel
export type GetWorkplaceUserArgs = {
  workplaceUserId: string
}
export type UpdateWorkplaceUserResponse = /** status 200 Workplace Users updated. */ WorkplaceChargingUserModel
export type UpdateWorkplaceUserArgs = {
  workplaceUserId: string
  workplaceChargingUserModel: WorkplaceChargingUserModel
}
export type DeleteWorkplaceUserResponse = /** status 200 Workplace user deleted. */ boolean
export type DeleteWorkplaceUserArgs = {
  workplaceUserId: string
}
export type UpdateTaxRateResponse = /** status 200 OK */ TaxRateRead
export type UpdateTaxRateArgs = {
  'X-Organization-Id': string
  taxId: string
  taxRateUpdateParams: TaxRateUpdateParams
}
export type GetUserTaxProfileResponse = /** status 200 The user's tax profile */ TaxProfile
export type GetUserTaxProfileArgs = void
export type UpsertUserTaxProfileResponse = /** status 200 The upserted user tax profile */ TaxProfile
export type UpsertUserTaxProfileArgs = {
  taxProfilePatchParams: TaxProfilePatchParams
}
export type GetOrganizationTaxProfileResponse = /** status 200 The organization's tax profile */ TaxProfile
export type GetOrganizationTaxProfileArgs = void
export type UpsertOrganizationTaxProfileResponse = /** status 200 The upserted organization tax profile */ TaxProfile
export type UpsertOrganizationTaxProfileArgs = {
  taxProfilePatchParams: TaxProfilePatchParams
}
export type GetAgreementTaxOverrideResponse = /** status 200 The agreement's tax override */ TaxProfile
export type GetAgreementTaxOverrideArgs = {
  /** Agreement id (ag_*) */
  agreementId: string
}
export type UpsertAgreementTaxOverrideResponse = /** status 200 The upserted agreement tax override */ TaxProfile
export type UpsertAgreementTaxOverrideArgs = {
  /** Agreement id (ag_*) */
  agreementId: string
  taxProfilePatchParams: TaxProfilePatchParams
}
export type ListDecisionsResponse = /** status 200 OK */ TaxJurisdictionDecision[]
export type ListDecisionsArgs = {
  'X-Organization-Id': string
  connectedAccountId?: number
}
export type UpsertDecisionResponse = /** status 200 OK */ TaxJurisdictionDecision
export type UpsertDecisionArgs = {
  'X-Organization-Id': string
  connectedAccountId?: number
  taxJurisdictionDecisionUpsertParams: TaxJurisdictionDecisionUpsertParams
}
export type GetProductResponse = /** status 200 Product found */ ProductResponseRead
export type GetProductArgs = {
  productId: string
  /** Rate schedule start (inclusive) */
  scheduleFrom?: string
  /** Rate schedule end (inclusive) */
  scheduleTo?: string
}
export type UpdateProductResponse = /** status 200 Product updated successfully */ ProductResponseRead
export type UpdateProductArgs = {
  productId: string
  updateProductRequest: UpdateProductRequest
}
export type DeleteProductResponse = unknown
export type DeleteProductArgs = {
  /** The ID of the product to delete */
  productId: string
}
export type GetVisibilityResponse = /** status 200 OK */ MarketplaceVisibility
export type GetVisibilityArgs = {
  organizationId: string
}
export type UpdateVisibilityResponse = /** status 200 OK */ MarketplaceVisibility
export type UpdateVisibilityArgs = {
  organizationId: string
  marketplaceVisibilityUpdateParams: MarketplaceVisibilityUpdateParams
}
export type ClearVisibilityResponse = /** status 200 OK */ MarketplaceVisibility
export type ClearVisibilityArgs = {
  organizationId: string
}
export type GetProfileResponse = /** status 200 OK */ MarketplaceOrganizationProfileResponse
export type GetProfileArgs = void
export type UpdateProfileResponse = /** status 200 OK */ MarketplaceOrganizationProfileResponse
export type UpdateProfileArgs = {
  marketplaceOrganizationProfileUpdateParams: MarketplaceOrganizationProfileUpdateParams
}
export type UpdatePresentationResponse = /** status 200 OK */ MarketplaceLocation
export type UpdatePresentationArgs = {
  id: string
  marketplaceLocationPresentationParams: MarketplaceLocationPresentationParams
}
export type GetReservationConfigurationResponse =
  /** status 200 Configuration retrieved successfully */ SiteReservationConfiguration
export type GetReservationConfigurationArgs = {
  /** ID of the site */
  siteId: string
}
export type UpdateReservationConfigurationResponse =
  /** status 200 Configuration updated successfully */ SiteReservationConfiguration
export type UpdateReservationConfigurationArgs = {
  /** ID of the site */
  siteId: string
  reservationConfigurationUpdateParams: ReservationConfigurationUpdateParams
}
export type GetReservationResponse = /** status 200 Reservation found */ ChargerEvent
export type GetReservationArgs = {
  /** ID of the charger */
  chargerId: string
  /** ID of the reservation to retrieve */
  eventId: string
}
export type UpdateReservationResponse = /** status 200 Reservation updated successfully */ ChargerEvent
export type UpdateReservationArgs = {
  /** ID of the charger */
  chargerId: string
  /** ID of the reservation to update */
  eventId: string
  /** Whether to update recurring events */
  isRecurrence?: boolean
  reservationUpdateRequest: ReservationUpdateRequest
}
export type CancelReservationResponse = /** status 200 Reservation cancelled successfully */ ChargerEvent
export type CancelReservationArgs = {
  /** ID of the charger */
  chargerId: string
  /** ID of the reservation to cancel */
  eventId: string
  /** Whether to cancel recurring events */
  isRecurrence?: boolean
}
export type GetMeterResponse = /** status 200 Successfully retrieved meter */ Meter
export type GetMeterArgs = {
  /** Meter ID (UUID or human-readable format like meter_abc123) */
  id: string
  /** Expand related resources (e.g., 'attachments') */
  expand?: string
}
export type UpdateMeterResponse = /** status 200 Successfully updated meter */ Meter
export type UpdateMeterArgs = {
  /** Meter ID (UUID or human-readable format like meter_abc123) */
  id: string
  meterUpdateParams: MeterUpdateParams
}
export type DeleteMeterResponse = unknown
export type DeleteMeterArgs = {
  /** Meter ID (UUID or human-readable format like meter_abc123) */
  id: string
}
export type GetOfferingResponse = /** status 200 OK */ MarketplaceOfferingRead
export type GetOfferingArgs = {
  id: string
  accessCode?: string
}
export type UpdateOfferingResponse = /** status 200 OK */ MarketplaceOfferingRead
export type UpdateOfferingArgs = {
  id: string
  marketplaceOfferingUpdateParams: MarketplaceOfferingUpdateParams
}
export type GetInvoiceDetailResponse = /** status 200 Invoice detail retrieved */ SynopInvoiceDetail
export type GetInvoiceDetailArgs = {
  /** Synop invoice id (invoice_*) */
  invoiceId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type UpdateInvoiceResponse = /** status 200 OK */ SynopInvoice
export type UpdateInvoiceArgs = {
  invoiceId: string
  organizationId?: string
  synopInvoiceUpdateParams: SynopInvoiceUpdateParams
}
export type DeleteInvoiceResponse = unknown
export type DeleteInvoiceArgs = {
  invoiceId: string
  organizationId?: string
}
export type UpdateLineItemResponse = /** status 200 OK */ SynopInvoiceLineItem
export type UpdateLineItemArgs = {
  invoiceId: string
  lineItemId: string
  organizationId?: string
  lineItemUpdateParams: LineItemUpdateParams
}
export type DeleteLineItemResponse = unknown
export type DeleteLineItemArgs = {
  invoiceId: string
  lineItemId: string
  organizationId?: string
}
export type UpdateArtifactPickupResponse = /** status 200 Updated access state */ ArtifactStorageAccess
export type UpdateArtifactPickupArgs = {
  artifactPickupParams: ArtifactPickupParams
}
export type DeleteArtifactPickupResponse = /** status 200 Updated access state */ ArtifactStorageAccess
export type DeleteArtifactPickupArgs = void
export type UpdateArtifactAccessAllowedSourcesResponse = /** status 200 Updated access state */ ArtifactStorageAccess
export type UpdateArtifactAccessAllowedSourcesArgs = {
  artifactAccessAllowedSourcesParams: ArtifactAccessAllowedSourcesParams
}
export type GetInvoicePaymentOptionsV1Response = /** status 200 OK */ InvoicePaymentOptionsRead
export type GetInvoicePaymentOptionsV1Args = {
  /** Connected account id (account_xxx) */
  accountId: string
  /** ISO 4217 currency for availablePaymentMethods (e.g. SEK); defaults to the account's default currency, else USD. */
  currency?: string
}
export type UpdateInvoicePaymentOptionsV1Response = /** status 200 OK */ InvoicePaymentOptionsRead
export type UpdateInvoicePaymentOptionsV1Args = {
  /** Connected account id (account_xxx) */
  accountId: string
  invoicePaymentOptionsUpdateParams: InvoicePaymentOptionsUpdateParams
}
export type UpdateAutoReloadV1Response = /** status 200 OK */ AssistantBillingConfig
export type UpdateAutoReloadV1Args = {
  assistantAutoReloadRequest: AssistantAutoReloadRequest
}
export type GetAgreementResponse = /** status 200 Agreement found */ AgreementResponse
export type GetAgreementArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  includeInactive?: boolean
}
export type UpdateAgreementResponse = /** status 200 Agreement updated successfully */ AgreementResponse
export type UpdateAgreementArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  agreementUpdateParams: AgreementUpdateParams
}
export type UpdatePushNotificationResponse = /** status 200 OK */ UserPushNotificationMap
export type UpdatePushNotificationArgs = {
  id: string
  createUserPushParams: CreateUserPushParams
}
export type SetDefaultPaymentMethodResponse = /** status 200 OK */ BillingDetailsModel
export type SetDefaultPaymentMethodArgs = {
  id: string
  paymentMethodId: string
}
export type UpdateUserTagsResponse = /** status 200 OK */ FleetManagementUserTagModel[]
export type UpdateUserTagsArgs = {
  id: string
  body: FleetManagementUserTagModel[]
}
export type GetSessions1Response = /** status 200 OK */ ResponseFormatListSessionDto
export type GetSessions1Args = {
  dateFrom?: string
  dateTo?: string
  offset?: number
  limit?: number
}
export type PutChargingPreferencesResponse = /** status 200 OK */ ResponseFormatChargingPreferences
export type PutChargingPreferencesArgs = {
  sessionId: string
  chargingPreferences: ChargingPreferences
}
export type GetSessionResponse = /** status 200 OK */ BillableTransactionEntity
export type GetSessionArgs = {
  sessionId: string
}
export type UpdateSessionResponse = /** status 200 OK */ BillableTransactionEntity
export type UpdateSessionArgs = {
  sessionId: string
  updateSessionRequest: UpdateSessionRequest
}
export type GetLocationResponse = /** status 200 OK */ ResponseFormatLocation
export type GetLocationArgs = {
  locationId: string
}
export type UpdateLocationResponse = /** status 200 OK */ ResponseFormatLocationData
export type UpdateLocationArgs = {
  locationId: string
  location: Location
}
export type GetInvoiceResponse = /** status 200 OK */ InvoiceModel
export type GetInvoiceArgs = {
  invoiceId: string
}
export type UpdateInvoice1Response = /** status 200 OK */ UpdateInvoiceModel
export type UpdateInvoice1Args = {
  invoiceId: string
  updateInvoiceModel: UpdateInvoiceModel
}
export type DeleteInvoice1Response = /** status 200 OK */ boolean
export type DeleteInvoice1Args = {
  invoiceId: string
}
export type GetWorkplaceUsersResponse = /** status 200 Workplace users retrieved. */ WorkplaceChargingUserModel[]
export type GetWorkplaceUsersArgs = {
  organizationId?: string
}
export type SaveWorkplaceUserResponse = /** status 200 Workplace Users configured. */ WorkplaceChargingUserModel
export type SaveWorkplaceUserArgs = {
  createWorkplaceChargingUser: CreateWorkplaceChargingUser
}
export type GetWorkplaceChargingConfigurationResponse =
  /** status 200 Workplace Charging retrieved. */ WorkplaceConfiguration
export type GetWorkplaceChargingConfigurationArgs = {
  organizationId?: string
}
export type SaveWorkplaceChargingConfigurationResponse =
  /** status 200 Workplace Charging configured. */ WorkplaceConfiguration
export type SaveWorkplaceChargingConfigurationArgs = {
  workplaceConfiguration: WorkplaceConfiguration
}
export type RebaselineWalletResponse =
  /** status 200 Re-baseline report (dry run, applied, no change, or already applied) */ WalletRebaseline
export type RebaselineWalletArgs = {
  walletRebaselineParams: WalletRebaselineParams
}
export type StartTwilioChargingSessionResponse = /** status 200 OK */ TwilioStartSessionResponse
export type StartTwilioChargingSessionArgs = {
  twilioStartSessionRequest: TwilioStartSessionRequest
}
export type BackfillTouRecurrenceResponse = /** status 200 TOU recurrence backfill completed */ TouRecurrenceBackfill
export type BackfillTouRecurrenceArgs = {
  touRecurrenceBackfillParams: TouRecurrenceBackfillParams
}
export type RepairTopUpLinksResponse = /** status 200 Top-up link repair completed */ TopUpLinkRepair
export type RepairTopUpLinksArgs = {
  topUpLinkRepairParams: TopUpLinkRepairParams
}
export type PreviewTaxResponse = /** status 200 OK */ TaxPreviewResult
export type PreviewTaxArgs = {
  'X-Organization-Id': string
  taxPreviewParams: TaxPreviewParams
}
export type ListRegistrationsResponse = /** status 200 OK */ TaxRegistration[]
export type ListRegistrationsArgs = {
  'X-Organization-Id': string
}
export type CreateRegistrationResponse = /** status 200 OK */ TaxRegistration
export type CreateRegistrationArgs = {
  'X-Organization-Id': string
  taxRegistrationCreateParams: TaxRegistrationCreateParams
}
export type ListTaxRatesResponse = /** status 200 OK */ PagedResponseTaxRateRead
export type ListTaxRatesArgs = {
  'X-Organization-Id': string
  /** Exact tax id (single-fetch) */
  taxId?: string
  /** Filter by name (partial match) */
  name?: string
  /** Filter by tax type */
  taxType?: string
  /** Filter by active status */
  active?: boolean
  page?: number
  pageSize?: number
}
export type CreateTaxRateResponse = /** status 200 OK */ TaxRateRead
export type CreateTaxRateArgs = {
  'X-Organization-Id': string
  taxRateCreateParams: TaxRateCreateParams
}
export type ListTaxApplicationsResponse = /** status 200 OK */ PagedResponseTaxApplication
export type ListTaxApplicationsArgs = {
  'X-Organization-Id': string
  /** Exact application id (single-fetch) */
  id?: number
  /** Scope type filter */
  scopeType?: 'PRODUCT' | 'PRICE' | 'METER' | 'AGREEMENT' | 'SITE' | 'CHARGER'
  /** Scope id filter */
  scopeId?: string
  /** Tax id filter */
  taxId?: string
  /** Active filter */
  active?: boolean
  page?: number
  pageSize?: number
}
export type CreateTaxApplicationResponse = /** status 200 OK */ TaxApplication
export type CreateTaxApplicationArgs = {
  'X-Organization-Id': string
  taxApplicationCreateParams: TaxApplicationCreateParams
}
export type HandleStripeWebhookResponse = unknown
export type HandleStripeWebhookArgs = {
  'Stripe-Signature'?: string
  body: string
}
export type ListTerminalsV1Response = /** status 200 OK */ PageStripeTerminal
export type ListTerminalsV1Args = {
  pageable: Pageable
  expand?: string[]
}
export type RegisterTerminalV1Response = /** status 200 OK */ StripeTerminal
export type RegisterTerminalV1Args = {
  stripeTerminalCreateParams: StripeTerminalCreateParams
}
export type RefreshTerminalV1Response = /** status 200 OK */ StripeTerminal
export type RefreshTerminalV1Args = {
  readerId: string
}
export type PushRatesV1Response = /** status 200 OK */ {
  [key: string]: boolean
}
export type PushRatesV1Args = {
  readerId: string
}
export type CancelReaderActionV1Response = /** status 200 OK */ {
  [key: string]: boolean
}
export type CancelReaderActionV1Args = {
  readerId: string
  merchantOrganizationId?: string
}
export type CreateConnectionTokenV1Response = /** status 200 OK */ {
  [key: string]: string
}
export type CreateConnectionTokenV1Args = {
  merchantOrganizationId?: string
}
export type CollectPaymentV1Response = /** status 200 OK */ CollectPayment
export type CollectPaymentV1Args = {
  collectPaymentParamsV1: CollectPaymentParamsV1
}
export type CancelPaymentV1Response = unknown
export type CancelPaymentV1Args = {
  cancelPaymentParamsV1: CancelPaymentParamsV1
}
export type SyncStripeLedgerResponse = /** status 200 Stripe ledger sync completed */ StripeLedgerSync
export type SyncStripeLedgerArgs = {
  stripeLedgerSyncParams: StripeLedgerSyncParams
}
export type ListTransactionRedrivesResponse =
  /** status 200 Transaction redrive requests returned */ PagedResponseTransactionRedriveRequestModel
export type ListTransactionRedrivesArgs = {
  /** Organization ID. Defaults to the caller's organization. */
  organizationId?: string
  /** Page number (0-based) */
  page?: number
  /** Page size (max 100) */
  size?: number
}
export type CreateTransactionRedriveResponse =
  /** status 201 Transaction redrive request queued */ TransactionRedriveRequestModel
export type CreateTransactionRedriveArgs = {
  createTransactionRedriveRequest: CreateTransactionRedriveRequest
}
export type RedriveReimbursementsResponse = /** status 200 Reimbursement redrive completed */ AuditResponseModel
export type RedriveReimbursementsArgs = {
  reimbursementRedriveRequest: ReimbursementRedriveRequest
}
export type CreatePublicCheckoutSessionResponse = /** status 200 OK */ CheckoutSession
export type CreatePublicCheckoutSessionArgs = {
  invoiceId: string
}
export type ListProductsResponse = /** status 200 Products retrieved successfully */ PagedResponseV2ProductResponseRead
export type ListProductsArgs = {
  page?: number
  size?: number
  /** Filter products by status */
  status?: 'ACTIVE' | 'ARCHIVED'
  /** Organization id; defaults to current org */
  organizationId?: string
  /** Filter by agreement id */
  agreementId?: string
  /** Filter products by visibility (e.g. PUBLIC for walk-up charging products) */
  visibility?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
}
export type CreateProductResponse = /** status 200 Product created successfully */ ProductResponseRead
export type CreateProductArgs = {
  createProductRequest: CreateProductRequest
}
export type UnarchiveProductResponse = /** status 200 Product unarchived successfully */ ProductResponseRead
export type UnarchiveProductArgs = {
  /** The ID of the product to unarchive */
  productId: string
}
export type ArchiveProductResponse = unknown
export type ArchiveProductArgs = {
  /** The ID of the product to archive */
  productId: string
}
export type RefundPaymentResponse = /** status 200 Refund issued */ Payment
export type RefundPaymentArgs = {
  /** Payment id (payment_*) */
  paymentId: string
  paymentRefundParams: PaymentRefundParams
}
export type CapturePaymentResponse = /** status 200 Payment captured */ Payment
export type CapturePaymentArgs = {
  /** Payment id (payment_*) */
  paymentId: string
  paymentCaptureParams: PaymentCaptureParams
}
export type CancelPaymentHoldResponse = /** status 200 Hold cancelled */ Payment
export type CancelPaymentHoldArgs = {
  /** Payment id (payment_*) */
  paymentId: string
  paymentCancelParams: PaymentCancelParams
}
export type BackfillPaymentCustomerNamesResponse =
  /** status 200 Customer display name backfill completed */ PaymentCustomerNameBackfill
export type BackfillPaymentCustomerNamesArgs = {
  paymentCustomerNameBackfillParams: PaymentCustomerNameBackfillParams
}
export type ListConnectionsResponse = /** status 200 OK */ PagedResponseV2OcpiConnection
export type ListConnectionsArgs = {
  page?: number
  size?: number
  includeUsage?: boolean
}
export type CreateConnectionResponse = /** status 200 OK */ OcpiConnection
export type CreateConnectionArgs = {
  ocpiConnectionCreateParams: OcpiConnectionCreateParams
}
export type CreateConnectionRequestResponse = /** status 200 OK */ MarketplaceSubscriptionRequest
export type CreateConnectionRequestArgs = {
  ocpiConnectionRequestCreateParams: OcpiConnectionRequestCreateParams
}
export type ListReservationsResponse = /** status 200 Reservations retrieved successfully */ ChargerEventCollection
export type ListReservationsArgs = {
  /** Filter by site ID */
  siteId?: string
  /** Filter by charger ID */
  chargerId?: string
  /** Filter by connector ID */
  connectorId?: string
  /** Filter by vehicle ID */
  vehicleId?: string
  /** Filter by auth tag */
  ocppTag?: string
  /** Filter by event type */
  eventType?: 'TIMED_CHARGE' | 'AD_HOC_CHARGE' | 'PREDICTED' | 'RESERVATION'
  /** Filter events starting before this time */
  startsBefore?: string
  /** Filter events starting after this time */
  startsAfter?: string
  /** Filter events ending before this time */
  endsBefore?: string
  /** Filter events ending after this time */
  endsAfter?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Sort order (ASC or DESC) */
  order?: string
}
export type CreateReservationResponse = /** status 200 Reservation created successfully */ ChargerEvent
export type CreateReservationArgs = {
  reservationCreateRequest: ReservationCreateRequest
}
export type CreateMyPayoutOnboardingLinkResponse = /** status 200 Onboarding link created */ ConnectedAccountLink
export type CreateMyPayoutOnboardingLinkArgs = {
  connectedAccountLinkCreateParams: ConnectedAccountLinkCreateParams
}
export type CreateHomeChargerResponse = /** status 201 Home charger onboarded */ ReimbursementUser
export type CreateHomeChargerArgs = {
  homeChargerCreateParams: HomeChargerCreateParams
}
export type ListChargingSchedulesResponse =
  /** status 200 Charging schedules retrieved successfully */ ChargerEventCollection
export type ListChargingSchedulesArgs = {
  /** Filter events starting before this time */
  startsBefore?: string
  /** Filter events starting after this time */
  startsAfter?: string
  /** Filter events ending before this time */
  endsBefore?: string
  /** Filter events ending after this time */
  endsAfter?: string
  /** Page number (0-indexed) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Sort order (ASC or DESC) */
  order?: string
}
export type CreateChargingScheduleResponse = /** status 200 Charging schedule created successfully */ ChargerEvent
export type CreateChargingScheduleArgs = {
  chargingScheduleCreateParams: ChargingScheduleCreateParams
}
export type ListMeters1Response = /** status 200 Successfully fetched meters */ PagedResponseV2Meter
export type ListMeters1Args = {
  /** Page number (0-based) */
  page?: number
  /** Page size */
  size?: number
  /** Expand related resources (e.g., 'attachments') */
  expand?: string
  assetId: string
  assetType: 'FLEET' | 'SITE' | 'VEHICLE' | 'CHARGER' | 'CONNECTOR' | 'SERVICE' | 'EQUIPMENT'
}
export type CreateMeterResponse = /** status 200 Successfully created meter */ Meter
export type CreateMeterArgs = {
  meterCreateParams: MeterCreateParams
}
export type DenyResponse = /** status 200 OK */ MarketplaceSubscriptionRequest
export type DenyArgs = {
  id: string
  marketplaceSubscriptionRequestDenyParams: MarketplaceSubscriptionRequestDenyParams
}
export type CancelResponse = /** status 200 OK */ MarketplaceSubscriptionRequest
export type CancelArgs = {
  id: string
}
export type ApproveResponse = /** status 200 OK */ MarketplaceSubscriptionRequestApprovalResult
export type ApproveArgs = {
  id: string
  marketplaceSubscriptionRequestApproveParams: MarketplaceSubscriptionRequestApproveParams
}
export type GetOfferingsResponse = /** status 200 OK */ PagedResponseV2MarketplaceOfferingRead
export type GetOfferingsArgs = {
  browse?: boolean
  accessCode?: string
  page?: number
  size?: number
}
export type CreateOfferingResponse = /** status 200 OK */ MarketplaceOfferingRead
export type CreateOfferingArgs = {
  marketplaceOfferingCreateParams: MarketplaceOfferingCreateParams
}
export type CreateSubscriptionRequestResponse = /** status 200 OK */ MarketplaceSubscriptionRequest
export type CreateSubscriptionRequestArgs = {
  id: string
  marketplaceSubscriptionRequestCreateParams: MarketplaceSubscriptionRequestCreateParams
}
export type SubscribeToOfferingResponse = /** status 200 OK */ AgreementResponse
export type SubscribeToOfferingArgs = {
  id: string
  subscribeToOfferingParams: SubscribeToOfferingParams
}
export type RegenerateAccessCodeResponse = /** status 200 OK */ RegeneratedAccessCode
export type RegenerateAccessCodeArgs = {
  id: string
}
export type RedeemAccessCodeResponse = /** status 200 OK */ MarketplaceOfferingRead
export type RedeemAccessCodeArgs = {
  redeemAccessCodeParams: RedeemAccessCodeParams
}
export type CreatePaymentSetupSessionResponse =
  /** status 200 Checkout session created */ MarketplacePaymentSetupSession
export type CreatePaymentSetupSessionArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
  marketplacePaymentSetupSessionParams: MarketplacePaymentSetupSessionParams
}
export type ListInvoicesResponse = /** status 200 Invoices retrieved successfully */ PagedResponseV2SynopInvoice
export type ListInvoicesArgs = {
  /** Organization to fetch invoices for; defaults to the authenticated org */
  organizationId?: string
  /** SENT (we issued) or RECEIVED (we are billed) */
  requestType?: 'SENT' | 'RECEIVED'
  /** Filter by payor id */
  payorId?: string
  /** Filter by agreement id */
  agreementId?: string
  /** Filter by payor account type (INDIVIDUAL or ORGANIZATION) */
  payorType?: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Filter by merchant-facing payor segment: ORGANIZATION, DRIVER, PUBLIC_GUEST, or PUBLIC_UNKNOWN */
  payorSegment?: 'ORGANIZATION' | 'DRIVER' | 'PUBLIC_GUEST' | 'PUBLIC_UNKNOWN'
  /** Filter invoices that include line items with this product type */
  productType?: string
  /** Case-insensitive search on public-charging guest email metadata */
  payorEmail?: string
  /** Filter by Stripe connected account id stamped on the invoice */
  connectedAccountId?: string
  /** Filter invoices with line items for this vehicle id */
  vehicleId?: string
  /** Filter invoices with line items matching this auth tag */
  authTag?: string
  /** Filter invoices with line items whose payor id matches (e.g. driver user id) */
  lineItemPayorId?: string
  /** Filter by economic payor org (direct bill or org-sponsored individuals). Caller must be authorized for this org. */
  payorOrgId?: string
  /** Filter by one or more statuses */
  status?: (
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  )[]
  /** Zero-based page index */
  page?: number
  /** Number of records per page (max 100) */
  size?: number
  /** Start of the date range (inclusive); applies to the field named by dateField */
  from?: string
  /** End of the date range (inclusive); applies to the field named by dateField */
  to?: string
  /** Which invoice timestamp the from/to range filters on: CREATED (default), PERIOD (billing period start), FINALIZED, PAID, or DUE. */
  dateField?: 'CREATED' | 'PERIOD' | 'FINALIZED' | 'PAID' | 'DUE'
  /** Sort property (camelCase), optionally prefixed with '-' for descending -- e.g. sort=-createdAt. Allowed: createdAt, dueDate, status, total, amountPaid, amountDue, periodStart, finalizedAt, paidAt, payorName. Omit for the default -createdAt. Results always break ties on the invoice's internal id in the same direction, so paging is stable when the sorted values are equal. Nullable columns follow MySQL placement: nulls sort first ascending and last descending. The exception is payorName: invoices with no payor name (null or blank) always sort after the named ones in either direction, newest first, and invoices sharing a payor name are also ordered newest first. */
  sort?: string
  /** Expand sub-resources (repeatable): data.lineItems, data.lineItems.rateDetails, data.taxSummary. Unknown paths return 400. */
  expand?: string[]
}
export type CreateInvoiceResponse = /** status 200 OK */ SynopInvoice
export type CreateInvoiceArgs = {
  organizationId?: string
  synopInvoiceCreateParams: SynopInvoiceCreateParams
}
export type VoidInvoiceResponse = /** status 200 OK */ SynopInvoice
export type VoidInvoiceArgs = {
  invoiceId: string
  organizationId?: string
}
export type SendInvoiceResponse = /** status 200 OK */ SynopInvoice
export type SendInvoiceArgs = {
  invoiceId: string
  organizationId?: string
}
export type ReleaseInvoiceResponse = unknown
export type ReleaseInvoiceArgs = {
  invoiceId: string
  organizationId?: string
  /** Issue the invoice even when the readiness check finds a blocking problem */
  force?: boolean
}
export type MarkPaidResponse = /** status 200 OK */ SynopInvoice
export type MarkPaidArgs = {
  invoiceId: string
  organizationId?: string
  markPaidRequest: MarkPaidRequest
}
export type AddLineItemResponse = /** status 200 OK */ SynopInvoiceLineItem
export type AddLineItemArgs = {
  invoiceId: string
  organizationId?: string
  lineItemCreateParams: LineItemCreateParams
}
export type FinalizeInvoiceResponse = /** status 200 OK */ SynopInvoice
export type FinalizeInvoiceArgs = {
  invoiceId: string
  organizationId?: string
}
export type GetDraftInvoiceArtifactsResponse = /** status 200 Draft artifact links retrieved */ InvoiceArtifacts
export type GetDraftInvoiceArtifactsArgs = {
  /** Synop invoice id (invoice_*) */
  invoiceId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type GenerateDraftInvoiceArtifactsResponse = unknown
export type GenerateDraftInvoiceArtifactsArgs = {
  /** Synop invoice id (invoice_*) */
  invoiceId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type CreateCheckoutSessionResponse = /** status 200 Checkout Session URL and expiry */ CheckoutSession
export type CreateCheckoutSessionArgs = {
  invoiceId: string
  organizationId?: string
}
export type BackfillInvoiceWalletAppliedResponse =
  /** status 200 Wallet-applied backfill completed */ InvoiceWalletAppliedBackfill
export type BackfillInvoiceWalletAppliedArgs = {
  invoiceWalletAppliedBackfillParams: InvoiceWalletAppliedBackfillParams
}
export type ListTemplatesResponse = /** status 200 Templates retrieved */ PagedResponseInvoiceTemplateModel
export type ListTemplatesArgs = {
  organizationId?: string
  /** Filter by lifecycle status */
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  page?: number
  size?: number
}
export type CreateTemplateResponse = /** status 200 Template created */ InvoiceTemplateModel
export type CreateTemplateArgs = {
  organizationId?: string
  invoiceTemplateCreateParams: InvoiceTemplateCreateParams
}
export type PreviewTemplateResponse = unknown
export type PreviewTemplateArgs = {
  templateId: string
  sampleInvoiceId?: string
  organizationId?: string
}
export type ArchiveTemplateResponse = /** status 200 Template archived */ InvoiceTemplateModel
export type ArchiveTemplateArgs = {
  templateId: string
  organizationId?: string
}
export type BackfillInvoicesResponse = /** status 200 Invoice backfill completed */ InvoiceBackfill
export type BackfillInvoicesArgs = {
  invoiceBackfillParams: InvoiceBackfillParams
}
export type CreateArtifactAccessKeyResponse =
  /** status 201 Key created; the secret is in this response only */ ArtifactAccessKeyCreated
export type CreateArtifactAccessKeyArgs = void
export type DecommissionResponse = /** status 200 OK */ DecommissionReport
export type DecommissionArgs = {
  decommissionRequest: DecommissionRequest
}
export type BackfillResponse = /** status 200 OK */ MigrationReport
export type BackfillArgs = {
  migrationRequest: MigrationRequest
}
export type CreateCheckoutSession1Response = /** status 200 Checkout session created */ StripeRedirectModel
export type CreateCheckoutSession1Args = {
  hardwareCheckoutSessionParams: HardwareCheckoutSessionParams
}
export type BackfillCustomersResponse = /** status 200 OK */ {
  [key: string]: number
}
export type BackfillCustomersArgs = {
  'X-Organization-Id': string
}
export type BackfillAddressesResponse = /** status 200 OK */ {
  [key: string]: number
}
export type BackfillAddressesArgs = {
  'X-Organization-Id': string
}
export type ListConnectedAccountsV1Response = /** status 200 OK */ ConnectedAccountRead[]
export type ListConnectedAccountsV1Args = void
export type CreateConnectedAccountV1Response = /** status 200 OK */ ConnectedAccountRead
export type CreateConnectedAccountV1Args = {
  connectedAccountCreateParams: ConnectedAccountCreateParams
}
export type ShareConnectedAccountWithOrganizationV1Response = /** status 200 OK */ ConnectedAccountRead
export type ShareConnectedAccountWithOrganizationV1Args = {
  /** Connected account id (account_xxx, legacy acc_xxx, or Stripe acct_xxx) owned by the current organization */
  accountId: string
  connectedAccountOrganizationLinkParams: ConnectedAccountOrganizationLinkParams
}
export type CreateLoginLinkV1Response = /** status 200 OK */ ConnectedAccountLink
export type CreateLoginLinkV1Args = {
  /** Connected account id (account_xxx) */
  accountId: string
  connectedAccountLinkCreateParams: ConnectedAccountLinkCreateParams
}
export type CreateAccountLinkV1Response = /** status 200 OK */ ConnectedAccountLink
export type CreateAccountLinkV1Args = {
  /** Connected account id (account_xxx) */
  accountId: string
  connectedAccountLinkCreateParams: ConnectedAccountLinkCreateParams
}
export type SyncConnectedAccountTypesResponse =
  /** status 200 Connected account type sync completed */ ConnectedAccountTypeSync
export type SyncConnectedAccountTypesArgs = {
  connectedAccountTypeSyncParams: ConnectedAccountTypeSyncParams
}
export type ListRegistrations1Response = /** status 200 OK */ TaxRegistration[]
export type ListRegistrations1Args = {
  'X-Organization-Id': string
  accountId: string
}
export type CreateRegistration1Response = /** status 200 OK */ TaxRegistration
export type CreateRegistration1Args = {
  'X-Organization-Id': string
  accountId: string
  taxRegistrationCreateParams: TaxRegistrationCreateParams
}
export type CloseReimbursementsResponse = /** status 200 Reimbursement close completed */ ReimbursementCloseResult
export type CloseReimbursementsArgs = {
  reimbursementRedriveRequest: ReimbursementRedriveRequest
}
export type BackfillChargeReceiptNumbersResponse =
  /** status 200 Receipt number backfill completed */ ChargeReceiptNumberBackfill
export type BackfillChargeReceiptNumbersArgs = {
  chargeReceiptNumberBackfillParams: ChargeReceiptNumberBackfillParams
}
export type CreateBillingConfigurationResponse = /** status 200 OK */ BillingConfiguration
export type CreateBillingConfigurationArgs = {
  billingConfigurationCreateParams: BillingConfigurationCreateParams
}
export type CreateRevenueShareRuleResponse = /** status 200 OK */ BillingRevenueShareRule
export type CreateRevenueShareRuleArgs = {
  configurationId: string
  billingRevenueShareRuleCreateParams: BillingRevenueShareRuleCreateParams
}
export type BackfillBalanceTransactionsResponse = /** status 200 OK */ {
  [key: string]: number
}
export type BackfillBalanceTransactionsArgs = {
  'X-Organization-Id': string
  /** Created-at lower bound (ISO date-time, UTC) */
  from?: string
  /** Created-at upper bound (ISO date-time, UTC) */
  to?: string
}
export type IngestUsageV1Response = /** status 200 OK */ AssistantUsageIngestResult
export type IngestUsageV1Args = {
  assistantUsageIngestRequest: AssistantUsageIngestRequest
}
export type TopUpV1Response = /** status 200 OK */ AssistantTopUpResult
export type TopUpV1Args = {
  assistantTopUpRequest: AssistantTopUpRequest
}
export type RefreshGrantsV1Response = /** status 200 OK */ number
export type RefreshGrantsV1Args = void
export type UpsertConfigV1Response = /** status 200 OK */ AssistantBillingConfig
export type UpsertConfigV1Args = {
  assistantBillingConfigRequest: AssistantBillingConfigRequest
}
export type GetAgreementsResponse = /** status 200 Agreements retrieved successfully */ PagedResponseV2AgreementResponse
export type GetAgreementsArgs = {
  payorId?: string
  payeeId?: string
  entityType?:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  entityId?: string
  page?: number
  size?: number
  includeArchived?: boolean
  includeInactive?: boolean
  /** Return only what is in effect: ACTIVE agreements dated live at asOf, with only their active, currently-effective assignments of ACTIVE products. Stricter than includeArchived=false, which admits DRAFT. Defaults asOf to now when omitted. An ARCHIVED product is out of effect and is never returned. */
  inEffect?: boolean
  /** Evaluate the agreement dates and assignment windows at this instant, as a half-open [effectiveFrom, effectiveTo) window. Optional: omit it and billing dates the read on its own clock — the clock that wrote effectiveTo, so no skew between the two can report a just-ended assignment as still in effect. Supply one only for a genuine historical read. The instant actually used is pinned into every Link header, so a traversal replays it without knowing it in advance. Interpreted as UTC, with or without a trailing Z, to any precision up to nanoseconds. A non-UTC offset is NOT honoured — its wall-clock fields are read as UTC — so send UTC. */
  asOf?: string
  /** Expand sub-resources (repeatable): data.products, data.products.authorizedEntities, data.products.entitySelections, data.discounts, data.commitments. Unknown paths return 400. */
  expand?: string[]
}
export type CreateAgreementResponse = /** status 200 Agreement created successfully */ AgreementResponse
export type CreateAgreementArgs = {
  agreementCreateParams: AgreementCreateParams
}
export type UnarchiveAgreementResponse = /** status 200 Agreement unarchived successfully */ AgreementResponse
export type UnarchiveAgreementArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
}
export type AcknowledgeReconciliationExceptionResponse =
  /** status 200 Exception acknowledged */ ReconciliationException
export type AcknowledgeReconciliationExceptionArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
  /** Deterministic reconciliation exception id */
  exceptionId: string
}
export type GetAgreementProductsResponse = /** status 200 Products retrieved successfully */ AgreementProductResponse[]
export type GetAgreementProductsArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
}
export type AddAgreementProductResponse = /** status 200 Product added successfully */ AgreementProductResponse
export type AddAgreementProductArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  addAgreementProductRequest: AddAgreementProductRequest
}
export type GetAuthorizedEntitiesResponse =
  /** status 200 Authorized entities retrieved successfully */ AgreementAuthorizedEntityResponse[]
export type GetAuthorizedEntitiesArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  /** Product ID (UUID or human-readable format like prod_abc123) */
  productId: string
}
export type AddAuthorizedEntityResponse = unknown
export type AddAuthorizedEntityArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  /** Product ID (UUID or human-readable format like prod_abc123) */
  productId: string
  addAgreementAuthorizedEntityRequest: AddAgreementAuthorizedEntityRequest
}
export type ArchiveAgreementResponse = unknown
export type ArchiveAgreementArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
}
export type UpdateWorkplaceChargingRecordStatusesResponse = /** status 200 OK */ UpdateWorkplaceChargingRecordStatus
export type UpdateWorkplaceChargingRecordStatusesArgs = {
  organizationId?: string
  updateWorkplaceChargingRecordStatus: UpdateWorkplaceChargingRecordStatus
}
export type GetReimbursementUsersResponse = /** status 200 Reimbursement users retrieved. */ ReimbursementUserResponse[]
export type GetReimbursementUsersArgs = {
  organizationId?: string
}
export type SaveReimbursementUserResponse = /** status 200 Reimbursement configured. */ ReimbursementUser
export type SaveReimbursementUserArgs = {
  reimbursementUserUpsertParams: ReimbursementUserUpsertParams
}
export type GetReimbursementConfigurationResponse =
  /** status 200 Reimbursement configured. */ ReimbursementConfiguration
export type GetReimbursementConfigurationArgs = {
  organizationId?: string
}
export type SaveReimbursementConfigurationResponse =
  /** status 200 Reimbursement configured. */ ReimbursementConfiguration
export type SaveReimbursementConfigurationArgs = {
  reimbursementConfiguration: ReimbursementConfiguration
}
export type OnboardOrganizationToStripeResponse = /** status 200 OK */ StripeRedirectModel
export type OnboardOrganizationToStripeArgs = {
  id: string
  urlRedirectModel: UrlRedirectModel
}
export type StopSessionResponse = /** status 200 OK */ StopTransactionResponse
export type StopSessionArgs = {
  stopTransactionRequest: StopTransactionRequest
}
export type StartSessionResponse = /** status 200 OK */ StartSessionResult
export type StartSessionArgs = {
  startSessionRequest: StartSessionRequest
}
export type GetInvoicesResponse = /** status 200 OK */ PagedResponseInvoiceModel
export type GetInvoicesArgs = {
  page?: number
  count?: number
  status?: (
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  )[]
  organizationId?: string
  requestType?: 'SENT' | 'RECEIVED'
}
export type CreateInvoice1Response = /** status 200 OK */ CreateInvoiceModel
export type CreateInvoice1Args = {
  createInvoiceModel: CreateInvoiceModel
}
export type VoidInvoice1Response = /** status 200 OK */ boolean
export type VoidInvoice1Args = {
  invoiceId: string
  invoiceOperationRequest: InvoiceOperationRequest
}
export type SendInvoice1Response = /** status 200 OK */ boolean
export type SendInvoice1Args = {
  invoiceId: string
  invoiceOperationRequest: InvoiceOperationRequest
}
export type MarkInvoicePaidResponse = /** status 200 OK */ boolean
export type MarkInvoicePaidArgs = {
  invoiceId: string
  invoiceOperationRequest: InvoiceOperationRequest
}
export type EnrichLineItemsResponse = /** status 200 OK */ EnrichLineItems
export type EnrichLineItemsArgs = {
  /** Usage-end start (ISO 8601). Defaults to 30 days ago. */
  from?: string
  /** Usage-end end (ISO 8601). Defaults to now. */
  to?: string
}
export type EnrichLineItemsByPayoutResponse = /** status 200 OK */ EnrichLineItems
export type EnrichLineItemsByPayoutArgs = {
  /** Organization ID (payee/connected account owner) */
  organizationId: string
  /** Stripe payout ID (e.g. po_...) */
  payoutId: string
  /** Create missing line items for unmatched payout charges. */
  createMissingLineItems?: boolean
}
export type BulkUpdateReimbursementUsersResponse =
  /** status 200 User rate configurations updated. */ BulkReimbursementConfiguration
export type BulkUpdateReimbursementUsersArgs = {
  bulkReimbursementConfiguration: BulkReimbursementConfiguration
}
export type AuthorizePublicSessionResponse = /** status 200 OK */ StripeIntentModel
export type AuthorizePublicSessionArgs = {
  authorizePublicSessionRequest: AuthorizePublicSessionRequest
}
export type GetSettingsResponse = /** status 200 OK */ MerchantTaxSettings
export type GetSettingsArgs = {
  'X-Organization-Id': string
}
export type PatchSettingsResponse = /** status 200 OK */ MerchantTaxSettings
export type PatchSettingsArgs = {
  'X-Organization-Id': string
  merchantTaxSettingsPatchParams: MerchantTaxSettingsPatchParams
}
export type DeleteTaxApplicationResponse = unknown
export type DeleteTaxApplicationArgs = {
  'X-Organization-Id': string
  id: number
}
export type UpdateTaxApplicationResponse = /** status 200 OK */ TaxApplication
export type UpdateTaxApplicationArgs = {
  'X-Organization-Id': string
  id: number
  taxApplicationUpdateParams: TaxApplicationUpdateParams
}
export type GetTerminalV1Response = /** status 200 OK */ StripeTerminal
export type GetTerminalV1Args = {
  readerId: string
  expand?: string[]
}
export type DeleteTerminalV1Response = unknown
export type DeleteTerminalV1Args = {
  readerId: string
}
export type AssignTerminalV1Response = /** status 200 OK */ StripeTerminal
export type AssignTerminalV1Args = {
  readerId: string
  stripeTerminalUpdateParams: StripeTerminalUpdateParams
}
export type UpdateMyGridEnrollmentResponse = /** status 200 Grid enrollment updated */ ReimbursementUserResponse
export type UpdateMyGridEnrollmentArgs = {
  gridEnrollmentUpdateParams: GridEnrollmentUpdateParams
}
export type GetRequirementsResponse = /** status 200 OK */ OrganizationMetadataRequirements
export type GetRequirementsArgs = {
  'X-Organization-Id': string
}
export type PatchRequirementsResponse = /** status 200 OK */ OrganizationMetadataRequirements
export type PatchRequirementsArgs = {
  'X-Organization-Id': string
  organizationMetadataRequirementsPatchParams: OrganizationMetadataRequirementsPatchParams
}
export type GetTemplateResponse = /** status 200 Template retrieved */ InvoiceTemplateModel
export type GetTemplateArgs = {
  templateId: string
  organizationId?: string
}
export type UpdateTemplateResponse = /** status 200 Template updated */ InvoiceTemplateModel
export type UpdateTemplateArgs = {
  templateId: string
  organizationId?: string
  invoiceTemplateUpdateParams: InvoiceTemplateUpdateParams
}
export type DeleteArtifactAccessKeyResponse = unknown
export type DeleteArtifactAccessKeyArgs = {
  /** AWS access key id */
  accessKeyId: string
}
export type UpdateArtifactAccessKeyResponse = /** status 200 Updated key */ ArtifactAccessKey
export type UpdateArtifactAccessKeyArgs = {
  /** AWS access key id */
  accessKeyId: string
  artifactAccessKeyUpdateParams: ArtifactAccessKeyUpdateParams
}
export type GetCustomerResponse = /** status 200 OK */ Customer
export type GetCustomerArgs = {
  'X-Organization-Id': string
  id: string
}
export type UpdateCustomerResponse = /** status 200 OK */ Customer
export type UpdateCustomerArgs = {
  'X-Organization-Id': string
  id: string
  customerUpdateParams: CustomerUpdateParams
}
export type UpdateConnectedAccountV1Response = /** status 200 OK */ ConnectedAccountRead
export type UpdateConnectedAccountV1Args = {
  /** Connected account id (account_xxx) */
  accountId: string
  connectedAccountUpdateParams: ConnectedAccountUpdateParams
}
export type SetDefaultConnectedAccountV1Response = /** status 200 OK */ ConnectedAccountRead
export type SetDefaultConnectedAccountV1Args = {
  /** Connected account id (account_xxx) */
  accountId: string
}
export type GetSyncResponse = /** status 200 OK */ ConnectedAccountTaxSync
export type GetSyncArgs = {
  'X-Organization-Id': string
  /** Connected account id (account_*) */
  accountId: string
}
export type PatchSyncResponse = /** status 200 OK */ ConnectedAccountTaxSync
export type PatchSyncArgs = {
  'X-Organization-Id': string
  /** Connected account id (account_*) */
  accountId: string
  connectedAccountTaxSyncPatchParams: ConnectedAccountTaxSyncPatchParams
}
export type GetBillingConfigurationResponse = /** status 200 OK */ BillingConfiguration
export type GetBillingConfigurationArgs = {
  /** Configuration ID */
  configurationId: string
}
export type UpdateBillingConfigurationResponse = /** status 200 OK */ BillingConfiguration
export type UpdateBillingConfigurationArgs = {
  configurationId: string
  billingConfigurationUpdateParams: BillingConfigurationUpdateParams
}
export type UpdateRevenueShareRuleResponse = /** status 200 OK */ BillingRevenueShareRule
export type UpdateRevenueShareRuleArgs = {
  configurationId: string
  ruleId: string
  billingRevenueShareRuleUpdateParams: BillingRevenueShareRuleUpdateParams
}
export type RemoveAgreementProductResponse = unknown
export type RemoveAgreementProductArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  /** Product ID (UUID or human-readable format like prod_abc123) */
  productId: string
}
export type UpdateAgreementProductResponse =
  /** status 200 Product assignment updated successfully */ AgreementProductResponse
export type UpdateAgreementProductArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  /** Product ID (UUID or human-readable format like prod_abc123) */
  productId: string
  updateAgreementProductRequest: UpdateAgreementProductRequest
}
export type GetWorkplaceSummaryResponse =
  /** status 200 Workplace Charging summary retrieved. */ WorkplaceChargingSummaryModel
export type GetWorkplaceSummaryArgs = {
  billingMonth?: string
  organizationId?: string
}
export type GetWorkplaceChargingRecordsResponse = /** status 200 OK */ WorkplaceChargingModel[]
export type GetWorkplaceChargingRecordsArgs = {
  from: string
  to: string
  organizationId?: string
}
export type ListWalletTransactionsV1Response = /** status 200 OK */ WalletTransactionEntry[]
export type ListWalletTransactionsV1Args = {
  /** Agreement id (ag_*) */
  agreementId: string
}
export type GetWalletBalanceV1Response = /** status 200 OK */ WalletBalanceSummary
export type GetWalletBalanceV1Args = {
  /** Agreement id (ag_*) */
  agreementId: string
}
export type ValidatePublicChargerResponse = /** status 200 OK */ TwilioChargerValidationResponse
export type ValidatePublicChargerArgs = {
  evseId: string
  connectorName: string
}
export type GetTimeOfUseRateResponse = /** status 200 Rate found */ BillableTimeOfUseRateRead
export type GetTimeOfUseRateArgs = {
  /** The rate's public id (rate_...) */
  timeOfUseRateId: string
}
export type ListTaxCodesResponse = /** status 200 OK */ StripeTaxCode[]
export type ListTaxCodesArgs = {
  /** Case-insensitive substring filter applied to id, name, and description */
  query?: string
  /** Maximum number of matches to return (default 50, 0 for all) */
  limit?: number
}
export type GetReaderMetadataV1Response = /** status 200 OK */ ReaderMetadata
export type GetReaderMetadataV1Args = {
  readerId: string
  merchantOrganizationId?: string
}
export type GetPaymentStatusV1Response = /** status 200 OK */ PaymentStatus
export type GetPaymentStatusV1Args = {
  paymentIntentId: string
  /** Organization that owns the PaymentIntent (from collect-payment response) */
  merchantOrganizationId?: string
}
export type ListStartAttemptsResponse = /** status 200 OK */ PagedResponseStartAttempt
export type ListStartAttemptsArgs = {
  organizationId?: string
  /** Zero-based page index. */
  page?: string
  /** Page size. */
  size?: string
  /** Optional filter by outcome (e.g. NEVER_MATERIALIZED for failed starts). */
  outcome?: string
  /** Optional filter by who initiated the start. */
  identityType?: string
  /** Optional filter by site / depot id. */
  siteId?: string
  /** Optional filter by charger id. */
  chargerId?: string
  /** Optional inclusive lower bound on the request time (ISO-8601). */
  from?: string
  /** Optional exclusive upper bound on the request time (ISO-8601). */
  to?: string
}
export type StartAttemptTimeseriesResponse = /** status 200 OK */ StartAttemptTimeseries
export type StartAttemptTimeseriesArgs = {
  organizationId?: string
  /** Optional filter by outcome (e.g. NEVER_MATERIALIZED for failed starts). */
  outcome?: string
  /** Optional filter by who initiated the start. */
  identityType?: string
  /** Optional filter by site / depot id. */
  siteId?: string
  /** Optional filter by charger id. */
  chargerId?: string
  /** Optional inclusive lower bound on the request time (ISO-8601). */
  from?: string
  /** Optional exclusive upper bound on the request time (ISO-8601). */
  to?: string
  /** Time-series bucket width. Ignored by the summary endpoint. */
  granularity?: string
  /** IANA time zone used to align time-series bucket boundaries (e.g. America/New_York). Defaults to UTC. */
  timezone?: string
}
export type SummarizeStartAttemptsResponse = /** status 200 OK */ StartAttemptSummary
export type SummarizeStartAttemptsArgs = {
  organizationId?: string
  /** Optional filter by outcome (e.g. NEVER_MATERIALIZED for failed starts). */
  outcome?: string
  /** Optional filter by who initiated the start. */
  identityType?: string
  /** Optional filter by site / depot id. */
  siteId?: string
  /** Optional filter by charger id. */
  chargerId?: string
  /** Optional inclusive lower bound on the request time (ISO-8601). */
  from?: string
  /** Optional exclusive upper bound on the request time (ISO-8601). */
  to?: string
  /** Time-series bucket width. Ignored by the summary endpoint. */
  granularity?: string
  /** IANA time zone used to align time-series bucket boundaries (e.g. America/New_York). Defaults to UTC. */
  timezone?: string
}
export type GetTimelineResponse = /** status 200 Timeline retrieved */ SettlementTimeline
export type GetTimelineArgs = {
  /** Charging transaction id */
  transactionId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type GetTransactionRedriveResponse =
  /** status 200 Transaction redrive request returned */ TransactionRedriveRequestModel
export type GetTransactionRedriveArgs = {
  requestId: string
}
export type GetReceiptResponse = /** status 200 OK */ PublicReceiptDto
export type GetReceiptArgs = {
  transactionId: string
}
export type GetMeterValuesResponse = /** status 200 OK */ PublicReceiptMeterValueDto[]
export type GetMeterValuesArgs = {
  transactionId: string
}
export type DownloadMeterValuesResponse = unknown
export type DownloadMeterValuesArgs = {
  transactionId: string
}
export type GetPublicInvoiceResponse = /** status 200 OK */ PublicInvoice
export type GetPublicInvoiceArgs = {
  invoiceId: string
}
export type DownloadPublicInvoicePdfResponse = unknown
export type DownloadPublicInvoicePdfArgs = {
  invoiceId: string
}
export type GetPublicInvoiceArtifactsResponse = /** status 200 OK */ InvoiceArtifacts
export type GetPublicInvoiceArtifactsArgs = {
  invoiceId: string
}
export type DownloadPublicInvoiceArchiveResponse = unknown
export type DownloadPublicInvoiceArchiveArgs = {
  invoiceId: string
}
export type GetActiveAgreementsUsingProductResponse =
  /** status 200 Blocking agreements, empty when the product can be retired */ BlockingAgreementResponse[]
export type GetActiveAgreementsUsingProductArgs = {
  /** The ID of the product */
  productId: string
}
export type ListPaymentsResponse = /** status 200 Payments retrieved */ PagedResponseV2Payment
export type ListPaymentsArgs = {
  /** Organization id; defaults to authenticated org */
  organizationId?: string
  /** Filter by provider status (succeeded, canceled, …) or Synop outcome (SUCCEEDED, PENDING, CANCELLED, FAILED, BLOCKED). Comma-separated values are OR'd. */
  status?: string
  /** Filter by Synop customer id (customer_*) or billed-to payor id */
  customerId?: string
  /** Created-at range start (inclusive) */
  from?: string
  /** Created-at range end (inclusive) */
  to?: string
  /** Sort property (camelCase), optionally prefixed with '-' for descending -- e.g. sort=-created. Allowed: created, customerName, displayAmount. Omit for the default -created. Results always break ties on the payment's internal id in the same direction, so paging is stable when the sorted values are equal (Stripe timestamps are whole seconds, so ties are common). Nullable columns follow MySQL placement: nulls sort first ascending and last descending. The exception is customerName: payments with no customer name (null or blank) always sort after the named ones in either direction, newest first, and payments sharing a name are also ordered newest first. */
  sort?: string
  /** Zero-based page index */
  page?: number
  /** Page size (max 100) */
  size?: number
  /** Omit cancelled zero-capture payment intents (default true) */
  excludeCancelled?: boolean
}
export type GetPaymentResponse = /** status 200 Payment retrieved */ Payment
export type GetPaymentArgs = {
  /** Payment id (payment_*) */
  paymentId: string
}
export type ListBillingConfigurationsResponse = /** status 200 OK */ BillingConfiguration[]
export type ListBillingConfigurationsArgs = {
  /** Administered (child) organization ID */
  organizationId: string
}
export type ListLocationsResponse = /** status 200 OK */ MarketplaceLocation[]
export type ListLocationsArgs = void
export type GetConnectionResponse = /** status 200 OK */ OcpiConnection
export type GetConnectionArgs = {
  id: string
}
export type GetRequestLogsResponse = /** status 200 OK */ PagedResponseV2OcpiRequestLogEntry
export type GetRequestLogsArgs = {
  id: string
  page?: number
  size?: number
}
export type GetRequestLogResponse = /** status 200 OK */ OcpiRequestLogEntry
export type GetRequestLogArgs = {
  id: string
  requestId: string
}
export type GetUsageSummaryResponse = /** status 200 OK */ OcpiConnectionUsageSummary
export type GetUsageSummaryArgs = {
  id: string
  from?: string
  to?: string
}
export type GetSessionsResponse = /** status 200 OK */ AgreementOcpiRecord[]
export type GetSessionsArgs = {
  id: string
  from?: string
  to?: string
  offset?: number
  limit?: number
}
export type GetCdrsResponse = /** status 200 OK */ AgreementOcpiRecord[]
export type GetCdrsArgs = {
  id: string
  from?: string
  to?: string
  offset?: number
  limit?: number
}
export type ListJoinableConnectionsResponse = /** status 200 OK */ PagedResponseV2OcpiJoinableConnection
export type ListJoinableConnectionsArgs = void
export type GetMyReimbursementUsersResponse =
  /** status 200 Reimbursement users retrieved */ ReimbursementUserResponse[]
export type GetMyReimbursementUsersArgs = void
export type GetMyPayoutAccountStatusResponse =
  /** status 200 Payout account status retrieved */ DriverPayoutAccountStatusModel
export type GetMyPayoutAccountStatusArgs = void
export type GetMyLineItemsResponse = /** status 200 Line items retrieved */ PagedResponseSynopLineItem
export type GetMyLineItemsArgs = {
  /** Filter by product type, e.g. HOME_CHARGING or PUBLIC_CHARGING */
  productType?: string
  /** Usage-end start (ISO 8601) */
  from?: string
  /** Usage-end end (ISO 8601) */
  to?: string
  /** Page number for pagination (default is 0) */
  page?: number
  /** Page size for pagination (default is 20, max is 200) */
  size?: number
}
export type ListRequestsResponse = /** status 200 OK */ PagedResponseV2MarketplaceSubscriptionRequest
export type ListRequestsArgs = {
  direction?: string
  status?: 'PENDING' | 'APPROVED' | 'DENIED' | 'CANCELLED' | 'EXPIRED'
  requestType?: 'SUBSCRIPTION' | 'CONNECTION'
  page?: number
  size?: number
}
export type GetFeePreviewResponse = /** status 200 OK */ MarketplaceFeePreview
export type GetFeePreviewArgs = {
  id: string
}
export type GetMapSitesResponse = /** status 200 Map sites retrieved */ MarketplaceMapSiteRead[]
export type GetMapSitesArgs = {
  /** Only sites covered by the caller's live agreements */
  coveredOnly?: boolean
  /** Only sites the caller is not yet covered for */
  availableToSignup?: boolean
  /** Connector standard, e.g. CCS, CHAdeMO, J1772, NACS or an OCPI value */
  connectorStandard?: string
  /** Minimum site max power, in kW */
  minPowerKw?: number
  /** Maximum site max power, in kW */
  maxPowerKw?: number
  /** Viewport south-west latitude */
  minLat?: number
  /** Viewport south-west longitude */
  minLng?: number
  /** Viewport north-east latitude */
  maxLat?: number
  /** Viewport north-east longitude */
  maxLng?: number
  /** Also return sites without usable coordinates (for list views) */
  includeMissingCoordinates?: boolean
  /** Heavy fields to include: pricing, presentation */
  expand?: string[]
}
export type GetBillingStatusResponse = /** status 200 Billing status retrieved */ MarketplaceAgreementBillingStatus
export type GetBillingStatusArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
}
export type DownloadInvoicePdfResponse = unknown
export type DownloadInvoicePdfArgs = {
  /** Synop invoice id (invoice_*) */
  invoiceId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type GetInvoiceArtifactsResponse = /** status 200 Artifact links retrieved */ InvoiceArtifacts
export type GetInvoiceArtifactsArgs = {
  /** Synop invoice id (invoice_*) */
  invoiceId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type DownloadInvoiceArchiveResponse = unknown
export type DownloadInvoiceArchiveArgs = {
  /** Synop invoice id (invoice_*) */
  invoiceId: string
  /** Organization context; defaults to the authenticated org */
  organizationId?: string
}
export type AttributeCatalogResponse = /** status 200 Attribute catalog retrieved */ AttributeDescriptor[]
export type AttributeCatalogArgs = {
  organizationId?: string
}
export type GetArtifactStorageAccessResponse = /** status 200 Current access state */ ArtifactStorageAccess
export type GetArtifactStorageAccessArgs = void
export type ListLegacyRatesResponse = /** status 200 OK */ MappingResult[]
export type ListLegacyRatesArgs = void
export type ListHardwareProductsResponse = /** status 200 Hardware products retrieved successfully */ HardwareProduct[]
export type ListHardwareProductsArgs = void
export type ListHardwareOrdersResponse =
  /** status 200 Hardware orders retrieved successfully */ PagedResponseV2HardwareOrder
export type ListHardwareOrdersArgs = {
  page?: number
  size?: number
  /** Filter by Stripe Checkout session id */
  sessionId?: string
}
export type GetHardwareOrderResponse = /** status 200 Hardware order found */ HardwareOrder
export type GetHardwareOrderArgs = {
  id: string
}
export type ListCustomersResponse = /** status 200 OK */ PagedResponseCustomer
export type ListCustomersArgs = {
  'X-Organization-Id': string
  /** Zero-based page index. */
  page?: string
  /** Page size. */
  size?: string
  /** Optional filter by customer type. */
  type?: string
  /** Optional filter by customer status. */
  status?: string
  /** Optional case-insensitive name/email search. */
  search?: string
}
export type GetCustomerBalanceResponse = /** status 200 OK */ CustomerBalance
export type GetCustomerBalanceArgs = {
  'X-Organization-Id': string
  id: string
}
export type GetCustomerWalletBalancesResponse = /** status 200 OK */ CustomerWalletBalances
export type GetCustomerWalletBalancesArgs = {
  'X-Organization-Id': string
  customerIds: string[]
}
export type GetSuggestedCapabilitiesV1Response = /** status 200 OK */ SuggestedCapabilities
export type GetSuggestedCapabilitiesV1Args = {
  /** Three-letter ISO 4217 currency (e.g. usd, eur). */
  currency?: string
  /** Two-letter ISO 3166-1 country (e.g. US, DE, GB). */
  country?: string
}
export type GetOverviewV1Response = /** status 200 OK */ ConnectedAccountOverview
export type GetOverviewV1Args = {
  /** Connected account id; omit for org default */
  accountId?: string
  /** Period start (epoch seconds) */
  periodFrom?: number
  /** Period end (epoch seconds) */
  periodTo?: number
  /** Max top customers (default 10) */
  topCustomersLimit?: number
  /** Time-series granularity (daily, weekly, monthly) */
  granularity?: string
  /** Include previous-period comparison */
  compare?: boolean
}
export type ListConnectedAccountsLinkedToOrganizationV1Response = /** status 200 OK */ ConnectedAccountRead[]
export type ListConnectedAccountsLinkedToOrganizationV1Args = {
  /** Child organization ID */
  organizationId: string
}
export type ListBalanceTransactionsResponse = /** status 200 OK */ PagedResponseBalanceTransactionFeedItem
export type ListBalanceTransactionsArgs = {
  'X-Organization-Id': string
  /** Payor id: fleet organization id or driver user id */
  payorId?: string
  /** Synop customer id (customer_*) */
  customerId?: string
  /** Synop connected account id (account_*) */
  accountId?: string
  page?: number
  size?: number
}
export type ListSessionsV1Response = /** status 200 OK */ PageAssistantSessionSummary
export type ListSessionsV1Args = {
  pageable: Pageable
}
export type GateV1Response = /** status 200 OK */ AssistantGateResult
export type GateV1Args = {
  /** Enabled organization id. */
  organizationId: string
}
export type GetCreditsV1Response = /** status 200 OK */ AssistantCreditsSummary
export type GetCreditsV1Args = void
export type GetBreakdownV1Response = /** status 200 OK */ AssistantSpendBreakdown
export type GetBreakdownV1Args = {
  /** Inclusive range start (ISO instant); defaults to 84 days ago. */
  from?: string
  /** Exclusive range end (ISO instant); defaults to now. */
  to?: string
}
export type GetReconciliationExceptionsResponse =
  /** status 200 Reconciliation exceptions retrieved */ ReconciliationException[]
export type GetReconciliationExceptionsArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
}
export type GetAgreementProductHistoryResponse =
  /** status 200 Product history retrieved successfully */ AgreementProductResponse[]
export type GetAgreementProductHistoryArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
}
export type GetOcpiUsageSummaryResponse = /** status 200 Usage summary retrieved */ AgreementOcpiUsageSummary
export type GetOcpiUsageSummaryArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
  /** Window start (inclusive; default: 30 days before the window end) */
  from?: string
  /** Window end (exclusive; default: now) */
  to?: string
}
export type GetOcpiSessionsResponse = /** status 200 Sessions retrieved */ AgreementOcpiRecord[]
export type GetOcpiSessionsArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
  /** Window start (inclusive) */
  from?: string
  /** Window end (exclusive) */
  to?: string
  /** Rows to skip (default 0) */
  offset?: number
  /** Maximum rows to return (default 100, cap 1000) */
  limit?: number
}
export type GetOcpiCdrsResponse = /** status 200 CDRs retrieved */ AgreementOcpiRecord[]
export type GetOcpiCdrsArgs = {
  /** Agreement id (ag_* or UUID) */
  id: string
  /** Window start (inclusive) */
  from?: string
  /** Window end (exclusive) */
  to?: string
  /** Rows to skip (default 0) */
  offset?: number
  /** Maximum rows to return (default 100, cap 1000) */
  limit?: number
}
export type GetPayoutsByCursorResponse = /** status 200 OK */ CursorPagedResponsePayoutModel
export type GetPayoutsByCursorArgs = {
  /** Organization ID */
  organizationId: string
  /** Number of items per page */
  count?: number
  /** Cursor for forward pagination */
  after?: string
  /** Cursor for backward pagination */
  before?: string
  /** Start date for filtering payouts (inclusive) */
  from?: string
  /** End date for filtering payouts (inclusive) */
  to?: string
  /** Status to filter by */
  status?: 'PAID' | 'PENDING' | 'IN_TRANSIT' | 'CANCELED' | 'FAILED'
}
export type GetPayoutByIdResponse = /** status 200 OK */ PayoutModel
export type GetPayoutByIdArgs = {
  /** ID of the payout to retrieve */
  payoutId: string
  /** Organization ID */
  organizationId?: string
}
export type GetInvoicesByCursorResponse =
  /** status 200 Invoices retrieved successfully */ CursorPagedResponseInvoiceModel
export type GetInvoicesByCursorArgs = {
  /** ID of the organization to fetch invoices for */
  organizationId?: string
  /** ID of the payor to filter by */
  payorId?: string
  /** Number of records to return per page */
  count?: number
  /** Cursor for the next page (ID of the last item in current page) */
  after?: string
  /** Cursor for the previous page (ID of the first item in current page) */
  before?: string
  /** Type of invoices to retrieve (SENT or RECEIVED) */
  requestType?: 'SENT' | 'RECEIVED'
  /** Start date for filtering invoices (inclusive) */
  from?: string
  /** End date for filtering invoices (inclusive) */
  to?: string
  /** Statuses to filter by */
  status?: ('DRAFT' | 'OPEN' | 'PAID' | 'UNCOLLECTIBLE' | 'VOID' | 'PAST_DUE')[]
}
export type GetInvoiceByIdResponse = /** status 200 Invoice retrieved successfully */ InvoiceModel
export type GetInvoiceByIdArgs = {
  /** ID of the invoice to retrieve */
  invoiceId: string
  /** ID of the organization to fetch the invoice for */
  organizationId: string
}
export type BillingOverviewGetPayoutsResponse =
  /** status 200 Successfully retrieved payouts overview */ PayoutsOverview
export type BillingOverviewGetPayoutsArgs = {
  /** Organization ID */
  organizationId?: string
  /** Number of payouts to return */
  limit?: number
}
export type BillingOverviewGetPaymentsResponse = /** status 200 Successfully retrieved payments */ PaymentsOverview
export type BillingOverviewGetPaymentsArgs = {
  /** Organization ID */
  organizationId?: string
  /** Payment filter type */
  filter?: 'RECENT' | 'SUCCESSFUL' | 'FAILED' | 'PENDING'
  /** Number of payments to return */
  limit?: number
}
export type BillingOverviewGetInvoicesResponse = /** status 200 Successfully retrieved invoices */ object
export type BillingOverviewGetInvoicesArgs = {
  /** Organization ID */
  organizationId?: string
  /** Invoice filter type */
  filter?: 'RECENT' | 'PAST_DUE' | 'OUTSTANDING'
  /** Max invoices to return */
  limit?: number
}
export type BillingOverviewGetCustomersResponse =
  /** status 200 Successfully retrieved recent customers */ CustomersOverview
export type BillingOverviewGetCustomersArgs = {
  /** Organization ID */
  organizationId?: string
  /** Number of customers to return */
  limit?: number
}
export type BillingOverviewGetVolumeChartResponse =
  /** status 200 Successfully retrieved volume chart */ BillingOverviewChart
export type BillingOverviewGetVolumeChartArgs = {
  /** Organization ID */
  organizationId?: string
  /** GROSS or NET */
  type?: 'GROSS' | 'NET'
  /** Date range preset */
  dateRange?: 'TODAY' | 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_12_MONTHS' | 'CUSTOM'
  /** Time series granularity */
  granularity?: 'HOUR' | 'DAY' | 'WEEK' | 'MONTH'
  /** Comparison period */
  comparison?: 'PREVIOUS_PERIOD' | 'PREVIOUS_WEEK' | 'PREVIOUS_MONTH' | 'PREVIOUS_YEAR' | 'NONE'
  /** Currency filter (default USD) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Custom start date (for CUSTOM date range) */
  from?: string
  /** Custom end date (for CUSTOM date range) */
  to?: string
}
export type BillingOverviewGetPaymentsChartResponse =
  /** status 200 Successfully retrieved payments chart */ BillingOverviewChart
export type BillingOverviewGetPaymentsChartArgs = {
  /** Organization ID */
  organizationId?: string
  /** Date range preset */
  dateRange?: 'TODAY' | 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_12_MONTHS' | 'CUSTOM'
  /** Time series granularity */
  granularity?: 'HOUR' | 'DAY' | 'WEEK' | 'MONTH'
  /** Comparison period */
  comparison?: 'PREVIOUS_PERIOD' | 'PREVIOUS_WEEK' | 'PREVIOUS_MONTH' | 'PREVIOUS_YEAR' | 'NONE'
  /** Custom start date (for CUSTOM date range) */
  from?: string
  /** Custom end date (for CUSTOM date range) */
  to?: string
}
export type BillingOverviewGetCustomersChartResponse =
  /** status 200 Successfully retrieved customers chart */ BillingOverviewChart
export type BillingOverviewGetCustomersChartArgs = {
  /** Organization ID */
  organizationId?: string
  /** NEW or SPEND */
  metric?: 'NEW' | 'SPEND'
  /** Date range preset */
  dateRange?: 'TODAY' | 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_90_DAYS' | 'LAST_12_MONTHS' | 'CUSTOM'
  /** Time series granularity */
  granularity?: 'HOUR' | 'DAY' | 'WEEK' | 'MONTH'
  /** Comparison period */
  comparison?: 'PREVIOUS_PERIOD' | 'PREVIOUS_WEEK' | 'PREVIOUS_MONTH' | 'PREVIOUS_YEAR' | 'NONE'
  /** Currency filter for SPEND (default USD) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Custom start date (for CUSTOM date range) */
  from?: string
  /** Custom end date (for CUSTOM date range) */
  to?: string
}
export type GetStripeIntentDetailResponse = /** status 200 OK */ StripeIntentModel
export type GetStripeIntentDetailArgs = {
  id: string
  apiVersion?: string
  forceNewSetupIntent?: boolean
}
export type GetPaymentMethodResponse = /** status 200 OK */ BillingDetailsModel
export type GetPaymentMethodArgs = {
  id: string
}
export type GetPortalLoginResponse = /** status 200 OK */ StripeRedirectModel
export type GetPortalLoginArgs = {
  id: string
}
export type GetUserInvoicesResponse = /** status 200 OK */ StripeRedirectModel
export type GetUserInvoicesArgs = {
  id: string
}
export type GetCheckoutSessionResponse = /** status 200 OK */ StripeRedirectModel
export type GetCheckoutSessionArgs = {
  id: string
}
export type GetUserBalanceResponse = /** status 200 OK */ UserBalanceResponse
export type GetUserBalanceArgs = {
  id: string
}
export type GetReimbursementsResponse = /** status 200 OK */ ReimbursementsModelObject[]
export type GetReimbursementsArgs = {
  from: string
  to: string
  organizationId?: string
}
export type GetReimbursementUserResponse = /** status 200 Reimbursement configured. */ ReimbursementUserResponse
export type GetReimbursementUserArgs = {
  reimbursementUserId: string
}
export type DeleteReimbursementUserResponse = /** status 200 Reimbursement user deleted. */ boolean
export type DeleteReimbursementUserArgs = {
  reimbursementUserId: string
}
export type GetReimbursementSummaryResponse =
  /** status 200 Reimbursement summary retrieved. */ ReimbursementSummaryModel
export type GetReimbursementSummaryArgs = {
  billingMonth?: string
  organizationId?: string
}
export type GetQuotasResponse = /** status 200 OK */ ApiQuota[]
export type GetQuotasArgs = {
  organizationId?: string
  month?: string
}
export type GetReimbursements1Response = /** status 200 OK */ ReimbursementsModelObject[]
export type GetReimbursements1Args = {
  id: string
  from: string
  to: string
}
export type GetPortalResponse = /** status 200 OK */ StripeRedirectModel
export type GetPortalArgs = {
  id: string
}
export type GetLoginSessionResponse = /** status 200 OK */ StripeRedirectModel
export type GetLoginSessionArgs = {
  id: string
}
export type GetOrganizationBalanceResponse = /** status 200 OK */ AccountBalance
export type GetOrganizationBalanceArgs = {
  id: string
}
export type GetMeterValues1Response = /** status 200 OK */ MeterValueModel[]
export type GetMeterValues1Args = {
  sessionId: string
}
export type GetLocationsResponse = /** status 200 OK */ ResponseFormatListLocation
export type GetLocationsArgs = {
  dateFrom?: string
  dateTo?: string
  offset?: number
  limit?: number
  source?: string
}
export type GetEvseResponse = /** status 200 OK */ ResponseFormatLocationData
export type GetEvseArgs = {
  locationId: string
  evseUid: string
}
export type GetConnectorResponse = /** status 200 OK */ ResponseFormatLocationData
export type GetConnectorArgs = {
  locationId: string
  evseUid: string
  connectorId: string
}
export type GetCdrResponse = /** status 200 OK */ ResponseFormatListCdrDto
export type GetCdrArgs = {
  authTag: string
  dateFrom?: string
  dateTo?: string
  offset: number
  limit: number
}
export type GetCdrByIdResponse = /** status 200 OK */ ResponseFormatCdrDto
export type GetCdrByIdArgs = {
  sessionId: string
}
export type GetLineItemsResponse = /** status 200 Successfully retrieved line items */ PagedResponseSynopLineItem
export type GetLineItemsArgs = {
  /** Type of the product */
  productType?: string
  /** ID of the product this line item was generated for */
  productId?: string
  /** ID of the charger */
  chargerId?: string
  /** ID of the vehicle */
  vehicleId?: string
  /** IDs of vehicles to include (line items must match one of these) */
  vehicleIds?: string[]
  /** Authorization tag */
  authTag?: string
  /** ID of the fleet */
  fleetId?: string
  /** ID of the site */
  siteId?: string
  /** ID of the payee */
  payeeId?: string
  /** ID of the payor */
  payorId?: string
  /** ID of the org the payor belongs to */
  payorOrgId?: string
  /** Agreement id (ag_* or UUID) the line item was rated under */
  agreementId?: string
  /** payoutId from Stripe */
  payoutId?: string
  /** ID of the usage source */
  usageSourceId?: string
  /** Synop invoice id (invoice_...) the line item belongs to; matches the line item's synopInvoiceId */
  invoiceId?: string
  /** ID of the balance transaction from Stripe */
  balanceTransactionId?: string
  /** Start date and time for filtering (ISO 8601 format) */
  from?: string
  /** End date and time for filtering (ISO 8601 format) */
  to?: string
  /** Filter by line item status (IN_PROGRESS, COMPLETED). Defaults to COMPLETED. */
  status?: ('IN_PROGRESS' | 'COMPLETED')[]
  /** Case-insensitive search across line item id, usage source id, charger id, auth tag, product name, and price description */
  search?: string
  /** Sort property (camelCase): usageStart, usageEnd, chargeAmount, totalAmount, usageAmount, appliedRate, usageSourceId, productId, id, and related ids. */
  sortBy?: string
  /** Sort direction when sortBy is set. Allowed: ASC, DESC. Defaults to ASC. */
  sortOrder?: string
  /** Page number for pagination (default is 0) */
  page?: number
  /** Page size for pagination (default is 10, max is 2000) */
  size?: number
}
export type GetLineItemByIdResponse = /** status 200 Successfully retrieved line item */ SynopLineItem
export type GetLineItemByIdArgs = {
  /** The unique identifier of the line item */
  id: string
}
export type GetCostExplorerResponse = /** status 200 OK */ CostExplorerResponse
export type GetCostExplorerArgs = {
  groupBy?: string
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  granularity?: 'HOUR' | 'DAY' | 'WEEK' | 'MONTH'
  from: string
  to: string
  organizationId?: string
  vehicleIds?: string[]
}
export type GetChargingRatesResponse =
  /** status 200 Charging rates retrieved. */ ChargingRateModelRateStructureModelListRatePeriod[]
export type GetChargingRatesArgs = {
  organizationId?: string
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
}
export type GetChargingRateByIdResponse = /** status 200 Charging rates retrieved. */ ChargingRateModel
export type GetChargingRateByIdArgs = {
  organizationId?: string
  rateMappingId: string
}
export type GetChargesForOrganizationResponse =
  /** status 200 Successfully retrieved charges */ CursorPagedResponseChargeModel
export type GetChargesForOrganizationArgs = {
  /** Organization ID */
  organizationId?: string
  /** Page size */
  size?: number
  /** Cursor for pagination (after) */
  after?: string
  /** Cursor for pagination (before) */
  before?: string
  /** Payor ID to filter charges */
  payorId?: string
  /** Status to filter charges */
  status?: 'PENDING' | 'SUCCEEDED' | 'FAILED' | 'CANCELED' | 'IN_DISPUTE'
  /** Start date for filtering charges (ISO-8601 format) */
  from?: string
  /** End date for filtering charges (ISO-8601 format) */
  to?: string
}
export type GetBootEventsResponse = /** status 200 Successfully retrieved boot events */ BootEventResponse
export type GetBootEventsArgs = {
  /** Charger ID to filter events */
  chargerId?: string
  /** Site ID(s) to filter events (repeatable query param, e.g. ?siteId=A&siteId=B) */
  siteId?: string[]
  /** Start time for the query (ISO-8601 format) */
  from: string
  /** End time for the query (ISO-8601 format) */
  to: string
  /** Include raw event data in response */
  includeRawEvents?: boolean
  /** Time bucket size for aggregating events */
  bucket?: 'FIFTEEN_MINUTES' | 'THIRTY_MINUTES' | 'SIXTY_MINUTES'
}
export type GetBalanceResponse = /** status 200 OK */ CustomerBillingModel
export type GetBalanceArgs = {
  accountType: 'INDIVIDUAL' | 'ORGANIZATION'
  organizationId?: string
  userId?: string
}
export type DeleteRegistrationResponse = unknown
export type DeleteRegistrationArgs = {
  'X-Organization-Id': string
  id: number
}
export type DeleteDecisionResponse = unknown
export type DeleteDecisionArgs = {
  'X-Organization-Id': string
  connectedAccountId?: number
  id: number
}
export type DisablePeakSaverResponse = /** status 200 Peak saver disabled */ BillableTransactionEntity
export type DisablePeakSaverArgs = {
  /** ID of the charging session */
  sessionId: string
}
export type CancelChargingScheduleResponse = /** status 200 Charging schedule cancelled successfully */ ChargerEvent
export type CancelChargingScheduleArgs = {
  /** ID of the charging schedule to cancel */
  eventId: string
  /** Whether to cancel the whole recurrence */
  includeRecurring?: boolean
}
export type DeleteRegistration1Response = unknown
export type DeleteRegistration1Args = {
  'X-Organization-Id': string
  accountId: string
  id: number
}
export type RemoveAuthorizedEntityResponse = unknown
export type RemoveAuthorizedEntityArgs = {
  /** Agreement ID (UUID or human-readable format like ag_abc123) */
  id: string
  /** Product ID (UUID or human-readable format like prod_abc123) */
  productId: string
  entityId: string
}
export type RemovePaymentMethodResponse = /** status 200 OK */ BillingDetailsModel
export type RemovePaymentMethodArgs = {
  id: string
  paymentMethodId: string
}
export type UserTagModel = {
  /** Identifier for this user. The application of this value is predicated on the UserType (Synop User, External Workplace Charging User, etc) */
  userId?: string
  /** The type of user this tag is associated with. */
  userType?:
    | 'EXTERNAL_OTHER_USER'
    | 'EXTERNAL_REIMBURSEMENT_CHARGING_USER'
    | 'EXTERNAL_WORKPLACE_CHARGING_USER'
    | 'SYNOP_USER'
  /** The value authorising a user. Example could be storing an RFID tag value for a user. */
  ocppTagValue?: string
  /** The type of tag this is. Could be RFID, QR Code, etc. */
  ocppTagType?: 'MOBILE' | 'NFC' | 'OTHER' | 'QR_CODE' | 'RFID' | 'VID'
  /** The use case this tag should be used for. Could be WORKPLACE_CHARGING, FLEET_CHARGING, etc. */
  useCase?: 'FLEET_CHARGING' | 'OPERATIONS' | 'OTHER' | 'REIMBURSEMENTS' | 'WORKPLACE_CHARGING'
  /** The date and time this record was created. */
  created?: string
  /** The date and time this record was last updated. */
  updated?: string
  /** The user who last modified this record. */
  modifiedBy?: string
  /** The user who created this record. */
  createdBy?: string
}
export type WorkplaceChargingUserModel = {
  firstNm?: string
  lastNm?: string
  email?: string
  externalId?: string
  /** The Synop user ID for the user if applicable. */
  userId?: string
  organizationId?: string
  status?: 'CURRENT' | 'PAST_DUE' | 'PENDING'
  onboarded?: string
  /** The value user for authorising a user. Example could be storing an RFID tag value for a user. */
  ocppTags?: UserTagModel[]
  id: string
}
export type TaxRate = {
  /** Unique tax rate identifier */
  id?: string
  /** Display name of the tax rate */
  name?: string
  /** Description of the tax rate */
  description?: string
  /** Calculation type: PERCENTAGE, PER_UNIT, or FLAT */
  taxType?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  /** Tax value: percentage (6.0 for 6%), per-unit rate (0.034), or flat amount */
  value?: number
  /** Unit that a PER_UNIT tax rate applies to */
  valueUnit?: 'KWH' | 'MINUTES' | 'SESSION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Jurisdiction identifier (e.g. US-PA, EU-DE) */
  jurisdiction?: string
  /** ISO 3166-1 alpha-2 country code */
  countryCode?: string
  /** Sub-national region */
  region?: string
  /** Stripe TaxRate object ID (for PERCENTAGE taxes) */
  stripeTaxRateId?: string
  /** Whether this tax rate is currently active */
  active?: boolean
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
  /** Identifier of the user or system that created the resource */
  createdBy?: string
  /** Identifier of the user or system that last updated the resource */
  updatedBy?: string
}
export type TaxRateRead = {
  /** Unique tax rate identifier */
  id?: string
  /** Display name of the tax rate */
  name?: string
  /** Description of the tax rate */
  description?: string
  /** Calculation type: PERCENTAGE, PER_UNIT, or FLAT */
  taxType?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  /** Tax value: percentage (6.0 for 6%), per-unit rate (0.034), or flat amount */
  value?: number
  /** Unit that a PER_UNIT tax rate applies to */
  valueUnit?: 'KWH' | 'MINUTES' | 'SESSION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Jurisdiction identifier (e.g. US-PA, EU-DE) */
  jurisdiction?: string
  /** ISO 3166-1 alpha-2 country code */
  countryCode?: string
  /** Sub-national region */
  region?: string
  /** Read-only. Whether this tax is quoted inside the price (VAT-style) vs. added on top (US-style), derived server-side from the rate's jurisdiction and the merchant's resolved default behavior. Mirrored to the Stripe TaxRate for display; settlement decides inclusivity from the price's taxBehavior, not from this flag. */
  isInclusive?: boolean
  /** Stripe TaxRate object ID (for PERCENTAGE taxes) */
  stripeTaxRateId?: string
  /** Whether this tax rate is currently active */
  active?: boolean
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
  /** Identifier of the user or system that created the resource */
  createdBy?: string
  /** Identifier of the user or system that last updated the resource */
  updatedBy?: string
}
export type TaxRateUpdateParams = {
  name?: string
  description?: string
  taxType?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  value?: number
  /** Unit that a PER_UNIT tax rate applies to */
  valueUnit?: 'KWH' | 'MINUTES' | 'SESSION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  jurisdiction?: string
  countryCode?: string
  region?: string
  /** Ignored. Inclusivity is derived server-side from the rate's jurisdiction and the merchant's resolved default tax behavior; settlement reads the price's taxBehavior, never this flag. Read the derived value back from the response. */
  isInclusive?: boolean
  active?: boolean
}
export type TaxId = {
  /** Type of a buyer tax identifier */
  type:
    | 'EU_VAT'
    | 'GB_VAT'
    | 'US_EIN'
    | 'CA_GST_HST'
    | 'AU_ABN'
    | 'OTHER'
    | 'CA_BN'
    | 'CA_QST'
    | 'CA_PST'
    | 'US_STATE_TAX_ID'
    | 'CH_VAT'
    | 'NO_VAT'
  /** The identifier value */
  value: string
  /** ISO 3166-1 alpha-2 country the identifier was issued in */
  country?: string
  /** Verification status for a tax ID */
  verificationStatus?: 'PENDING' | 'VERIFIED' | 'UNVERIFIED' | 'UNAVAILABLE'
}
export type TaxProfile = {
  id?: number
  /** Scope of a tax profile */
  scope?: 'SUBJECT' | 'AGREEMENT'
  /** (SUBJECT) billing counterparty id — an organization id or a user id */
  counterpartyId?: string
  /** Whether a SUBJECT-scoped tax profile belongs to an organization or an individual driver/user */
  subjectType?: 'ORGANIZATION' | 'USER'
  /** (AGREEMENT) agreement id */
  agreementId?: string
  /** Buyer self-service billing address: first line. */
  billingLine1?: string
  /** Buyer self-service billing address: second line. */
  billingLine2?: string
  /** Buyer self-service billing address: city. */
  billingCity?: string
  billingCountryCode?: string
  billingRegion?: string
  billingPostalCode?: string
  primaryVatNumber?: string
  primaryVatCountryCode?: string
  /** Verification status for a tax ID */
  primaryVatVerificationStatus?: 'PENDING' | 'VERIFIED' | 'UNVERIFIED' | 'UNAVAILABLE'
  /** When the primary VAT verification status was last established */
  primaryVatVerifiedAt?: string
  /** Additional buyer tax identifiers (typed; replaces the legacy taxIdsJson string blob) */
  taxIds?: TaxId[]
  /** Tax exemption status */
  taxExempt?: 'NONE' | 'EXEMPT' | 'REVERSE'
  /** Whether the buyer is a taxable dealer of electricity (reseller). Drives EV-charging place-of-supply (Art. 38/39). Defaults to false. */
  taxableDealer?: boolean
  notes?: string
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
  /** Identifier of the user or system that created the resource */
  createdBy?: string
  /** Identifier of the user or system that last updated the resource */
  updatedBy?: string
}
export type TaxProfilePatchParams = {
  /** Billing address line 1. null = unchanged, "" = clear. */
  billingLine1?: string | null
  /** Billing address line 2. null = unchanged, "" = clear. */
  billingLine2?: string | null
  /** Billing city. null = unchanged, "" = clear. */
  billingCity?: string | null
  /** Billing country, ISO 3166-1 alpha-2. null = unchanged, "" = clear. */
  billingCountryCode?: string | null
  /** Billing region or state. null = unchanged, "" = clear. */
  billingRegion?: string | null
  /** Billing postal code. null = unchanged, "" = clear. */
  billingPostalCode?: string | null
  /** Primary VAT number; whitespace, dots and dashes are stripped and it is upper-cased. null = unchanged, "" = clear (also clears its verification status). */
  primaryVatNumber?: string | null
  /** Country of the primary VAT number, ISO 3166-1 alpha-2; derived from the number's prefix when blank. null = unchanged, "" = clear. */
  primaryVatCountryCode?: string | null
  /** Additional buyer tax identifiers. null = unchanged, [] = clear. */
  taxIds?: TaxId[] | null
  /** Tax exemption status */
  taxExempt?: ('NONE' | 'EXEMPT' | 'REVERSE') | null
  /** Whether the buyer is a taxable dealer of electricity (a reseller). null = unchanged. */
  taxableDealer?: boolean | null
  /** Free-text notes. null = unchanged, "" = clear. */
  notes?: string | null
}
export type TaxJurisdictionDecision = {
  /** Database identifier */
  id?: number
  /** Owning organization ID */
  organizationId?: string
  /** Connected account row id when this is a per-account override; null for org-level decisions */
  connectedAccountId?: number
  /** ISO 3166-1 alpha-2 country code */
  countryCode?: string
  /** State, province or region; null for a country-level decision */
  region?: string
  /** COLLECTING, NOT_COLLECTING, or UNSURE. Every value is a valid tax position. */
  decision?: 'COLLECTING' | 'NOT_COLLECTING' | 'UNSURE'
  /** Optional merchant-facing note */
  note?: string
  /** When the merchant last chose this value */
  decidedAt?: string
  /** Who last chose this value */
  decidedBy?: string
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
}
export type TaxJurisdictionDecisionUpsertParams = {
  /** ISO 3166-1 alpha-2 country code */
  countryCode: string
  /** State, province or region. Required in practice for US and Canadian places, which are asked sub-nationally; omit for a country-level decision. */
  region?: string
  /** COLLECTING (yes), NOT_COLLECTING (no), or UNSURE (not sure) */
  decision: 'COLLECTING' | 'NOT_COLLECTING' | 'UNSURE'
  /** Optional merchant-facing note */
  note?: string
}
export type VolumeTierDto = {
  /** Upper bound of this tier in units; null means unlimited (Stripe 'inf') */
  upTo?: number
  /** Cost per unit in cents for this tier */
  unitAmount: number
  /** Optional flat fee for this tier in cents */
  flatAmount?: number
}
export type ProductPriceResponse = {
  /** Unique identifier of the price */
  id?: string
  /** Currency for this price */
  currency?: string
  /** Amount in smallest currency unit (e.g. cents) */
  unitAmount?: number
  /** Stripe price ID for this price */
  stripePriceId?: string
  /** Type of billing schedule */
  billingType?: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval?: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** Volume tiers for volume-based pricing */
  volumeTiers?: VolumeTierDto[]
  /** When volume pricing rolls up on a Synop meter for the billing period (aligns with billing-sdk TierQuantitySource.PERIOD_METER_QUANTITY). Omitted when unknown or legacy Stripe-only rows. */
  tierQuantitySource?: string
  /** Synop meter id when tierQuantitySource is PERIOD_METER_QUANTITY (e.g. meter_...). */
  tierMeterId?: string
  /** Synop billing scheme when exposed by upstream catalog (PER_UNIT, FLAT, TIERED, USAGE_BASED). May be null for legacy Stripe catalog rows. */
  billingScheme?: string
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
  default?: boolean
}
export type ProductEntitySelectionResponse = {
  /** Unique identifier of the entity selection */
  id?: string
  /** Types of entities that can be associated with products and billing */
  entityType?:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  /** ID of the selected entity */
  entityId?: string
  /** Internal ID of the entity (for internal system reference) */
  internalId?: string
  /** Child entity selections */
  children?: ProductEntitySelectionResponse[]
}
export type PricingDetails = {
  /** Currency code in ISO 4217 format */
  currency: string
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type FlatRatePricing = PricingDetails & {
  /** Currency code in ISO 4217 format */
  currency: string
  /** The fixed amount to charge in cents */
  unitAmount: number
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type PerUnitPricing = {
  /** Currency code in ISO 4217 format */
  currency: string
  /** Price per unit in the specified currency */
  unitAmount: number
  /** Name of the unit being charged (e.g., kWh, GB, API call) */
  units: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type TimePeriod = {
  /** Unique identifier for the time period */
  id?: string
  /** Name of the time period */
  name: string
  /** The start time of the period. If start time equals end time, the period applies for 24 hours (all day). */
  startTime: string
  /** The end time of the period. If start time equals end time, the period applies for 24 hours (all day). Alternatively, use 00:00 to 23:59:59 for a full day. */
  endTime: string
  /** Rate for this period in cents */
  rate: number
  /** Days of the week this period applies to */
  daysOfWeek: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
}
export type IdleFeeConfig = {
  /** Rate for idle fee in cents */
  rate: number
  /** Grace period in minutes before idle fee applies */
  gracePeriod: number
  /** Step size in minutes for idle fee */
  stepSize: number
}
export type ReservationConfig = {
  /** Price for the reservation */
  price: number
  /** Duration in minutes */
  duration: number
  /** Penalty for no-show */
  noShowPenalty: number
  /** Minimum lead time in minutes */
  minimumLeadTime: number
  /** Maximum lead time in hours */
  maximumLeadTime: number
  /** Cancellation window in minutes */
  cancellationWindow: number
}
export type TariffRestrictionResponse = {
  /** Unique identifier of the restriction */
  id?: string
  /** Name of the restriction */
  name?: string
  /** Description of the restriction */
  description?: string
  /** Minimum power in watts */
  minPower?: number
  /** Maximum power in watts */
  maxPower?: number
  /** Minimum duration in minutes */
  minDuration?: number
  /** Maximum duration in minutes */
  maxDuration?: number
  /** Minimum energy consumption in Wh */
  minEnergy?: number
  /** Maximum energy consumption in Wh */
  maxEnergy?: number
  /** Maximum state of charge percentage */
  maxSoc?: number
  /** Penalty amount for violating this restriction */
  penaltyAmount?: number
  /** The start time of the restriction. If start time equals end time, the restriction applies for 24 hours (all day). */
  startTime: string
  /** End time of the restriction. If start time equals end time, the restriction applies for 24 hours (all day). Alternatively, use 00:00 to 23:59:59 for a full day. */
  endTime: string
  /** Days of the week when the restriction applies. If null or empty, the restriction applies to all days of the week */
  daysOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Start date of the restriction */
  startDate?: string
  /** End date of the restriction */
  endDate?: string
  hardLimit?: boolean
}
export type BillableTimeOfUseRate = {
  /** Unique identifier for the rate */
  id?: string
  /** Name of the rate */
  name: string
  /** Description of the rate */
  description?: string
  /** Time periods associated with this rate */
  periods: TimePeriod[]
  /** Currency for this rate */
  currency: string
  /** Start date and time when this rate is valid */
  validFrom: string
  /** End date and time when this rate is valid */
  validTo?: string
  /** Year-independent start of the yearly recurrence window in ISO MonthDay format (--MM-dd).
    Required with recurrenceTo when isYearlyRecurring is true. When recurrenceFrom is after
    recurrenceTo, the window wraps across the year boundary (e.g. --11-01 → --03-31).
     */
  recurrenceFrom?: string
  /** Year-independent end of the yearly recurrence window in ISO MonthDay format (--MM-dd).
    Required with recurrenceFrom when isYearlyRecurring is true. When recurrenceFrom is after
    recurrenceTo, the window wraps across the year boundary (e.g. --11-01 → --03-31).
     */
  recurrenceTo?: string
  /** Defines the type of dimension for tariff calculation */
  tariffDimensionType?: 'TIME' | 'ENERGY'
  /** One-time fee charged at the start of service in cents */
  initiationFee?: number
  idleFeeConfig?: IdleFeeConfig
  reservationConfig?: ReservationConfig
  /** List of restrictions that apply to this rate */
  restrictions?: TariffRestrictionResponse[]
  /** Controls when the rate period is determined for billing purposes.
    
    - **true**: Capture and lock the rate period at session start (plug-in time).
    The entire session will be billed using the rate that was applicable when
    the session started, regardless of time period transitions during charging.
    
    - **false** (default): Use dynamic time-of-use allocation. The system will
    apply different rates as the session transitions through different time periods,
    allocating energy consumption to each period based on when it occurred.
     */
  lockRateAtPlugIn?: boolean
  /** Whether this rate is active */
  isActive?: boolean
  /** Designates if this rate is a holiday rate */
  isHolidayRate?: boolean
  /** Whether this rate recurs yearly */
  isYearlyRecurring?: boolean
}
export type PercentageTaxRates = {
  /** Combined percentage tax rate on per-kWh charges */
  energy?: number
  /** Combined percentage tax rate on per-session charges */
  session?: number
  /** Combined percentage tax rate on per-minute charges */
  time?: number
  /** Combined percentage tax rate on idle fees */
  idle?: number
}
export type PreTaxPrices = {
  /** Pre-tax energy price per kWh, keyed by time period id */
  periodPrices?: {
    [key: string]: number
  }
  /** Pre-tax per-session fee */
  initiationFee?: number
  /** Pre-tax idle fee per idle-fee step */
  idleFeePerStep?: number
}
export type TaxVariant = {
  /** Stable hash of the sorted resolved tax ids: exactly 12 lowercase hex characters */
  jurisdictionKey: string
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior: 'EXCLUSIVE' | 'INCLUSIVE'
  percentageTaxRates?: PercentageTaxRates
  /** Sites this variant covers. Never null; an empty list does not mean every site */
  siteIds: string[]
  /** Null means every charger at siteIds; otherwise only these chargers at those sites */
  chargerIds?: string[]
  preTaxPrices?: PreTaxPrices
}
export type TaxVariantRead = {
  /** Stable hash of the sorted resolved tax ids: exactly 12 lowercase hex characters */
  jurisdictionKey: string
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior: 'EXCLUSIVE' | 'INCLUSIVE'
  percentageTaxRates?: PercentageTaxRates
  /** Sites this variant covers. Never null; an empty list does not mean every site */
  siteIds: string[]
  /** Null means every charger at siteIds; otherwise only these chargers at those sites */
  chargerIds?: string[]
  preTaxPrices?: PreTaxPrices
}
export type BillableTimeOfUseRateRead = {
  /** Unique identifier for the rate */
  id?: string
  /** Name of the rate */
  name: string
  /** Description of the rate */
  description?: string
  /** Time periods associated with this rate */
  periods: TimePeriod[]
  /** Currency for this rate */
  currency: string
  /** Start date and time when this rate is valid */
  validFrom: string
  /** End date and time when this rate is valid */
  validTo?: string
  /** Year-independent start of the yearly recurrence window in ISO MonthDay format (--MM-dd).
    Required with recurrenceTo when isYearlyRecurring is true. When recurrenceFrom is after
    recurrenceTo, the window wraps across the year boundary (e.g. --11-01 → --03-31).
     */
  recurrenceFrom?: string
  /** Year-independent end of the yearly recurrence window in ISO MonthDay format (--MM-dd).
    Required with recurrenceFrom when isYearlyRecurring is true. When recurrenceFrom is after
    recurrenceTo, the window wraps across the year boundary (e.g. --11-01 → --03-31).
     */
  recurrenceTo?: string
  /** Defines the type of dimension for tariff calculation */
  tariffDimensionType?: 'TIME' | 'ENERGY'
  /** One-time fee charged at the start of service in cents */
  initiationFee?: number
  idleFeeConfig?: IdleFeeConfig
  reservationConfig?: ReservationConfig
  /** List of restrictions that apply to this rate */
  restrictions?: TariffRestrictionResponse[]
  /** Controls when the rate period is determined for billing purposes.
    
    - **true**: Capture and lock the rate period at session start (plug-in time).
    The entire session will be billed using the rate that was applicable when
    the session started, regardless of time period transitions during charging.
    
    - **false** (default): Use dynamic time-of-use allocation. The system will
    apply different rates as the session transitions through different time periods,
    allocating energy consumption to each period based on when it occurred.
     */
  lockRateAtPlugIn?: boolean
  /** Tax jurisdictions this rate is sold under, each with its percentage tax rates and, for tax-inclusive
    pricing, pre-tax prices. Every charger at the rate's sites belongs to exactly one variant. Null means not resolved
    (consumers keep their previous behavior); an empty list means the rate is offered at no sites or
    chargers. Read-only: ignored on create and update.
     */
  taxVariants?: TaxVariantRead[]
  /** Whether this rate is active */
  isActive?: boolean
  /** Designates if this rate is a holiday rate */
  isHolidayRate?: boolean
  /** Whether this rate recurs yearly */
  isYearlyRecurring?: boolean
}
export type TimeOfUsePricing = {
  /** Currency code in ISO 4217 format */
  currency: string
  /** List of time-of-use rates */
  rates: BillableTimeOfUseRate[]
  /** Global restrictions that apply to the entire tariff */
  tariffRestrictions?: TariffRestrictionResponse[]
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type TimeOfUsePricingRead = {
  /** Currency code in ISO 4217 format */
  currency: string
  /** List of time-of-use rates */
  rates: BillableTimeOfUseRateRead[]
  /** Global restrictions that apply to the entire tariff */
  tariffRestrictions?: TariffRestrictionResponse[]
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type VolumePricing = {
  /** Currency code in ISO 4217 format */
  currency: string
  /** Name of the unit being charged (e.g., kWh) */
  units: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** How the charge is calculated when quantity spans tiers: VOLUME (all at tier rate) or GRADUATED (split across tiers) */
  tiersMode: 'VOLUME' | 'GRADUATED'
  /** What quantity drives tier selection: ENTITY_COUNT (number of attached assets) or USAGE (kWh/usage) */
  tierQuantitySource: 'ENTITY_COUNT' | 'AGREEMENT_QUANTITY' | 'USAGE'
  /** Volume tiers, ordered by upTo. Last tier should have upTo=null for unlimited. */
  volumeTiers: VolumeTierDto[]
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type TariffPassThroughPricing = PricingDetails & {
  /** Currency code in ISO 4217 format */
  currency: string
  /** How the optional premium is calculated. Defaults to FLAT (fixed per-kWh amount). */
  premiumType?: 'FLAT' | 'PERCENTAGE'
  /** Fixed premium per kWh in minor currency units (e.g. cents) added on top of the utility tariff cost. Used when premiumType is FLAT. Defaults to 0 (pure pass-through). */
  premium?: number
  /** Percentage premium applied to the published utility tariff cost (e.g. 10.5 for a 10.5% markup). Used when premiumType is PERCENTAGE. Defaults to 0 (pure pass-through). */
  premiumPercent?: number
  /** Type of billing schedule */
  billingType: 'ONE_TIME' | 'RECURRING'
  /** Interval for recurring charges */
  recurringInterval: 'DAY' | 'MONTH' | 'QUARTER' | 'WEEK' | 'YEAR'
  /** How tax is applied relative to the price amount (maps to Stripe tax_behavior). When unspecified, billing resolves it per merchant and currency convention. */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
}
export type ProductResponse = {
  /** Unique identifier of the product */
  id: string
  /** Name of the product */
  name?: string
  /** Description of the product */
  description?: string
  /** Types of EV charging products and services */
  type?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Visibility settings controlling who can see and access products */
  visibility?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** Status of a product in the billing system */
  status?: 'ACTIVE' | 'ARCHIVED'
  /** Organization that owns this product */
  organizationId?: string
  /** Type of pricing model used for this product */
  pricingType?: 'FLAT_RATE' | 'PER_UNIT' | 'TIME_OF_USE' | 'VOLUME_BASED' | 'TARIFF_PASS_THROUGH'
  /** List of flat/per-unit prices associated with this product */
  prices?: ProductPriceResponse[]
  /** Entity selections this product applies to */
  entitySelections?: ProductEntitySelectionResponse[]
  /** When the product was created */
  created?: string
  /** When the product was last updated */
  updated?: string
  flatRatePricing?: FlatRatePricing
  perUnitPricing?: PerUnitPricing
  timeOfUsePricing?: TimeOfUsePricing
  volumePricing?: VolumePricing
  tariffPassThroughPricing?: TariffPassThroughPricing
  /** Non-blocking warnings, e.g. covered sites without a utility tariff attached for tariff pass-through products, or deleted sites an update dropped from the product's selections. Only populated on create/update responses. */
  warnings?: string[]
  /** Tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*) — this classifies what the product is for place-of-supply rules (EV charging vs general service); the VAT/sales-tax percentage comes from Synop tax rates attached via tax applications. Falls back to the merchant's default tax code when unset. */
  taxCode?: string
  /** Card pre-authorization hold, in minor currency units, placed before a walk-up public charging session on infrastructure this PUBLIC product covers. Null inherits the platform default. */
  authorizationCharge?: number
  /** Arbitrary string key-value metadata for this product */
  metadata?: {
    [key: string]: string
  }
}
export type ProductResponseRead = {
  /** Unique identifier of the product */
  id: string
  /** Name of the product */
  name?: string
  /** Description of the product */
  description?: string
  /** Types of EV charging products and services */
  type?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Visibility settings controlling who can see and access products */
  visibility?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** Status of a product in the billing system */
  status?: 'ACTIVE' | 'ARCHIVED'
  /** Organization that owns this product */
  organizationId?: string
  /** Type of pricing model used for this product */
  pricingType?: 'FLAT_RATE' | 'PER_UNIT' | 'TIME_OF_USE' | 'VOLUME_BASED' | 'TARIFF_PASS_THROUGH'
  /** List of flat/per-unit prices associated with this product */
  prices?: ProductPriceResponse[]
  /** Entity selections this product applies to */
  entitySelections?: ProductEntitySelectionResponse[]
  /** When the product was created */
  created?: string
  /** When the product was last updated */
  updated?: string
  flatRatePricing?: FlatRatePricing
  perUnitPricing?: PerUnitPricing
  timeOfUsePricing?: TimeOfUsePricingRead
  volumePricing?: VolumePricing
  tariffPassThroughPricing?: TariffPassThroughPricing
  /** Non-blocking warnings, e.g. covered sites without a utility tariff attached for tariff pass-through products, or deleted sites an update dropped from the product's selections. Only populated on create/update responses. */
  warnings?: string[]
  /** Tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*) — this classifies what the product is for place-of-supply rules (EV charging vs general service); the VAT/sales-tax percentage comes from Synop tax rates attached via tax applications. Falls back to the merchant's default tax code when unset. */
  taxCode?: string
  /** Card pre-authorization hold, in minor currency units, placed before a walk-up public charging session on infrastructure this PUBLIC product covers. Null inherits the platform default. */
  authorizationCharge?: number
  /** Arbitrary string key-value metadata for this product */
  metadata?: {
    [key: string]: string
  }
}
export type EntitySelection = {
  /** Types of entities that can be associated with products and billing */
  entityType:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  /** ID of the selected entity */
  entityId: string
  /** Internal ID of the entity (for internal system reference) */
  internalId?: string
  /** Child entity selections under this entity */
  children?: EntitySelection[]
}
export type UpdateProductRequest = {
  /** Organization ID that owns this product. If not provided, defaults to current organization from security context. */
  organizationId?: string
  /** Name of the product visible to customers */
  name: string
  /** Detailed description of the product */
  description?: string
  /** Types of EV charging products and services */
  type:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Visibility settings controlling who can see and access products */
  visibility: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  flatRatePricing?: FlatRatePricing
  perUnitPricing?: PerUnitPricing
  timeOfUsePricing?: TimeOfUsePricing
  volumePricing?: VolumePricing
  tariffPassThroughPricing?: TariffPassThroughPricing
  /** Hierarchical selections of entities this product applies to */
  entitySelections?: EntitySelection[]
  /** Tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*) — this classifies what the product is for place-of-supply rules (EV charging vs general service); the VAT/sales-tax percentage comes from Synop tax rates attached via tax applications. Falls back to the merchant's default tax code when unset. */
  taxCode?: string
  /** Card pre-authorization hold, in minor currency units (e.g. cents), placed on a walk-up customer's card before a public charging session on infrastructure this product covers. Omit to inherit the platform default. Only accepted on PUBLIC visibility products. */
  authorizationCharge?: number
  /** Arbitrary string key-value metadata for this product */
  metadata?: {
    [key: string]: string
  }
  /** Whether to archive old entity selections before applying new ones */
  replaceEntitySelections?: boolean
  /** Whether to archive old pricing configurations before applying new ones */
  replacePricing?: boolean
}
export type UpdateProductRequestRead = {
  /** Organization ID that owns this product. If not provided, defaults to current organization from security context. */
  organizationId?: string
  /** Name of the product visible to customers */
  name: string
  /** Detailed description of the product */
  description?: string
  /** Types of EV charging products and services */
  type:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Visibility settings controlling who can see and access products */
  visibility: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  flatRatePricing?: FlatRatePricing
  perUnitPricing?: PerUnitPricing
  timeOfUsePricing?: TimeOfUsePricingRead
  volumePricing?: VolumePricing
  tariffPassThroughPricing?: TariffPassThroughPricing
  /** Hierarchical selections of entities this product applies to */
  entitySelections?: EntitySelection[]
  /** Tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*) — this classifies what the product is for place-of-supply rules (EV charging vs general service); the VAT/sales-tax percentage comes from Synop tax rates attached via tax applications. Falls back to the merchant's default tax code when unset. */
  taxCode?: string
  /** Card pre-authorization hold, in minor currency units (e.g. cents), placed on a walk-up customer's card before a public charging session on infrastructure this product covers. Omit to inherit the platform default. Only accepted on PUBLIC visibility products. */
  authorizationCharge?: number
  /** Arbitrary string key-value metadata for this product */
  metadata?: {
    [key: string]: string
  }
  /** Whether to archive old entity selections before applying new ones */
  replaceEntitySelections?: boolean
  /** Whether to archive old pricing configurations before applying new ones */
  replacePricing?: boolean
}
export type EffectivePolicyDto = {
  /** FULL, CURATED, or DISABLED */
  access?: 'FULL' | 'CURATED' | 'DISABLED'
  /** Provider organization ids whose public offerings stay discoverable (CURATED) */
  providerOrganizationIds?: string[]
  /** Organization whose policy row is in effect; null for the platform default */
  sourceOrganizationId?: string
  /** True when the effective policy comes from an ancestor rather than this org */
  inherited?: boolean
}
export type PolicyDto = {
  /** FULL, CURATED, or DISABLED */
  access?: 'FULL' | 'CURATED' | 'DISABLED'
  /** Provider organization ids (CURATED only) */
  providerOrganizationIds?: string[]
  /** Organization that configured the policy */
  configuredByOrganizationId?: string
}
export type MarketplaceVisibility = {
  /** Organization the visibility applies to */
  organizationId?: string
  effective?: EffectivePolicyDto
  explicit?: PolicyDto
}
export type MarketplaceVisibilityUpdateParams = {
  /** FULL, CURATED, or DISABLED */
  access: 'FULL' | 'CURATED' | 'DISABLED'
  /** Provider organization ids whose public offerings stay discoverable; required and non-empty for CURATED, ignored otherwise */
  providerOrganizationIds?: string[]
}
export type MarketplaceOrganizationProfileResponse = {
  /** Organization display name, resolved from the platform */
  name?: string
  /** Business website */
  website?: string
  /** Marketplace description shown to counterparties */
  marketplaceDescription?: string
}
export type MarketplaceOrganizationProfileUpdateParams = {
  /** Business website */
  website?: string
  /** Marketplace description shown to counterparties */
  marketplaceDescription?: string
}
export type MarketplaceLocation = {
  /** Synop site internal id */
  id?: string
  /** Site name */
  name?: string
  /** Street address, when available */
  address?: string
  /** City, when available */
  city?: string
  /** Number of EVSEs at the site (excluding removed ones) */
  evseCount?: number
  /** Number of connectors at the site (on non-removed EVSEs) */
  connectorCount?: number
  /** Maximum connector power at the site, in kW */
  maxPowerKw?: number
  /** Whether an ACTIVE INTEGRATION agreement projects this site into a connection's scope */
  published?: boolean
  /** Marketplace display name override, when set */
  displayName?: string
  /** Marketplace directions text, when set */
  directions?: string
  /** Marketplace opening hours text, when set */
  openingHoursText?: string
}
export type MarketplaceLocationPresentationParams = {
  /** Marketplace display name override */
  displayName?: string
  /** Directions text */
  directions?: string
  /** Opening hours text */
  openingHoursText?: string
}
export type SiteReservationConfiguration = {
  /** Unique identifier for the configuration */
  id?: string
  /** Whether site reservation is enabled */
  enabled: boolean
  /** Site identifier */
  siteId?: string
  /** Date and time when the configuration becomes valid */
  validFrom?: string
  /** Date and time when the configuration expires. Null means active indefinitely */
  validTo?: string
  /** User who created this configuration */
  createdBy?: string
  /** Organization identifier of the site */
  organizationId?: string
  /** Creator organization identifier */
  creatorOrganizationId?: string
  /** Minimum lead time for reservations in seconds */
  minLeadTime?: number
  /** Maximum reservation length in seconds */
  maxReservationLength?: number
  /** Minimum reservation length in seconds */
  minReservationLength?: number
  /** Maximum lead time for reservations in seconds */
  maxLeadTime?: number
}
export type ReservationConfigurationUpdateParams = {
  /** Whether site reservation is enabled */
  enabled: boolean
}
export type EventRecurrence = {
  /** Unique identifier for the event recurrence */
  eventRecurrenceId?: string
  /** Recurrence rule in RFC 5545 format */
  recurrenceRule?: string
  /** Start date for the recurrence pattern */
  startDate?: string
  /** End date for the recurrence pattern */
  endDate?: string
  /** Timezone for the recurrence pattern */
  timezone?: string
}
export type ChargerEvent = {
  /** Unique identifier for the charger event */
  eventId: string
  /** ID of the depot containing the charger */
  depotId: string
  /** Name of the asset */
  assetNm?: string
  /** ID of the asset */
  assetId?: string
  /** ID of the charger */
  chargerId?: string
  /** ID of the dispenser */
  dispenserId?: string
  /** ID of the fleet */
  fleetId?: string
  /** ID of the site */
  siteId?: string
  /** ID of the connector */
  connectorId?: string
  /** ID of the vehicle */
  vehicleId?: string
  /** Status of a charger event in its lifecycle */
  status?: 'SCHEDULED' | 'ACTIVE' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'FAILED'
  /** When the event is scheduled to start */
  scheduledStart?: string
  /** When the event is scheduled to end */
  scheduledEnd?: string
  /** When the event actually started */
  actualStart?: string
  /** When the event actually ended */
  actualEnd?: string
  /** Type of the event */
  eventType?: 'TIMED_CHARGE' | 'AD_HOC_CHARGE' | 'PREDICTED' | 'RESERVATION'
  /** Power offered in kW */
  powerOffered?: number
  /** Target state of charge percentage */
  targetSoc?: number
  /** Name of the event target */
  eventTargetNm?: string
  /** Charger tag ID used for authentication */
  chargerTagId?: string
  /** AWS Step Functions execution ARN */
  executionArn?: string
  /** ID of the charging profile */
  profileId?: string
  /** Behavior for starting the charging session */
  startBehavior?: 'NeverSendRemoteStart' | 'AlwaysSendRemoteStart' | 'SynopManaged'
  /** Behavior for stopping the charging session */
  stopBehavior?: 'SendStopAtEndOfEvent' | 'NeverSendStop'
  eventRecurrence?: EventRecurrence
  /** Padding duration added before the scheduled start time */
  startPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    units?: {
      durationEstimated?: boolean
      duration?: {
        seconds?: number
        zero?: boolean
        nano?: number
        negative?: boolean
      }
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  /** Padding duration added after the scheduled end time */
  endPadding?: {
    seconds?: number
    zero?: boolean
    nano?: number
    negative?: boolean
    units?: {
      durationEstimated?: boolean
      duration?: {
        seconds?: number
        zero?: boolean
        nano?: number
        negative?: boolean
      }
      timeBased?: boolean
      dateBased?: boolean
    }[]
  }
  /** The effective start for the event with padding accounted */
  effectiveStart?: string
  /** The effective end for the event with padding accounted */
  effectiveEnd?: string
  scheduled?: boolean
  active?: boolean
  cancelled?: boolean
  completed?: boolean
}
export type ReservationUpdateRequest = {
  /** Updated scheduled end time */
  scheduledEnd?: string
  /** Updated scheduled start time */
  scheduledStart?: string
  /** Updated target state of charge percentage (0-100) */
  targetSoc?: number
  /** Updated power offered in watts */
  powerOffered?: number
  /** Updated profile ID */
  profileId?: string
  /** Updated start behavior */
  startBehavior?: string
  /** Updated stop behavior */
  stopBehavior?: string
}
export type MeterAttachmentDto = {
  /** Unique identifier of the attachment */
  id?: string
  /** Asset ID this meter is attached to */
  assetId?: string
  /** Type of asset that can be attached to meters in the billing system.
    
    ## Asset Types
    
    ### Vehicle Assets
    - **FLEET**: Collection of vehicles managed as a group
    - **VEHICLE**: Individual vehicle with unique identifier
    
    ### Infrastructure Assets
    - **SITE**: Physical location containing multiple chargers
    - **CHARGER**: Individual charging station or connector
    - **CONNECTOR**: Specific charging connector within a charger
    
    ### Service Assets
    - **SERVICE**: Service or subscription-based asset
    - **EQUIPMENT**: Physical equipment or hardware
    
    ## Usage Examples
    
    ### Fleet Management
    - **FLEET**: For fleet-wide billing and management
    - **VEHICLE**: For individual vehicle tracking and billing
    
    ### Charging Infrastructure
    - **SITE**: For site-level billing and management
    - **CHARGER**: For individual charger billing
    - **CONNECTOR**: For connector-specific billing
    
    ### Service Billing
    - **SERVICE**: For subscription or service-based billing
    - **EQUIPMENT**: For equipment rental or usage billing
    
    ## Asset Hierarchy
    
    ```
    SITE
    ├── CHARGER
    │   └── CONNECTOR
    └── EQUIPMENT
    
    FLEET
    └── VEHICLE
    
    SERVICE
    └── EQUIPMENT
    ```
     */
  assetType?: 'FLEET' | 'SITE' | 'VEHICLE' | 'CHARGER' | 'CONNECTOR' | 'SERVICE' | 'EQUIPMENT'
  /** Whether the attachment is active */
  active?: boolean
}
export type Meter = {
  /** Unique identifier of the meter (UUID) */
  id?: string
  /** Meter ID (business identifier) */
  meterId?: string
  /** Name of the meter */
  name?: string
  /** Detailed description of the meter */
  description?: string
  /** Measurement units for meters in the billing system.
    
    ## Unit Categories
    
    ### Time Units
    - **HOURS**: Duration in hours (e.g., charging session duration)
    - **MINUTES**: Duration in minutes (e.g., parking time)
    
    ### Distance Units
    - **MILES**: Distance in miles (e.g., vehicle miles driven)
    - **KILOMETERS**: Distance in kilometers (e.g., vehicle kilometers driven)
    
    ### Energy Units
    - **KILOWATT_HOURS**: Energy consumption in kWh (e.g., electricity consumed)
    - **MEGAWATT_HOURS**: Energy consumption in MWh (e.g., large-scale energy usage)
    
    ### Volume Units
    - **GALLONS**: Volume in gallons (e.g., fuel consumption)
    - **LITERS**: Volume in liters (e.g., fuel consumption)
    
    ### Count Units
    - **COUNT**: Discrete count (e.g., number of charging sessions, transactions)
    
    ## Usage Examples
    
    ### EV Charging
    - Energy: KILOWATT_HOURS for electricity consumed
    - Time: HOURS for session duration
    - Count: COUNT for number of sessions
    
    ### Fleet Management
    - Distance: MILES or KILOMETERS for vehicle usage
    - Fuel: GALLONS or LITERS for fuel consumption
    - Count: COUNT for number of trips
    
    ### Parking Services
    - Time: MINUTES or HOURS for parking duration
    - Count: COUNT for number of parking sessions
     */
  unit?:
    | 'HOURS'
    | 'MINUTES'
    | 'MILES'
    | 'KILOMETERS'
    | 'WATT_HOURS'
    | 'KILOWATT_HOURS'
    | 'MEGAWATT_HOURS'
    | 'GALLONS'
    | 'LITERS'
    | 'COUNT'
  /** Additional metadata */
  metadata?: {
    [key: string]: string
  }
  /** Meter attachments (only included when expand=attachments) */
  attachments?: MeterAttachmentDto[]
}
export type MeterUpdateParams = {
  /** Name of the meter */
  name?: string
  /** Detailed description of the meter */
  description?: string
  /** Measurement units for meters in the billing system.
    
    ## Unit Categories
    
    ### Time Units
    - **HOURS**: Duration in hours (e.g., charging session duration)
    - **MINUTES**: Duration in minutes (e.g., parking time)
    
    ### Distance Units
    - **MILES**: Distance in miles (e.g., vehicle miles driven)
    - **KILOMETERS**: Distance in kilometers (e.g., vehicle kilometers driven)
    
    ### Energy Units
    - **KILOWATT_HOURS**: Energy consumption in kWh (e.g., electricity consumed)
    - **MEGAWATT_HOURS**: Energy consumption in MWh (e.g., large-scale energy usage)
    
    ### Volume Units
    - **GALLONS**: Volume in gallons (e.g., fuel consumption)
    - **LITERS**: Volume in liters (e.g., fuel consumption)
    
    ### Count Units
    - **COUNT**: Discrete count (e.g., number of charging sessions, transactions)
    
    ## Usage Examples
    
    ### EV Charging
    - Energy: KILOWATT_HOURS for electricity consumed
    - Time: HOURS for session duration
    - Count: COUNT for number of sessions
    
    ### Fleet Management
    - Distance: MILES or KILOMETERS for vehicle usage
    - Fuel: GALLONS or LITERS for fuel consumption
    - Count: COUNT for number of trips
    
    ### Parking Services
    - Time: MINUTES or HOURS for parking duration
    - Count: COUNT for number of parking sessions
     */
  unit?:
    | 'HOURS'
    | 'MINUTES'
    | 'MILES'
    | 'KILOMETERS'
    | 'WATT_HOURS'
    | 'KILOWATT_HOURS'
    | 'MEGAWATT_HOURS'
    | 'GALLONS'
    | 'LITERS'
    | 'COUNT'
  /** Additional metadata */
  metadata?: {
    [key: string]: string
  }
}
export type MarketplaceOfferingProduct = {
  /** Unique identifier of the offering-product link */
  id: string
  /** Product ID */
  productId: string
  /** Product name */
  productName: string
  /** Product description */
  productDescription?: string
  /** Types of EV charging products and services */
  productType:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Pricing type of the product */
  pricingType: 'FLAT_RATE' | 'PER_UNIT' | 'TIME_OF_USE' | 'VOLUME_BASED' | 'TARIFF_PASS_THROUGH'
  /** Asset selections (sites, chargers, connectors) for this product */
  entitySelections?: ProductEntitySelectionResponse[]
  /** Active time-of-use rate schedules (day-of-week periods with per-kWh rates) so consumers can visualize when each rate applies. Null for products without TOU pricing. */
  timeOfUseRates?: BillableTimeOfUseRate[]
}
export type MarketplaceOfferingProductRead = {
  /** Unique identifier of the offering-product link */
  id: string
  /** Product ID */
  productId: string
  /** Product name */
  productName: string
  /** Product description */
  productDescription?: string
  /** Types of EV charging products and services */
  productType:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Pricing type of the product */
  pricingType: 'FLAT_RATE' | 'PER_UNIT' | 'TIME_OF_USE' | 'VOLUME_BASED' | 'TARIFF_PASS_THROUGH'
  /** Asset selections (sites, chargers, connectors) for this product */
  entitySelections?: ProductEntitySelectionResponse[]
  /** Active time-of-use rate schedules (day-of-week periods with per-kWh rates) so consumers can visualize when each rate applies. Null for products without TOU pricing. */
  timeOfUseRates?: BillableTimeOfUseRateRead[]
}
export type MarketplaceConnectorClass = {
  /** OCPI connector standard (e.g. IEC_62196_T2, IEC_62196_T2_COMBO, CHADEMO) */
  standard?: string
  /** OCPI power type (e.g. AC_1_PHASE, AC_3_PHASE, DC) */
  powerType?: string
  /** Number of connectors of this class */
  count?: number
  /** Maximum power of this class, in kW */
  maxPowerKw?: number
}
export type MarketplaceOfferingInfrastructureSummary = {
  /** Number of distinct charging sites (locations) covered by the offering */
  siteCount?: number
  /** Number of EVSEs across the offering's sites and directly selected chargers */
  evseCount?: number
  /** Number of connectors across the offering's sites and directly selected chargers */
  connectorCount?: number
  /** Maximum connector power across the offering's EVSEs, in kW */
  maxPowerKw?: number
  /** Lowest advertised per-kWh energy rate across the offering's products (flat per-kWh prices and active, currently valid time-of-use periods), in minor units of the settlement currency. Null when no product defines energy pricing. Derived from the same rate structures billing charges against, so the advertised number cannot drift from the billed one. */
  energyRate?: number
  /** True when any product prices energy with time-of-use periods (the advertised rate is then the lowest period rate) */
  touPricing?: boolean
  /** Connector classes across the offering's sites (standard + power type with count and max power), so mixed AC/DC networks are described per class instead of one blended number */
  connectors?: MarketplaceConnectorClass[]
  /** When the offering's infrastructure data was last synced (max connector last-updated) */
  lastSyncedAt?: string
}
export type MarketplaceOffering = {
  /** Unique identifier of the offering */
  id: string
  /** Organization ID of the CPO that owns this offering */
  organizationId: string
  /** Display name of the CPO organization that owns this offering */
  organizationName?: string
  /** Display name of the offering */
  name: string
  /** Detailed description of the offering */
  description?: string
  /** Terms and conditions for agreements created from this offering */
  terms?: string
  /** Status of a marketplace offering */
  status: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  /** Marketplace offering visibility */
  visibility: 'PUBLIC' | 'PRIVATE'
  /** How consumers enroll in a marketplace offering */
  enrollmentMode: 'INSTANT' | 'REQUEST'
  /** Allowed payor categories */
  allowedCategories?: ('FLEET' | 'DRIVER' | 'INTEGRATION')[]
  /** Whether explicit authorized entities are required */
  requireAuthorizedEntities?: boolean
  /** Whether all payor entities are authorized when none specified */
  authorizeAllPayorEntities?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Peak saver enabled on spawned agreements */
  peakSaverEnabled?: boolean
  /** Invoice template for spawned agreements */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Metadata copied to spawned agreements */
  metadata?: {
    [key: string]: string
  }
  /** Cover image URL */
  coverImageUrl?: string
  /** Connected account public id */
  connectedAccountId?: string
  /** Billing cycle for agreements created from this offering */
  billingCycle: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month (1-31) when monthly or annual billing cycles start */
  billingAnchorDayOfMonth?: number
  /** Day of week when weekly billing cycles start */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Number of days after billing cycle end until invoice is due */
  invoiceDueDays: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Whether agreements should automatically charge customers */
  autoCharge?: boolean
  /** Whether agreements should automatically renew */
  autoRenew?: boolean
  /** Whether prepayment is required */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents */
  initialPrepaymentAmount?: number
  /** Balance threshold that triggers a top-off payment in cents */
  topOffThreshold?: number
  /** Whether authorization charges are enabled */
  authorizationChargeEnabled?: boolean
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays: number
  /** Products included in this offering */
  products: MarketplaceOfferingProduct[]
  /** Plaintext access code (returned once on create/regenerate for private offerings) */
  accessCode?: string
  infrastructureSummary?: MarketplaceOfferingInfrastructureSummary
  /** When the offering was created */
  createdAt: string
  /** When the offering was last updated */
  updatedAt: string
}
export type MarketplaceOfferingRead = {
  /** Unique identifier of the offering */
  id: string
  /** Organization ID of the CPO that owns this offering */
  organizationId: string
  /** Display name of the CPO organization that owns this offering */
  organizationName?: string
  /** Display name of the offering */
  name: string
  /** Detailed description of the offering */
  description?: string
  /** Terms and conditions for agreements created from this offering */
  terms?: string
  /** Status of a marketplace offering */
  status: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  /** Marketplace offering visibility */
  visibility: 'PUBLIC' | 'PRIVATE'
  /** How consumers enroll in a marketplace offering */
  enrollmentMode: 'INSTANT' | 'REQUEST'
  /** Allowed payor categories */
  allowedCategories?: ('FLEET' | 'DRIVER' | 'INTEGRATION')[]
  /** Whether explicit authorized entities are required */
  requireAuthorizedEntities?: boolean
  /** Whether all payor entities are authorized when none specified */
  authorizeAllPayorEntities?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Peak saver enabled on spawned agreements */
  peakSaverEnabled?: boolean
  /** Invoice template for spawned agreements */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Metadata copied to spawned agreements */
  metadata?: {
    [key: string]: string
  }
  /** Cover image URL */
  coverImageUrl?: string
  /** Connected account public id */
  connectedAccountId?: string
  /** Billing cycle for agreements created from this offering */
  billingCycle: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month (1-31) when monthly or annual billing cycles start */
  billingAnchorDayOfMonth?: number
  /** Day of week when weekly billing cycles start */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Number of days after billing cycle end until invoice is due */
  invoiceDueDays: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Whether agreements should automatically charge customers */
  autoCharge?: boolean
  /** Whether agreements should automatically renew */
  autoRenew?: boolean
  /** Whether prepayment is required */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents */
  initialPrepaymentAmount?: number
  /** Balance threshold that triggers a top-off payment in cents */
  topOffThreshold?: number
  /** Whether authorization charges are enabled */
  authorizationChargeEnabled?: boolean
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays: number
  /** Products included in this offering */
  products: MarketplaceOfferingProductRead[]
  /** Plaintext access code (returned once on create/regenerate for private offerings) */
  accessCode?: string
  infrastructureSummary?: MarketplaceOfferingInfrastructureSummary
  /** When the offering was created */
  createdAt: string
  /** When the offering was last updated */
  updatedAt: string
}
export type MarketplaceOfferingUpdateParams = {
  /** Status of a marketplace offering */
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  /** Display name of the offering */
  name?: string
  /** Detailed description of the offering */
  description?: string
  /** Terms and conditions for agreements created from this offering */
  terms?: string
  /** Marketplace offering visibility */
  visibility?: 'PUBLIC' | 'PRIVATE'
  /** How consumers enroll in a marketplace offering */
  enrollmentMode?: 'INSTANT' | 'REQUEST'
  /** Allowed payor categories */
  allowedCategories?: ('FLEET' | 'DRIVER' | 'INTEGRATION')[]
  /** Require explicit authorized entities at enrollment */
  requireAuthorizedEntities?: boolean
  /** Authorize all payor entities when none specified */
  authorizeAllPayorEntities?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Peak saver enabled */
  peakSaverEnabled?: boolean
  /** Invoice template id */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language?: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Metadata */
  metadata?: {
    [key: string]: string
  }
  /** Cover image URL */
  coverImageUrl?: string
  /** Connected account public id */
  connectedAccountId?: string
  /** Billing cycle for agreements created from this offering */
  billingCycle?: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month (1-31) when monthly or annual billing cycles start */
  billingAnchorDayOfMonth?: number
  /** Day of week when weekly billing cycles start */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Number of days after billing cycle end until invoice is due */
  invoiceDueDays?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Whether agreements should automatically charge customers */
  autoCharge?: boolean
  /** Whether agreements should automatically renew */
  autoRenew?: boolean
  /** Whether prepayment is required */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents */
  initialPrepaymentAmount?: number
  /** Balance threshold that triggers a top-off payment in cents */
  topOffThreshold?: number
  /** Whether authorization charges are enabled */
  authorizationChargeEnabled?: boolean
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays?: number
  /** Product IDs to include in this offering. Replaces existing products if provided. */
  productIds?: string[]
}
export type AddressModel = {
  /** First line of the address */
  line1?: string
  /** Second line of the address */
  line2?: string
  /** City */
  city?: string
  /** State or province */
  state?: string
  /** Postal code */
  postalCode?: string
  /** Country code */
  country?: string
}
export type TaxDetail = {
  /** External id of the applied tax rate, e.g. tax_abc123 */
  taxId?: string
  /** Display name of the applied tax rate at the time of calculation */
  taxRateName?: string
  /** Calculation type of the tax rate (PERCENTAGE / PER_UNIT / FLAT) */
  taxType?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  /** Configured rate/value of the tax rate */
  rate?: number
  /** Taxable base this rate was applied to, in minor units */
  taxableAmount?: number
  /** This tax's contribution to the line item tax, in minor units */
  taxAmount?: number
  /** Stripe TaxRate id (PERCENTAGE taxes only; null for PER_UNIT / FLAT) */
  stripeTaxRateId?: string
  /** Scope that resolved this tax: agreement, price, product, meter, site, or charger */
  source?: string
  /** Reason a line item was taxed (or not) */
  taxabilityReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
}
export type LineItemGroupSummary = {
  /** Grouping dimension key (e.g. site id, product id, siteId::priceId, or 'ungrouped'). */
  groupKey?: string
  /** Customer-facing group label (site name, product name, price name, or joined names). */
  label?: string
  /** Synop product id for this group; null when the grouping has no product dimension or the group is ungrouped. */
  productId?: string
  /** Product display name for this group; null when the grouping has no product dimension or the group is ungrouped. */
  productName?: string
  /** Product metadata snapshotted onto member line items at create time; null when the grouping has no product dimension, the group is ungrouped, or no metadata was snapshotted. */
  productMetadata?: {
    [key: string]: string
  }
  /** Synop site (depot) id for this group; null when the grouping has no site dimension or the group is ungrouped. */
  siteId?: string
  /** Site display name for this group; null when the grouping has no site dimension or the group is ungrouped. */
  siteName?: string
  /** Site ERP external id from the platform depot record; null when the grouping has no site dimension, the group is ungrouped, or the site has no external id. */
  externalId?: string
  /** Synop price id for this group; null when the grouping has no price dimension or the group is ungrouped. */
  priceId?: string
  /** Price display name for this group; null when the grouping has no price dimension or the group is ungrouped. */
  priceName?: string
  /** Distinct tax rates applied across this group's usage line items (from each member's snapshotted tax breakdown), in first-seen order. Typically one entry for product-scoped VAT; taxRateName is the merchant VAT code (e.g. U2, U3). Null when no member recorded tax details. */
  taxDetails?: TaxDetail[]
  /** Number of usage line items (sessions) rolled into this group. */
  sessionCount?: number
  /** Total usage across the group when all members share the same unit; null otherwise. */
  usageAmount?: number
  /** Unit of the usage total; null when members mix units. */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Summed pre-tax gross charge for the group (before agreement discount), in the invoice currency's minor unit. */
  chargeAmount?: number
  /** Summed agreement discount already applied within the group, in the invoice currency's minor unit. */
  discountAmount?: number
  /** Summed pre-tax net charge for the group (chargeAmount minus discountAmount), in the invoice currency's minor unit. */
  netAmount?: number
}
export type ExcludedRecipient = {
  /** The excluded address. */
  email?: string
  /** Where the recipients of an invoice email were found. */
  source?:
    | 'EXPLICIT_RECIPIENTS'
    | 'REIMBURSEMENT_PAYEE'
    | 'CUSTOMER_BILLING_EMAIL'
    | 'AGREEMENT_CONTACT'
    | 'PAYOR_USER'
    | 'PAYOR_ORG_ADMINS'
    | 'NONE'
  /** Why the address was excluded. */
  reason?: 'MERCHANT_ORGANIZATION_USER'
}
export type InvoiceReadinessFinding = {
  /** A problem found on an invoice before it is issued. */
  issue?:
    | 'PAYOR_NAME_MISSING'
    | 'PAYOR_ADDRESS_MISSING'
    | 'SUPPLIER_ADDRESS_MISSING'
    | 'SUPPLIER_TAX_ID_MISSING'
    | 'NO_RECIPIENT'
    | 'RECIPIENT_IS_MERCHANT_USER'
    | 'CURRENCY_MISMATCH'
    | 'ZERO_TOTAL'
  /** Whether a readiness finding stops the invoice from going out unattended. */
  severity?: 'BLOCKING' | 'WARNING'
  /** Human-readable detail, e.g. which address fields are missing. */
  detail?: string
}
export type LineItemStatisticValue = {
  /** The lowest value observed */
  min?: number
  /** The sum of all values observed divided by the count */
  mean?: number
  /** The highest value observed */
  max?: number
  /** The number of values observed */
  count?: number
  /** The most recent value observed */
  latest?: number
}
export type RateDetail = {
  /** Display name of the applied rate (e.g. 'On-Peak') */
  rateNm?: string
  /** Price id for the applied rate tier (when available) */
  priceId?: string
  /** Rate in major currency units per usage unit */
  rate?: number
  /** Usage quantity billed in this period */
  quantity?: number
  /** Period total in the currency's minor unit */
  total?: number
  /** Start of the rate period */
  periodStart?: string
  /** End of the rate period */
  periodEnd?: string
  /** Aggregate telemetry statistics across this period, keyed by measurand */
  statistics?: {
    [key: string]: LineItemStatisticValue
  }
}
export type SignedMeterValue = {
  nature?: 'START' | 'END' | 'INTERMEDIATE'
  plainData?: string
  signedData?: string
}
export type SignedMeterData = {
  encodingMethod?: 'OCMF'
  publicKey?: string
  signedValues?: SignedMeterValue[]
}
export type SynopInvoiceLineItem = {
  /** Line item id */
  id?: string
  /** Line item type (e.g. CHARGE, DISCOUNT, CREDIT, REFUND) */
  type?: string
  /** Line description */
  description?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Subtotal before tax/discount, in minor units */
  subtotal?: number
  /** Tax amount in minor units */
  tax?: number
  /** Discount amount in minor units */
  discount?: number
  /** Additional fees in minor units */
  fees?: number
  /** Line total in minor units */
  total?: number
  /** Unit amount in minor units; may carry sub-cent (fractional minor unit) precision */
  unitAmount?: number
  /** Quantity billed */
  quantity?: number
  /** Usage period start */
  usageStart?: string
  /** Usage period end */
  usageEnd?: string
  /** Usage start note */
  usageStartNote?: string
  /** Usage end note */
  usageEndNote?: string
  /** Client reference / idempotency key */
  usageSourceId?: string
  /** Product id */
  productId?: string
  /** Types of EV charging products and services */
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Price id */
  priceId?: string
  /** Price description */
  priceDesc?: string
  /** Price type */
  priceType?: 'STRIPE' | 'SYNOP'
  /** Measurand for usage quantity */
  measurand?: 'DISTANCE_DRIVEN' | 'ENERGY_ADDED' | 'ENERGY_USED' | 'TIME_USED' | 'COUNT'
  /** Usage quantity unit */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Applied rate in major currency units */
  appliedRate?: number
  /** Site / depot id */
  depotId?: string
  /** Site / depot name */
  depotNm?: string
  /** Charger id */
  chargerId?: string
  /** Charger name */
  chargerNm?: string
  /** Connector id */
  connectorId?: string
  /** Vehicle id */
  vehicleId?: string
  /** Vehicle name */
  vehicleNm?: string
  /** Fleet id */
  fleetId?: string
  /** Types of entities that can be associated with products and billing */
  usageEntityType?:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  /** Usage entity id */
  usageEntityId?: string
  /** Per-rate-period breakdown ordered by period start. Null when unavailable. */
  rateDetails?: RateDetail[]
  /** Aggregate telemetry stats keyed by measurand. Null when unavailable. */
  statistics?: {
    [key: string]: LineItemStatisticValue
  }
  /** Reason a line item was taxed (or not) */
  taxReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  /** Per-tax breakdown summing to the line item tax. Null when unavailable. */
  taxDetails?: TaxDetail[]
  signedMeterData?: SignedMeterData
  /** Arbitrary string key-value metadata snapshotted from the product at line item creation */
  metadata?: {
    [key: string]: string
  }
  /** Amount saved by Peak Saver in minor units; null when Peak Saver did not apply or the save is zero */
  peakSaverCostSave?: number
}
export type TaxSummaryLine = {
  /** Applied tax rate id (tax_*) */
  taxId?: string
  /** Tax rate display name */
  taxRateName?: string
  /** Tax type (PERCENTAGE / PER_UNIT / FLAT) */
  taxType?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  /** Configured tax rate/value */
  rate?: number
  /** Reason a line item was taxed (or not) */
  taxabilityReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  /** Resolving scope (agreement/price/product/meter/site/charger) */
  source?: string
  /** Taxable base across the invoice (minor units) */
  taxableAmount?: number
  /** Tax contributed by this rate (minor units) */
  taxAmount?: number
}
export type SynopInvoice = {
  /** Synop invoice id (invoice_*). */
  invoiceId?: string
  /** Origin of a canonical invoice. STRIPE invoices are payable; SYNOP invoices are reporting only. */
  source?: 'SYNOP' | 'STRIPE'
  /** Invoice status. */
  status?:
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  /** Direction relative to the requesting organization. */
  direction?: 'SENT' | 'RECEIVED'
  merchantOrganizationId?: string
  payorId?: string
  payorType?: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Display name of the payor (organization name or user name/email), resolved server-side. */
  payorName?: string
  /** Merchant-facing classification of who this invoice is billed to. */
  payorSegment?: 'ORGANIZATION' | 'DRIVER' | 'PUBLIC_GUEST' | 'PUBLIC_UNKNOWN'
  /** Types of EV charging products and services */
  primaryProductType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  billingAddress?: AddressModel
  agreementId?: string
  connectedAccountId?: string
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Usage line items rolled up per lineItemGrouping. Null for ATOMIC. */
  lineItemGroups?: LineItemGroupSummary[]
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Subtotal before tax, in the currency minor unit (Stripe Invoice.subtotal). */
  subtotal?: number
  /** Total tax, in the currency minor unit. */
  tax?: number
  /** Total discounts, in the currency minor unit. */
  discount?: number
  /** Total additional fees, in the currency minor unit. */
  fees?: number
  /** Invoice total, in the currency minor unit (Stripe Invoice.total). */
  total?: number
  /** Amount still due, in the currency minor unit (Stripe Invoice.amount_due). */
  amountDue?: number
  /** Amount paid, in the currency minor unit (Stripe Invoice.amount_paid). */
  amountPaid?: number
  /** Amount remaining, in the currency minor unit (Stripe Invoice.amount_remaining). */
  amountRemaining?: number
  /** Customer's account balance after this invoice, in the currency minor unit (Stripe Invoice.ending_balance). Negative = credit, positive = owed. Null when unknown. */
  endingBalance?: number
  /** Wallet credit applied to this invoice (minor units). Null if none. */
  walletApplied?: number
  number?: string
  /** Whether this is a wallet top-up invoice. Top-ups are charged by card with no Stripe invoice, so they have no number; show receiptNumber as their reference instead. Set on list and detail. */
  topUp?: boolean
  /** Stripe card receipt number (e.g. 1783-2580) of a top-up's charge: the reference the payor was emailed. Null until Stripe has sent the receipt, and for payors without a receipt email. */
  receiptNumber?: string
  /** Stripe-hosted receipt URL of a top-up's charge. */
  receiptUrl?: string
  description?: string
  footer?: string
  memo?: string
  /** Legal name of the taxable person as at issue (VAT Directive Art. 226(5)). Null on invoices finalized before the supplier snapshot existed. */
  supplierName?: string
  supplierAddress?: AddressModel
  /** Supplier tax registration number as at issue, for the supply country (VAT Directive Art. 226(3)). Null when the merchant has no registration on file. */
  supplierTaxId?: string
  /** ISO 3166-1 alpha-2 country the supplier registration was issued in. */
  supplierTaxIdCountry?: string
  /** Customer tax identifier as at issue (Art. 226(4)); the basis for a reverse-charge supply. Null when the customer supplied none. */
  customerTaxId?: string
  /** Kind of identifier in customerTaxId, e.g. EU_VAT, GB_VAT, US_EIN. */
  customerTaxIdType?: string
  /** Country whose place-of-supply rules the tax on this invoice was computed under. */
  supplyCountryCode?: string
  /** Bank statement descriptor when Stripe-backed. */
  statementDescriptor?: string
  /** Whether credit card payment is allowed (legacy mirror of allowedPaymentMethodTypes). */
  allowCreditCard?: boolean
  /** Whether ACH payment is allowed (legacy mirror of allowedPaymentMethodTypes). */
  allowAch?: boolean
  /** Payment methods allowed on the hosted invoice page. */
  allowedPaymentMethodTypes?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  /** Additional invoice email recipients. */
  emailRecipients?: string[]
  /** Addresses the invoice email will go to if it is sent now, in send order. Set only on the merchant's single-invoice GET of an unsent or OPEN invoice that Synop issues or collects; an empty list means nobody can receive it. Null on list endpoints. */
  willSendTo?: string[]
  /** Where willSendTo was found: EXPLICIT_RECIPIENTS, REIMBURSEMENT_PAYEE, CUSTOMER_BILLING_EMAIL, AGREEMENT_CONTACT, PAYOR_USER, PAYOR_ORG_ADMINS, or NONE. Set together with willSendTo. */
  willSendToSource?: string
  /** Candidate addresses left out of willSendTo, each with its source and the reason (for example MERCHANT_ORGANIZATION_USER: the address belongs to the merchant's own user, not the customer). Set together with willSendTo. */
  willSendToExcluded?: ExcludedRecipient[]
  /** Delivery state of the issued-invoice email. */
  deliveryStatus?: 'NOT_SENT' | 'QUEUED' | 'SENT' | 'FAILED'
  /** When the email provider (SES or Stripe) last accepted the invoice email. Kept when a later send fails. */
  lastSentAt?: string
  /** Recipients of the last accepted invoice email. Kept when a later send fails. */
  lastSentTo?: string[]
  /** Why the last automatic send failed (truncated); cleared by the next successful send. */
  lastDeliveryError?: string
  /** True while the invoice is held unissued for the merchant to review and release (POST /api/v1/invoices/{id}/release). heldForReviewReason says why; reviewFindings lists any problems. */
  needsAttention?: boolean
  /** Who runs the issued-invoice lifecycle for invoices Synop collects through this account. */
  invoicingMode?: 'STRIPE_INVOICING' | 'SYNOP_INVOICING'
  /** True while a payment on a Synop-owned invoice is in flight (a bank debit clearing, a Checkout payment awaiting funds, or a charge attempt not yet applied), so no second payment should be requested. Set on the single-invoice GET only; null elsewhere. */
  paymentProcessing?: boolean
  /** Why the invoice is waiting for the merchant to release it. */
  heldForReviewReason?: 'READINESS' | 'FIRST_INVOICES' | 'MANUAL'
  /** What the readiness check found the last time it ran (period close or release). Kept after issue as a record of what the invoice was released with. Null when the check never ran. */
  reviewFindings?: InvoiceReadinessFinding[]
  periodStart?: string
  periodEnd?: string
  dueDate?: string
  finalizedAt?: string
  /** Date of issue (Art. 226(1)). Distinct from finalizedAt, which is an internal lifecycle timestamp a resync can move. */
  issuedAt?: string
  paidAt?: string
  voidedAt?: string
  createdAt?: string
  /** External provider supplementing a canonical invoice. */
  externalProvider?: 'NONE' | 'STRIPE'
  /** External Stripe invoice id (in_*), if Stripe-backed. */
  externalInvoiceId?: string
  externalHostedUrl?: string
  externalPdfUrl?: string
  /** Stable Synop-hosted PDF URL. Null until artifacts are generated. */
  invoiceUrl?: string
  /** Stable Synop-hosted artifact archive URL. Null until artifacts are generated. */
  archiveUrl?: string
  metadata?: {
    [key: string]: string
  }
  /** Invoice line items. On list responses only when expand=data.lineItems. */
  lineItems?: SynopInvoiceLineItem[]
  /** Invoice-wide tax breakdown per rate. On list responses only when expand=data.taxSummary. */
  taxSummary?: TaxSummaryLine[]
}
export type MoneyObjectView = {
  externalId?: string
  status?: string
  amount?: number
  currency?: string
  url?: string
  occurredAt?: string
}
export type BalanceTransactionView = {
  externalId?: string
  transactionType?: string
  reportingCategory?: string
  currency?: string
  amount?: number
  fee?: number
  applicationFee?: number
  processingFee?: number
  net?: number
  sourceExternalId?: string
  availableOn?: string
  occurredAt?: string
}
export type PaymentBreakdown = {
  currency?: string
  authorizedAmount?: number
  capturedAmount?: number
  releasedAmount?: number
  refundedAmount?: number
  applicationFee?: number
  processingFee?: number
  netAmount?: number
  walletApplied?: number
  paymentIntentId?: string
  chargeId?: string
}
export type ActivityEntry = {
  type?: string
  description?: string
  at?: string
}
export type SynopInvoiceDetail = {
  invoice?: SynopInvoice
  lineItems?: SynopInvoiceLineItem[]
  paymentIntents?: MoneyObjectView[]
  charges?: MoneyObjectView[]
  balanceTransactions?: BalanceTransactionView[]
  payouts?: MoneyObjectView[]
  paymentBreakdown?: PaymentBreakdown
  activity?: ActivityEntry[]
}
export type SynopInvoiceUpdateParams = {
  /** Payor entity id (organization or user) */
  payorId?: string
  /** Whether payorId is an organization or individual */
  payorType?: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Invoice due date (UTC) */
  dueDate?: string
  /** Invoice description */
  description?: string
  /** Footer shown on the invoice PDF */
  footer?: string
  /** Memo / internal note */
  memo?: string
  /** Additional email recipients (merged into invoice metadata) */
  emailRecipients?: string[]
  /** Custom metadata key-value pairs (merged into existing metadata) */
  metadata?: {
    [key: string]: string
  }
  /** Bank statement descriptor when Stripe-backed. Must be 5–22 characters when set; forbidden characters: < > \ ' " * */
  statementDescriptor?: string
  /** Whether credit card payment is allowed (legacy; prefer allowedPaymentMethodTypes) */
  allowCreditCard?: boolean
  /** Whether ACH payment is allowed (legacy; prefer allowedPaymentMethodTypes) */
  allowAch?: boolean
  /** Full replacement of payment methods allowed on the hosted invoice page. When set, overrides allowCreditCard/allowAch and is written through to Stripe payment_settings. */
  allowedPaymentMethodTypes?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
}
export type LineItemUpdateParams = {
  /** Line description (LineItem.productNm) */
  description: string
  /** Semantic line item type (LineItem.lineItemType). Defaults to CHARGE when omitted; use DISCOUNT, CREDIT, or REFUND for non-charge lines. */
  type?:
    | 'CHARGE'
    | 'CREDIT'
    | 'REFUND'
    | 'DISCOUNT'
    | 'REIMBURSEMENT'
    | 'COMMITMENT'
    | 'IDLE_FEE'
    | 'WALLET_TOP_UP'
    | 'PARENT_REVENUE_SHARE'
    | 'INITIATION_FEE'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Tax amount in minor units (LineItem.taxAmount) */
  tax?: number
  /** Additional fees in minor units (LineItem.additionalFees) */
  fees?: number
  /** Unit amount in minor units (chargeAmount = unitAmount × quantity). Up to 6 decimal places for sub-cent precision. */
  unitAmount: number
  /** Quantity billed (LineItem.usageAmount; defaults to 1) */
  quantity?: number
  /** Usage period start (LineItem.usageStart) */
  usageStart?: string
  /** Usage period end (LineItem.usageEnd) */
  usageEnd?: string
  /** Usage start note (LineItem.usageStartNote) */
  usageStartNote?: string
  /** Usage end note (LineItem.usageEndNote) */
  usageEndNote?: string
  /** Client reference / idempotency key (LineItem.usageSourceId) */
  usageSourceId?: string
  /** Product id (LineItem.productId) */
  productId?: string
  /** Types of EV charging products and services */
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Price id (LineItem.priceId) */
  priceId?: string
  /** Price description (LineItem.priceDesc) */
  priceDesc?: string
  /** Price type (LineItem.priceType) */
  priceType?: 'STRIPE' | 'SYNOP'
  /** Measurand for usage quantity (LineItem.measurand) */
  measurand?: 'DISTANCE_DRIVEN' | 'ENERGY_ADDED' | 'ENERGY_USED' | 'TIME_USED' | 'COUNT'
  /** Usage quantity unit (LineItem.usageUnits) */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Applied rate in major currency units (LineItem.appliedRate) */
  appliedRate?: number
  /** Site / depot id (LineItem.depotId) */
  depotId?: string
  /** Site / depot name (LineItem.depotNm) */
  depotNm?: string
  /** Charger id (LineItem.chargerId) */
  chargerId?: string
  /** Charger name (LineItem.chargerNm) */
  chargerNm?: string
  /** Connector id (LineItem.connectorId) */
  connectorId?: string
  /** Vehicle id (LineItem.vehicleId) */
  vehicleId?: string
  /** Vehicle name (LineItem.vehicleNm) */
  vehicleNm?: string
  /** Fleet id (LineItem.fleetId) */
  fleetId?: string
  /** Types of entities that can be associated with products and billing */
  usageEntityType?:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  /** Usage entity id (LineItem.usageEntityId) */
  usageEntityId?: string
}
export type ArtifactAccessKey = {
  /** AWS access key id */
  accessKeyId?: string
  /** Status of a merchant artifact-storage access key */
  status?: 'ACTIVE' | 'INACTIVE'
  /** When the key was created */
  createdAt?: string
  /** When AWS last saw a request signed with this key; null if never used */
  lastUsedAt?: string | null
  /** AWS service the key was last used with, e.g. s3 */
  lastUsedService?: string | null
  /** AWS region the key was last used in */
  lastUsedRegion?: string | null
}
export type ArtifactStorageAccess = {
  /** The organization the access is scoped to */
  organizationId?: string
  /** Whether a storage user has been provisioned yet; false until the first key is created */
  provisioned?: boolean
  /** IAM user name of the storage user, once provisioned */
  userName?: string | null
  /** S3 bucket name */
  bucket?: string
  /** AWS region of the bucket */
  region?: string
  /** The only key prefix (folder) the keys can read: {merchantOrganizationId}/ */
  prefix?: string
  /** s3://{bucket}/{prefix} — the folder to point an S3 client at */
  s3Uri?: string
  /** Maximum number of keys that may exist at once (AWS limit); two allows zero-downtime rotation */
  maxKeys?: number
  /** Existing keys, newest first */
  keys?: ArtifactAccessKey[]
  /** CIDR blocks (IPv4 or IPv6) requests signed with the keys must originate from; a request from anywhere else is refused even with a valid key. Empty until set, and no key can be created while it is empty. */
  allowedSourceIps?: string[]
  /** Maximum number of allowed source IP entries */
  maxAllowedSourceIps?: number
  /** Files copied into the pickup folder for every invoice that closes, in a fixed order. Empty while invoice pickup is off. */
  pickupArtifacts?: (
    | 'INVOICE_PDF'
    | 'ATTACHMENT_PDF'
    | 'INVOICE_CSV'
    | 'LINE_ITEMS_CSV'
    | 'LINE_ITEM_GROUPS_CSV'
    | 'LINE_ITEM_TAXES_CSV'
    | 'INVOICE_TAXES_CSV'
    | 'SCHEMA_JSON'
    | 'INVOICE_JSON'
    | 'INVOICE_XML'
    | 'ARCHIVE'
  )[]
  /** The flat folder invoice pickup delivers into: {merchantOrganizationId}/pickup/. Your keys can read it like the rest of your folder and, while pickup is on, delete files from it. */
  pickupPrefix?: string
  /** s3://{bucket}/{pickupPrefix} — the folder to point a polling integration at */
  pickupS3Uri?: string
}
export type ArtifactPickupParams = {
  /** The files to copy into the pickup folder for each invoice. At least one is required; to turn pickup off, delete the setting instead. */
  artifactTypes: (
    | 'INVOICE_PDF'
    | 'ATTACHMENT_PDF'
    | 'INVOICE_CSV'
    | 'LINE_ITEMS_CSV'
    | 'LINE_ITEM_GROUPS_CSV'
    | 'LINE_ITEM_TAXES_CSV'
    | 'INVOICE_TAXES_CSV'
    | 'INVOICE_JSON'
    | 'INVOICE_XML'
    | 'ARCHIVE'
  )[]
}
export type ArtifactAccessAllowedSourcesParams = {
  /** CIDR blocks (IPv4 or IPv6) that requests signed with your keys must originate from, e.g. the published egress addresses of your integration platform. A plain address is taken as a single-host block. Requests from anywhere else are refused even with a valid key, so at least one entry is required and a catch-all block (/0) is not accepted. */
  allowedSourceIps: string[]
}
export type RemittanceDetails = {
  /** Bankgiro number, digits and hyphens. */
  bankgiro?: string
  /** Plusgiro number, digits and hyphens. */
  plusgiro?: string
  /** IBAN; spaces are removed and the mod-97 check digits verified. */
  iban?: string
  /** BIC / SWIFT code of the IBAN account (8 or 11 characters). */
  bic?: string
  /** Bank holding the IBAN account. */
  bankName?: string
  /** Holder of the account. */
  accountHolder?: string
  /** Reference the payor quotes: OCR (a Swedish OCR number generated from the invoice number) or INVOICE_NUMBER. Defaults to INVOICE_NUMBER. */
  referenceType?: 'OCR' | 'INVOICE_NUMBER'
  /** Free text printed under the bank details. */
  note?: string
}
export type InvoicePaymentOptions = {
  /** Online payment methods the merchant offers on invoices. Null when not configured: invoices derive their methods from the account's capabilities. An empty list turns every online method off. Each invoice offers only the methods its currency and the account's country support. */
  allowedPaymentMethods?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  /** Whether Synop-rendered invoices, emails and the hosted invoice page offer an off-platform bank transfer to the remittance account. The merchant marks such invoices paid. */
  offlineBankTransferEnabled: boolean
  remittance?: RemittanceDetails
  /** Whether Synop-rendered invoices and emails show the Pay online link. Hidden regardless when the invoice offers no online method. */
  showPayOnlineLink: boolean
  /** Whether allowedPaymentMethods has been configured (false means derived from capabilities). */
  configured: boolean
}
export type InvoicePaymentOptionsRead = {
  /** Online payment methods the merchant offers on invoices. Null when not configured: invoices derive their methods from the account's capabilities. An empty list turns every online method off. Each invoice offers only the methods its currency and the account's country support. */
  allowedPaymentMethods?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  /** Whether Synop-rendered invoices, emails and the hosted invoice page offer an off-platform bank transfer to the remittance account. The merchant marks such invoices paid. */
  offlineBankTransferEnabled: boolean
  remittance?: RemittanceDetails
  /** Whether Synop-rendered invoices and emails show the Pay online link. Hidden regardless when the invoice offers no online method. */
  showPayOnlineLink: boolean
  /** Read-only: the online methods this account's requested capabilities and country support in the queried currency; allowedPaymentMethods may only name these. Omitted on the connected account itself. */
  availablePaymentMethods?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  /** Whether allowedPaymentMethods has been configured (false means derived from capabilities). */
  configured: boolean
}
export type InvoicePaymentOptionsUpdateParams = {
  /** Online payment methods to offer. Null (or omitted) derives them from the account's capabilities; an empty list offers none. Each must be available for the account's default currency. */
  allowedPaymentMethods?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  /** Offer an off-platform bank transfer to the remittance account. */
  offlineBankTransferEnabled?: boolean
  remittance?: RemittanceDetails
  /** Show the Pay online link on invoices and emails. Defaults to true. */
  showPayOnlineLink?: boolean
}
export type AssistantBillingConfig = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  configId: string
  organizationId: string
  billableOrganizationId: string
  enabled: boolean
  currency: string
  monthlyCreditAmount: number
  markupBasisPoints: number
  autoReloadEnabled: boolean
  autoReloadThreshold?: number
  autoReloadAmount?: number
  stripeCustomerId?: string
}
export type AssistantAutoReloadRequest = {
  /** Whether auto-reload is enabled. */
  enabled: boolean
  /** Balance at/below which a reload triggers, minor units. Required when enabling. */
  threshold?: number
  /** Amount to purchase per reload, minor units. Required when enabling. */
  amount?: number
}
export type AgreementStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'CANCELLED'
  | 'DRAFT'
  | 'EXPIRED'
  | 'PENDING'
  | 'SUSPENDED'
  | 'TERMINATED'
export type AgreementAuthorizedEntityResponse = {
  /** Unique identifier of the authorized entity */
  id: string
  /** Type of the authorized entity */
  entityType: 'FLEET' | 'USER' | 'USER_GROUP' | 'VEHICLE' | 'AUTH_TAG'
  /** ID of the entity */
  entityId: string
}
export type AgreementProductResponse = {
  /** Unique identifier of the agreement product assignment */
  id?: string
  /** ID of the product */
  productId?: string
  /** Name of the product */
  productName?: string
  /** ID of the price assigned to this agreement product */
  priceId?: string
  /** Display name or label for the assigned price */
  priceName?: string
  /** Billable quantity for flat-rate period fees and for volume tiers when tierQuantitySource is AGREEMENT_QUANTITY */
  quantity?: number
  /** Optional override for volume tier quantity source. When null, the assigned price tierQuantitySource applies. */
  tierQuantitySource?: 'ENTITY_COUNT' | 'AGREEMENT_QUANTITY' | 'USAGE'
  /** Optional billing level (CHARGER | CONNECTOR) for ENTITY_COUNT quantity. */
  entityCountLevel?: 'CHARGER' | 'CONNECTOR'
  /** When this assignment becomes billable */
  effectiveFrom?: string
  /** When this assignment ended; null means current */
  effectiveTo?: string
  /** Status of a product in the billing system */
  productStatus?: 'ACTIVE' | 'ARCHIVED'
  /** Authorized entities for this product */
  authorizedEntities?: AgreementAuthorizedEntityResponse[]
  /** Entity selections scoping the assigned product; root selections only, children nested */
  entitySelections?: ProductEntitySelectionResponse[]
  /** Whether the agreement product is currently active */
  isActive?: boolean
}
export type AgreementDiscountTierResponse = {
  /** Unique identifier of the tier */
  id: string
  /** Starting quantity for this tier (inclusive) */
  startQuantity: number
  /** Ending quantity for this tier (exclusive). If null, represents unlimited usage. */
  endQuantity?: number
  /** Discount amount (percentage or fixed amount in cents based on discount type) */
  discountAmount: number
  /** COURTESY discounts only: the period (DAY or WEEK) this tier's quantity resets over. */
  period?: 'DAY' | 'WEEK'
}
export type AgreementDiscountResponse = {
  /** Unique identifier of the discount */
  id: string
  /** Descriptive name of the discount (e.g., 'Volume Discount - Tier 1', 'Early Bird Discount') */
  name: string
  /** Type of discount (PERCENTAGE for percentage off, FLAT for fixed amount off) */
  discountType: 'FLAT' | 'PERCENTAGE'
  /** How the discount is applied. VOLUME applies the selected tier to the entire quantity; FIRST_UNITS applies tiers from the start of the session quantity; COURTESY discounts the first units per day and week across every session of the driver, one tier per period, DRIVER agreements only. */
  application?: 'VOLUME' | 'FIRST_UNITS' | 'COURTESY'
  /** Unit used for tier quantities (e.g., KWH, MINUTES, MILES) */
  quantityUnit?: 'KWH' | 'MINUTES' | 'MILES'
  /** COURTESY discounts only: the day the weekly courtesy quantity resets on. Null otherwise. */
  weekStartDay?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Set of product IDs that this discount applies to */
  applicableProductIds: string[]
  /** Usage tiers defining discount amounts based on quantity thresholds */
  tiers: AgreementDiscountTierResponse[]
  /** Whether the discount is currently active */
  isActive?: boolean
}
export type AgreementCommitmentResponse = {
  /** Unique identifier of the commitment */
  id: string
  /** Descriptive name of the commitment */
  name: string
  /** Type of commitment that can be applied to agreement products */
  commitmentType: 'COST' | 'USAGE'
  /** Committed usage quantity. Required when commitmentType is USAGE. */
  usageQuantity?: number
  /** Committed cost amount in cents. Required when commitmentType is COST. */
  costAmount?: number
  /** Set of product IDs that this commitment applies to */
  productIds: string[]
  /** Whether the commitment is currently active */
  isActive?: boolean
}
export type PeakSaverConfiguration = {
  /** Unique identifier of the configuration */
  id?: string
  /** Agreement ID this configuration applies to */
  agreementId?: string
  /** Whether peak saver throttling is enabled. When enabled, sessions throttle charging power during the most expensive time-of-use period. */
  enabled?: boolean
  /** Type of peak saver throttling behavior */
  saveType?: 'POWER' | 'PERCENTAGE'
  /** Quantity value interpreted by saveType: kW for POWER (e.g., 4.0 means throttle to 4 kW), percentage for PERCENTAGE (e.g., 80 means reduce by 80%) */
  quantity?: number
  /** Configuration creation timestamp */
  createdAt?: string
  /** Configuration last update timestamp */
  updatedAt?: string
}
export type DemandChargeAllocationConfiguration = {
  /** Unique identifier of the configuration */
  id?: string
  /** Agreement ID this configuration applies to */
  agreementId?: string
  /** Whether demand-charge allocation is enabled. When enabled, period close adds a 'Demand Charge' line item per site to the period invoice. */
  enabled?: boolean
  /** How a customer's share of a site's utility demand charge is computed at period close */
  allocationMethod?: 'SITE_PEAK_CONTRIBUTION' | 'CUSTOMER_PEAK'
  /** Percentage of the computed demand charge passed through to the customer (0-100) */
  passThroughPercentage?: number
  /** Configuration creation timestamp */
  createdAt?: string
  /** Configuration last update timestamp */
  updatedAt?: string
}
export type AgreementResponse = {
  /** Unique identifier of the agreement */
  id?: string
  /** ID of the organization that owns the agreement */
  payeeOrganizationId?: string
  /** Display name for the payee (provider) organization */
  payeeOrganizationName?: string
  /** ID of the payor organization or integration */
  payorOrganizationId?: string
  /** Display name for the payor organization or integration */
  payorOrganizationName?: string
  /** Name of the agreement */
  name?: string
  /** Stripe customer ID associated with the agreement */
  customerId?: string
  /** Start date of the agreement */
  startDate?: string
  /** End date of the agreement */
  endDate?: string
  /** Whether the agreement automatically renews */
  autoRenew?: boolean
  /** Whether the agreement automatically charges customers */
  autoCharge?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Billing cycle for the agreement */
  billingCycle?: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month when monthly or annual billing cycles start */
  billingAnchorDayOfMonth?: number
  /** Day of week when weekly billing cycles start */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Agreement terms */
  terms?: string
  status?: AgreementStatus
  /** Type of agreement that defines the relationship between organizations */
  type?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** Category of agreement that defines who is responsible for payment */
  category?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Primary contact name */
  primaryContactName?: string
  /** Primary contact email */
  primaryContactEmail?: string
  /** Public id (template_*) of the invoice template applied when minting invoices for this agreement */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language?: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Arbitrary string key-value metadata for this agreement */
  metadata?: {
    [key: string]: string
  }
  /** Products included in the agreement */
  products?: AgreementProductResponse[]
  /** Discounts included in the agreement */
  discounts?: AgreementDiscountResponse[]
  /** Commitments included in the agreement */
  commitments?: AgreementCommitmentResponse[]
  /** Agreement creation timestamp */
  createdAt?: string
  /** Agreement update timestamp */
  updatedAt?: string
  /** Days after billing cycle end until invoice is due */
  invoiceDueDays?: number
  /** How many of the agreement's first Synop-issued invoices are held for review before issue */
  reviewFirstInvoices?: number
  /** Whether prepayment is required */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents */
  initialPrepaymentAmount?: number
  /** Balance threshold in cents that triggers a top-off payment */
  topOffThreshold?: number
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether authorization charges are enabled */
  authorizationChargeEnabled?: boolean
  /** Whether peak-saver throttling is enabled for sessions under this agreement. */
  peakSaverEnabled?: boolean
  peakSaverConfiguration?: PeakSaverConfiguration
  demandChargeAllocationConfiguration?: DemandChargeAllocationConfiguration
  /** Non-blocking configuration warnings, e.g. covered sites without a utility tariff demand component when demand-charge allocation is enabled. Only populated on create/update responses. */
  warnings?: string[]
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays?: number
  /** Public id (mpo_*) of the marketplace offering this agreement was created from */
  sourceOfferingId?: string
  /** Computed billing onboarding state for a marketplace agreement */
  billingSetupStatus?: 'NOT_REQUIRED' | 'PENDING_CONNECT' | 'PENDING_PAYMENT_METHOD' | 'READY'
  /** Synop customer directory id (customer_*) for this agreement's payor */
  synopCustomerId?: string
}
export type PeakSaverConfigurationUpdateParams = {
  /** Whether peak saver throttling is enabled. When enabled, sessions throttle charging power during the most expensive time-of-use period. */
  enabled?: boolean
  /** Type of peak saver throttling behavior */
  saveType?: 'POWER' | 'PERCENTAGE'
  /** Quantity value interpreted by saveType: kW for POWER (e.g., 4.0 means throttle to 4 kW), percentage for PERCENTAGE (e.g., 80 means reduce by 80%) */
  quantity?: number
}
export type DemandChargeAllocationConfigurationUpdateParams = {
  /** Whether demand-charge allocation is enabled */
  enabled?: boolean
  /** How a customer's share of a site's utility demand charge is computed at period close */
  allocationMethod?: 'SITE_PEAK_CONTRIBUTION' | 'CUSTOMER_PEAK'
  /** Percentage of the computed demand charge passed through to the customer (0-100) */
  passThroughPercentage?: number
}
export type AgreementAuthorizedEntityUpdateParams = {
  /** ID of the entity (vehicle ID, user ID, user group ID, fleet ID, or auth tag) */
  entityId: string
  /** Type of the authorized entity */
  entityType?: 'FLEET' | 'USER' | 'USER_GROUP' | 'VEHICLE' | 'AUTH_TAG'
}
export type AgreementProductUpdateParams = {
  /** ID of the product */
  productId: string
  /** Billable quantity for flat-rate period fees and for volume tiers when tierQuantitySource is AGREEMENT_QUANTITY (defaults to 1) */
  quantity?: number
  /** Optional override for volume tier quantity source. When null, the assigned price tierQuantitySource applies. */
  tierQuantitySource?: 'ENTITY_COUNT' | 'AGREEMENT_QUANTITY' | 'USAGE'
  /** Optional billing level (CHARGER | CONNECTOR) for ENTITY_COUNT quantity. */
  entityCountLevel?: 'CHARGER' | 'CONNECTOR'
  /** ID of the price to assign; defaults to the product default price */
  priceId?: string
  /** When this assignment becomes effective; defaults to agreement start or now */
  effectiveFrom?: string
  /** Assets to be included with this product */
  assets?: string[]
  /** Authorized entities for this product */
  authorizedEntities?: AgreementAuthorizedEntityUpdateParams[]
}
export type AgreementDiscountTierCreateParams = {
  /** Starting quantity for this tier (inclusive) */
  startQuantity: number
  /** Ending quantity for this tier (exclusive). If null, represents unlimited usage. */
  endQuantity?: number
  /** Discount amount (percentage or fixed amount in cents based on discount type) */
  discountAmount: number
  /** COURTESY discounts only: the period (DAY or WEEK) this tier's quantity resets over; endQuantity is then the courtesy quantity per period. Rejected on other applications. */
  period?: 'DAY' | 'WEEK'
  endQuantityValid?: boolean
}
export type AgreementDiscountCreateParams = {
  /** Descriptive name of the discount */
  name: string
  /** Type of discount (PERCENTAGE for percentage off, FLAT for fixed amount off) */
  discountType: 'FLAT' | 'PERCENTAGE'
  /** How the discount is applied. VOLUME applies the selected tier to the entire quantity; FIRST_UNITS applies tiers from the start of the session quantity; COURTESY discounts the first units per day and week across every session of the driver, one tier per period, DRIVER agreements only. */
  application?: 'VOLUME' | 'FIRST_UNITS' | 'COURTESY'
  /** Unit used for tier quantities (e.g., KWH, MINUTES, MILES) */
  quantityUnit?: 'KWH' | 'MINUTES' | 'MILES'
  /** COURTESY discounts only: the day the weekly courtesy quantity resets on, in the site's local time. Defaults to MONDAY. Rejected on other applications. */
  weekStartDay?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Set of product IDs that this discount applies to */
  applicableProductIds: string[]
  /** Usage tiers defining discount amounts based on quantity thresholds */
  tiers: AgreementDiscountTierCreateParams[]
}
export type AgreementCommitmentCreateParams = {
  /** Descriptive name of the commitment */
  name: string
  /** Type of commitment that can be applied to agreement products */
  commitmentType: 'COST' | 'USAGE'
  /** Committed usage quantity. Required when commitmentType is USAGE. */
  usageQuantity?: number
  /** Committed cost amount in cents. Required when commitmentType is COST. */
  costAmount?: number
  /** Set of product IDs that this commitment applies to */
  productIds: string[]
}
export type AgreementUpdateParams = {
  /** End date of the agreement (optional for auto-renewing agreements) */
  endDate?: string
  /** Start date of the agreement */
  startDate?: string
  /** Name of the agreement */
  name: string
  /** Whether the agreement should automatically charge customers */
  autoCharge?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Billing cycle for the agreement */
  billingCycle?: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month (1-31) when monthly or annual billing cycles start. If not specified, uses the start date. */
  billingAnchorDayOfMonth?: number
  /** Day of week (MONDAY, TUESDAY, etc.) when weekly billing cycles start. If not specified, uses the start date. */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Number of days after billing cycle end until invoice is due */
  invoiceDueDays?: number
  /** How many of the agreement's first Synop-issued invoices are held for review before they are issued. 0 never holds for this reason. Unchanged when omitted. */
  reviewFirstInvoices?: number
  /** Whether prepayment is required for this agreement. Unchanged when omitted. */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents. Unchanged when omitted. */
  initialPrepaymentAmount?: number
  /** Balance threshold in cents that triggers a top-off payment. Unchanged when omitted. */
  topOffThreshold?: number
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether authorization charges are enabled for this agreement */
  authorizationChargeEnabled?: boolean
  /** Whether peak-saver throttling is enabled. Unchanged when omitted. */
  peakSaverEnabled?: boolean
  peakSaverConfiguration?: PeakSaverConfigurationUpdateParams
  demandChargeAllocationConfiguration?: DemandChargeAllocationConfigurationUpdateParams
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test (cents for balance, days/count for others) */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays?: number
  /** Agreement terms and conditions */
  terms?: string
  /** Type of agreement that defines the relationship between organizations */
  type?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** Category of agreement that defines who is responsible for payment */
  category?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Primary contact name for the agreement */
  primaryContactName: string
  /** Primary contact email for the agreement */
  primaryContactEmail: string
  /** Public id (template_*) of the invoice template applied when minting invoices for this agreement */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language?: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Arbitrary string key-value metadata for this agreement. If provided, replaces existing metadata. */
  metadata?: {
    [key: string]: string
  }
  /** Products to be included in the agreement */
  products?: AgreementProductUpdateParams[]
  /** Discounts for the agreement. If provided, replaces all existing discounts. If not provided, existing discounts remain unchanged. */
  discounts?: AgreementDiscountCreateParams[]
  /** Commitments for the agreement. If provided, replaces all existing commitments. If not provided, existing commitments remain unchanged. */
  commitments?: AgreementCommitmentCreateParams[]
}
export type UserPushNotificationMap = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  userId?: string
  deviceId?: string
  snsArn?: string
}
export type CreateUserPushParams = {
  /** The user to attach a push notification topic to */
  userId: string
  /** Unique ID for the device */
  deviceId: string
  /** The token for this particular user to onboard */
  token: string
}
export type CardDetails = {
  /** Last 4 digits of the card */
  last4?: string
  /** Card brand */
  brand?: string
  /** Card expiration month */
  expMonth?: number
  /** Card expiration year */
  expYear?: number
  /** Card funding type */
  funding?: string
  /** Card fingerprint */
  fingerprint?: string
  /** Card issuer */
  issuer?: string
}
export type UsBankAccountDetails = {
  /** Bank name (e.g., Chase, Wells Fargo) */
  bankName?: string
  /** Last 4 digits of the account number */
  last4?: string
  /** Account type (checking or savings) */
  accountType?: string
  /** Account holder type (individual or company) */
  accountHolderType?: string
  /** ABA routing number for the bank */
  routingNumber?: string
  /** Stripe-stable fingerprint for the bank account */
  fingerprint?: string
}
export type SepaDebitDetails = {
  /** Last 4 digits of the IBAN */
  last4?: string
  /** Two-letter ISO country code of the bank account */
  country?: string
  /** Bank code of the bank account */
  bankCode?: string
  /** Branch code of the bank account */
  branchCode?: string
  /** Stripe-stable fingerprint for the SEPA debit account */
  fingerprint?: string
}
export type Address = {
  /** City */
  city?: string
  /** Country */
  country?: string
  /** Line 1 */
  line1?: string
  /** Line 2 */
  line2?: string
  /** Postal code */
  postalCode?: string
  /** State */
  state?: string
}
export type BillingDetails = {
  /** Billing email */
  email?: string
  /** Billing name */
  name?: string
  /** Billing phone */
  phone?: string
  address?: Address
}
export type PaymentMethodModel = {
  /** Unique identifier of the payment method */
  id?: string
  /** Type of the payment method (e.g., card, us_bank_account) */
  type?: string
  /** Whether this payment method is the default for the customer */
  isDefault?: boolean
  card?: CardDetails
  usBankAccount?: UsBankAccountDetails
  sepaDebit?: SepaDebitDetails
  billingDetails?: BillingDetails
  /** Additional metadata about the payment method */
  metadata?: {
    [key: string]: string
  }
}
export type BillingDetailsModel = {
  /** List of payment methods associated with the customer */
  paymentMethods?: PaymentMethodModel[]
  /** Customer's available balance */
  availableBalance?: number
  address?: Address
  /** Customer's email address */
  email?: string
  /** Customer's name */
  name?: string
  /** Customer's preferred currency */
  currency?: string
  /** Whether the customer has a valid payment method */
  hasValidPaymentMethod?: boolean
  /** Whether the customer has a default payment method */
  hasDefaultPaymentMethod?: boolean
}
export type FleetManagementUserTagModel = {
  /** Identifier for this user. The application of this value is predicated on the UserType (Synop User, External Workplace Charging User, etc) */
  userId?: string
  /** The value authorising a user. Example could be storing an RFID tag value for a user. */
  ocppTagValue?: string
  /** The type of tag this is. Could be RFID, QR Code, etc. */
  ocppTagType?: 'MOBILE' | 'NFC' | 'OTHER' | 'QR_CODE' | 'RFID' | 'VID'
  /** The use case this tag should be used for. Could be WORKPLACE_CHARGING, FLEET_CHARGING, etc. */
  ocppTagUseCase?: 'FLEET_CHARGING' | 'OPERATIONS' | 'OTHER' | 'REIMBURSEMENTS' | 'WORKPLACE_CHARGING'
  created?: string
  updated?: string
}
export type CdrToken = {
  /** ISO-3166 alpha-2 country code of the MSP that 'owns' this Token. */
  countryCode: string
  /** ID of the eMSP that 'owns' this Token (following the ISO-15118 standard). */
  partyId: string
  /** Unique ID by which this Token can be identified. This is the field used by the CPO's system (RFID reader on the Charge Point) to identify this token. Currently, in most cases: type=RFID, this is the RFID hidden ID as read by the RFID reader, but that is not a requirement. If this is a type=APP_USER Token, it will be a unique, by the eMSP, generated ID. */
  uid: string
  /** Type of the token */
  type: 'AD_HOC_USER' | 'APP_USER' | 'VEHICLE' | 'OTHER' | 'RFID'
  /** Uniquely identifies the EV driver contract token within the eMSP's platform (and suboperator platforms). Recommended to follow the specification for eMA ID from "eMI3 standard version V1.0" (<a href="http://emi3group.com/documents-links/">...</a>) "Part 2: business objects." */
  contractId: string
}
export type Price = {
  /** Price/Cost excluding VAT. */
  exclVat: number
  /** Price/Cost including VAT. */
  inclVat: number
}
export type CdrDimension = {
  /** Type of CDR dimension. */
  type:
    | 'CURRENT'
    | 'ENERGY'
    | 'ENERGY_EXPORT'
    | 'ENERGY_IMPORT'
    | 'MAX_CURRENT'
    | 'MIN_CURRENT'
    | 'MAX_POWER'
    | 'MIN_POWER'
    | 'PARKING_TIME'
    | 'POWER'
    | 'RESERVATION_TIME'
    | 'STATE_OF_CHARGE'
    | 'TIME'
  /** Volume of the dimension consumed, measured according to the dimension type. */
  volume: number
  price?: Price
}
export type ChargingPeriod = {
  /** Start timestamp of the charging period. This period ends when a next period starts, or the session ends. */
  startDateTime: string
  /** List of relevant values for this charging period. */
  dimensions: CdrDimension[]
  /** Unique identifier of the Tariff that is relevant for this Charging Period. If not provided, no Tariff is relevant during this period. */
  tariffId?: string
}
export type SessionDto = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr). */
  countryCode: string
  /** ID of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr) (following the ISO-15118 standard). */
  partyId: string
  /** The unique id that identifies the object in the CPO/eMSP platform. */
  id: string
  /** Timestamp when this object (e.g. Session, Tariff, Cdr) was last updated (or created). */
  lastUpdated: string
  /** The timestamp when the session became ACTIVE in the Charge Point. */
  startDateTime: string
  /** The timestamp when the session was completed/finished, charging might have finished before the session ends, for example: EV is full, but parking cost also has to be paid. */
  endDateTime?: string
  /** How many kWh were charged. */
  kwh: number
  cdrToken: CdrToken
  /** Method used for authentication. This might change during a session, for example when the session was started with a reservation: ReserveNow: COMMAND. When the. */
  authMethod: 'AUTH_REQUEST' | 'COMMAND' | 'WHITELIST'
  /** Reference to the authorization given by the eMSP. */
  authorizationReference?: string
  /** Location.id of the Location object of this CPO, on which the charging session is/was happening. */
  locationId: string
  /** EVSE.uid of the EVSE of this Location on which the charging session is/was happening. */
  evseUid: string
  /** Connector.id of the Connector of this Location where the charging session is/was happening. */
  connectorId: string
  /** Optional identification of the kWh meter. */
  meterId?: string
  /** ISO 4217 code of the currency used for this session. */
  currency: string
  /** An optional list of Charging Periods that can be used to calculate and verify the total cost. */
  chargingPeriods?: ChargingPeriod[]
  totalCost?: Price
  /** The status of the session. */
  status: 'ACTIVE' | 'COMPLETED' | 'INVALID' | 'PENDING' | 'RESERVATION'
}
export type ResponseFormatListSessionDto = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: SessionDto[]
  totalItems?: number
}
export type ChargingPreferences = {
  /** Type of Smart Charging Profile selected by the driver. The ProfileType has to be supported at the Connector and for every supported ProfileType, a Tariff MUST be provided. This gives the EV driver the option between different pricing options. */
  profileType: 'CHEAP' | 'FAST' | 'GREEN' | 'REGULAR'
  /** Expected departure. The driver has given this Date/Time as expected departure moment. It is only an estimation and not necessarily the Date/Time of the actual departure. */
  departureTime?: string
  /** Requested amount of energy in kWh. The EV driver wants to have this amount of energy charged. */
  energyNeed?: number
  /** Synop Added - Target State of Charge (SoC) in percentage. */
  targetSoc?: number
  /** The driver allows their EV to be discharged when needed, as long as the other preferences are met: EV is charged with the preferred energy (energy_need) until the preferred departure moment (departure_time). Default if omitted: false */
  dischargeAllowed?: boolean
}
export type ResponseFormatChargingPreferences = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: ChargingPreferences
  totalItems?: number
}
export type SourceAttributeValue = {
  source?: string
  attribute?: string
  value?: number
  unit?: string
  metadata?: {
    [key: string]: string
  }
  timestamp?: string
}
export type RatePeriod = {
  /** The parent id of the rate */
  rateId?: string
  /** The id of the rate period */
  ratePeriodId?: string
  /** The start time of the period */
  from: string
  /** The end time of the period */
  to: string
  /** The price in cents to apply to usage that happens within this period */
  price: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  priceId?: string
  productId?: string
  productNm?: string
  priceDesc?: string
  /** Pricing type of the product this rate was derived from (TIME_OF_USE, FLAT_RATE, PER_UNIT). */
  pricingType?: 'FLAT_RATE' | 'PER_UNIT' | 'TIME_OF_USE' | 'VOLUME_BASED' | 'TARIFF_PASS_THROUGH'
  /** Tariff pass-through premium type (FLAT per-kWh or PERCENTAGE of tariff cost). */
  premiumType?: 'FLAT' | 'PERCENTAGE'
  /** Tariff pass-through percentage premium in percentage points. */
  premiumPercent?: number
  /** Days of week this tariff is valid; omit for all days. */
  dayOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
}
export type Rate = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  rateId?: string
  timeOfUseRateUuid?: string
  rateNm?: string
  rateType?: 'FLAT' | 'TIER' | 'TIME_OF_USE' | 'TOU' | 'VOLUME_BASED'
  measurand?: 'DISTANCE_DRIVEN' | 'ENERGY_ADDED' | 'ENERGY_USED' | 'TIME_USED' | 'COUNT'
  effectiveFrom?: string
  effectiveTo?: string
  productId?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  ratePeriods?: RatePeriod[]
  idleFee?: number
  idleStepSize?: number
  gracePeriod?: number
  initiationFee?: number
  maxSoc?: number
  maxTime?: number
  lockRateAtPlugin?: boolean
}
export type TransactionSummaryModel = {
  /** The ID generated by Synop for a transaction. */
  id?: string
  /** The ID for a transaction stored by the charger. */
  transactionPk?: number
  /** The ID for the connector on which the transaction occurred . */
  connectorId?: number
  /** The name of the connector on which the transaction occurred. */
  connectorName?: string
  /** The internal ID of the charger on which the transaction occurred. */
  chargerPk?: number
  /** The OCPP ID for charger on which the transaction occurred. */
  chargerId?: string
  /** The name of the charger on which the transaction occurred. */
  chargerName?: string
  /** The id of the depot of which the charger belongs to. */
  depotId?: string
  /** The id of the organization of which the charger belongs to. */
  organizationId?: string
  /** The ocpp id tag associated with the transaction. */
  ocppTag?: string
  /** The reason why the transaction stopped. */
  stopReason?: string
  /** What caused the transaction to stop. */
  stopEventActor?: string
  /** The time in UTC in which the transaction started. */
  startTimestamp?: string
  /** The time in UTC in which the transaction stopped. */
  stopTimestamp?: string
  /** The time in UTC in which the transaction was updated. */
  updatedTimestamp?: string
  /** The total energy imported during the transaction in kiloWatt hours. */
  totalEnergyImported?: number
  /** The total energy exported during the transaction in kiloWatt hours. */
  totalEnergyExported?: number
  /** OCPP meterStart (StartTransaction) — import register at transaction begin, in Wh. */
  meterStart?: number
  /** OCPP meterStop (StopTransaction) — import register at transaction end, in Wh. */
  meterStop?: number
  /** The mean power imported during the transaction in kiloWatts. */
  meanPowerImport?: number
  /** The most recent power imported during the transaction in kiloWatts. */
  maxPowerImport?: number
  /** The latest power imported during the transaction in kiloWatts. */
  latestPowerImport?: number
  /** The mean power exported during the transaction in kiloWatts. */
  meanPowerExport?: number
  /** The max power exported during the transaction in kiloWatts. */
  maxPowerExport?: number
  /** The most recent power exported during the transaction in kiloWatts. */
  latestPowerExport?: number
  /** The mean power offered to the EV by the charger during the transaction in kiloWatts. */
  meanPowerOffered?: number
  /** The max power offered to the EV by the charger during the transaction in kiloWatts. */
  maxPowerOffered?: number
  /** The most recent power offered to the EV by the charger during the transaction in kiloWatts. */
  latestPowerOffered?: number
  /** The mean amperage of the transaction in Amps. */
  meanAmperageImport?: number
  /** The max amperage of the transaction in Amps. */
  maxAmperageImport?: number
  /** The most recent amperage of the transaction in Amps. */
  latestAmperageImport?: number
  /** The mean amperage offered to the EV by the charger during the transaction in Amps. */
  meanAmperageOffered?: number
  /** The max amperage offered to the EV by the charger during the transaction in Amps. */
  maxAmperageOffered?: number
  /** The most recent amperage offered to the EV by the charger during the transaction in Amps. */
  latestAmperageOffered?: number
  /** The minimum voltage during the transaction in Volts. */
  minVoltage?: number
  /** The mean voltage during the transaction in Volts. */
  meanVoltage?: number
  /** The max voltage during the transaction in Volts. */
  maxVoltage?: number
  /** The most recent voltage during the transaction in Volts. */
  latestVoltage?: number
  /** The minimum frequency during the transaction in Volts. */
  minFrequency?: number
  /** The mean frequency during the transaction in Volts. */
  meanFrequency?: number
  /** The max frequency during the transaction in Volts. */
  maxFrequency?: number
  /** The most recent frequency during the transaction in Volts. */
  latestFrequency?: number
  /** The starting temperature of the connector of the charger during the transaction in Celsius. */
  startingTemperature?: number
  /** The minimum temperature of the connector of the charger during the transaction in Celsius. */
  minTemperature?: number
  /** The mean temperature of the connector of the charger during the transaction in Celsius. */
  meanTemperature?: number
  /** The maximum temperature of the connector of the charger during the transaction in Celsius. */
  maxTemperature?: number
  /** The most recent temperature of the connector of the charger during the transaction in Celsius. */
  latestTemperature?: number
  /** The starting SoC of the EV during the transaction. */
  startingSoc?: number
  /** The most recent SoC of the EV during the transaction. */
  latestSoc?: number
  /** The timezone of the charger & site where the transaction took place. */
  timezone?: string
  /** The cost of the transaction in the currency of the organization. */
  transactionCost?: number
}
export type GeometryBigDecimal = {
  type?: string
  coordinates?: number[]
}
export type ConnectorStatusModel = {
  chargerId?: string
  chargerNm?: string
  connectorId?: number
  status?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
  currentCombinedStatus?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
    | 'Offline'
  legacyStatus?: string
  operationalStatus?: string
  occupiedStatus?: string
  simplifiedStatus?: string
  errorCode?: string
  errorInfo?: string
  vendorId?: string
  vendorErrorCode?: string
  statusTimestamp?: string
}
export type ConnectorUtilizationModel = {
  lastKnownPowerImportKw?: number
  livePowerImportKw?: number
  lastKnownPowerExportKw?: number
  livePowerExportKw?: number
}
export type LastMeterValuesModel = {
  currentImportAmps?: number
  currentImportAmpsTimestamp?: string
  voltage?: number
  voltageTimestamp?: string
  currentOfferedAmps?: number
  currentOfferedAmpsTimestamp?: string
  energyActiveImportRegisterKwh?: number
  energyActiveImportRegisterKwhTimestamp?: string
  powerActiveImportKw?: number
  powerActiveImportKwTimestamp?: string
  powerOfferedKw?: number
  powerOfferedKwTimestamp?: string
  powerActiveExportKw?: number
  powerActiveExportKwTimestamp?: string
  powerFactor?: number
  powerFactorTimestamp?: string
  temperature?: number
  temperatureTimestamp?: string
  soc?: number
  socTimestamp?: string
  currentExportAmps?: number
  currentExportAmpsTimestamp?: string
  energyActiveExportRegisterKwh?: number
  energyActiveExportRegisterKwhTimestamp?: string
}
export type ChargerStatusModel = {
  status?: 'Operative' | 'Faulted' | 'Unavailable' | 'Unknown' | 'PartiallyFaulted'
  currentCombinedStatus?: 'Operative' | 'Faulted' | 'Unavailable' | 'Unknown' | 'Offline' | 'PartiallyFaulted'
  statusTimestamp?: string
  operationalStatus?: string
  connectivityStatus?: string
}
export type ConnectorSimplifiedStatusCountsModel = {
  numConnectorsFaulted?: number
  numConnectorsUnavailable?: number
  numConnectorsPreparingOrCharging?: number
  numConnectorsFinishedCharging?: number
  numConnectorsUnoccupied?: number
}
export type ConnectorModel = {
  /** The ID of the connector */
  connectorId?: number
  /** The ID of the associated charger */
  chargerId?: string
  /** The connection type of the connector */
  connectorType?:
    | 'CHAdeMO'
    | 'J1772'
    | 'CCS1'
    | 'CCS2'
    | 'NACS'
    | 'Other'
    | 'Unknown'
    | 'CHADEMO'
    | 'CHAOJI'
    | 'DOMESTIC_A'
    | 'DOMESTIC_B'
    | 'DOMESTIC_C'
    | 'DOMESTIC_D'
    | 'DOMESTIC_E'
    | 'DOMESTIC_F'
    | 'DOMESTIC_G'
    | 'DOMESTIC_H'
    | 'DOMESTIC_I'
    | 'DOMESTIC_J'
    | 'DOMESTIC_K'
    | 'DOMESTIC_L'
    | 'DOMESTIC_M'
    | 'DOMESTIC_N'
    | 'DOMESTIC_O'
    | 'GBT_AC'
    | 'GBT_DC'
    | 'IEC_60309_2_single_16'
    | 'IEC_60309_2_three_16'
    | 'IEC_60309_2_three_32'
    | 'IEC_60309_2_three_64'
    | 'IEC_62196_T1'
    | 'IEC_62196_T1_COMBO'
    | 'IEC_62196_T2'
    | 'IEC_62196_T2_COMBO'
    | 'IEC_62196_T3A'
    | 'IEC_62196_T3C'
    | 'MCS'
    | 'NEMA_5_20'
    | 'NEMA_6_30'
    | 'NEMA_6_50'
    | 'NEMA_10_30'
    | 'NEMA_10_50'
    | 'NEMA_14_30'
    | 'NEMA_14_50'
    | 'PANTOGRAPH_BOTTOM_UP'
    | 'PANTOGRAPH_TOP_DOWN'
    | 'TESLA_R'
    | 'TESLA_S'
  connectorName?: string
  maxCurrent?: number
  maxPower?: number
  voltage?: number
  currentType?: string
  powerFactor?: number
}
export type EnergyEfficiencyModel = {
  value?: number
  sourceEntityType?: string
  sourceEntityId?: string
}
export type ChargerModel = {
  chargerId?: string
  chargerName?: string
  endpointAddress?: string
  ocppProtocol?: string
  registrationStatus?: string
  chargePointYear?: number
  chargePointVendor?: string
  chargePointModel?: string
  chargePointSerialNumber?: string
  chargeBoxSerialNumber?: string
  firmwareVersion?: string
  firmwareUpdateStatus?: string
  firmwareUpdateInferredStatus?: string
  firmwareUpdateTimestamp?: string
  iccid?: string
  imsi?: string
  location?: GeometryBigDecimal
  meterType?: string
  meterSerialNumber?: string
  diagnosticsStatus?: string
  diagnosticStatus?: string
  diagnosticsTimestamp?: string
  lastHeartbeatTimestamp?: string
  lastHeardTimestamp?: string
  description?: string
  note?: string
  autoRegisterTags?: boolean
  groupId?: string
  groupName?: string
  nodeId?: string
  nodeName?: string
  isDefaultNode?: boolean
  maxPower?: number
  maxCurrent?: number
  voltage?: number
  currentType?: string
  depotId?: string
  depotName?: string
  fleetId?: string
  externalId?: string
  latitude?: number
  longitude?: number
  created?: string
  updated?: string
  connectorIds?: number[]
  activeConnectorIds?: number[]
  connectorStatus?: {
    [key: string]: ConnectorStatusModel
  }
  connectorUtilization?: {
    [key: string]: ConnectorUtilizationModel
  }
  lastMeterValues?: {
    [key: string]: LastMeterValuesModel
  }
  lastTransactions?: {
    [key: string]: TransactionSummaryModel
  }
  latestChargerStatus?: ChargerStatusModel
  connectorSimplifiedStatusCounts?: ConnectorSimplifiedStatusCountsModel
  connectors?: {
    [key: string]: ConnectorModel
  }
  livePowerImport?: number
  livePowerImportKw?: number
  lastKnownPowerImportKw?: number
  livePowerImportUnit?: string
  livePowerExport?: number
  livePowerExportKw?: number
  lastKnownPowerExportKw?: number
  livePowerExportUnit?: string
  powerUnit?: string
  commissioningDate?: string
  decommissioningDate?: string
  networkConnectionMethod?: string
  networkConnectionDetails?: string
  utilityLocationId?: string
  isAdaAccessible?: boolean
  evseInstallationType?: string
  preferredProfileNumPhases?: number
  isSimulator?: boolean
  commissioningState?: string
  manufacturerId?: string
  manufacturerName?: string
  makeModelId?: string
  makeModelName?: string
  chargingProfilesRequireUniqueStackLevels?: boolean
  efficiency?: number
  energyEfficiencyDetail?: EnergyEfficiencyModel
}
export type AddressDetails = {
  streetAddress?: string
  city?: string
  state?: string
  postalCode?: string
  country?: string
}
export type SiteModel = {
  depotId?: string
  depotNm?: string
  externalId?: string
  fleetId?: string
  powerCeiling?: number
  currentCeiling?: number
  voltageCeiling?: number
  latitude?: number
  longitude?: number
  address?: string
  addressDetails?: AddressDetails
  timezone?: string
  v2gEnrolled?: boolean
  geofence?: string
  rateCardId?: string
  rateCardTierType?: string
  isLoadBalanced?: boolean
  created?: string
  updated?: string
  numChargers?: number
}
export type GeoLocation = {
  /** Latitude of the point in decimal degree. Example: 50.770774. Decimal separator: "." Regex: -?[0-9]{1,2}\.[0-9]{5,7} */
  latitude: string
  /** Longitude of the point in decimal degree. Example: -126.104965. Decimal separator: "." Regex: -?[0-9]{1,3}\.[0-9]{5,7} */
  longitude: string
}
export type Image = {
  /** URL from where the image data can be fetched through a web browser. */
  url: string
  /** URL from where a thumbnail of the image can be fetched through a web browser. */
  thumbnail?: string
  /** Describes what the image is used for. */
  category: 'CHARGER' | 'ENTRANCE' | 'LOCATION' | 'NETWORK' | 'OPERATOR' | 'OTHER' | 'OWNER'
  /** Image type like: gif, jpeg, png, svg. */
  type: string
  /** Width of the full scale image. */
  width?: string
  /** Height of the full scale image. */
  height?: string
}
export type BusinessDetails = {
  /** Phone number for the business. */
  phone_number?: string
  /** Name of the operator. */
  name: string
  /** Link to the operator's website. */
  website?: string
  logo?: Image
  /** Email address for the business. */
  email?: string
}
export type CdrLocation = {
  /** Uniquely identifies the location within the CPO's platform (and sub-operator platforms). This field can never be changed, modified or renamed. */
  locationId: string
  /** Display name of the location. */
  name?: string
  /** Street/block name and house number if available. */
  address: string
  /** City or town. */
  city: string
  /** Postal code of the location, may only be omitted when the location has no postal code: in some countries charging locations at highways don't have postal codes. */
  postalCode?: string
  /** State only to be used when relevant. */
  state?: string
  /** ISO 3166-1 alpha-3 code for the country of this location. */
  country: string
  coordinates: GeoLocation
  /** Uniquely identifies the EVSE within the CPO's platform (and suboperator platforms). */
  evseUid: string
  /** Compliant with the following specification for EVSE ID from "eMI3 standard version V1.0" (<a href="http://emi3group.com/documents-links/">...</a>) "Part 2: business objects.". */
  evseId: string
  /** Identifier of the connector within the EVSE. Allowed to be set to: #NA when this CDR is created for a reservation that never resulted in a charging session. */
  connectorId: string
  /** The standard of the installed connector. */
  connectorStandard?:
    | 'CHAdeMO'
    | 'J1772'
    | 'CCS1'
    | 'CCS2'
    | 'NACS'
    | 'Other'
    | 'Unknown'
    | 'CHADEMO'
    | 'CHAOJI'
    | 'DOMESTIC_A'
    | 'DOMESTIC_B'
    | 'DOMESTIC_C'
    | 'DOMESTIC_D'
    | 'DOMESTIC_E'
    | 'DOMESTIC_F'
    | 'DOMESTIC_G'
    | 'DOMESTIC_H'
    | 'DOMESTIC_I'
    | 'DOMESTIC_J'
    | 'DOMESTIC_K'
    | 'DOMESTIC_L'
    | 'DOMESTIC_M'
    | 'DOMESTIC_N'
    | 'DOMESTIC_O'
    | 'GBT_AC'
    | 'GBT_DC'
    | 'IEC_60309_2_single_16'
    | 'IEC_60309_2_three_16'
    | 'IEC_60309_2_three_32'
    | 'IEC_60309_2_three_64'
    | 'IEC_62196_T1'
    | 'IEC_62196_T1_COMBO'
    | 'IEC_62196_T2'
    | 'IEC_62196_T2_COMBO'
    | 'IEC_62196_T3A'
    | 'IEC_62196_T3C'
    | 'MCS'
    | 'NEMA_5_20'
    | 'NEMA_6_30'
    | 'NEMA_6_50'
    | 'NEMA_10_30'
    | 'NEMA_10_50'
    | 'NEMA_14_30'
    | 'NEMA_14_50'
    | 'PANTOGRAPH_BOTTOM_UP'
    | 'PANTOGRAPH_TOP_DOWN'
    | 'TESLA_R'
    | 'TESLA_S'
  /** The format (socket/cable) of the installed connector. */
  connectorFormat?: 'SOCKET' | 'CABLE'
  /** When this CDR is created for a reservation that never resulted in a charging session, this field can be set to any value and should be ignored by the Receiver. */
  connectorPowerType?: 'AC_1_PHASE' | 'AC_2_PHASE' | 'AC_2_PHASE_SPLIT' | 'AC_3_PHASE' | 'DC'
  operator?: BusinessDetails
}
export type DisplayText = {
  /** Language Code ISO 639-1. */
  language: string
  /** Text to be displayed to end user. No markup, html etc. allowed. */
  text: string
}
export type PriceComponent = {
  /** Type of tariff dimension. */
  type: 'ENERGY' | 'FLAT' | 'PARKING_TIME' | 'TIME'
  /** Price per unit (excl. VAT) for this tariff dimension. */
  price: number
  /** Applicable VAT percentage for this tariff dimension. If omitted, no VAT is applicable. Not providing a VAT is different from 0% VAT, which would be a value of 0.0 here. */
  vat?: number
  /** Minimum amount to be billed. This unit will be billed in this step_size blocks. Amounts that are less than this step_size are rounded up to the given step_size. For example: if type is TIME and step_size has a value of 300, then time will be billed in blocks of 5 minutes. If 6 minutes were used, 10 minutes (2 blocks of step_size) will be billed. */
  stepSize?: number
}
export type TariffRestrictions = {
  /** Start time of day in local time, the time zone is defined in the time_zone field of the Location, for example 13:30, valid from this time of the day. Must be in 24h format with leading zeros. Hour/Minute separator: ":" Regex: ([0-1][0-9]|2[0-3]):[0-5][0-9] */
  startTime?: string
  /** End time of day in local time, the time zone is defined in the time_zone field of the Location, for example 19:45, valid until this time of the day. Same syntax as start_time. If end_time < start_time then the period wraps around to the next day. To stop at end of the day use: 00:00. */
  endTime?: string
  /** Start date in local time, the time zone is defined in the time_zone field of the Location, for example: 2015-12-24, valid from this day (inclusive). Regex: ([12][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]) */
  startDate?: string
  /** End date in local time, the time zone is defined in the time_zone field of the Location, for example: 2015-12-27, valid until this day (exclusive). Same syntax as start_date. */
  endDate?: string
  /** Minimum consumed energy in kWh, for example 20, valid from this amount of energy (inclusive) being used. */
  minKwh?: number
  /** Maximum consumed energy in kWh, for example 50, valid until this amount of energy (exclusive) being used. */
  maxKwh?: number
  /** Sum of the minimum current (in Amperes) over all phases, for example 5. When the EV is charging with more than, or equal to, the defined amount of current, this TariffElement is/becomes active. If the charging current is or becomes lower, this TariffElement is not or no longer valid and becomes inactive. This describes NOT the minimum current over the entire Charging Session. This restriction can make a TariffElement become active when the charging current is above the defined value, but the TariffElement MUST no longer be active when the charging current drops below the defined value. */
  minCurrent?: number
  /** Sum of the maximum current (in Amperes) over all phases, for example 20. When the EV is charging with less than the defined amount of current, this TariffElement becomes/is active. If the charging current is or becomes higher, this TariffElement is not or no longer valid and becomes inactive. This describes NOT the maximum current over the entire Charging Session. This restriction can make a TariffElement become active when the charging current is below this value, but the TariffElement MUST no longer be active when the charging current raises above the defined value */
  maxCurrent?: number
  /** Minimum power in kW, for example 5. When the EV is charging with more than, or equal to, the defined amount of power, this TariffElement is/becomes active. If the charging power is or becomes lower, this TariffElement is not or no longer valid and becomes inactive. This describes NOT the minimum power over the entire Charging Session. This restriction can make a TariffElement become active when the charging power is above this value, but the TariffElement MUST no longer be active when the charging power drops below the defined value. */
  minPower?: number
  /** Maximum power in kW, for example 20. When the EV is charging with less than the defined amount of power, this TariffElement becomes/is active. If the charging power is or becomes higher, this TariffElement is not or no longer valid and becomes inactive. This describes NOT the maximum power over the entire Charging Session. This restriction can make a TariffElement become active when the charging power is below this value, but the TariffElement MUST no longer be active when the charging power raises above the defined value */
  maxPower?: number
  /** Minimum duration in seconds the Charging Session MUST last (inclusive). When the duration of a Charging Session is longer than the defined value, this TariffElement is or becomes active. Before that moment, this TariffElement is not yet active. */
  minDuration?: number
  /** Maximum duration in seconds the Charging Session MUST last (exclusive). When the duration of a Charging Session is shorter than the defined value, this TariffElement is or becomes active. After that moment, this TariffElement is no longer active. */
  maxDuration?: number
  /** Which day(s) of the week this TariffElement is active */
  dayOfWeek?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  reservation?: 'RESERVATION' | 'RESERVATION_EXPIRES'
}
export type TariffElement = {
  /** List of price components that describe the pricing of a tariff. */
  priceComponents: PriceComponent[]
  restrictions?: TariffRestrictions
}
export type EnergySource = {
  /** The type of energy source. */
  source: 'NUCLEAR' | 'GENERAL_FOSSIL' | 'COAL' | 'GAS' | 'GENERAL_GREEN' | 'SOLAR' | 'WIND' | 'WATER'
  /** Percentage of this source (0-100) in the mix. */
  percentage: number
}
export type EnvironmentalImpact = {
  /** The environmental impact category of this value. */
  category: 'NUCLEAR_WASTE' | 'CARBON_DIOXIDE'
  /** Amount of this portion in g/kWh. */
  amount: number
}
export type EnergyMix = {
  /** Key-value pairs (enum + percentage) of energy sources of this location's tariff. */
  energy_sources?: EnergySource[]
  /** Key-value pairs (enum + percentage) of nuclear waste and CO2 exhaust of this location's tariff. */
  environ_impact?: EnvironmentalImpact[]
  /** Name of the energy supplier, delivering the energy for this location or tariff. */
  supplier_name?: string
  /** Name of the energy suppliers product/tariff plan used at this location. */
  energy_product_name?: string
  is_green_energy?: boolean
}
export type TariffDto = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr). */
  countryCode: string
  /** ID of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr) (following the ISO-15118 standard). */
  partyId: string
  /** The unique id that identifies the object in the CPO/eMSP platform. */
  id: string
  /** Timestamp when this object (e.g. Session, Tariff, Cdr) was last updated (or created). */
  lastUpdated: string
  /** ISO-4217 code of the currency of this tariff. */
  currency: string
  /** Defines the type of the tariff. This allows for distinction in case of given Charging Preferences. When omitted, this tariff is valid for all sessions. */
  type?: 'AD_HOC_PAYMENT' | 'PROFILE_CHEAP' | 'PROFILE_FAST' | 'REGULAR' | 'PROFILE_GREEN'
  /** List of multi-language alternative tariff info texts */
  tariffAltText?: DisplayText[]
  /** URL to tariff info. */
  tariffAltUrl?: string
  minPrice?: Price
  maxPrice?: Price
  /** List of Tariff Elements. */
  elements: TariffElement[]
  /** The time when this tariff becomes active, in UTC, time_zone field of the Location can be used to convert to local time. Typically used for a new tariff that is already given with the location, before it becomes active. */
  startDateTime?: string
  /** The time after which this tariff is no longer valid, in UTC, time_zone field if the Location can be used to convert to local time. Typically used when this tariff is going to be replaced with a different tariff in the near future. */
  endDateTime?: string
  energyMix?: EnergyMix
}
export type SignedValue = {
  /** Nature of the value, in other words, the event this value belongs to. Possible values at moment of writing: - Start (value at the start of the Session) - End (signed value at the end of the Session) - Intermediate (signed values take during the Session, after Start, before End) Others might be added later. */
  nature: string
  /** The un-encoded string of data. The format of the content depends on the EncodingMethod field. */
  plainData: string
  /** Blob of signed data, base64 encoded. The format of the content depends on the EncodingMethod field. */
  signedData: string
}
export type SignedData = {
  /** The name of the encoding used in the SignedData field. This is the name given to the encoding by a company or group of companies. See note below. */
  encodingMethod: string
  /** Version of the EncodingMethod (when applicable) */
  encodingMethodVersion?: number
  /** Public key used to sign the data, base64 encoded. */
  publicKey?: string
  /** One or more signed values */
  signedValues: SignedValue[]
  /** URL that can be shown to an EV driver. This URL gives the EV driver the possibility to check the signed data from a charging session. */
  url?: string
}
export type CdrDto = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr). */
  countryCode: string
  /** ID of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr) (following the ISO-15118 standard). */
  partyId: string
  /** The unique id that identifies the object in the CPO/eMSP platform. */
  id: string
  /** Timestamp when this object (e.g. Session, Tariff, Cdr) was last updated (or created). */
  lastUpdated: string
  /** Start timestamp of the charging session, or in-case of a reservation (before the start of a session) the start of the reservation. */
  startDateTime: string
  /** The timestamp when the session was completed/finished, charging might have finished before the session ends, for example: EV is full, but parking cost also has to be paid. */
  endDateTime: string
  /** Unique ID of the Session for which this CDR is sent. */
  sessionId?: string
  authToken?: string
  cdrToken: CdrToken
  /** Method used for authentication. Multiple AuthMethods are possible during a charging sessions, for example when the session was started with a reservation. */
  authMethod: 'AUTH_REQUEST' | 'COMMAND' | 'WHITELIST'
  /** Reference to the authorization given by the eMSP. */
  authorizationReference?: string
  cdrLocation: CdrLocation
  /** Identification of the Meter inside the Charge Point. */
  meterId?: string
  /** Currency of the CDR in ISO 4217 Code. */
  currency: string
  /** List of relevant Tariff Elements, see: Tariff. When relevant, a Free of Charge tariff should also be in this list, and point to a defined Free of Charge Tariff. */
  tariffs?: TariffDto[]
  /** List of Charging Periods that make up this charging session. A session consists of 1 or more periods, where each period has a different relevant Tariff. */
  chargingPeriods: ChargingPeriod[]
  signedData?: SignedData
  totalCost: Price
  totalFixedCost?: Price
  /** Total energy charged, in kWh. */
  totalEnergy: number
  totalEnergyCost?: Price
  /** Total duration of the charging session (including the duration of charging and not charging), in hours. */
  totalTime: number
  totalTimeCost?: Price
  /** Total duration of the charging session where the EV was not charging (no energy was transferred between EVSE and EV), in hours. */
  totalParkingTime?: number
  totalParkingCost?: Price
  totalReservationCost?: Price
  remark?: string
  invoiceReferenceId?: string
  invoiceUrl?: string
  /** Status of the invoice: DRAFT, OPEN, PAID, UNCOLLECTIBLE, VOID, or PAST_DUE if the invoice is overdue */
  invoiceStatus?: 'DRAFT' | 'OPEN' | 'PAID' | 'UNCOLLECTIBLE' | 'VOID' | 'PAST_DUE'
  /** The due date of the invoice */
  invoiceDueDate?: string
  credit?: boolean
  creditReferenceId?: string
  homeChargingCompensation?: boolean
  transaction?: TransactionSummaryModel
}
export type LineItemRateDetail = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  lineItemRateDetailId?: string
  lineItemId?: string
  rateId?: string
  ratePeriodId?: string
  priceId?: string
  rateNm?: string
  rate?: number
  quantity?: number
  total?: number
  /** The time this period started. */
  detailStart?: string
  /** The time this period ended. */
  detailEnd?: string
  /** The type of line item. */
  lineItemType?:
    | 'CHARGE'
    | 'CREDIT'
    | 'REFUND'
    | 'DISCOUNT'
    | 'REIMBURSEMENT'
    | 'COMMITMENT'
    | 'IDLE_FEE'
    | 'WALLET_TOP_UP'
    | 'PARENT_REVENUE_SHARE'
    | 'INITIATION_FEE'
  /** Optional aggregate telemetry stats keyed by measurand. Null when unavailable. */
  statistics?: {
    [key: string]: LineItemStatisticValue
  }
}
export type LineItemTaxDetail = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  lineItemTaxDetailId?: string
  lineItemId?: string
  /** External id of the applied tax rate, e.g. tax_abc123. */
  taxId?: string
  /** Display name of the applied tax rate at the time of calculation. */
  taxRateName?: string
  taxType?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  /** The configured rate/value of the tax rate (percentage, per-unit rate, or flat amount). */
  rate?: number
  /** The taxable base this rate was applied to. */
  taxableAmount?: number
  /** This tax's contribution to the line item's total tax amount. */
  taxAmount?: number
  /** Stripe TaxRate id (PERCENTAGE taxes only; null for PER_UNIT / FLAT). */
  stripeTaxRateId?: string
  /** Scope that resolved this tax: agreement, price, product, meter, site, or charger. */
  source?: string
  /** Reason a line item was taxed (or not) */
  taxabilityReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  /** True when this tax is embedded in the line's charge (tax-inclusive pricing); false when it is added on top. Null on rows written before it was recorded. */
  taxIncluded?: boolean
}
export type CostComponent = {
  chargeAmount?: number
  taxAmount?: number
  totalAmount?: number
}
export type CostBreakdown = {
  energy?: CostComponent
  session?: CostComponent
  time?: CostComponent
  idle?: CostComponent
  reservation?: CostComponent
  total?: CostComponent
}
export type SynopLineItem = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  /** The unique identifier for the line item. */
  id?: string
  /** The organization ID that administered the product this line item was generated for. Example: a CPO. */
  administeringOrgId?: string
  /** The ID of the organization of the entity that paid for the product this line item was generated for. Example: the organization a driver belongs to. */
  payorOrgId?: string
  /** The type of line item. */
  lineItemType?:
    | 'CHARGE'
    | 'CREDIT'
    | 'REFUND'
    | 'DISCOUNT'
    | 'REIMBURSEMENT'
    | 'COMMITMENT'
    | 'IDLE_FEE'
    | 'WALLET_TOP_UP'
    | 'PARENT_REVENUE_SHARE'
    | 'INITIATION_FEE'
  /** The type of entity that received payment for this line item. */
  payeeType?: 'ORGANIZATION' | 'USER' | 'INTEGRATION'
  /** The ID of the entity that received payment for this line item. */
  payeeId?: string
  /** The type of entity that paid for this line item. */
  payorType?: 'ORGANIZATION' | 'USER' | 'INTEGRATION'
  /** The ID of the entity that paid for this line item. */
  payorId?: string
  /** The ID of the product this line item was generated for. */
  productId?: string
  /** The name of the product this line item was generated for. */
  productNm?: string
  /** Types of EV charging products and services */
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** The ID of the price that was applied to this line item. */
  priceId?: string
  /** The description of the price that was applied to this line item. */
  priceDesc?: string
  /** The type of price that was applied to this line item. */
  priceType?: 'STRIPE' | 'SYNOP'
  /** The type of measurand that was used to calculate the usage amount. */
  measurand?: 'DISTANCE_DRIVEN' | 'ENERGY_ADDED' | 'ENERGY_USED' | 'TIME_USED' | 'COUNT'
  /** The amount of usage that was billed. Example Measurand = ENERGY_ADDED, UsageAmount = 10.0, UsageUnits = KWH. This would represent 10.0 KWH of energy added to a vehicle. */
  usageAmount?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** The unit of measure for the chargeAmount that was billed in. */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** The start time of the usage period. */
  usageStart?: string
  /** Notes about the start of the usage. */
  usageStartNote?: string
  /** The end time of the usage period. */
  usageEnd?: string
  /** Notes about the end of the usage. */
  usageEndNote?: string
  /** The rate that was applied to the usage amount. */
  appliedRate?: number
  /** Describes whether this rate is a derived rate from multiple rates. */
  isBlended?: boolean
  rateDetail?: LineItemRateDetail[]
  /** The amount that was charged for the usage amount. */
  chargeAmount?: number
  /** Per-unit price in major units (manual rows). Null for usage-generated rows. */
  unitAmount?: number
  /** The total taxes applied to this line item. */
  taxAmount?: number
  /** Reason a line item was taxed (or not) */
  taxReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  /** Stripe product tax code (txcd_*) the tax classification resolved to at calculation time (product code, or the merchant default when the product had none). Null when unclassified. */
  taxCode?: string
  /** VAT place-of-supply category for a charge */
  supplyType?: 'ELECTRICITY' | 'GENERAL_SERVICE'
  /** Structured per-tax breakdown that sums to taxAmount (sibling of rateDetail). */
  taxDetails?: LineItemTaxDetail[]
  /** Any additional fees added to this line item. */
  additionalFees?: number
  /** The total amount that was charged for the usage amount, including taxes and fees. */
  totalAmount?: number
  /** Wallet minor units already debited for this session's running cost. */
  sessionDebitedAmount?: number
  /** Type of auth tag. */
  authTagType?: 'AD_HOC_USER' | 'APP_USER' | 'VEHICLE' | 'OTHER' | 'RFID'
  /** If applicable, the authorization tag that was used to authorize the usage. */
  authTag?: string
  /** The external ID attached to the auth tag type. For a user it would be the user entity externalId */
  authTagExternalId?: string
  /** The ID of the charger that was used to charge the vehicle. */
  chargerId?: string
  /** The ID of the connector that was used to charge the vehicle. */
  connectorId?: string
  /** The name of the charger that was used to charge the vehicle. */
  chargerNm?: string
  /** The ID of the site that was used to charge the vehicle. */
  depotId?: string
  /** The name of the site that was used to charge the vehicle. */
  depotNm?: string
  /** The ID of the vehicle that was charged. */
  vehicleId?: string
  /** The name of the vehicle that was charged. */
  vehicleNm?: string
  /** The ID of the fleet that the vehicle belongs to. */
  fleetId?: string
  /** Types of entities that can be associated with products and billing */
  usageEntityType?:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  /** The ID of the entity that provided the usage. */
  usageEntityId?: string
  /** Usage source id (transactionId, or balance_txn:<id> for payout ledger rows). */
  usageSourceId?: string
  billRunId?: string
  /** The ID of the agreement associated with this line item. */
  agreementId?: string
  /** The name of the agreement associated with this line item. Resolved at read time. */
  agreementNm?: string
  /** The invoice's human-facing number (the Invoice # shown in the Invoices table), resolved at read time. Null when the line item has no invoice yet or the invoice has no number yet. */
  invoiceNumber?: string
  /** External reference id for this line item. */
  externalId?: string
  /** The external Stripe invoice ID (in_*) that included this line item, if Stripe-backed. */
  invoiceId?: string
  /** The canonical Synop invoice id (invoice_*) that groups this line item. Set when the line item is invoiced; independent of whether a Stripe invoice exists. */
  synopInvoiceId?: string
  /** The status of the invoice associated with this line item. */
  invoiceStatus?:
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  /** The payment ID that paid for this line item. */
  paymentId?: string
  /** The charge ID that paid for this line item. */
  chargeId?: string
  /** The payout ID that included this line item. */
  payoutId?: string
  /** The ID of the balance transaction that included this line item. */
  balanceTransactionId?: string
  /** Identifier shared by your bank that connects to this payout and line item. May be referred to as a reference number. */
  traceId?: string
  /** The URL to the receipt for this paymentId. */
  receiptUrl?: string
  stripeFee?: number
  platformFee?: number
  totalFees?: number
  customerBalanceBefore?: number
  customerBalanceAfter?: number
  /** Total credit applied to this invoice/session (e.g., customer balance credit) in currency units. */
  appliedCredit?: number
  /** Peak saver cost save for this session. Zero when peak saver did not apply. */
  peakSaverCostSave?: number
  /** Idle fee after charging completes (SuspendedEV). See rateDetail IDLE_FEE. */
  idleFee?: number
  /** Total SuspendedEV minutes. Populated whenever idleFee is populated. */
  idleMinutes?: number
  /** Per-session initiation fee, snapshotted from the session's rate when it is rated. Not part of chargeAmount; included in totalAmount. See rateDetail INITIATION_FEE. */
  initiationFee?: number
  /** Optional aggregate telemetry stats keyed by measurand. Null when unavailable. */
  statistics?: {
    [key: string]: LineItemStatisticValue
  }
  /** Arbitrary string key-value metadata for this line item. Product metadata is snapshotted here when the line item is created. */
  metadata?: {
    [key: string]: string
  }
  signedMeterData?: SignedMeterData
  /** The status of the line item based on whether the usage period has ended. */
  status?: 'IN_PROGRESS' | 'COMPLETED'
  costBreakdown?: CostBreakdown
}
export type User = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  id?: string
  name?: string
  email?: string
  phoneNumber?: string
  organizationId?: string
  rfidTag?: string
  termsAccepted?: boolean
  termsAcceptedDt?: string
  preferredTimeZone?: string
  preferredDistanceUnits?: string
  preferredTemperatureUnits?: string
  preferredEfficiencyUnits?: string
  preferredTimeFormat?: string
  preferredDateFormat?: string
  active?: boolean
  connectedAccountId?: string
  externalId?: string
}
export type Vehicle = {
  id?: string
  vehicleNm?: string
  vin?: string
  make?: string
  model?: string
  modelYear?: number
  serialNumber?: string
  vehicleClass?: number
  vehicleType?: string
  batteryCapacity?: number
  estimatedRange?: number
  mpgEstimate?: number
  conventionalFuelType?: string
  purchaseDt?: string
  ocppTag?: string
  vehicleToGridCapable?: boolean
  efficiency?: number
  homeSiteId?: string
  homeSiteLatitude?: number
  homeSiteLongitude?: number
  providerId?: string
  active?: boolean
  externalId?: string
}
export type BillableTransactionEntity = {
  isMobileInitiated?: boolean
  userId?: string
  vehicleId?: string
  transactionId: string
  transactionPk?: number
  limitType?: 'TIME' | 'COST' | 'ENERGY' | 'STATE_OF_CHARGE'
  limitValue?: number
  siteId?: string
  chargerId?: string
  connectorId?: number
  authToken?: string
  tokenType?: 'AD_HOC_USER' | 'APP_USER' | 'VEHICLE' | 'OTHER' | 'RFID'
  authorizationId?: string
  rawIdTag?: string
  lastEnergyImport?: SourceAttributeValue
  lastEnergyExport?: SourceAttributeValue
  lastCurrentImport?: SourceAttributeValue
  lastCurrentExport?: SourceAttributeValue
  lastPowerImport?: SourceAttributeValue
  lastPowerExport?: SourceAttributeValue
  lastVoltage?: SourceAttributeValue
  lastSessionCost?: SourceAttributeValue
  lastSoc?: SourceAttributeValue
  chargeTimeRemaining?: SourceAttributeValue
  isFinalized?: boolean
  isBillable?: boolean
  rate?: Rate
  rateJson?: string
  timeOfUseRatePins?: {
    [key: string]: string
  }
  applicableRate?: RatePeriod
  applicableRates?: RatePeriod[]
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  transactionSummary?: TransactionSummaryModel
  charger?: ChargerModel
  site?: SiteModel
  cdr?: CdrDto
  lineItem?: SynopLineItem
  requestingUser?: User
  requestingVehicle?: Vehicle
  paymentId?: string
  externalId?: string
  chargeId?: string
  customerId?: string
  receiptEmail?: string
  setupIntentId?: string
  paymentIntentId?: string
  paymentMethodId?: string
  merchantAccountId?: string
  preAuthAmountCents?: number
  isPaymentIntentOnPlatform?: boolean
  isPhonePayment?: boolean
  additionalFees?: number
  receiptUrl?: string
  /** Types of EV charging products and services */
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  payeeType?: 'ORGANIZATION' | 'USER' | 'INTEGRATION'
  payeeId?: string
  payorType?: 'ORGANIZATION' | 'USER' | 'INTEGRATION'
  payorId?: string
  payorOrgId?: string
  administeringOrgId?: string
  agreementId?: string
  fleetId?: string
  stopReason?: string
  peakSaverEvaluatedAtStart?: boolean
  peakSaverEventId?: string
  peakSaverThrottleStartUtc?: string
  peakSaverThrottleEndUtc?: string
  peakSaverThrottlePowerKw?: number
  peakSaverCostSave?: number
}
export type UpdateSessionRequest = {
  sessionId: string
  /** The departure time to target. */
  departureTime?: string
  /** Session limit type: TIME, COST, ENERGY, or STATE_OF_CHARGE. Omit to charge to 100%. */
  limitType?: 'TIME' | 'COST' | 'ENERGY' | 'STATE_OF_CHARGE'
  /** Limit value; unit depends on limitType (minutes/dollars/kWh/percent). */
  limitValue?: number
}
export type PublishTokenType = {
  /** Unique ID by which this Token can be identified. */
  uid?: string
  /** Type of the token. */
  type?: 'AD_HOC_USER' | 'APP_USER' | 'VEHICLE' | 'OTHER' | 'RFID'
  /** Visual readable number/identification as printed on the Token (RFID card). */
  visualNumber?: string
  /** Issuing company, most of the time the name of the company printed on the token (RFID card), not necessarily the eMSP */
  issuer?: string
  /** This ID groups a couple of tokens. This can be used to make two or more tokens work as one. */
  groupId?: string
}
export type AdditionalGeoLocation = {
  /** Latitude of the point in decimal degree. Example: 50.770774. Decimal separator: "." Regex: -?[0-9]{1,2}\.[0-9]{5,7} */
  latitude: string
  /** Longitude of the point in decimal degree. Example: -126.104965. Decimal separator: "." Regex: -?[0-9]{1,3}\.[0-9]{5,7} */
  longitude: string
  name?: DisplayText
}
export type StatusSchedule = {
  /** Begin of the scheduled period. */
  periodBegin: string
  /** End of the scheduled period, if known. */
  periodEnd?: string
  /** Status value during the scheduled period. */
  status:
    | 'AVAILABLE'
    | 'BLOCKED'
    | 'CHARGING'
    | 'INOPERATIVE'
    | 'OUTOFORDER'
    | 'PLANNED'
    | 'REMOVED'
    | 'RESERVED'
    | 'UNKNOWN'
}
export type Connector = {
  /** Identifier of the Connector within the EVSE. Two Connectors may have the same id as long as they do not belong to the same EVSE object. */
  connectorId: string
  /** Display name of the connector. */
  connectorName?: string
  /** The standard of the installed connector. */
  standard:
    | 'CHAdeMO'
    | 'J1772'
    | 'CCS1'
    | 'CCS2'
    | 'NACS'
    | 'Other'
    | 'Unknown'
    | 'CHADEMO'
    | 'CHAOJI'
    | 'DOMESTIC_A'
    | 'DOMESTIC_B'
    | 'DOMESTIC_C'
    | 'DOMESTIC_D'
    | 'DOMESTIC_E'
    | 'DOMESTIC_F'
    | 'DOMESTIC_G'
    | 'DOMESTIC_H'
    | 'DOMESTIC_I'
    | 'DOMESTIC_J'
    | 'DOMESTIC_K'
    | 'DOMESTIC_L'
    | 'DOMESTIC_M'
    | 'DOMESTIC_N'
    | 'DOMESTIC_O'
    | 'GBT_AC'
    | 'GBT_DC'
    | 'IEC_60309_2_single_16'
    | 'IEC_60309_2_three_16'
    | 'IEC_60309_2_three_32'
    | 'IEC_60309_2_three_64'
    | 'IEC_62196_T1'
    | 'IEC_62196_T1_COMBO'
    | 'IEC_62196_T2'
    | 'IEC_62196_T2_COMBO'
    | 'IEC_62196_T3A'
    | 'IEC_62196_T3C'
    | 'MCS'
    | 'NEMA_5_20'
    | 'NEMA_6_30'
    | 'NEMA_6_50'
    | 'NEMA_10_30'
    | 'NEMA_10_50'
    | 'NEMA_14_30'
    | 'NEMA_14_50'
    | 'PANTOGRAPH_BOTTOM_UP'
    | 'PANTOGRAPH_TOP_DOWN'
    | 'TESLA_R'
    | 'TESLA_S'
  /** The format (socket/cable) of the installed connector. */
  format: 'SOCKET' | 'CABLE'
  /** Power type of the connector. */
  powerType: 'AC_1_PHASE' | 'AC_2_PHASE' | 'AC_2_PHASE_SPLIT' | 'AC_3_PHASE' | 'DC'
  /** Maximum voltage of the connector (line to neutral for AC_3_PHASE), in volt [V]. For example: DC Chargers might vary the voltage during charging when battery almost full. */
  maxVoltage: number
  /** Maximum amperage of the connector, in ampere [A]. */
  maxAmperage: number
  /** Maximum electric power that can be delivered by this connector, in Watts (W). When the maximum electric power is lower than the calculated value from voltage and amperage, this value should be set. For example: A DC Charge Point which can delivers up to 920V and up to 400A can be limited to a maximum of 150kW (max_electric_power = 150000). Depending on the car, it may supply max voltage or current, but not both at the same time. For AC Charge Points, the amount of phases used can also have influence on the maximum power */
  maxElectricPower?: number
  /** Indicates the current status of the connector. */
  status:
    | 'AVAILABLE'
    | 'BLOCKED'
    | 'CHARGING'
    | 'INOPERATIVE'
    | 'OUTOFORDER'
    | 'PLANNED'
    | 'REMOVED'
    | 'RESERVED'
    | 'UNKNOWN'
  /** Identifiers of the currently valid charging tariffs. Multiple tariffs are possible, but only one of each Tariff.type can be active at the same time. Tariffs with the same type are only allowed if they are not active at the same time: start_date_time and end_date_time period not overlapping. When preference-based smart charging is supported, one tariff for every possible ProfileType should be provided. These tell the user about the options they have at this Connector, and what the tariff is for every option. For a "free of charge" tariff, this field should be set and point to a defined "free of charge" tariff. */
  tariffIds?: string[]
  /** URL to the operator's terms and conditions. */
  termsAndConditions?: string
  /** Timestamp when this Connector was last updated (or created). */
  lastUpdated: string
  tariff?: TariffDto
  currentPrice?: PriceComponent
}
export type Evse = {
  /** Uniquely identifies the EVSE within the CPOs platform (and sub-operator platforms). For example a database ID or the actual "EVSE ID". This field can never be changed, modified or renamed. This is the 'technical' identification of the EVSE, not to be used as 'human-readable' identification, use the field evse_id for that. This field is named uid instead of id, because id could be confused with evse_id which is an eMI3 defined field. */
  uid: string
  /** Compliant with the following specification for EVSE ID from "eMI3 standard version V1.0" (<a href="http://emi3group.com/documents-links/"/>) "Part 2: business objects." Optional because: if an evse_id is to be re-used in the real world, the evse_id can be removed from an EVSE object if the status is set to REMOVED. */
  evseId?: string
  /** Indicates the current status of the EVSE. */
  status:
    | 'AVAILABLE'
    | 'BLOCKED'
    | 'CHARGING'
    | 'INOPERATIVE'
    | 'OUTOFORDER'
    | 'PLANNED'
    | 'REMOVED'
    | 'RESERVED'
    | 'UNKNOWN'
  /** Synop Added: Name of the EVSE. */
  evseName?: string
  /** Indicates a planned status update of the EVSE. */
  statusSchedule?: StatusSchedule[]
  /** List of functionalities that the EVSE is capable of. */
  capabilities?: (
    | 'CHARGING_PROFILE_CAPABLE'
    | 'CHARGING_PREFERENCES_CAPABLE'
    | 'CHIP_CARD_SUPPORT'
    | 'CONTACTLESS_CARD_SUPPORT'
    | 'CREDIT_CARD_PAYABLE'
    | 'DEBIT_CARD_PAYABLE'
    | 'PED_TERMINAL'
    | 'REMOTE_START_STOP_CAPABLE'
    | 'RESERVABLE'
    | 'RFID_READER'
    | 'START_SESSION_CONNECTOR_REQUIRED'
    | 'TOKEN_GROUP_CAPABLE'
    | 'UNLOCK_CAPABLE'
  )[]
  /** List of available connectors on the EVSE. */
  connectors: Connector[]
  /** Level on which the Charge Point is located (in garage buildings) in the locally displayed numbering scheme. */
  floorLevel?: string
  coordinates?: GeoLocation
  /** A number/string printed on the outside of the EVSE for visual identification. */
  physicalReference?: string
  /** Multi-language human-readable directions when more detailed information on how to reach the EVSE from the Location is required. */
  directions?: DisplayText[]
  /** The restrictions that apply to the parking spot. */
  parkingRestrictions?: ('EV_ONLY' | 'PLUGGED' | 'DISABLED' | 'CUSTOMERS' | 'MOTORCYCLES')[]
  /** Links to images related to the EVSE such as photos or logos. */
  images?: Image[]
  /** Timestamp when this EVSE or one of its Connectors was last updated (or created). */
  lastUpdated: string
  tariff?: TariffDto
  currentPrice?: PriceComponent
  charger?: ChargerModel
}
export type RegularHours = {
  /** Number of day in the week, from Monday (1) till Sunday (7) */
  weekday: number
  /** Begin of the regular period, in local time, given in hours and minutes. Must be in 24h format with leading zeros. Example: "18:15". Hour/Minute separator: ":" Regex: ([0-1][0-9]|2[0-3]):[0-5][0-9]. */
  periodBegin: string
  /** End of the regular period, in local time, syntax as for period_begin. Must be later than period_begin. */
  periodEnd: string
}
export type ExceptionalPeriod = {
  /** Begin of the exception. In UTC, time_zone field can be used to convert to local time. */
  periodBegin: string
  /** End of the exception. In UTC, time_zone field can be used to convert to local time. */
  periodEnd: string
}
export type Hours = {
  /** True to represent 24 hours a day and 7 days a week, except the given exceptions. */
  twentyFourSeven: boolean
  /** Regular hours, weekday-based. Only to be used if twentyfourseven=false, then this field needs to contain at least one RegularHours object. */
  regularHours?: RegularHours[]
  /** Exceptions for specified calendar dates, time-range based. Periods the station is operating/accessible. Additional to regular_hours. May overlap regular rules. */
  exceptionalOpenings?: ExceptionalPeriod[]
  /** Exceptions for specified calendar dates, time-range based. Periods the station is not operating/accessible. Overwriting regular_hours and exceptional_openings. Should not overlap exceptional_openings. */
  exceptionalClosings?: ExceptionalPeriod[]
}
export type Instruction = {
  /** Title of the instruction. */
  title?: string
  /** Description of the instruction. */
  description?: string
  /** Whether the instruction links to a mobile app. */
  isMobileAppLink?: boolean
}
export type Location = {
  /** ISO-3166 alpha-2 country code of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr). */
  countryCode: string
  /** ID of the CPO that 'owns' this object (e.g. Session, Tariff, Cdr) (following the ISO-15118 standard). */
  partyId: string
  /** The unique id that identifies the object in the CPO/eMSP platform. */
  id: string
  /** Timestamp when this object (e.g. Session, Tariff, Cdr) was last updated (or created). */
  lastUpdated: string
  /** Defines if a Location may be published on an website or app etc. When this is set to false, only tokens identified in the field: publish_allowed_to are allowed to be shown this Location. When the same location has EVSEs that may be published and may not be published, two 'Locations' should be created. */
  publish: boolean
  /** This field may only be used when the published field is set to false. Only owners of Tokens that match all the set fields of one PublishToken in the list are allowed to be shown this location. */
  publishAllowedTo?: PublishTokenType[]
  /** Display name of the location. */
  name?: string
  /** Street/block name and house number if available. */
  address: string
  /** City or town. */
  city: string
  /** Postal code of the location, may only be omitted when the location has no postal code: in some countries charging locations at highways don't have postal codes. */
  postalCode?: string
  /** State or province of the location, only to be used when relevant. */
  state?: string
  /** ISO 3166-1 alpha-3 code for the country of this location. */
  country: string
  coordinates: GeoLocation
  /** Geographical location of related points relevant to the user. */
  relatedLocations?: AdditionalGeoLocation[]
  /** The general type of parking at the charge point location. */
  parking_type?:
    | 'ALONG_MOTORWAY'
    | 'PARKING_GARAGE'
    | 'PARKING_LOT'
    | 'ON_DRIVEWAY'
    | 'ON_STREET'
    | 'UNDERGROUND_GARAGE'
  /** List of EVSEs that belong to this Location. */
  evses?: Evse[]
  /** Human-readable directions on how to reach the location. */
  directions?: DisplayText[]
  operator?: BusinessDetails
  suboperator?: BusinessDetails
  owner?: BusinessDetails
  /** Optional list of facilities this charging location directly belongs to. */
  facilities?: (
    | 'HOTEL'
    | 'RESTAURANT'
    | 'CAFE'
    | 'MALL'
    | 'SUPERMARKET'
    | 'SPORT'
    | 'RECREATION_AREA'
    | 'NATURE'
    | 'MUSEUM'
    | 'BIKE_SHARING'
    | 'BUS_STOP'
    | 'TAXI_STAND'
    | 'TRAM_STOP'
    | 'METRO_STATION'
    | 'TRAIN_STATION'
    | 'AIRPORT'
    | 'PARKING_LOT'
    | 'CARPOOL_PARKING'
    | 'FUEL_STATION'
    | 'WIFI'
    | 'RESTROOM'
  )[]
  /** One of IANA tzdata's TZ-values representing the time zone of the location. Examples: "Europe/Oslo", "Europe/Zurich". (@see <a href="http://www.iana.org/time-zones">Time Zones</a>) */
  timeZone: string
  openingTimes?: Hours
  /** Indicates if the EVSEs are still charging outside the opening hours of the location. E.g. when the parking garage closes its barriers over-night, is it allowed to charge till the next morning? Default: true */
  chargingWhenClosed?: boolean
  /** Links to images related to the location such as photos or logos. */
  images?: Image[]
  energyMix?: EnergyMix
  tariff?: TariffDto
  currentPrice?: PriceComponent
  /** Synop added: Total number of connectors at this location. */
  totalConnectors?: number
  /** Synop added: Number of available connectors at this location. */
  availableConnectors?: number
  /** Synop added: Instructions for this location. */
  instructions?: Instruction[]
  /** Synop added: FAQ URL for this location. */
  faqUrl?: string
  /** Synop added: OrganizationId this Site is Assigned to. */
  organizationId?: string
  /** Whether the driver is responsible for payment (DRIVER agreement category). */
  isDriverResponsibleForPayment?: boolean
  /** Authorization charge amount in cents that will be held on the payment method when starting a session (null if no authorization charge). */
  authorizationCharge?: number
  /** Synop added: Marketplace offering IDs that include this location's site. */
  marketplaceOfferingIds?: string[]
  site?: SiteModel
}
export type ResponseFormatLocation = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: Location
  totalItems?: number
}
export type LocationData = object
export type ResponseFormatLocationData = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: LocationData
  totalItems?: number
}
export type UpdateInvoiceLineItemModel = {
  /** Describes whether the line item belongs to an invoice */
  belongsTo?: 'SUBSCRIPTION' | 'INVOICE'
  /** Invoice line item identifier from the payment provider */
  invoiceLineItemId?: string
  /** Our internal line item ID */
  lineItemId?: string
  /** Unique identifier for the invoice */
  invoiceId?: string
  /** Source of the usage (e.g., transaction ID) */
  usageSourceId?: string
  /** Name of the line item */
  lineItemNm: string
  /** Unit amount of the line item */
  unitAmount: number
  /** The quantity of the line item */
  quantity: number
  /** The total of the line item */
  total?: number
  /** Tax rate percentage for this line, when available. */
  taxRate?: number
  /** Tax amount for this line, when available. */
  taxAmount?: number
}
export type InvoiceModel = {
  /** Unique identifier for the invoice. */
  invoiceId: string
  /** URL to the invoice if available. */
  invoiceUrl?: string
  /** URL to the PDF of the invoice if available. */
  invoicePdfUrl?: string
  /** Name of billed organization or person. */
  billedEntityNm: string
  /** Type of billed entity, e.g., 'organization' or 'individual'. */
  billedEntityType: 'ORGANIZATION' | 'USER' | 'INTEGRATION'
  /** Unique identifier for the billed entity. */
  billedEntityId: string
  /** Name of the organization that is being billed. */
  billedOrganizationNm?: string
  /** Unique identifier for the organization that is being billed. */
  billedOrganizationId: string
  /** Name of the organization that is billing a customer. */
  billingOrganizationNm?: string
  /** Unique identifier for the organization that is billing a customer. */
  billingOrganizationId: string
  /** Description shown on the invoice in the memo section. */
  description?: string
  /** Footer text shown on the customer-facing invoice. */
  footer?: string
  /** The descriptor used on the customers bank statement. Defaults to organization name. */
  statementDescriptor?: string
  /** The status of the invoice. */
  status?: 'DRAFT' | 'OPEN' | 'PAID' | 'UNCOLLECTIBLE' | 'VOID' | 'PAST_DUE'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** The total amount due on the invoice. */
  amountDue?: number
  /** The total amount paid on the invoice. */
  amountPaid?: number
  /** The amount of account credit applied to this invoice. */
  appliedCredit?: number
  /** Total tax amount for the invoice when a tax breakdown is available. */
  taxAmount?: number
  /** Customer's account balance before this invoice (negative = credit, positive = owed). */
  startingBalance?: number
  /** Customer's account balance after this invoice (negative = credit, positive = owed). */
  endingBalance?: number
  /** The last time this invoice was updated. */
  asOf?: string
  /** The due date of the invoice. */
  dueDate?: string
  /** Start date of the billing period. Nullable; populated for invoices generated by agreements with a non-real-time billing cycle. */
  periodStart?: string | null
  /** End date of the billing period. Nullable; populated for invoices generated by agreements with a non-real-time billing cycle. */
  periodEnd?: string | null
  /** Allow credit card as payment method. */
  allowCreditCard?: boolean
  /** Allow ACH as payment method. */
  allowAch?: boolean
  /** Line items on the invoice */
  lineItems?: UpdateInvoiceLineItemModel[]
  /** Metadata on the invoice (string keys and values). */
  metadata?: {
    [key: string]: string
  }
  /** Additional email addresses to copy on the invoice send, alongside the default customer contact email. */
  emailRecipients?: string[]
}
export type UpdateInvoiceModel = {
  merchantOrganizationId: string
  invoiceId: string
  customerOrganizationId: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** The collection method for the invoice. Defaults to send invoice */
  collectionMethod?: 'CHARGE_AUTOMATICALLY' | 'SEND_INVOICE'
  /** Description shown on the invoice in the memo section. Defaults to organization name */
  description?: string
  /** Memo text shown on the customer-facing invoice. Overrides description when provided. */
  memo?: string
  /** Footer text shown on the customer-facing invoice. */
  footer?: string
  /** The descriptor used on the customers bank statement. Defaults to organization name */
  statementDescriptor?: string
  /** The date the invoice is due. Defaults to date finalized + 30 days. */
  dueDate?: string
  /** Line items to be updated on the invoice */
  lineItems?: UpdateInvoiceLineItemModel[]
  /** Allow credit card as payment method. */
  allowCreditCard?: boolean
  /** Allow ACH as payment method. */
  allowAch?: boolean
  /** Additional email addresses to copy on the invoice send, alongside the default customer contact email. */
  emailRecipients?: string[]
  /** Metadata stored on the invoice (string keys and values). */
  metadata?: {
    [key: string]: string
  }
}
export type CreateWorkplaceChargingUser = {
  firstNm?: string
  lastNm?: string
  email?: string
  externalId?: string
  /** The Synop user ID for the user if applicable. */
  userId?: string
  organizationId?: string
  status?: 'CURRENT' | 'PAST_DUE' | 'PENDING'
  onboarded?: string
  /** The value user for authorising a user. Example could be storing an RFID tag value for a user. */
  ocppTags?: UserTagModel[]
}
export type WorkplaceConfiguration = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  organizationId?: string
  billingAnchor?: number
  billingCycle?: string
  administeredBy?: string
  /** When enabled, transactions will be settled at the end of each charging session. */
  transactionLevelSettlement?: boolean
  /** When enabled, invoices will be automatically processed at the end of the billing cycle. */
  autoBill?: boolean
  /** The amount that must be pre-paid and maintained on the account. If null no amount will be charged. */
  prepayAmount?: number
  /** The threshold at which the prepay amount must be replenished. Defaults to 0.0. */
  prepayThreshold?: number
  /** When true, charging sessions will be rejected for users without valid payment methods. When null or false, payment method validation is skipped. */
  rejectMissingPaymentMethod?: boolean
  /** When not null, charging sessions will be rejected for users with outstanding balance over this amount (in cents). When null, balance validation is skipped. */
  rejectOutstandingBalanceOver?: number
  /** Current balance for the user. Should be bound by pre-pay amount or pre-pay threshold, or zero if neither are defined. */
  currentBalance?: number
  administeredByOrgName?: string
}
export type WalletRebaselineLineItem = {
  lineItemId?: string
  payorId?: string
  usageSourceId?: string
  /** Line item total in minor units */
  totalAmount?: number
  /** session_debited_amount before this run, minor units */
  sessionDebitedAmount?: number
  /** Stripe invoice id (in_*), if the row is already on a Stripe invoice */
  stripeInvoiceId?: string
  synopInvoiceId?: string
}
export type WalletRebaseline = {
  walletId?: string
  payorId?: string
  payeeOrgId?: string
  currency?: string
  mode?: 'STRIPE_CREDIT' | 'EFFECTIVE_BALANCE'
  agreementId?: string
  dryRun?: boolean
  outcome?:
    | 'DRY_RUN'
    | 'APPLIED'
    | 'NO_CHANGE'
    | 'ALREADY_APPLIED'
    | 'LEDGER_NOT_MAINTAINED'
    | 'NO_CONNECTED_ACCOUNT'
    | 'NO_STRIPE_CUSTOMER'
    | 'CUSTOMER_UNRESOLVABLE'
    | 'CURRENCY_MISMATCH'
    | 'INCOMPLETE_TOP_UP'
    | 'DEBITED_UNSETTLED_USAGE_PRESENT'
    | 'UNBILLED_SUM_MISMATCH'
  /** Why the request was refused, or a note on the outcome */
  message?: string
  /** Idempotency key of the adjustment: rebaseline:<walletId>:<UTC date> */
  sourceExternalId?: string
  /** Stripe customer the target was read from */
  stripeCustomerId?: string
  /** Where stripeCustomerId came from: directory or stored */
  customerSource?: string
  directoryCustomerId?: string
  storedCustomerId?: string
  /** deleted or resource_missing when the customer is unresolvable */
  unresolvableReason?: string
  stripeCredit?: number
  /** The top-up gate's unbilled sum for the pot's payor at re-baseline time. EFFECTIVE_BALANCE subtracts it from the target; STRIPE_CREDIT reports it when agreementId is given */
  unbilledUsage?: number
  balanceBefore?: number
  target?: number
  /** Adjustment amount (target - balanceBefore); for ALREADY_APPLIED, the existing row's amount */
  delta?: number
  balanceAfter?: number
  /** EFFECTIVE_BALANCE: line items whose session_debited_amount is set to their total */
  stampedLineItems?: WalletRebaselineLineItem[]
  /** Stamped line items already on a Stripe invoice: settled usage the gate may still count */
  stampedOnStripeInvoice?: WalletRebaselineLineItem[]
  /** EFFECTIVE_BALANCE: unbilled line items on the agreements excluded because their payor differs */
  excludedLineItems?: WalletRebaselineLineItem[]
  /** DEBITED_UNSETTLED_USAGE_PRESENT: the debited, unsettled line items */
  debitedUnsettledLineItems?: WalletRebaselineLineItem[]
  /** DEBITED_UNSETTLED_USAGE_PRESENT: total session_debited_amount of those line items */
  debitedUnsettledAmount?: number
}
export type WalletRebaselineParams = {
  /** Wallet pot to re-baseline (wallet_*). */
  walletId: string
  /** STRIPE_CREDIT sets the pot to the Stripe customer's credit. EFFECTIVE_BALANCE sets it to Stripe credit minus the gate's unbilled usage and stamps those line items as debited. */
  mode: 'STRIPE_CREDIT' | 'EFFECTIVE_BALANCE'
  /** Public agreement id (ag_*) whose wallet agreements define the top-up gate's unbilled usage. Required for EFFECTIVE_BALANCE. Optional for STRIPE_CREDIT, where it only adds the gate's unbilled sum to the report. */
  agreementId?: string
  /** When true (the default), reports what would happen without writing anything. */
  dryRun?: boolean
}
export type TwilioStartSessionResponse = {
  success?: boolean
}
export type TwilioStartSessionRequest = {
  /** The EVSE ID to start the charging session on */
  evseId: string
  /** The Connector ID on the EVSE to start the charging session on */
  connectorName: string
  /** The payment token to start the charging session on */
  paymentToken: string
}
export type TouRecurrenceBackfillRate = {
  /** Human-readable rate id (rate_...) */
  timeOfUseRateId?: string
  /** Rate display name */
  rateName?: string
  /** Human-readable product id (prod_...) */
  productId?: string
  /** Organization owning the product */
  organizationId?: string
  /** What the backfill did (or would do on a dry run) to this rate */
  action?: 'WINDOW_DERIVED' | 'VALID_TO_CLEARED' | 'SKIPPED_MISSING_VALIDITY'
  /** Recurrence window start after the backfill, ISO MonthDay (--MM-dd) */
  recurrenceFrom?: string
  /** Recurrence window end after the backfill, ISO MonthDay (--MM-dd) */
  recurrenceTo?: string
  /** The validTo value that was (or would be) cleared */
  previousValidTo?: string
}
export type TouRecurrenceBackfill = {
  /** Whether this was a dry run (no writes were performed) */
  dryRun?: boolean
  /** Rates whose recurrence window was derived from their year-stamped validity dates */
  windowsDerived?: number
  /** Windowed rates whose historically ignored validTo was cleared */
  validTosCleared?: number
  /** Legacy flagged rates skipped because validFrom/validTo were missing */
  skipped?: number
  /** Per-rate outcomes */
  rates?: TouRecurrenceBackfillRate[]
}
export type TouRecurrenceBackfillParams = {
  /** Organization whose TOU rates to backfill. Required; self or an ancestor. */
  organizationId?: string
  /** When true, reports the rows that would change without writing anything. */
  dryRun?: boolean
}
export type Row = {
  /** PAYMENT_INTENT, CHARGE or BALANCE_TRANSACTION */
  kind?: string
  /** Stripe id (pi_*, ch_* or txn_*) */
  externalId?: string
  /** Stripe payment intent id the row belongs to (pi_*) */
  paymentIntentId?: string
  /** Canonical invoice the row is currently linked to */
  currentInvoiceId?: string
  /** Top-up invoice the payment intent's metadata names, which the row is repaired to */
  topUpInvoiceId?: string
  /** When the row was created at Stripe */
  created?: string
}
export type TopUpLinkRepair = {
  /** Whether this was a dry run (no writes were performed) */
  dryRun?: boolean
  /** Top-up payment intents linked to an invoice other than their own top-up invoice */
  mislinkedPaymentIntents?: number
  /** Top-up charges linked to an invoice other than their payment intent's top-up invoice */
  mislinkedCharges?: number
  /** Top-up charges' balance transactions linked to an invoice other than the charge's top-up invoice */
  mislinkedBalanceTransactions?: number
  /** Rows re-pointed at their top-up invoice by this run; 0 on a dry run */
  repaired?: number
  /** The merchant's refunded top-up charges. Their refund balance transactions cannot be checked locally, so a write run re-mirrors each from Stripe to re-link them */
  refundedCharges?: number
  /** Refunded top-up charges re-mirrored from Stripe by this run; 0 on a dry run */
  remirroredRefundedCharges?: number
  /** Every mislinked row found, current link beside the top-up invoice it belongs to */
  rows?: Row[]
}
export type TopUpLinkRepairParams = {
  /** Merchant organization of the top-up invoices to repair. Required; self or an ancestor. */
  organizationId?: string
  /** When true (the default), reports the mislinked top-up payments and charges without writing anything. After a write run, a dry run reporting 0 of each is the verification. */
  dryRun?: boolean
}
export type AppliedTax = {
  taxId?: string
  name?: string
  type?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  rate?: number
  taxableAmount?: number
  taxAmount?: number
  stripeTaxRateId?: string
  source?: string
  /** Reason a line item was taxed (or not) */
  reason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  /** Unit that a PER_UNIT tax rate applies to */
  valueUnit?: 'KWH' | 'MINUTES' | 'SESSION'
  category?: 'ENERGY' | 'SESSION' | 'TIME' | 'IDLE' | 'RESERVATION'
  included?: boolean
}
export type TaxPreviewResult = {
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Taxable base (the charge amount, less any backed-out tax for inclusive pricing). */
  preTaxAmount?: number
  /** Total tax in the currency's major units. */
  taxAmount?: number
  /** Total including tax (the original charge for inclusive pricing; charge + tax for exclusive). */
  totalWithTax?: number
  /** Whether tax was treated as included in the charge (INCLUSIVE) or added on top (EXCLUSIVE). */
  taxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
  /** Reason a line item was taxed (or not) */
  taxabilityReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  /** Country (ISO 3166-1 alpha-2) whose place-of-supply rules applied: the charging site's country when the preview names a site with a known address, else the merchant's effective tax origin. */
  supplyCountryCode?: string
  /** Buyer billing country (ISO 3166-1 alpha-2) resolved from the override or the payor's profile. */
  customerCountryCode?: string
  /** Per-rate breakdown of the taxes that applied. */
  appliedTaxes?: AppliedTax[]
  /** VAT place-of-supply category for a charge */
  supplyType?: 'ELECTRICITY' | 'GENERAL_SERVICE'
  /** Stripe product tax code (txcd_*) the classification resolved to: the product's own code, or the merchant's effective default when the product has none. Null when unclassified. */
  taxCode?: string
}
export type TaxPreviewParams = {
  /** Agreement id for AGREEMENT-scoped tax. */
  agreementId?: string
  /** Product id for PRODUCT-scoped tax. */
  productId?: string
  /** Price id for PRICE-scoped tax. */
  priceId?: string
  /** Meter id for METER-scoped tax. */
  meterId?: string
  /** Site id for SITE-scoped tax. */
  siteId?: string
  /** Charger id for CHARGER-scoped tax. */
  chargerId?: string
  /** The charge amount to tax, in the currency's major units (e.g. dollars). For a charging preview (a site, charger, meter or energy amount is given) it is the energy charge: a per-kWh tax can be inside it, while per-minute and per-session taxes are levied on the session and added on top under inclusive pricing, as settlement does. */
  amount: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Energy in kWh, used when a resolved rate is PER_UNIT/KWH. */
  energyKwh?: number
  /** Duration in minutes, used when a resolved rate is PER_UNIT/MINUTES. */
  durationMinutes?: number
  /** Payor id whose tax profile supplies buyer jurisdiction. */
  payorId?: string
  /** Payor type: ORGANIZATION or INDIVIDUAL. Defaults to ORGANIZATION. */
  payorType?: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Buyer country override (ISO 3166-1 alpha-2). */
  buyerCountryCode?: string
  /** Buyer VAT number override. */
  buyerVatNumber?: string
  /** Tax exemption status */
  buyerTaxExempt?: 'NONE' | 'EXEMPT' | 'REVERSE'
  /** Buyer taxable-dealer (reseller) override. */
  buyerTaxableDealer?: boolean
  /** Connected account id for origin overrides; omit for org default. */
  connectedAccountId?: string
  /** Timestamp used to evaluate agreement tax application date windows. Defaults to now. */
  usageTime?: string
}
export type TaxRegistration = {
  /** Database identifier */
  id?: number
  /** Owning organization ID */
  organizationId?: string
  /** Connected account row id (connected_account.id) when this is a per-account override; null for org-level defaults */
  connectedAccountId?: number
  /** ISO 3166-1 alpha-2 country code */
  countryCode?: string
  /** State, province or region it was issued for; null for a country-level registration */
  region?: string
  /** Registration number (VAT, sales-tax permit, GST, …) */
  registrationNumber?: string
  /** Stripe Tax registration type */
  registrationType?: string
  /** Stripe Tax registration id (taxreg_*); null when not declared to Stripe */
  stripeRegistrationId?: string
  /** When collection under this registration began */
  activeFrom?: string
  /** When collection stopped; null means open-ended */
  expiresAt?: string
  /** Where this record came from. MERCHANT and STRIPE are authoritative; INFERRED was deduced from existing rates and is an assumption awaiting confirmation. */
  provenance?: 'MERCHANT' | 'STRIPE' | 'INFERRED'
  /** When a human confirmed an INFERRED record; null while it is still an assumption */
  confirmedAt?: string
  /** Whether this registration is currently active (false = expired / revoked) */
  active?: boolean
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
}
export type TaxRegistrationCreateParams = {
  /** ISO 3166-1 alpha-2 country code */
  countryCode: string
  /** State, province or region the registration was issued for. Required in practice for US and Canadian registrations, which are issued sub-nationally; omit for a country-level registration such as an EU VAT number. */
  region?: string
  /** Registration number (VAT, sales-tax permit, GST, …) */
  registrationNumber: string
  /** Stripe Tax registration type, e.g. state_sales_tax, home_rule_tax, oss_union, province_standard. Inferred from country and region when omitted. */
  registrationType?: string
  /** When collection under this registration began. Defaults to now. */
  activeFrom?: string
  /** When collection stopped (deregistration). Null means open-ended. Set this rather than deleting the registration, so past invoices keep the number in force when they were issued. */
  expiresAt?: string
  /** Whether this registration is active */
  active?: boolean
}
export type PagedResponseTaxRate = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TaxRate[]
}
export type PagedResponseTaxRateRead = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TaxRateRead[]
}
export type TaxRateCreateParams = {
  name: string
  description?: string
  taxType: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  value: number
  /** Unit that a PER_UNIT tax rate applies to */
  valueUnit?: 'KWH' | 'MINUTES' | 'SESSION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  jurisdiction?: string
  countryCode?: string
  region?: string
  /** Ignored. Inclusivity is derived server-side from the rate's jurisdiction and the merchant's resolved default tax behavior; settlement reads the price's taxBehavior, never this flag. Read the derived value back from the response. */
  isInclusive?: boolean
  active?: boolean
}
export type TaxApplication = {
  /** Database identifier of the tax application */
  id?: number
  /** Scope of a tax application */
  scopeType?: 'PRODUCT' | 'PRICE' | 'METER' | 'AGREEMENT' | 'SITE' | 'CHARGER'
  /** External ID of the scoped entity (productId / priceId / meterId / agreementId) */
  scopeId?: string
  /** Tax rate identifier */
  taxId?: string
  /** Display name of the attached tax rate */
  taxRateName?: string
  /** Price IDs this tax applies to (AGREEMENT scope only; empty = agreement-wide) */
  priceIds?: string[]
  /** Whether the attachment is active */
  active?: boolean
  /** Priority when multiple taxes apply; lower = higher priority */
  priorityOrder?: number
  /** Effective-from date (AGREEMENT scope only) */
  startDate?: string
  /** Effective-until date (AGREEMENT scope only) */
  endDate?: string
  /** Free-text notes */
  notes?: string
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
  /** Identifier of the user or system that created the resource */
  createdBy?: string
  /** Identifier of the user or system that last updated the resource */
  updatedBy?: string
}
export type PagedResponseTaxApplication = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TaxApplication[]
}
export type TaxApplicationCreateParams = {
  /** Scope of a tax application */
  scopeType: 'PRODUCT' | 'PRICE' | 'METER' | 'AGREEMENT' | 'SITE' | 'CHARGER'
  scopeId: string
  taxId: string
  priceIds?: string[]
  active?: boolean
  priorityOrder?: number
  startDate?: string
  endDate?: string
  notes?: string
}
export type StripeTerminal = {
  /** Stripe reader ID (e.g., tmr_xxx) */
  readerId: string
  /** Organization ID that owns this terminal */
  organizationId: string
  /** Stripe Terminal Location ID */
  stripeLocationId?: string
  /** Synop site/depot ID */
  siteId?: string
  /** Display name for the terminal */
  label?: string
  /** Charger ID this terminal is assigned to */
  chargerId?: string
  /** Connector IDs this terminal serves */
  connectorIds?: number[]
  /** Integration ID for ChargingIntent resolution */
  integrationId?: string
  /** Last time reader reported to Stripe (ms since epoch) */
  lastSeenAt?: number
  /** Reader connectivity status */
  status?: 'online' | 'offline'
  /** Serial number of the reader */
  serialNumber?: string
  /** Device type from Stripe */
  deviceType?: 'stripe_s700' | 'stripe_m2' | 'simulated_stripe_s700'
  /** Current firmware/software version */
  deviceSwVersion?: string
  /** When the terminal was created */
  createdAt: string
  /** When the terminal was last updated */
  updatedAt: string
}
export type SortObject = {
  direction?: string
  nullHandling?: string
  ascending?: boolean
  property?: string
  ignoreCase?: boolean
}
export type PageableObject = {
  offset?: number
  sort?: SortObject[]
  pageSize?: number
  paged?: boolean
  pageNumber?: number
  unpaged?: boolean
}
export type PageStripeTerminal = {
  totalElements?: number
  totalPages?: number
  size?: number
  content?: StripeTerminal[]
  number?: number
  sort?: SortObject[]
  first?: boolean
  last?: boolean
  numberOfElements?: number
  pageable?: PageableObject
  empty?: boolean
}
export type Pageable = {
  page?: number
  size?: number
  sort?: string[]
}
export type StripeTerminalCreateParams = {
  /** The pairing/registration code displayed on the reader */
  registrationCode: string
  /** Synop site/depot ID. Used to look up Site for Stripe Location (name, address). */
  siteId: string
  /** Display name for the terminal */
  label?: string
  /** Two-letter country code (ISO 3166-1 alpha-2). Provide if registration fails with 'country is required'—this can happen when the site has no coordinates or geocoding fails. */
  country?: string
}
export type CollectPayment = {
  /** Whether the PaymentIntent was successfully pushed to the reader */
  success?: boolean
  /** PaymentIntent ID for polling status */
  paymentIntentId?: string
  /** PaymentIntent status */
  status?: string
  /** Amount in cents */
  amount?: number
  /** Currency code */
  currency?: string
  /** Payee organization ID - use when polling payment-status */
  payeeOrganizationId?: string
  /** Error message if collection initiation failed */
  errorMessage?: string
}
export type CollectPaymentParamsV1 = {
  /** Stripe Terminal reader ID */
  readerId: string
  /** Amount to collect in smallest currency unit (e.g., cents for USD) */
  amount: number
  /** Merchant organization ID for connected account lookup (defaults to X-Organization-Id) */
  merchantOrganizationId?: string
  /** Charger ID (for metadata) */
  chargerId?: string
  /** Connector ID (for metadata) */
  connectorId?: number
  /** Description for the PaymentIntent */
  description?: string
}
export type CancelPaymentParamsV1 = {
  /** The PaymentIntent ID to cancel */
  paymentIntentId: string
  /** Merchant organization ID used to resolve connected Stripe account (defaults to X-Organization-Id) */
  merchantOrganizationId?: string
}
export type StripeLedgerSyncResult = {
  /** Stripe object id that was requested (in_*, pi_*, ch_*, txn_*) */
  objectId?: string
  /** Stripe object type (invoice, payment_intent, charge, balance_transaction) */
  objectType?: string
  /** Whether the object was synced, skipped, or failed */
  outcome?: 'SYNCED' | 'SKIPPED' | 'FAILED'
  /** Failure or skip reason, when not synced */
  error?: string
}
export type StripeLedgerSync = {
  /** Merchant organization the sync ran for */
  organizationId?: string
  /** Stripe connected account id (acct_*) the objects were fetched from */
  stripeAccountId?: string
  /** Objects fetched from Stripe and upserted */
  synced?: number
  /** Objects intentionally not written (e.g. Stripe draft invoices) */
  skipped?: number
  /** Objects that could not be fetched or upserted */
  failed?: number
  /** Per-object results, in the order processed */
  results?: StripeLedgerSyncResult[]
}
export type StripeLedgerSyncParams = {
  /** Merchant organization whose connected account owns the requested Stripe objects. */
  organizationId: string
  /** Stripe account id (acct_*); required when the org has multiple connected accounts. */
  stripeAccountId?: string
  /** Stripe invoice ids (in_*) to upsert into the canonical invoice table. */
  invoiceIds?: string[]
  /** Stripe payment intent ids (pi_*) to upsert into the payment ledger. */
  paymentIntentIds?: string[]
  /** Stripe charge ids (ch_*) to upsert; balance transactions are mirrored. */
  chargeIds?: string[]
  /** Stripe balance transaction ids (txn_*) to upsert into the balance transaction ledger. */
  balanceTransactionIds?: string[]
}
export type TransactionRedriveRequestModel = {
  requestId?: string
  organizationId?: string
  requestedBy?: string
  status?: 'QUEUED' | 'RUNNING' | 'SUCCEEDED' | 'FAILED'
  requestedTransactionCount?: number
  processedTransactionCount?: number
  errorMessage?: string
  createdAt?: string
  updatedAt?: string
  startedAt?: string
  completedAt?: string
  from?: string
  to?: string
}
export type PagedResponseTransactionRedriveRequestModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TransactionRedriveRequestModel[]
}
export type CreateTransactionRedriveRequest = {
  /** Organization ID to redrive transactions for. Defaults to the caller's organization. */
  organizationId?: string
  /** Transaction IDs to redrive. Mutually exclusive with from/to. */
  transactionIds?: string[]
  /** Start of the transaction time range to redrive (inclusive). Requires to. */
  from?: string
  /** End of the transaction time range to redrive (inclusive). Requires from. */
  to?: string
  validRedriveSelection?: boolean
  validDateRangeOrder?: boolean
}
export type Error = {
  userId?: string
  message?: string
}
export type AuditResponseModel = {
  updatedLineItemIds?: string[]
  createdLineItemIds?: string[]
  errors?: Error[]
}
export type ReimbursementRedriveRequest = {
  /** Organization ID to rebuild home-charging reimbursement records for. */
  organizationId: string
  /** Billing month to recalculate (any day in the month). */
  billingMonth: string
}
export type CheckoutSession = {
  /** Stripe-hosted Checkout URL to redirect the payor to. */
  url?: string
  /** When the payment page stops accepting payment; request a new one after that. */
  expiresAt?: string
}
export type PaginationMetadata = {
  first: boolean
  last: boolean
  pageSize: number
  page: number
  totalPages: number
  totalItems: number
}
export type Meta = {
  pagination: PaginationMetadata
}
export type PagedResponseV2ProductResponse = {
  meta: Meta
  data: ProductResponse[]
}
export type PagedResponseV2ProductResponseRead = {
  meta: Meta
  data: ProductResponseRead[]
}
export type CreateProductRequest = {
  /** Organization ID that owns this product. If not provided, defaults to current organization from security context. */
  organizationId?: string
  /** Name of the product visible to customers */
  name: string
  /** Detailed description of the product */
  description?: string
  /** Types of EV charging products and services */
  type:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Visibility settings controlling who can see and access products */
  visibility: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  flatRatePricing?: FlatRatePricing
  perUnitPricing?: PerUnitPricing
  timeOfUsePricing?: TimeOfUsePricing
  volumePricing?: VolumePricing
  tariffPassThroughPricing?: TariffPassThroughPricing
  /** Hierarchical selections of entities this product applies to */
  entitySelections?: EntitySelection[]
  /** Tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*) — this classifies what the product is for place-of-supply rules (EV charging vs general service); the VAT/sales-tax percentage comes from Synop tax rates attached via tax applications. Falls back to the merchant's default tax code when unset. */
  taxCode?: string
  /** Card pre-authorization hold, in minor currency units (e.g. cents), placed on a walk-up customer's card before a public charging session on infrastructure this product covers. Omit to inherit the platform default. Only accepted on PUBLIC visibility products. */
  authorizationCharge?: number
  /** Arbitrary string key-value metadata for this product */
  metadata?: {
    [key: string]: string
  }
}
export type CreateProductRequestRead = {
  /** Organization ID that owns this product. If not provided, defaults to current organization from security context. */
  organizationId?: string
  /** Name of the product visible to customers */
  name: string
  /** Detailed description of the product */
  description?: string
  /** Types of EV charging products and services */
  type:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Visibility settings controlling who can see and access products */
  visibility: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  flatRatePricing?: FlatRatePricing
  perUnitPricing?: PerUnitPricing
  timeOfUsePricing?: TimeOfUsePricingRead
  volumePricing?: VolumePricing
  tariffPassThroughPricing?: TariffPassThroughPricing
  /** Hierarchical selections of entities this product applies to */
  entitySelections?: EntitySelection[]
  /** Tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*) — this classifies what the product is for place-of-supply rules (EV charging vs general service); the VAT/sales-tax percentage comes from Synop tax rates attached via tax applications. Falls back to the merchant's default tax code when unset. */
  taxCode?: string
  /** Card pre-authorization hold, in minor currency units (e.g. cents), placed on a walk-up customer's card before a public charging session on infrastructure this product covers. Omit to inherit the platform default. Only accepted on PUBLIC visibility products. */
  authorizationCharge?: number
  /** Arbitrary string key-value metadata for this product */
  metadata?: {
    [key: string]: string
  }
}
export type Payment = {
  /** First-party Synop payment id (payment_*) — the stable handle for this payment. */
  id?: string
  /** Stripe PaymentIntent id (pi_*) — the provider reference behind this payment. */
  paymentIntentId?: string
  /** Stripe charge id (ch_*), when captured. */
  chargeId?: string
  /** Provider status of the payment intent (e.g. succeeded, canceled, requires_capture). */
  status?: string
  /** Synop payment outcome for display (derived from provider status and context). */
  outcome?: 'SUCCEEDED' | 'PENDING' | 'CANCELLED' | 'FAILED' | 'BLOCKED'
  /** ISO 4217 currency. */
  currency?: string
  /** Authorized amount, in minor units. */
  amount?: number
  /** Captured amount, in minor units. */
  amountCaptured?: number
  /** Refunded amount, in minor units. */
  amountRefunded?: number
  /** Amount to show for this payment, in minor units: the captured total once anything has been captured, the authorized total until then. This is the column the list sorts on for sort=displayAmount, so the ordering and the figure always agree. */
  displayAmount?: number
  /** Capture method: automatic or manual (pre-auth then capture). */
  captureMethod?: string
  /** Human-readable payment method, e.g. "Visa ····4242" or "card_present". */
  paymentMethod?: string
  /** Synop customer id (customer_*) this payment is attributed to; null when anonymous. */
  customerId?: string
  /** Customer display name, resolved from the Synop customer directory. */
  customerName?: string
  /** Customer email, resolved from the Synop customer directory. */
  customerEmail?: string
  /** Canonical Synop invoice id linked to this payment, if any. */
  synopInvoiceId?: string
  /** Human-facing invoice number (the Invoice # shown in the Invoices table), if the payment is linked to an invoice that has been numbered. Null for un-invoiced payments and drafts. */
  invoiceNumber?: string
  /** Canonical invoice status after reconciliation, if linked. */
  invoiceStatus?: string
  /** Whether this payment is a wallet top-up. Top-ups have no invoice number; show receiptNumber as their reference instead. */
  topUp?: boolean
  /** Stripe card receipt number (e.g. 1783-2580), once Stripe has emailed the receipt. Null when no receipt was sent. */
  receiptNumber?: string
  /** Stripe-hosted receipt URL for the charge, if any. */
  receiptUrl?: string
  /** Charging transaction id when this payment settles a per-session invoice. */
  transactionId?: string
  /** When the payment was created at the provider. */
  created?: string
}
export type PaymentRefundParams = {
  /** Amount to refund, in the currency's minor unit. Omit to refund the full remaining captured amount. */
  amount?: number
  /** Optional reason (Stripe refund reason or free text) recorded on the audit trail. */
  reason?: string
}
export type PaymentCaptureParams = {
  /** Amount to capture (minor units). Omit for full capture. */
  amountToCapture?: number
}
export type PaymentCancelParams = {
  /** Optional human-readable reason recorded on the audit trail. */
  reason?: string
}
export type PaymentCustomerNameBackfillSample = {
  /** First-party Synop payment id (payment_*) */
  paymentId?: string
  /** Stripe PaymentIntent id (pi_*) */
  paymentIntentId?: string
  /** Name currently stored on the row; null when it has never been written */
  storedName?: string
  /** Name the fallback chain resolves today */
  resolvedName?: string
  /** Which level of the fallback chain produced the resolved name */
  nameSource?: string
}
export type PaymentCustomerNameBackfill = {
  /** Whether this was a dry run (no writes were performed) */
  dryRun?: boolean
  /** Payments examined */
  scanned?: number
  /** Payments that had no stored name and gained one */
  filled?: number
  /** Payments whose stored name differed from the resolved one and was corrected */
  corrected?: number
  /** Payments whose stored name already matched the resolved one */
  unchanged?: number
  /** Payments for which no name could be resolved at any level -- expected for anonymous public-charging sessions, and the population that sorts as NULL */
  unresolved?: number
  /** Payments holding a name that no longer resolves to anything, left as they are rather than cleared -- the column is a snapshot of who was billed */
  retained?: number
  /** Rows this run resolved but did not write, because a live writer had already changed the name since this run read it -- expected under load, not a failure */
  skippedConcurrent?: number
  /** Resolved names that came from the customer directory row */
  fromDirectory?: number
  /** Resolved names that came from the guest identity on the Stripe PaymentIntent or Charge */
  fromGuest?: number
  /** Resolved names that came from the canonical invoice's payor name */
  fromInvoicePayor?: number
  /** Example rows that changed (or would change), capped by sampleSize */
  samples?: PaymentCustomerNameBackfillSample[]
}
export type PaymentCustomerNameBackfillParams = {
  /** Merchant organization whose payments to backfill. Required; self or an ancestor. */
  organizationId?: string
  /** When true, reports the rows that would change without writing anything. */
  dryRun?: boolean
  /** When true, re-resolves every payment and reports rows whose stored name differs from the resolved one. Combined with dryRun this is the check that the persisted column matches what the list renders. When false (the default) only rows with no stored name are touched, so a repeat run is cheap and cannot disturb a name already verified. */
  overwriteExisting?: boolean
  /** Rows per keyset page. Defaults to 500; clamped to 1..5000. */
  batchSize?: number
  /** Maximum rows to examine in this run; omit for no limit. Useful to sample before committing. */
  maxRows?: number
  /** How many example rows to return in the response. Defaults to 20; clamped to 0..200. */
  sampleSize?: number
}
export type OcpiConnectionRegistration = {
  /** The minted CREDENTIALS_TOKEN_A the counterparty registers with. One-time display. */
  tokenA?: string
}
export type OcpiConnectionMembership = {
  /** Ids of the current organization's ACTIVE INTEGRATION agreements anchored to this connection */
  agreementIds?: string[]
}
export type OcpiConnectionUsageSummary = {
  /** Number of distinct OCPI sessions in the window across membership agreements */
  sessionCount?: number
  /** Number of distinct OCPI CDRs in the window across membership agreements */
  cdrCount?: number
  /** Total energy in kWh summed over CDRs only; null when no CDR carried it */
  totalEnergyKwh?: number
  /** Total cost excluding VAT summed over CDRs only; null when no CDR carried it */
  totalCost?: number
  /** ISO 4217 currency code of totalCost — the first non-null currency seen on a CDR */
  currency?: string
  /** Effective window start (inclusive) */
  from?: string
  /** Effective window end (exclusive) */
  to?: string
  /** Membership agreement ids whose OCPI records contributed to this rollup */
  agreementIds?: string[]
}
export type OcpiConnection = {
  /** Connection (credential) id */
  id?: string
  /** OCPI country code of our local party on the connection */
  countryCode?: string
  /** OCPI party id of our local party on the connection */
  partyId?: string
  /** OCPI role of our local party on the connection (CPO or EMSP) */
  role?: string
  /** Lifecycle status of an OCPI credential */
  status?: 'TEMPORARY' | 'PENDING' | 'VALID' | 'SUSPENDED' | 'REVOKED'
  /** ROAMING integration key the credential is anchored to; null for unanchored connections */
  integrationKey?: string
  registration?: OcpiConnectionRegistration
  membership?: OcpiConnectionMembership
  /** How the current organization relates to this connection: OWNER or MEMBER (joined via ACTIVE INTEGRATION agreements on a shared credential; read-only). */
  access?: 'OWNER' | 'MEMBER'
  usage?: OcpiConnectionUsageSummary
}
export type PagedResponseV2OcpiConnection = {
  meta: Meta
  data: OcpiConnection[]
}
export type OcpiConnectionCreateParams = {
  /** Direction of an OCPI registration handshake */
  mode: 'INITIATE' | 'RECEIVE'
  /** ROAMING integration key this connection is anchored to. Anchoring lets approvals materialize INTEGRATION agreements against the credential. */
  integrationKey?: string
  /** Counterparty versions URL. Required for INITIATE. */
  counterpartyVersionsUrl?: string
  /** CREDENTIALS_TOKEN_A the counterparty issued us out-of-band. Required for INITIATE. */
  counterpartyTokenA?: string
  /** OCPI country code of our local party on this connection. Required. */
  countryCode: string
  /** OCPI party id of our local party on this connection. Required. */
  partyId: string
  /** OCPI role of our local party (CPO or EMSP); defaults to CPO */
  role?: string
}
export type SubscriptionRequestFleetProfile = {
  /** Number of vehicles the requester expects to charge under this offering */
  vehicleCount?: number
  /** Connector types used by the requester's vehicles (e.g. CCS, CHAdeMO, J1772) */
  connectorTypes?: string[]
  /** Expected monthly energy consumption in MWh */
  expectedMonthlyEnergyMwh?: number
  /** Free-form notes from the requester for the provider */
  notes?: string
}
export type SubscriptionRequestAuthorizedEntities = {
  /** Fleet IDs to authorize */
  fleets?: string[]
  /** Vehicle IDs to authorize */
  vehicles?: string[]
  /** User IDs to authorize */
  users?: string[]
  /** User group IDs to authorize */
  userGroups?: string[]
}
export type ConnectionRequestDetails = {
  /** Credential the scope grant targets. May be null until supplied at approval time. */
  targetCredentialId?: string
  /** Display name of the counterparty the requester wants to connect with */
  counterpartyName?: string
  /** ROAMING integration provider the requester asked for, when the counterparty was picked from the provider catalog rather than free-typed. Informs the reviewer's credential choice. */
  integrationProviderId?: string
  /** Synop site internal ids the requester asks to expose */
  locationIds?: string[]
  /** Tariff ids the requester asks to expose */
  tariffIds?: string[]
}
export type MarketplaceSubscriptionRequest = {
  /** Public id (subreq_*) */
  id?: string
  /** What a marketplace request asks for: enrollment in an offering, or an OCPI connection */
  requestType?: 'SUBSCRIPTION' | 'CONNECTION'
  /** Offering public id (mpo_*); null for CONNECTION requests */
  offeringId?: string
  /** Offering display name; null for CONNECTION requests or when the offering row is unavailable */
  offeringName?: string
  /** Requester organization id */
  requesterOrganizationId?: string
  /** Display name of the requester organization */
  requesterOrganizationName?: string
  /** Organization that reviews a CONNECTION request (the target credential's owner, or the Synop root organization for target-less requests); null for SUBSCRIPTION requests and legacy rows */
  reviewerOrganizationId?: string
  /** Display name of the reviewer organization when reviewerOrganizationId is set */
  reviewerOrganizationName?: string
  /** Status of a marketplace subscription request */
  status?: 'PENDING' | 'APPROVED' | 'DENIED' | 'CANCELLED' | 'EXPIRED'
  /** Primary contact name */
  primaryContactName?: string
  /** Primary contact email */
  primaryContactEmail?: string
  /** Requested agreement name override */
  requestedName?: string
  /** Category of agreement that defines who is responsible for payment */
  requestedCategory?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  fleetProfile?: SubscriptionRequestFleetProfile
  authorizedEntities?: SubscriptionRequestAuthorizedEntities
  connectionRequest?: ConnectionRequestDetails
  /** Reason the request was denied */
  denialReason?: string
  /** Who reviewed (approved/denied) the request */
  reviewedBy?: string
  /** When the request was reviewed */
  reviewedAt?: string
  /** When a PENDING request expires. Null means the request never expires. */
  expiresAt?: string
  /** Agreement id created on approval */
  agreementId?: string
  /** When the request was created */
  createdAt?: string
  /** When the request was last updated */
  updatedAt?: string
}
export type OcpiConnectionRequestCreateParams = {
  /** Credential the scope grant targets. Optional; the reviewer may supply it at approval time. */
  targetCredentialId?: string
  /** Display name of the counterparty the requester wants to connect with */
  counterpartyName?: string
  /** ROAMING integration provider the requester picked from the catalog. Optional; carried on the request for the reviewer, who anchors the fulfilling credential to it. */
  integrationProviderId?: string
  /** Synop site internal ids to expose through the connection */
  locationIds?: string[]
  /** Tariff ids to expose through the connection */
  tariffIds?: string[]
  /** Primary contact name */
  primaryContactName: string
  /** Primary contact email */
  primaryContactEmail: string
}
export type ChargerEventCollection = {
  /** List of objects in this page */
  items?: ChargerEvent[]
  /** Total number of items matching the search criteria */
  totalItems?: number
  /** Number of items per page */
  pageSize?: number
  /** Current page number */
  page?: number
  /** Total number of pages */
  totalPages?: number
  /** Whether this is the first page */
  first?: boolean
  /** Whether this is the last page */
  last?: boolean
}
export type ReservationCreateRequest = {
  /** Site ID where the charger is located */
  siteId: string
  /** Charger ID to reserve */
  chargerId: string
  /** Connector ID (optional, specific connector) */
  connectorId?: string
  /** Vehicle ID for this reservation */
  vehicleId?: string
  /** Event type (defaults to TIMED_CHARGE) */
  eventType?: 'TIMED_CHARGE' | 'AD_HOC_CHARGE' | 'PREDICTED' | 'RESERVATION'
  /** Power offered for the reservation in watts */
  powerOffered?: number
  /** Target state of charge percentage (0-100) */
  targetSoc?: number
  /** Profile ID to use for charging */
  profileId?: string
  /** Charger tag ID to authorize the charge */
  chargerTagId?: string
  /** Scheduled start time for the reservation */
  scheduledStart: string
  /** Scheduled end time for the reservation */
  scheduledEnd: string
  /** Start behavior */
  startBehavior?: string
  /** Stop behavior */
  stopBehavior?: string
}
export type ConnectedAccountLink = {
  /** Single-use Connect onboarding URL */
  url: string
}
export type ConnectedAccountLinkCreateParams = {
  /** Return URL after onboarding completes or exits */
  returnUrl: string
  /** Refresh URL if the link expires or is invalid */
  refreshUrl: string
}
export type ReimbursementUser = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  id?: string
  firstNm?: string
  lastNm?: string
  email?: string
  externalId?: string
  zipCode?: string
  address?: string
  latitude?: number
  longitude?: number
  reimbursementRate?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  reimbursementMetric?: string
  reimbursementUnit?: string
  entityId?: string
  entityType?: string
  chargerId?: string
  vehicleId?: string
  userId?: string
  payoutAccountId?: string
  gridEnrollmentEnabled?: boolean
  status?: string
  organizationId?: string
  metadata?: {
    [key: string]: string
  }
}
export type TariffAssociation = {
  /** LSE (Load Serving Entity) identifier */
  lseId: string
  /** LSE name */
  lseName: string
  /** LSE code */
  lseCode?: string
  /** Master tariff identifier */
  masterTariffId: number
  /** Name of the tariff */
  tariffName: string
  /** Provider of the tariff */
  tariffProvider: string
  /** Customer classification */
  customerClass: 'RESIDENTIAL' | 'GENERAL' | 'SPECIAL_USE' | 'PROPOSED'
}
export type HomeChargerCreateParams = {
  /** Identifier of an already-registered charger to reimburse against. When omitted, a site and charger are provisioned at the given home address; latitude and longitude are then required. */
  chargerId?: string
  /** The driver's home address the charger is installed at */
  address: string
  /** ZIP/postal code of the home address */
  zipCode: string
  /** Latitude coordinate of the home address */
  latitude?: number
  /** Longitude coordinate of the home address */
  longitude?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Fixed reimbursement rate per kWh. Provide either this or a tariff, not both. */
  reimbursementRate?: number
  tariff?: TariffAssociation
  /** The driver's first name; defaults to blank when omitted */
  firstNm?: string
  /** The driver's last name; defaults to blank when omitted */
  lastNm?: string
  /** OCPP chargeBoxId for a newly provisioned charger — the identifier printed on the unit. chargers-api uses this as the charger id the hardware connects with. When omitted, chargers-api generates a UUID. Only used when chargerId is omitted. */
  chargeBoxId?: string
  /** Display name for a newly provisioned charger, e.g. "Garage charger". Only used when chargerId is omitted; defaults to the provisioned site's name. */
  chargerNickname?: string
  /** Charger manufacturer/vendor as entered in the onboarding wizard; stored on the provisioned charger's description. Only used when chargerId is omitted. */
  chargerVendor?: string
  /** Charger model as entered in the onboarding wizard; stored on the provisioned charger's description. Only used when chargerId is omitted. */
  chargerModel?: string
  /** Current type of a newly provisioned charger; defaults to AC (residential). Only used when chargerId is omitted. */
  currentType?: string
  /** Supply voltage of a newly provisioned AC charger; defaults to 240 V. Only used when chargerId is omitted. */
  voltage?: number
  /** Maximum current of a newly provisioned AC charger; defaults to 32 A. Only used when chargerId is omitted. */
  maxCurrent?: number
  /** Maximum power of a newly provisioned charger; required when currentType is DC. Only used when chargerId is omitted. */
  maxPower?: number
  /** Whether the driver opts their home charger into grid services programs; defaults to false when omitted */
  gridEnrollmentEnabled?: boolean
}
export type Recurrence = {
  /** Recurrence rule in RFC 5545 format */
  recurrenceRule: string
  /** Recurrence classification; one of DAILY, WEEKLY, WEEKDAYS, CUSTOM */
  recurrenceType?: string
  /** First date of the recurrence; defaults to the date of scheduledStart in the given timezone (UTC when no timezone is provided) */
  startDate?: string
  /** IANA timezone the recurrence is evaluated in */
  timezone?: string
  /** When the recurrence stops; open-ended when omitted */
  validUntilDate?: string
}
export type ChargingScheduleCreateParams = {
  /** When the charging window starts */
  scheduledStart: string
  /** When the charging window ends */
  scheduledEnd: string
  /** OCPP auth tag to associate with the schedule. Optional - when omitted, the caller's own auth tag is used. When provided, it must belong to the caller. */
  chargerTagId?: string
  recurrence?: Recurrence
}
export type PagedResponseV2Meter = {
  meta: Meta
  data: Meter[]
}
export type MeterCreateParams = {
  /** Name of the meter */
  name: string
  /** Detailed description of the meter */
  description?: string
  /** Measurement units for meters in the billing system.
    
    ## Unit Categories
    
    ### Time Units
    - **HOURS**: Duration in hours (e.g., charging session duration)
    - **MINUTES**: Duration in minutes (e.g., parking time)
    
    ### Distance Units
    - **MILES**: Distance in miles (e.g., vehicle miles driven)
    - **KILOMETERS**: Distance in kilometers (e.g., vehicle kilometers driven)
    
    ### Energy Units
    - **KILOWATT_HOURS**: Energy consumption in kWh (e.g., electricity consumed)
    - **MEGAWATT_HOURS**: Energy consumption in MWh (e.g., large-scale energy usage)
    
    ### Volume Units
    - **GALLONS**: Volume in gallons (e.g., fuel consumption)
    - **LITERS**: Volume in liters (e.g., fuel consumption)
    
    ### Count Units
    - **COUNT**: Discrete count (e.g., number of charging sessions, transactions)
    
    ## Usage Examples
    
    ### EV Charging
    - Energy: KILOWATT_HOURS for electricity consumed
    - Time: HOURS for session duration
    - Count: COUNT for number of sessions
    
    ### Fleet Management
    - Distance: MILES or KILOMETERS for vehicle usage
    - Fuel: GALLONS or LITERS for fuel consumption
    - Count: COUNT for number of trips
    
    ### Parking Services
    - Time: MINUTES or HOURS for parking duration
    - Count: COUNT for number of parking sessions
     */
  unit:
    | 'HOURS'
    | 'MINUTES'
    | 'MILES'
    | 'KILOMETERS'
    | 'WATT_HOURS'
    | 'KILOWATT_HOURS'
    | 'MEGAWATT_HOURS'
    | 'GALLONS'
    | 'LITERS'
    | 'COUNT'
  /** Additional metadata */
  metadata?: {
    [key: string]: string
  }
}
export type MarketplaceSubscriptionRequestDenyParams = {
  /** Optional reason for denial */
  denialReason?: string
}
export type MarketplaceSubscriptionRequestApprovalResult = {
  /** What a marketplace request asks for: enrollment in an offering, or an OCPI connection */
  requestType?: 'SUBSCRIPTION' | 'CONNECTION'
  request?: MarketplaceSubscriptionRequest
  agreement?: AgreementResponse
}
export type MarketplaceSubscriptionRequestApproveParams = {
  /** For CONNECTION requests: the credential to apply the scope grant to, used when the stored request does not carry one. Ignored for SUBSCRIPTION requests. */
  targetCredentialId?: string
}
export type PagedResponseV2MarketplaceOffering = {
  meta: Meta
  data: MarketplaceOffering[]
}
export type PagedResponseV2MarketplaceOfferingRead = {
  meta: Meta
  data: MarketplaceOfferingRead[]
}
export type MarketplaceOfferingCreateParams = {
  /** Organization ID of the CPO. If not provided, uses the current organization context. */
  organizationId?: string
  /** Display name of the offering */
  name: string
  /** Detailed description of the offering */
  description?: string
  /** Terms and conditions for agreements created from this offering */
  terms?: string
  /** Marketplace offering visibility */
  visibility?: 'PUBLIC' | 'PRIVATE'
  /** How consumers enroll in a marketplace offering */
  enrollmentMode?: 'INSTANT' | 'REQUEST'
  /** Allowed payor categories */
  allowedCategories?: ('FLEET' | 'DRIVER' | 'INTEGRATION')[]
  /** Require explicit authorized entities at enrollment */
  requireAuthorizedEntities?: boolean
  /** Authorize all payor entities when none specified */
  authorizeAllPayorEntities?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Peak saver enabled on spawned agreements */
  peakSaverEnabled?: boolean
  /** Invoice template for spawned agreements */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language?: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Metadata copied to spawned agreements */
  metadata?: {
    [key: string]: string
  }
  /** Cover image URL for marketplace cards */
  coverImageUrl?: string
  /** Connected account public id for settlement */
  connectedAccountId?: string
  /** Billing cycle for agreements created from this offering */
  billingCycle: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month (1-31) when monthly or annual billing cycles start */
  billingAnchorDayOfMonth?: number
  /** Day of week when weekly billing cycles start */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Number of days after billing cycle end until invoice is due */
  invoiceDueDays?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Whether agreements should automatically charge customers */
  autoCharge?: boolean
  /** Whether agreements should automatically renew */
  autoRenew?: boolean
  /** Whether prepayment is required */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents */
  initialPrepaymentAmount?: number
  /** Balance threshold that triggers a top-off payment in cents */
  topOffThreshold?: number
  /** Whether authorization charges are enabled */
  authorizationChargeEnabled?: boolean
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays?: number
  /** Product IDs to include in this offering */
  productIds: string[]
}
export type MarketplaceSubscriptionRequestCreateParams = {
  /** Primary contact name */
  primaryContactName: string
  /** Primary contact email */
  primaryContactEmail: string
  /** Requested agreement name override */
  requestedName?: string
  /** Category of agreement that defines who is responsible for payment */
  requestedCategory?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Fleet IDs to authorize */
  authorizedFleets?: string[]
  /** Vehicle IDs to authorize */
  authorizedVehicles?: string[]
  /** User IDs to authorize */
  authorizedUsers?: string[]
  /** User group IDs to authorize */
  authorizedUserGroups?: string[]
  fleetProfile?: SubscriptionRequestFleetProfile
}
export type SubscribeToOfferingParams = {
  /** Name for the agreement. If not provided, uses the offering name. */
  name?: string
  /** Access code for private offerings. Required if the offering visibility is PRIVATE. */
  accessCode?: string
  /** Primary contact name for the agreement */
  primaryContactName: string
  /** Primary contact email for the agreement */
  primaryContactEmail: string
  /** Category of agreement that defines who is responsible for payment */
  requestedCategory?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Fleet IDs to authorize. If empty along with other entity lists, all entities are authorized. */
  authorizedFleets?: string[]
  /** Vehicle IDs to authorize. If empty along with other entity lists, all entities are authorized. */
  authorizedVehicles?: string[]
  /** User IDs to authorize. If empty along with other entity lists, all entities are authorized. */
  authorizedUsers?: string[]
  /** User group IDs to authorize. If empty along with other entity lists, all entities are authorized. */
  authorizedUserGroups?: string[]
}
export type RegeneratedAccessCode = {
  /** New plaintext access code */
  accessCode?: string
}
export type RedeemAccessCodeParams = {
  /** Plaintext access code */
  accessCode: string
}
export type MarketplacePaymentSetupSession = {
  /** Checkout session URL */
  url?: string
  /** When the session expires */
  expiresAt?: string
}
export type MarketplacePaymentSetupSessionParams = {
  /** URL to redirect after successful payment method setup */
  successUrl: string
  /** URL to redirect if the user cancels */
  cancelUrl: string
}
export type PagedResponseV2SynopInvoice = {
  meta: Meta
  data: SynopInvoice[]
}
export type LineItemCreateParams = {
  /** Line description (LineItem.productNm) */
  description: string
  /** Semantic line item type (LineItem.lineItemType). Defaults to CHARGE when omitted; use DISCOUNT, CREDIT, or REFUND for non-charge lines. */
  type?:
    | 'CHARGE'
    | 'CREDIT'
    | 'REFUND'
    | 'DISCOUNT'
    | 'REIMBURSEMENT'
    | 'COMMITMENT'
    | 'IDLE_FEE'
    | 'WALLET_TOP_UP'
    | 'PARENT_REVENUE_SHARE'
    | 'INITIATION_FEE'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Tax amount in minor units (LineItem.taxAmount) */
  tax?: number
  /** Additional fees in minor units (LineItem.additionalFees) */
  fees?: number
  /** Unit amount in minor units (chargeAmount = unitAmount × quantity). Up to 6 decimal places for sub-cent precision. */
  unitAmount: number
  /** Quantity billed (LineItem.usageAmount; defaults to 1) */
  quantity?: number
  /** Usage period start (LineItem.usageStart) */
  usageStart?: string
  /** Usage period end (LineItem.usageEnd) */
  usageEnd?: string
  /** Usage start note (LineItem.usageStartNote) */
  usageStartNote?: string
  /** Usage end note (LineItem.usageEndNote) */
  usageEndNote?: string
  /** Client reference / idempotency key (LineItem.usageSourceId) */
  usageSourceId?: string
  /** Product id (LineItem.productId) */
  productId?: string
  /** Types of EV charging products and services */
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Price id (LineItem.priceId) */
  priceId?: string
  /** Price description (LineItem.priceDesc) */
  priceDesc?: string
  /** Price type (LineItem.priceType) */
  priceType?: 'STRIPE' | 'SYNOP'
  /** Measurand for usage quantity (LineItem.measurand) */
  measurand?: 'DISTANCE_DRIVEN' | 'ENERGY_ADDED' | 'ENERGY_USED' | 'TIME_USED' | 'COUNT'
  /** Usage quantity unit (LineItem.usageUnits) */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Applied rate in major currency units (LineItem.appliedRate) */
  appliedRate?: number
  /** Site / depot id (LineItem.depotId) */
  depotId?: string
  /** Site / depot name (LineItem.depotNm) */
  depotNm?: string
  /** Charger id (LineItem.chargerId) */
  chargerId?: string
  /** Charger name (LineItem.chargerNm) */
  chargerNm?: string
  /** Connector id (LineItem.connectorId) */
  connectorId?: string
  /** Vehicle id (LineItem.vehicleId) */
  vehicleId?: string
  /** Vehicle name (LineItem.vehicleNm) */
  vehicleNm?: string
  /** Fleet id (LineItem.fleetId) */
  fleetId?: string
  /** Types of entities that can be associated with products and billing */
  usageEntityType?:
    | 'AUTH_TAG'
    | 'CHARGER'
    | 'VEHICLE'
    | 'CONNECTOR'
    | 'DRIVER'
    | 'EVSE'
    | 'FLEET'
    | 'LOCATION'
    | 'ORGANIZATION'
    | 'SITE'
  /** Usage entity id (LineItem.usageEntityId) */
  usageEntityId?: string
}
export type SynopInvoiceCreateParams = {
  /** Merchant organization id; defaults to the authenticated org */
  merchantOrganizationId?: string
  /** Payor entity id (organization or user) */
  payorId: string
  /** Whether payorId is an organization or individual */
  payorType: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Optional agreement context */
  agreementId?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Invoice due date (UTC) */
  dueDate?: string
  description?: string
  footer?: string
  memo?: string
  /** Bank statement descriptor when Stripe-backed. Must be 5–22 characters when set; forbidden characters: < > \ ' " * */
  statementDescriptor?: string
  /** Whether credit card payment is allowed (legacy; prefer allowedPaymentMethodTypes). Defaults to true when allowedPaymentMethodTypes is omitted. */
  allowCreditCard?: boolean
  /** Whether ACH payment is allowed (legacy; prefer allowedPaymentMethodTypes). Defaults to true when allowedPaymentMethodTypes is omitted. */
  allowAch?: boolean
  /** Payment methods allowed on the hosted invoice page (Stripe payment_settings.payment_method_types). When omitted on create, defaults from allowCreditCard/allowAch (both true → card + ach_debit). */
  allowedPaymentMethodTypes?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  emailRecipients?: string[]
  metadata?: {
    [key: string]: string
  }
  /** Initial manual line items (at least one required) */
  lineItems: LineItemCreateParams[]
}
export type MarkPaidRequest = {
  /** The payment's reference, e.g. the bank transfer reference or cheque number. */
  reference?: string
  /** When the payment was received. Defaults to now; must not be in the future. */
  paidAt?: string
  /** Free-text note about the payment. */
  note?: string
}
export type InvoiceArtifacts = {
  /** Synop invoice id (invoice_*). */
  invoiceId?: string
  /** When the artifacts were generated. */
  generatedAt?: string
  /** Pre-signed URL for the branded invoice PDF. */
  pdfUrl?: string
  /** Pre-signed URL for the charging-session detail PDF. */
  attachmentPdfUrl?: string
  /** Pre-signed URL for the invoice header/totals CSV. */
  invoiceCsvUrl?: string
  /** Pre-signed URL for the per-line-item CSV. */
  lineItemsCsvUrl?: string
  /** Pre-signed URL for line-item-groups.csv. Null for older invoices. */
  lineItemGroupsCsvUrl?: string
  /** Pre-signed URL for the per-line-item tax CSV. */
  lineItemTaxesCsvUrl?: string
  /** Pre-signed URL for the invoice-wide tax summary CSV. */
  invoiceTaxesCsvUrl?: string
  /** Pre-signed URL for schema.json describing CSV columns/types. */
  schemaJsonUrl?: string
  /** Pre-signed URL for the canonical invoice JSON. Null for older invoices. */
  invoiceJsonUrl?: string
  /** Pre-signed URL for the canonical invoice XML. Null for older invoices. */
  invoiceXmlUrl?: string
  /** Pre-signed URL for the artifact archive zip. */
  archiveUrl?: string
  /** When the pre-signed URLs expire. */
  expiresAt?: string
}
export type InvoiceWalletAppliedBackfillSample = {
  /** Canonical invoice id (invoice_*) */
  invoiceId?: string
  /** Invoice status */
  status?: string
  /** wallet_applied currently stored on the invoice (minor units); null when unset */
  storedWalletApplied?: number
  /** Wallet-applied credit derived from the invoice's wallet_debit ledger rows (minor units) */
  computedWalletApplied?: number
}
export type InvoiceWalletAppliedBackfill = {
  /** Whether this was a dry run (no writes were performed) */
  dryRun?: boolean
  /** Invoices examined */
  scanned?: number
  /** Invoices whose derived wallet-applied credit is non-null (they consumed wallet credit) */
  withWalletApplied?: number
  /** Invoices whose stored value differed from the derived one (written unless dryRun) */
  mismatched?: number
  /** Invoices recomputed by this run; 0 on a dry run */
  updated?: number
  /** Invoices whose stored value already matched the derived one */
  unchanged?: number
  /** Example mismatched invoices, stored beside derived, capped by sampleSize */
  samples?: InvoiceWalletAppliedBackfillSample[]
}
export type InvoiceWalletAppliedBackfillParams = {
  /** Merchant organization whose invoices to backfill. Required; self or an ancestor. */
  organizationId?: string
  /** When true, reports the invoices whose stored wallet_applied differs from the value derived from their wallet_debit ledger rows, without writing anything. After a write run, a dry run reporting mismatched = 0 is the verification that the list column matches the detail view. */
  dryRun?: boolean
  /** Invoices per keyset page. Defaults to 500; clamped to 1..5000. */
  batchSize?: number
  /** Maximum invoices to examine in this run; omit for no limit. Useful to sample first. */
  maxRows?: number
  /** How many example mismatches to return in the response. Defaults to 20; clamped to 0..200. */
  sampleSize?: number
}
export type AttributeReference = {
  /** Domain object the attribute is resolved against. */
  source?: 'AGREEMENT' | 'ORGANIZATION_PAYEE' | 'ORGANIZATION_PAYOR' | 'STRIPE_CUSTOMER' | 'USER' | 'INVOICE' | 'STATIC'
  /** Attribute key within the source (e.g. 'organizationNm', 'logoUrl', 'metadata.costCenter'). */
  path?: string
  /** Literal value used when source is STATIC. */
  staticValue?: string
}
export type TemplateBlock = {
  /** Stable client-generated block id (used for drag/drop reordering and selection). */
  id?: string
  /** Block kind. */
  type?:
    | 'HEADER'
    | 'LOGO'
    | 'PARTY'
    | 'INVOICE_META'
    | 'LINE_ITEMS_TABLE'
    | 'TOTALS'
    | 'TEXT'
    | 'FIELD'
    | 'SPACER'
    | 'DIVIDER'
  /** Zero-based render order within the layout. */
  order?: number
  /** Static styling/config props for the block. */
  props?: {
    [key: string]: string
  }
  /** Slot -> attribute bindings resolved at render time. */
  bindings?: {
    [key: string]: AttributeReference
  }
}
export type InvoiceTemplateLayout = {
  /** Blocks in render order. */
  blocks?: TemplateBlock[]
}
export type MetadataRule = {
  /** Invoice metadata key to write. */
  targetKey?: string
  /** Source object the value is read from. */
  source?: 'AGREEMENT' | 'ORGANIZATION_PAYEE' | 'ORGANIZATION_PAYOR' | 'STRIPE_CUSTOMER' | 'USER' | 'INVOICE' | 'STATIC'
  /** Attribute key within the source; ignored when source is STATIC. */
  path?: string
  /** Literal value used when source is STATIC. */
  staticValue?: string
  /** When true, overwrite an existing metadata value; otherwise only fill when absent. */
  override?: boolean
}
export type InvoiceTemplateModel = {
  /** Public template id (template_*) */
  templateId?: string
  /** Owning merchant (payee) organization id */
  payeeOrganizationId?: string
  name?: string
  description?: string
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  /** Incremented on every saved edit */
  version?: number
  layout?: InvoiceTemplateLayout
  metadataRules?: MetadataRule[]
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  createdAt?: string
  updatedAt?: string
}
export type PagedResponseInvoiceTemplateModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: InvoiceTemplateModel[]
}
export type InvoiceTemplateCreateParams = {
  /** Display name for the template */
  name: string
  /** Optional human-readable description */
  description?: string
  /** Initial lifecycle status; defaults to DRAFT */
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  layout?: InvoiceTemplateLayout
  /** Metadata-injection rules applied when invoices are minted */
  metadataRules?: MetadataRule[]
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
}
export type InvoiceBackfillAccount = {
  /** Merchant organization the connected account belongs to */
  organizationId?: string
  /** Stripe connected account id (acct_*) that was backfilled */
  stripeAccountId?: string
  /** True if the account was newly registered during backfill. */
  connectedAccountRegistered?: boolean
  /** Number of Stripe invoices listed for the account (after any created-date filter) */
  listed?: number
  /** Canonical invoices created (or that would be created on a dry run) */
  created?: number
  /** Canonical invoices updated (or that would be updated on a dry run) */
  updated?: number
  /** Stripe draft invoices skipped; drafts are excluded from the backfill */
  skippedDrafts?: number
  /** Invoices that failed to upsert; see service logs for details */
  failed?: number
  /** Payment intents listed for ledger backfill (only when includeLedger is set) */
  paymentIntents?: number
  /** Charges listed for ledger backfill (when includeLedger is set). */
  charges?: number
  /** Payouts listed for ledger backfill (when includeLedger is set). */
  payouts?: number
  /** Ledger objects that failed to upsert; see service logs for details */
  ledgerFailed?: number
  /** Errors that aborted part of this account's backfill, if any */
  error?: string
}
export type InvoiceBackfill = {
  /** Whether this was a dry run (no writes were performed) */
  dryRun?: boolean
  /** Number of connected accounts processed */
  accountCount?: number
  /** Total Stripe invoices listed across all accounts */
  listed?: number
  /** Total canonical invoices created (or that would be created on a dry run) */
  created?: number
  /** Total canonical invoices updated (or that would be updated on a dry run) */
  updated?: number
  /** Total Stripe draft invoices skipped */
  skippedDrafts?: number
  /** Total invoices that failed to upsert */
  failed?: number
  /** Total payment intents listed for ledger backfill (only when includeLedger is set) */
  paymentIntents?: number
  /** Total charges listed for ledger backfill (only when includeLedger is set) */
  charges?: number
  /** Total payouts listed for ledger backfill (only when includeLedger is set) */
  payouts?: number
  /** Total ledger objects that failed to upsert */
  ledgerFailed?: number
  /** Per-account results */
  accounts?: InvoiceBackfillAccount[]
}
export type InvoiceBackfillParams = {
  /** Organization to backfill; omit to run for all orgs with a connected account. */
  organizationId?: string
  /** Only backfill Stripe invoices created at or after this instant. */
  createdAfter?: string
  /** Only backfill Stripe invoices created at or before this instant. */
  createdBefore?: string
  /** Also backfill payment intents, charges, and payouts. */
  includeLedger?: boolean
  /** When true, lists and counts invoices without writing anything. */
  dryRun?: boolean
}
export type ArtifactAccessKeyCreated = {
  /** AWS access key id */
  accessKeyId?: string
  /** AWS secret access key — shown once */
  secretAccessKey?: string
  /** Status of a merchant artifact-storage access key */
  status?: 'ACTIVE' | 'INACTIVE'
  /** When the key was created */
  createdAt?: string
  /** S3 bucket name */
  bucket?: string
  /** AWS region of the bucket */
  region?: string
  /** The only key prefix (folder) the key can read: {merchantOrganizationId}/ */
  prefix?: string
  /** s3://{bucket}/{prefix} — the folder to point an S3 client at */
  s3Uri?: string
}
export type MappingResult = {
  rateMappingId?: string
  siteId?: string
  chargerId?: string
  organizationId?: string
  messages?: string[]
}
export type DecommissionReport = {
  dryRun?: boolean
  mappingsScanned?: number
  mappingsDeactivated?: number
  overridesDeactivated?: number
  skippedNotMigrated?: number
  skippedFiltered?: number
  blocked?: number
  errors?: number
  details?: MappingResult[]
}
export type DecommissionRequest = {
  organizationIds?: string[]
  siteIds?: string[]
  dryRun?: boolean
}
export type MigrationReport = {
  dryRun?: boolean
  mappingsScanned?: number
  productsCreated?: number
  skippedExisting?: number
  skippedFiltered?: number
  skippedUnsupported?: number
  errors?: number
  details?: MappingResult[]
}
export type MigrationRequest = {
  organizationIds?: string[]
  siteIds?: string[]
  dryRun?: boolean
}
export type StripeRedirectModel = {
  url?: string
  expires?: string
}
export type HardwareCheckoutSessionParams = {
  /** Hardware catalog product key */
  productKey: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Initial quantity (adjustable in Stripe Checkout) */
  quantity?: number
  /** Add SynopLink cellular connectivity (activation + monthly plan); synoplink only */
  includeCellular?: boolean
  /** URL Stripe redirects to after a completed checkout */
  successUrl: string
  /** URL Stripe redirects to when the buyer cancels */
  cancelUrl: string
}
export type ConnectedAccountSupportAddress = {
  /** Address line 1 */
  line1?: string
  /** Address line 2 */
  line2?: string
  /** City */
  city?: string
  /** State, province, or region */
  state?: string
  /** ZIP or postal code */
  postalCode?: string
  /** Two-letter ISO 3166-1 alpha-2 country code */
  country?: string
}
export type ConnectedAccountPayoutSchedule = {
  /** How often Stripe pays out funds. MANUAL disables automatic payouts. */
  interval?: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'MANUAL'
  /** Number of days Stripe holds available funds before payout. */
  delayDays?: number
  /** Weekdays for automatic weekly payouts. */
  weeklyPayoutDays?: ('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')[]
  /** Calendar days for automatic monthly payouts. */
  monthlyPayoutDays?: number[]
  /** Legacy Stripe weekly anchor returned for existing schedules. */
  weeklyAnchor?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Legacy Stripe monthly anchor returned for existing schedules. */
  monthlyAnchor?: number
}
export type RequirementError = {
  /** The requirement field the error relates to */
  requirement?: string
  /** Machine-readable error code */
  code?: string
  /** Human-readable explanation of the error */
  reason?: string
}
export type ConnectedAccountRequirements = {
  /** Fields currently due (Stripe requirements.currently_due) */
  currentlyDue?: string[]
  /** Fields past due (Stripe requirements.past_due) */
  pastDue?: string[]
  /** Fields eventually due (Stripe requirements.eventually_due) */
  eventuallyDue?: string[]
  /** Fields pending verification (Stripe requirements.pending_verification) */
  pendingVerification?: string[]
  /** Why capabilities are disabled, if applicable (Stripe requirements.disabled_reason) */
  disabledReason?: string
  /** Deadline (epoch seconds) for currently_due fields */
  currentDeadline?: number
  /** Per-field verification errors (Stripe requirements.errors) */
  errors?: RequirementError[]
}
export type ConnectedAccount = {
  /** Connected account id (account_xxx; legacy acc_xxx) */
  accountId: string
  /** Organization ID that owns this connected account */
  organizationId: string
  /** Synop-only display name (not Stripe business_profile.name). */
  displayName?: string
  /** Default revenue-share amount in minor units. */
  defaultRevenueShareMinorUnits?: number
  /** Customer-facing business name from Stripe (business_profile.name). */
  businessName?: string
  /** Public support email from Stripe (business_profile.support_email). */
  supportEmail?: string
  /** Public support phone from Stripe (business_profile.support_phone). */
  supportPhone?: string
  supportAddress?: ConnectedAccountSupportAddress
  payoutSchedule?: ConnectedAccountPayoutSchedule
  /** Stripe Connect account type (CONNECT_STANDARD, CONNECT_EXPRESS, CONNECT_CUSTOM). */
  accountType?: 'PLATFORM' | 'CONNECT_STANDARD' | 'CONNECT_EXPRESS' | 'CONNECT_CUSTOM'
  /** When the connected account was created */
  createdAt: string
  /** When the connected account was last updated */
  updatedAt: string
  /** Stripe Connect connected account status */
  status?: 'RESTRICTED' | 'PENDING' | 'ENABLED' | 'COMPLETE' | 'UNKNOWN'
  requirements?: ConnectedAccountRequirements
  /** Capabilities requested at account creation. */
  requestedCapabilities?: (
    | 'CARD_PAYMENTS'
    | 'TRANSFERS'
    | 'LINK_PAYMENTS'
    | 'US_BANK_ACCOUNT_ACH_PAYMENTS'
    | 'US_BANK_TRANSFER_PAYMENTS'
    | 'SEPA_DEBIT_PAYMENTS'
    | 'SEPA_BANK_TRANSFER_PAYMENTS'
    | 'PAY_BY_BANK_PAYMENTS'
  )[]
  /** Who runs the issued-invoice lifecycle for invoices Synop collects through this account. */
  invoicingMode: 'STRIPE_INVOICING' | 'SYNOP_INVOICING'
  /** Cap, in minor units, on the platform + processing application fee per invoice; null is uncapped. */
  applicationFeeCapMinor?: number
  /** Payor-facing invoice portal base URL for Synop-owned invoices; null uses the default. */
  invoicePortalBaseUrl?: string
  /** Stripe account country (ISO 3166-1 alpha-2); null until known. */
  country?: string
  /** Stripe account default currency (ISO 4217, lowercase); null until known. */
  defaultCurrency?: string
  invoicePaymentOptions?: InvoicePaymentOptions
  /** Whether this is the organization's default connected account */
  isDefault: boolean
}
export type ConnectedAccountRead = {
  /** Connected account id (account_xxx; legacy acc_xxx) */
  accountId: string
  /** Organization ID that owns this connected account */
  organizationId: string
  /** Synop-only display name (not Stripe business_profile.name). */
  displayName?: string
  /** Default revenue-share amount in minor units. */
  defaultRevenueShareMinorUnits?: number
  /** Customer-facing business name from Stripe (business_profile.name). */
  businessName?: string
  /** Public support email from Stripe (business_profile.support_email). */
  supportEmail?: string
  /** Public support phone from Stripe (business_profile.support_phone). */
  supportPhone?: string
  supportAddress?: ConnectedAccountSupportAddress
  payoutSchedule?: ConnectedAccountPayoutSchedule
  /** Stripe Connect account type (CONNECT_STANDARD, CONNECT_EXPRESS, CONNECT_CUSTOM). */
  accountType?: 'PLATFORM' | 'CONNECT_STANDARD' | 'CONNECT_EXPRESS' | 'CONNECT_CUSTOM'
  /** When the connected account was created */
  createdAt: string
  /** When the connected account was last updated */
  updatedAt: string
  /** Stripe Connect connected account status */
  status?: 'RESTRICTED' | 'PENDING' | 'ENABLED' | 'COMPLETE' | 'UNKNOWN'
  requirements?: ConnectedAccountRequirements
  /** Capabilities requested at account creation. */
  requestedCapabilities?: (
    | 'CARD_PAYMENTS'
    | 'TRANSFERS'
    | 'LINK_PAYMENTS'
    | 'US_BANK_ACCOUNT_ACH_PAYMENTS'
    | 'US_BANK_TRANSFER_PAYMENTS'
    | 'SEPA_DEBIT_PAYMENTS'
    | 'SEPA_BANK_TRANSFER_PAYMENTS'
    | 'PAY_BY_BANK_PAYMENTS'
  )[]
  /** Who runs the issued-invoice lifecycle for invoices Synop collects through this account. */
  invoicingMode: 'STRIPE_INVOICING' | 'SYNOP_INVOICING'
  /** Cap, in minor units, on the platform + processing application fee per invoice; null is uncapped. */
  applicationFeeCapMinor?: number
  /** Payor-facing invoice portal base URL for Synop-owned invoices; null uses the default. */
  invoicePortalBaseUrl?: string
  /** Stripe account country (ISO 3166-1 alpha-2); null until known. */
  country?: string
  /** Stripe account default currency (ISO 4217, lowercase); null until known. */
  defaultCurrency?: string
  invoicePaymentOptions?: InvoicePaymentOptionsRead
  /** Whether this is the organization's default connected account */
  isDefault: boolean
}
export type ConnectedAccountCreateParams = {
  /** Account type (CONNECT_STANDARD, CONNECT_EXPRESS, CONNECT_CUSTOM). Defaults to CONNECT_EXPRESS. */
  accountType?: 'PLATFORM' | 'CONNECT_STANDARD' | 'CONNECT_EXPRESS' | 'CONNECT_CUSTOM'
  /** Contact email for Stripe onboarding */
  email: string
  /** Synop-only display name (not Stripe business_profile.name). */
  displayName?: string
  /** Default revenue-share amount in minor units. */
  defaultRevenueShareMinorUnits?: number
  /** Two-letter ISO 3166-1 alpha-2 country code. */
  country?: string
  /** Three-letter ISO 4217 currency code (lowercase). */
  defaultCurrency?: string
  /** Customer-facing business name (Stripe business_profile.name). */
  businessName?: string
  /** Public support email (Stripe business_profile.support_email). */
  supportEmail?: string
  /** Public support phone (Stripe business_profile.support_phone). */
  supportPhone?: string
  supportAddress?: ConnectedAccountSupportAddress
  /** Set as the organization's default connected account. */
  setAsDefault?: boolean
  /** Capabilities to request. Defaults to CARD_PAYMENTS and TRANSFERS when omitted. To skip card payments, send an explicit list without CARD_PAYMENTS. */
  requestedCapabilities?: (
    | 'CARD_PAYMENTS'
    | 'TRANSFERS'
    | 'LINK_PAYMENTS'
    | 'US_BANK_ACCOUNT_ACH_PAYMENTS'
    | 'US_BANK_TRANSFER_PAYMENTS'
    | 'SEPA_DEBIT_PAYMENTS'
    | 'SEPA_BANK_TRANSFER_PAYMENTS'
    | 'PAY_BY_BANK_PAYMENTS'
  )[]
}
export type ConnectedAccountOrganizationLinkParams = {
  /** Child organization that should gain a linked connected_account row. */
  organizationId: string
  /** When true, set the linked account as the child's default. When omitted, defaults to true only if the child has no connected accounts yet. */
  setAsDefault?: boolean
}
export type ConnectedAccountTypeSyncAccount = {
  /** Connected account id (account_...) */
  accountId?: string
  /** Stripe account id (acct_...) */
  stripeAccountId?: string
  /** Account type stored before the sync */
  previousAccountType?: 'PLATFORM' | 'CONNECT_STANDARD' | 'CONNECT_EXPRESS' | 'CONNECT_CUSTOM'
  /** Account type derived from Stripe, when recognized */
  stripeAccountType?: 'PLATFORM' | 'CONNECT_STANDARD' | 'CONNECT_EXPRESS' | 'CONNECT_CUSTOM'
  /** What the sync did (or would do on a dry run) to this account */
  action?: 'UPDATED' | 'UNCHANGED' | 'SKIPPED_UNRECOGNIZED' | 'FAILED'
  /** Stripe error message when the action is FAILED */
  error?: string
}
export type ConnectedAccountTypeSync = {
  /** Whether this was a dry run (no writes were performed) */
  dryRun?: boolean
  /** Accounts whose stored type was (or would be) corrected */
  updated?: number
  /** Accounts whose stored type already matched Stripe */
  unchanged?: number
  /** Accounts skipped because Stripe reported no recognized type */
  skipped?: number
  /** Accounts that could not be retrieved from Stripe */
  failed?: number
  /** Per-account outcomes */
  accounts?: ConnectedAccountTypeSyncAccount[]
}
export type ConnectedAccountTypeSyncParams = {
  /** Organization whose connected accounts to sync. Required; self or an ancestor. */
  organizationId?: string
  /** When true (the default), reports the rows that would change without writing anything. */
  dryRun?: boolean
}
export type ReimbursementCloseResult = {
  /** Number of organizations whose just-ended (or requested) period was evaluated. */
  organizationsProcessed?: number
  /** Number of reimbursement invoices materialized and finalized during this run. */
  invoicesGenerated?: number
  /** Number of payee periods skipped because they were already closed or had no home-charging usage. */
  skipped?: number
}
export type ChargeReceiptNumberBackfill = {
  /** Whether this was a dry run (no Stripe calls, no writes) */
  dryRun?: boolean
  /** Succeeded top-up charges with a receipt email and no receipt number */
  scanned?: number
  /** Charges that got their receipt number from Stripe; 0 on a dry run */
  filled?: number
  /** Charges Stripe had no receipt number for (receipt not sent) or that could not be read; 0 on a dry run */
  stillMissing?: number
}
export type ChargeReceiptNumberBackfillParams = {
  /** Merchant organization whose top-up charges to backfill. Required; self or an ancestor. */
  organizationId?: string
  /** When true (the default), counts the top-up charges still missing a receipt number without calling Stripe or writing anything. */
  dryRun?: boolean
}
export type BillingRevenueShareRule = {
  /** Rule ID. */
  ruleId?: string
  /** Parent billing configuration ID. */
  configurationId?: string
  /** Whether this rule is active. */
  enabled?: boolean
  /** Category of agreement that defines who is responsible for payment */
  agreementCategory?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Type of agreement that defines the relationship between organizations */
  agreementType?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** How a parent organization revenue share amount is calculated. */
  revenueShareType?: 'PERCENTAGE' | 'FIXED_AMOUNT' | 'HYBRID'
  /** Percentage share (0-100) when type is PERCENTAGE or HYBRID. */
  percentage?: number
  /** Fixed amount in minor currency units when type is FIXED_AMOUNT or HYBRID. */
  fixedAmount?: number
  /** Optional ceiling on the percentage-derived share, in minor currency units. When set, percentage share is min(base × %, maxAmount). Does not apply to fixedAmount. */
  maxAmount?: number
  /** Public connected account ID (account_…) of the administering org that receives transfers. */
  payeeConnectedAccountId?: string
  effectiveFrom?: string
  effectiveUntil?: string
  created?: string
  updated?: string
}
export type BillingConfiguration = {
  /** Configuration ID. */
  configurationId?: string
  /** Child organization receiving billing enablement. */
  administeredOrganizationId?: string
  /** Parent organization administering billing for the child. */
  administeringOrganizationId?: string
  /** Lifecycle status for a parent-to-child organization billing configuration. */
  status?: 'ENABLED' | 'DISABLED'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Revenue share rules for this configuration. */
  revenueShareRules?: BillingRevenueShareRule[]
  created?: string
  updated?: string
}
export type BillingConfigurationCreateParams = {
  /** Child organization receiving billing enablement. */
  administeredOrganizationId: string
  /** Lifecycle status for a parent-to-child organization billing configuration. */
  status: 'ENABLED' | 'DISABLED'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
}
export type BillingRevenueShareRuleCreateParams = {
  /** Whether this rule is active. */
  enabled?: boolean
  /** Category of agreement that defines who is responsible for payment */
  agreementCategory?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Type of agreement that defines the relationship between organizations */
  agreementType?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** How a parent organization revenue share amount is calculated. */
  revenueShareType: 'PERCENTAGE' | 'FIXED_AMOUNT' | 'HYBRID'
  /** Percentage share (0-100) when type is PERCENTAGE or HYBRID. */
  percentage?: number
  /** Fixed amount in minor currency units when type is FIXED_AMOUNT or HYBRID. */
  fixedAmount?: number
  /** Optional ceiling on the percentage-derived share, in minor currency units. When set, percentage share is min(base × %, maxAmount). Does not apply to fixedAmount. */
  maxAmount?: number
  /** Public connected account ID of the administering org payee. */
  payeeConnectedAccountId: string
  /** Optional start of rule validity. */
  effectiveFrom?: string
  /** Optional end of rule validity. */
  effectiveUntil?: string
}
export type AssistantUsageIngestResult = {
  /** Usage event id (asstusg_*). */
  eventId?: string
  /** Paying organization resolved from the enabled org's config. */
  billableOrganizationId?: string
  /** Raw Anthropic cost, minor units. */
  rawCost?: number
  /** Billed cost (raw + markup), minor units. */
  billedCost?: number
  /** Where the charge was drawn from. */
  creditSource?: 'FEATURE_GRANT' | 'WORKSPACE_BALANCE' | 'MIXED' | 'UNCHARGED'
  /** Portion drawn from the monthly feature grant, minor units. */
  featureGrantApplied?: number
  /** Portion drawn from purchased workspace balance, minor units. */
  workspaceBalanceApplied?: number
  /** Remaining feature-grant credit this period, minor units. */
  featureGrantRemaining?: number
  /** Remaining purchased workspace balance, minor units. */
  workspaceBalanceRemaining?: number
  /** True when this message was already ingested and the charge was not reapplied. */
  duplicate?: boolean
}
export type AssistantUsageIngestRequest = {
  /** Organization the assistant ran under (the feature-enabled org). */
  organizationId: string
  /** Assistant conversation id (session grouping key). */
  conversationId: string
  /** Assistant message id; idempotency key so retries do not double-charge. */
  messageId: string
  /** User who initiated the turn. */
  userId?: string
  /** User email for the session-history display. */
  userEmail?: string
  /** Claude API model id used for the turn (e.g. claude-opus-5-5, claude-sonnet-5, claude-opus-4-8). Effort is not part of the model id; it only affects token counts. */
  model?: string
  /** Input (uncached) tokens consumed. */
  inputTokens: number
  /** Output tokens produced. */
  outputTokens: number
  /** Cache-read tokens consumed. */
  cacheReadTokens: number
  /** When the turn completed; defaults to ingestion time when omitted. */
  occurredAt?: string
}
export type AssistantTopUpResult = {
  /** Amount purchased, minor units. */
  amount?: number
  /** Stripe payment intent id backing the purchase. */
  paymentIntentId?: string
  /** Workspace balance after the purchase settled, minor units. */
  workspaceBalance?: number
  /** Currency. */
  currency?: string
}
export type AssistantTopUpRequest = {
  /** Amount to purchase, minor units. */
  amount: number
}
export type AssistantBillingConfigRequest = {
  /** Organization to enable the assistant for. */
  organizationId: string
  /** Organization that pays for the enabled org's usage (explicit; no tree walking). */
  billableOrganizationId: string
  /** Whether the feature is enabled. Defaults to true. */
  enabled?: boolean
  /** Currency; defaults to the configured default. */
  currency?: string
  /** Monthly feature-credit allotment, minor units; defaults to the configured default. */
  monthlyCreditAmount?: number
  /** Platform markup in basis points; defaults to the configured default. */
  markupBasisPoints?: number
}
export type PagedResponseV2AgreementResponse = {
  meta: Meta
  data: AgreementResponse[]
}
export type PeakSaverConfigurationCreateParams = {
  /** Whether peak saver throttling is enabled. When enabled, sessions throttle charging power during the most expensive time-of-use period. */
  enabled?: boolean
  /** Type of peak saver throttling behavior */
  saveType?: 'POWER' | 'PERCENTAGE'
  /** Quantity for saveType: kW for POWER, or percent reduction for PERCENTAGE. Defaults to 4.0 kW for POWER. */
  quantity?: number
}
export type DemandChargeAllocationConfigurationCreateParams = {
  /** Whether demand-charge allocation is enabled. Requires the agreement's sites to have a utility tariff with a demand component attached. */
  enabled?: boolean
  /** How a customer's share of a site's utility demand charge is computed at period close */
  allocationMethod?: 'SITE_PEAK_CONTRIBUTION' | 'CUSTOMER_PEAK'
  /** Percentage of the computed demand charge passed through to the customer (0-100). Defaults to 100. */
  passThroughPercentage?: number
}
export type AgreementAuthorizedEntityCreateParams = {
  /** ID of the entity (vehicle ID, user ID, user group ID, fleet ID, or auth tag) */
  entityId: string
  /** Type of the authorized entity */
  entityType: 'FLEET' | 'USER' | 'USER_GROUP' | 'VEHICLE' | 'AUTH_TAG'
}
export type AgreementProductCreateParams = {
  /** ID of the product */
  productId: string
  /** Billable quantity for flat-rate period fees and for volume tiers when tierQuantitySource is AGREEMENT_QUANTITY (defaults to 1) */
  quantity?: number
  /** Optional override for volume tier quantity source. When null, the assigned price tierQuantitySource applies. */
  tierQuantitySource?: 'ENTITY_COUNT' | 'AGREEMENT_QUANTITY' | 'USAGE'
  /** Optional billing level (CHARGER | CONNECTOR) for ENTITY_COUNT quantity. */
  entityCountLevel?: 'CHARGER' | 'CONNECTOR'
  /** ID of the price to assign; defaults to the product default price */
  priceId?: string
  /** When this assignment becomes effective; defaults to agreement start or now */
  effectiveFrom?: string
  /** Assets to be included with this product */
  assets?: string[]
  /** Authorized entities for this product */
  authorizedEntities?: AgreementAuthorizedEntityCreateParams[]
}
export type AgreementCreateParams = {
  /** ID of the organization creating the agreement (becomes the payee) */
  organizationId: string
  /** Payor ID: partner organization for FLEET/DRIVER, or IntegrationProvider ID for INTEGRATION. */
  partnerOrganizationId: string
  /** Name of the agreement */
  name: string
  /** Start date of the agreement */
  startDate: string
  /** End date of the agreement (optional for auto-renewing agreements) */
  endDate?: string
  /** Whether the agreement should automatically renew */
  autoRenew?: boolean
  /** Whether the agreement should automatically charge customers */
  autoCharge?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
  /** Billing cycle for the agreement */
  billingCycle: 'NONE' | 'REAL_TIME' | 'DAILY' | 'QUARTERLY' | 'WEEKLY' | 'MONTHLY'
  /** Day of month (1-31) when monthly or annual billing cycles start. If not specified, uses the start date. */
  billingAnchorDayOfMonth?: number
  /** Day of week (MONDAY, TUESDAY, etc.) when weekly billing cycles start. If not specified, uses the start date. */
  billingAnchorDayOfWeek?: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
  /** Number of days after billing cycle end until invoice is due */
  invoiceDueDays?: number
  /** How many of the agreement's first Synop-issued invoices are held for review before they are issued, even when nothing is wrong with them. 0 never holds for this reason. Defaults to the platform setting (1) when omitted. */
  reviewFirstInvoices?: number
  /** Whether prepayment is required for this agreement */
  prepaymentEnabled?: boolean
  /** Initial prepayment amount in cents */
  initialPrepaymentAmount?: number
  /** Balance threshold in cents that triggers a top-off payment */
  topOffThreshold?: number
  /** Authorization charge amount in cents */
  authorizationCharge?: number
  /** Whether authorization charges are enabled for this agreement */
  authorizationChargeEnabled?: boolean
  /** Enable peak-saver throttling during the most expensive TOU period for sessions under this agreement. */
  peakSaverEnabled?: boolean
  peakSaverConfiguration?: PeakSaverConfigurationCreateParams
  demandChargeAllocationConfiguration?: DemandChargeAllocationConfigurationCreateParams
  /** Whether delinquency enforcement is enabled */
  delinquencyEnforcementEnabled?: boolean
  /** Type of test used to determine delinquency status */
  delinquencyTestType?: 'OUTSTANDING_BALANCE' | 'DAYS_PAST_DUE' | 'NUM_OPEN_INVOICES'
  /** Threshold value for delinquency test (cents for balance, days/count for others) */
  delinquencyThreshold?: number
  /** Number of days notice required for termination */
  noticePeriodDays?: number
  /** Agreement terms */
  terms?: string
  /** Type of agreement that defines the relationship between organizations */
  type: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** Category of agreement that defines who is responsible for payment */
  category: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Primary contact name for the agreement */
  primaryContactName: string
  /** Primary contact email for the agreement */
  primaryContactEmail: string
  /** Public id (template_*) of the invoice template applied when minting invoices for this agreement */
  invoiceTemplateId?: string
  /** Agreement/invoice language. Drives translation of static invoice labels. */
  language?: 'ENGLISH' | 'FRENCH' | 'GERMAN' | 'POLISH' | 'SPANISH' | 'DUTCH' | 'SWEDISH'
  /** Arbitrary string key-value metadata for this agreement */
  metadata?: {
    [key: string]: string
  }
  /** Products to be included in the agreement */
  products?: AgreementProductCreateParams[]
  /** Discounts to be included in the agreement */
  discounts?: AgreementDiscountCreateParams[]
  /** Commitments to be included in the agreement */
  commitments?: AgreementCommitmentCreateParams[]
  /** Source marketplace offering id (mpo_*) when materialized from an offering */
  sourceOfferingId?: string
  /** When true, all entities in the payor org are authorized without explicit authorized-entity rows */
  authorizeAllPayorEntities?: boolean
}
export type ReconciliationException = {
  /** Deterministic exception id (hash of type + related record ids), stable across recomputation */
  id?: string
  /** Kind of reconciliation exception detected between an agreement's OCPI sessions and CDRs */
  type?: 'MISSING_CDR' | 'DUPLICATE_CDR' | 'TARIFF_MISMATCH'
  /** Severity of a reconciliation exception */
  severity?: 'LOW' | 'MEDIUM' | 'HIGH'
  /** Human-readable explanation of the discrepancy */
  detail?: string
  /** Row ids of the OCPI records involved */
  relatedRecordIds?: string[]
  /** When this computation detected the discrepancy */
  detectedAt?: string
  /** Whether the exception has been acknowledged for this agreement */
  acknowledged?: boolean
  /** Who acknowledged the exception */
  acknowledgedBy?: string
  /** When the exception was acknowledged */
  acknowledgedAt?: string
}
export type AddAgreementProductRequest = {
  /** ID of the product */
  productId: string
  /** Billable quantity for flat-rate period fees and for volume tiers when tierQuantitySource is AGREEMENT_QUANTITY (defaults to 1) */
  quantity?: number
  /** Optional override for volume tier quantity source. When null, the assigned price tierQuantitySource applies. */
  tierQuantitySource?: 'ENTITY_COUNT' | 'AGREEMENT_QUANTITY' | 'USAGE'
  /** Optional billing level (CHARGER | CONNECTOR) for ENTITY_COUNT quantity. */
  entityCountLevel?: 'CHARGER' | 'CONNECTOR'
  /** ID of the price to assign; defaults to the product default price */
  priceId?: string
  /** When this assignment becomes effective; defaults to now */
  effectiveFrom?: string
}
export type AddAgreementAuthorizedEntityRequest = {
  /** Type of entity to authorize */
  entityType?: 'FLEET' | 'USER' | 'USER_GROUP' | 'VEHICLE' | 'AUTH_TAG'
  /** ID of the entity to authorize. Auth tags are normalized before storage. */
  entityId?: string
}
export type UpdateWorkplaceChargingRecordStatus = {
  /** The status to update the workplace charging record to. */
  status:
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  /** The start of the billing period. */
  periodStart: string
  /** The workplace charging users whose invoices for the given period should be updated. */
  workplaceChargingUserIds: string[]
}
export type AssetTariffMapping = {
  id: string
  assetType: 'CHARGER' | 'SITE'
  assetId: string
  lseId: string
  lseName: string
  lseCode?: string
  masterTariffId: number
  tariffName: string
  tariffProvider: string
  customerClass: 'RESIDENTIAL' | 'GENERAL' | 'SPECIAL_USE' | 'PROPOSED'
  effectiveFrom: string
  effectiveTo?: string
}
export type OverrideRateStructureByOrganizationModelListRatePeriod = {
  /** The status of the rate. Can be ACTIVE or INACTIVE. */
  rateStatus?: 'ACTIVE' | 'INACTIVE'
  /** The name of the rate */
  rateNm: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Rate type: FLAT, VOLUME_BASED, or TIME_BASE. */
  rateType: 'FLAT' | 'TIER' | 'TIME_OF_USE' | 'TOU' | 'VOLUME_BASED'
  /** The structure of the rate. Can be a flat rate, a volume based rate or a time based rate. */
  rateStructure: RatePeriod[]
  OrganizationRateOverride?: OverrideRateStructureByOrganizationModelListRatePeriod
  /** The name of the last editing of the rate */
  lastModifiedByUserName?: string
  /** The ID of the last editing of the rate */
  lastModifiedByUserId?: string
  /** When this rate was last modified */
  lastModified?: string
  /** Optional idle fee after charging completes, before unplug. */
  idleFee?: number
  /** Idle fee step size in minutes. Multiplies idleFee by elapsed steps after session end. */
  idleStepSize?: number
  /** Base charge applied to every billed session under this rate. */
  flatFee?: number
  /** Max SoC for charging under this rate (percent). */
  maxSoc?: number
  /** Max charging session duration under this rate (minutes). */
  maxTime?: number
  /** When true, lock the TOU rate period at plug-in; when false, bill dynamically across periods. */
  lockRateAtPlugIn?: boolean
  /** The id of the rate mapping. This can be used as a reference to override this rate. */
  rateMappingId: string
  /** The id of the rate. This can be used as a reference to override this rate. */
  rateId?: string
  /** Product ID in stripe for this rate */
  productId?: string
  /** The target of the override. Can be a workplace, a charging point or a connector */
  overrideTargetType:
    | 'CHARGER'
    | 'FLEET'
    | 'HOME_CHARGING_USER'
    | 'NETWORK'
    | 'ORGANIZATION'
    | 'SITE'
    | 'USER'
    | 'VEHICLE'
  /** The id of the target of the override. Can be a SITE, CHARGER or ORGANIZATION */
  overrideTargetId: string
  /** Rate mapping id this override replaces */
  overridesMappingId: string
}
export type CreateRateStructureModelListRatePeriod = {
  /** The status of the rate. Can be ACTIVE or INACTIVE. */
  rateStatus?: 'ACTIVE' | 'INACTIVE'
  /** The name of the rate */
  rateNm: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Rate type: FLAT, VOLUME_BASED, or TIME_BASE. */
  rateType: 'FLAT' | 'TIER' | 'TIME_OF_USE' | 'TOU' | 'VOLUME_BASED'
  /** The structure of the rate. Can be a flat rate, a volume based rate or a time based rate. */
  rateStructure: RatePeriod[]
  OrganizationRateOverride?: OverrideRateStructureByOrganizationModelListRatePeriod
  /** The name of the last editing of the rate */
  lastModifiedByUserName?: string
  /** The ID of the last editing of the rate */
  lastModifiedByUserId?: string
  /** When this rate was last modified */
  lastModified?: string
  /** Optional idle fee after charging completes, before unplug. */
  idleFee?: number
  /** Idle fee step size in minutes. Multiplies idleFee by elapsed steps after session end. */
  idleStepSize?: number
  /** Base charge applied to every billed session under this rate. */
  flatFee?: number
  /** Max SoC for charging under this rate (percent). */
  maxSoc?: number
  /** Max charging session duration under this rate (minutes). */
  maxTime?: number
  /** When true, lock the TOU rate period at plug-in; when false, bill dynamically across periods. */
  lockRateAtPlugIn?: boolean
}
export type ReimbursementUserResponse = {
  /** Unique identifier for the reimbursement user */
  id: string
  /** User's first name */
  firstNm?: string
  /** User's last name */
  lastNm?: string
  /** User's email address */
  email?: string
  /** Payee External ID (employee number, office code, ERP key). Invoice templates bind this as USER.externalId. */
  externalId?: string
  /** User's ZIP/postal code */
  zipCode?: string
  /** Latitude coordinate of the user's location */
  latitude?: number
  /** Longitude coordinate of the user's location */
  longitude?: number
  /** User's physical address */
  address?: string
  /** Rate of reimbursement */
  reimbursementRate?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  tariff?: AssetTariffMapping
  /** Indicates if the user has a tariff association */
  hasTariffAssociation: boolean
  rateStructure?: CreateRateStructureModelListRatePeriod
  /** Metric used for reimbursement calculations */
  reimbursementMetric?: string
  /** Unit of measurement for reimbursement */
  reimbursementUnit?: string
  /** Type of entity (e.g., CHARGER). This field is deprecated and will be removed in a future version */
  entityType: string
  /** Identifier of the entity. This field is deprecated and will be removed in a future version */
  entityId: string
  /** Identifier of the charger */
  chargerId?: string
  /** Identifier of the vehicle */
  vehicleId?: string
  /** Identifier of the user */
  userId?: string
  /** Identifier of the organization */
  organizationId: string
  /** Current status of the reimbursement configuration */
  status?: string
  /** Whether the driver has opted their home charger into grid services programs */
  gridEnrollmentEnabled?: boolean
  /** Custom key/value pairs stored on the payee. Invoice templates bind individual keys as USER.metadata.<key>. */
  metadata?: {
    [key: string]: string
  }
  /** Timestamp when the user was onboarded */
  onboarded?: string
}
export type ReimbursementUserUpsertParams = {
  /** Unique identifier for the reimbursement configuration */
  id?: string
  /** User's first name */
  firstNm?: string
  /** User's last name */
  lastNm?: string
  /** User's email address */
  email?: string
  /** Payee External ID (employee number, office code, ERP key). Persisted on the reimbursement user and exposed on reimbursement views; invoice templates bind it as USER.externalId. */
  externalId?: string
  /** User's ZIP/postal code */
  zipCode?: string
  /** Latitude coordinate of the user's location */
  latitude?: number
  /** Longitude coordinate of the user's location */
  longitude?: number
  /** User's physical address */
  address?: string
  /** Rate of reimbursement */
  reimbursementRate?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  tariff?: TariffAssociation
  rateStructure?: CreateRateStructureModelListRatePeriod
  /** Metric used for reimbursement calculations */
  reimbursementMetric?: string
  /** Unit of measurement for reimbursement */
  reimbursementUnit?: string
  /** Type of entity (e.g., CHARGER). This field is deprecated and will be removed in a future version. Use chargerId or vehicleId instead. */
  entityType?: string
  /** Identifier of the entity. This field is deprecated and will be removed in a future version. Use chargerId or vehicleId instead. */
  entityId?: string
  /** Identifier of the charger */
  chargerId?: string
  /** Identifier of the vehicle */
  vehicleId?: string
  /** Identifier of the user */
  userId?: string
  /** Identifier of the organization */
  organizationId: string
  /** Current status of the reimbursement configuration */
  status?: string
  /** Whether the driver has opted their home charger into grid services programs */
  gridEnrollmentEnabled?: boolean
  /** Custom key/value pairs stored on the payee (cost center, department, badge number). Invoice templates bind individual keys as USER.metadata.<key>; when the reimbursement template defines no metadata rules, every entry is copied onto the minted statement. Omit to preserve the existing entries on update; send an empty object to clear them. */
  metadata?: {
    [key: string]: string
  }
  /** Timestamp when the user was onboarded */
  onboarded?: string
}
export type ReimbursementConfiguration = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  organizationId?: string
  billingAnchor?: number
  billingCycle?: string
  administeredBy?: string
  invoiceTemplateId?: string
  adminEmails?: string[]
  administeredByOrgName?: string
  autoFinalize?: boolean
}
export type UrlRedirectModel = {
  baseUrl?: string
  path?: string
  parameters?: string
}
export type StopTransactionResponse = {
  id?: string
  transactionPk?: number
}
export type StopTransactionRequest = {
  /** The transaction id to issue the stop command for. */
  transactionId: string
}
export type StartSessionResult = {
  /** The session key for this start command, of the form start_{chargerId}_{connectorId}_{authTag}. Use it to correlate the session. */
  id?: string
  /** Whether the charger accepted the remote start command. PENDING means no outcome was available before billing responded and is not a failure — the command may still succeed. */
  status?: 'ACCEPTED' | 'REJECTED' | 'PENDING'
  /** The charger's own word for the outcome as reported by the charger management system (for example Applied, Rejected, NotConnected, Timeout). Null when no outcome was available. Informational; branch on status. */
  statusDetail?: string
}
export type PhonePaymentDetails = {
  paymentIntentId?: string
  paymentMethodId?: string
  merchantAccountId?: string
  preAuthAmountCents?: number
}
export type StartSessionRequest = {
  /** The identifier of the user to start the transaction for. */
  userId?: string
  chargerId: string
  connectorId: number
  /** Auth tag; defaults to the user's MOBILE tag when omitted. */
  authTag: string
  /** Session limit type: TIME, COST, ENERGY, or STATE_OF_CHARGE. Omit to charge to 100%. */
  limitType?: 'TIME' | 'COST' | 'ENERGY' | 'STATE_OF_CHARGE'
  /** Limit value; unit depends on limitType (minutes/dollars/kWh/percent). */
  limitValue?: number
  /** SetupIntent id for public charging payment authorization (web/mobile). */
  setupIntentId?: string
  /** PaymentIntent id from Terminal collect-payment (terminal flow). */
  paymentIntentId?: string
  /** Target session end time (used for L3 vehicle events). */
  departureTime?: string
  preAuthorizedPayment?: PhonePaymentDetails
  /** Receipt email for public/guest charging. */
  receiptEmail?: string
}
export type PagedResponseInvoiceModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: InvoiceModel[]
}
export type CreateInvoiceLineItemModel = {
  /** Name of the line item */
  lineItemNm: string
  /** Unit amount of the line item */
  unitAmount: number
  /** The quantity of the line item */
  quantity: number
}
export type CreateInvoiceModel = {
  merchantOrganizationId: string
  /** Unique identifier for the organization that is being billed. */
  customerOrganizationId: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** The collection method for the invoice. Defaults to send invoice. */
  collectionMethod?: 'CHARGE_AUTOMATICALLY' | 'SEND_INVOICE'
  /** Description shown on the invoice in the memo section. Defaults to organization name. */
  description?: string
  /** Memo text shown on the customer-facing invoice. Overrides description when provided. */
  memo?: string
  /** Footer text shown on the customer-facing invoice. */
  footer?: string
  /** The descriptor used on the customers bank statement. Defaults to organization name. */
  statementDescriptor?: string
  /** The date the invoice is due. Defaults to date finalized + 30 days. */
  dueDate?: string
  /** Line items to be created on the invoice. */
  lineItems?: CreateInvoiceLineItemModel[]
  /** Allow credit card as payment method. */
  allowCreditCard?: boolean
  /** Allow ACH as payment method. */
  allowAch?: boolean
  /** Additional email addresses to copy on the invoice send, alongside the default customer contact email. */
  emailRecipients?: string[]
  /** Metadata stored on the invoice (string keys and values). */
  metadata?: {
    [key: string]: string
  }
}
export type InvoiceOperationRequest = {
  /** The operation to perform on the invoice. Possible values: VOID, SEND, FINALIZE */
  operation: 'VOID' | 'SEND' | 'FINALIZE' | 'MARK_PAID'
  /** The unique identifier for the invoice */
  invoiceId: string
}
export type EnrichLineItems = {
  /** Total number of line items processed */
  totalProcessed?: number
  /** Number of line items successfully enriched */
  successCount?: number
  /** Number of line items that failed to enrich */
  failureCount?: number
  /** Number of line items skipped (e.g., no connected account) */
  skippedCount?: number
  /** Sum of skipped amounts by currency (minor units, e.g., cents for USD) */
  skippedAmountByCurrency?: {
    [key: string]: number
  }
  /** Sum of amounts by currency for charges/invoices that had transactionId metadata but no matching line items were found (minor units) */
  unmatchedAmountByCurrency?: {
    [key: string]: number
  }
  /** Number of new line items created during enrichment (when enabled) */
  createdCount?: number
}
export type BulkReimbursementConfiguration = {
  /** Reimbursement rate */
  rate: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** List of reimbursement user IDs to update */
  reimbursementUserIds: string[]
}
export type IntentModel = {
  status?: string
}
export type StripeIntentModel = {
  id?: string
  type?: string
  intentId?: string
  ephemeralKey?: string
  customerId?: string
  connectedAccountId?: string
  clientSecret?: string
  status?: string
  paymentMethod?: string
  created?: number
  intent?: IntentModel
}
export type AuthorizePublicSessionRequest = {
  /** Location id of the EVSE (unique within the CPO platform). */
  siteId?: string
  /** EVSE id for the session (unique within the CPO platform). */
  chargerId?: string
  /** Optional connector on the EVSE. When known (the driver already picked a plug), pre-auth uses the same connector-aware PUBLIC product that session billing will, so a connector-restricted charger product cannot take the hold for a different plug. */
  connectorId?: number
}
export type MerchantTaxSettings = {
  id?: number
  /** Owning organization ID */
  organizationId?: string
  /** Origin country (ISO 3166-1 alpha-2) */
  originCountryCode?: string
  originRegion?: string
  originPostalCode?: string
  /** Default tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes), applied when a product has none. NOT a Synop tax rate id (tax_*). */
  defaultTaxCode?: string
  /** The merchant's chosen default tax behavior; null means not chosen, not a default. */
  defaultTaxBehavior?: ('EXCLUSIVE' | 'INCLUSIVE') | null
  /** Behavior in force: defaultTaxBehavior if chosen, else the origin convention, else EXCLUSIVE. */
  effectiveDefaultTaxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
}
export type MerchantTaxSettingsPatchParams = {
  /** Origin country (ISO 3166-1 alpha-2) */
  originCountryCode?: string
  originRegion?: string
  originPostalCode?: string
  /** Default tax classification code from Stripe's public tax-code catalog (txcd_*; see /api/v1/tax-codes). NOT a Synop tax rate id (tax_*). */
  defaultTaxCode?: string
  /** Default tax behavior for prices without their own; null leaves it unchanged. */
  defaultTaxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
  /** Settings to reset to not set; sending a cleared field is 400. */
  clear?: (
    | 'ORIGIN_COUNTRY_CODE'
    | 'ORIGIN_REGION'
    | 'ORIGIN_POSTAL_CODE'
    | 'DEFAULT_TAX_CODE'
    | 'DEFAULT_TAX_BEHAVIOR'
  )[]
}
export type TaxApplicationUpdateParams = {
  priceIds?: string[]
  active?: boolean
  priorityOrder?: number
  startDate?: string
  endDate?: string
  notes?: string
}
export type StripeTerminalUpdateParams = {
  /** Charger ID to assign. Null to clear assignment. */
  chargerId?: string
  /** Connector IDs this terminal serves. Omit to leave unchanged; use [] to explicitly clear; use [1, 2] to assign. */
  connectorIds?: number[]
  /** Integration ID for ChargingIntent resolution. Required when assigning to a charger. */
  integrationId?: string
}
export type GridEnrollmentUpdateParams = {
  /** When true, opts the caller's active home-charger payee into grid services programs */
  enrolled: boolean
}
export type OrganizationMetadataRequirements = {
  id?: number
  /** Owning organization ID */
  organizationId?: string
  /** Metadata keys that must be provided with a non-blank value on product create/update */
  requiredProductMetadataKeys?: string[]
  /** Metadata keys that must be provided with a non-blank value on agreement create/update */
  requiredAgreementMetadataKeys?: string[]
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
}
export type OrganizationMetadataRequirementsPatchParams = {
  /** Replaces required product metadata keys when provided (empty list clears requirements) */
  requiredProductMetadataKeys?: string[]
  /** Replaces required agreement metadata keys when provided (empty list clears requirements) */
  requiredAgreementMetadataKeys?: string[]
}
export type InvoiceTemplateUpdateParams = {
  /** New display name */
  name?: string
  /** New description */
  description?: string
  /** New lifecycle status */
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED'
  layout?: InvoiceTemplateLayout
  /** Replacement metadata-injection rules */
  metadataRules?: MetadataRule[]
  /** Controls how line items are aggregated into Stripe invoice items on period (non-real-time) invoices. Per-session detail is always preserved on the Synop invoice. */
  lineItemGrouping?: 'ATOMIC' | 'PRODUCT' | 'PRICE' | 'SITE' | 'PRODUCT_SITE' | 'SITE_PRICE'
}
export type ArtifactAccessKeyUpdateParams = {
  /** Status of a merchant artifact-storage access key */
  status: 'ACTIVE' | 'INACTIVE'
}
export type Customer = {
  /** Stable public id for this customer entry. */
  id?: string
  /** Display name for the payor. */
  name?: string
  /** Customer payor category (organization vs individual driver/user). */
  type?: 'ORGANIZATION' | 'DRIVER'
  /** Stored customer lifecycle status (simple lifecycle only — not billing health). */
  status?: 'ACTIVE' | 'ARCHIVED'
  /** Email address when available (typically for user payors). */
  email?: string
  /** Merchant-set address this customer's invoices are emailed to. Null when none is set, in which case invoices go to the agreement contact or the payor's users. */
  billingEmail?: string
  billingAddress?: AddressModel
  /** Merchant-set VAT / tax ID for this customer (fallback for the buyer's self-service profile). */
  vatNumber?: string
  /** Country of vatNumber (ISO 3166-1 alpha-2). */
  vatCountryCode?: string
  /** Tax exemption status */
  taxExempt?: 'NONE' | 'EXEMPT' | 'REVERSE'
  /** Whether this customer is a taxable dealer of electricity (reseller). */
  taxableDealer?: boolean
  /** Paid spend grouped by currency (minor units). This avoids mixing totals across currencies. */
  spendByCurrency?: {
    [key: string]: number
  }
  /** Primary paid spend amount (minor units) in the selected primary currency for convenient table display. */
  totalSpend?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Credit balance when available (minor units). Null when not available from the local billing ledger. */
  creditBalance?: number
  /** Underlying billed payor id (organization id or user id). */
  payorId?: string
  /** Creation timestamp used for this table (payor entity create time when available, otherwise first billed timestamp). */
  createdAt?: string
}
export type CustomerUpdateParams = {
  billingAddress?: AddressModel
  /** Address this customer's invoices are emailed to. Omitted or null leaves it unchanged, an empty string clears it; stored trimmed and lower-cased. */
  billingEmail?: string
  /** Merchant-set VAT/tax ID for this customer. */
  vatNumber?: string
  /** Country of vatNumber (ISO 3166-1 alpha-2). */
  vatCountryCode?: string
  /** Tax exemption status */
  taxExempt?: 'NONE' | 'EXEMPT' | 'REVERSE'
  /** Whether the customer is a taxable electricity dealer (reseller). */
  taxableDealer?: boolean
}
export type ConnectedAccountUpdateParams = {
  /** Synop-only display name. Send empty string to clear. */
  displayName?: string
  /** Default revenue-share amount in minor units. */
  defaultRevenueShareMinorUnits?: number
  /** Customer-facing business name (Stripe business_profile.name). */
  businessName?: string
  /** Public support email (Stripe business_profile.support_email) */
  supportEmail?: string
  /** Public support phone (Stripe business_profile.support_phone) */
  supportPhone?: string
  supportAddress?: ConnectedAccountSupportAddress
  /** Full desired capability set (replace semantics). Omit to leave unchanged; empty list relinquishes all. */
  requestedCapabilities?: (
    | 'CARD_PAYMENTS'
    | 'TRANSFERS'
    | 'LINK_PAYMENTS'
    | 'US_BANK_ACCOUNT_ACH_PAYMENTS'
    | 'US_BANK_TRANSFER_PAYMENTS'
    | 'SEPA_DEBIT_PAYMENTS'
    | 'SEPA_BANK_TRANSFER_PAYMENTS'
    | 'PAY_BY_BANK_PAYMENTS'
  )[]
  payoutSchedule?: ConnectedAccountPayoutSchedule
  /** Who runs the issued-invoice lifecycle for invoices Synop collects through this account. */
  invoicingMode?: 'STRIPE_INVOICING' | 'SYNOP_INVOICING'
  /** Absolute https base URL of the payor-facing invoice portal for Synop-owned invoices. Send empty string to clear. */
  invoicePortalBaseUrl?: string
  /** Cap, in minor units, on the platform + processing application fee charged through this account. Parent revenue-share allocations are not capped. Omitted: unchanged. Explicit null: clears the cap (uncapped). A value >= 0 sets it (0 means no platform fee). A negative value is rejected with 400. Only Synop may send this field. */
  applicationFeeCapMinor?: number | null
}
export type ConnectedAccountTaxSync = {
  id?: number
  /** Synop public connected account id (account_xxx) */
  connectedAccountPublicId?: string
  /** Owning organization ID */
  organizationId?: string
  /** Origin country override; null inherits org default */
  originCountryCode?: string
  /** Origin region override; null inherits org default */
  originRegion?: string
  /** Origin postal code override; null inherits org default */
  originPostalCode?: string
  /** Default tax-code override (Stripe catalog txcd_*, not a Synop tax rate id); null inherits org default */
  defaultTaxCode?: string
  /** Deprecated per-account override for prices without their own tax behavior; null inherits org default. */
  defaultTaxBehavior?: ('EXCLUSIVE' | 'INCLUSIVE') | null
  /** Effective origin country */
  effectiveOriginCountryCode?: string
  /** Effective origin region */
  effectiveOriginRegion?: string
  /** Effective origin postal code */
  effectiveOriginPostalCode?: string
  /** Effective default tax code */
  effectiveDefaultTaxCode?: string
  /** Behavior applied to prices without their own: account override, else org choice, else origin convention, else EXCLUSIVE. */
  effectiveDefaultTaxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
  /** Timestamp when the resource was created */
  createdAt?: string
  /** Timestamp when the resource was last updated */
  updatedAt?: string
}
export type ConnectedAccountTaxSyncPatchParams = {
  /** Optional origin-country override; null leaves the current value unchanged */
  originCountryCode?: string
  originRegion?: string
  originPostalCode?: string
  /** Optional default tax-code override (Stripe catalog txcd_*, not a Synop tax rate id); null leaves the current value unchanged */
  defaultTaxCode?: string
  /** Deprecated per-account tax-behavior override; null leaves it unchanged. Set the org or price behavior instead. */
  defaultTaxBehavior?: 'EXCLUSIVE' | 'INCLUSIVE'
  /** Overrides to remove so the account inherits org values; sending a cleared field is 400. */
  clear?: (
    | 'ORIGIN_COUNTRY_CODE'
    | 'ORIGIN_REGION'
    | 'ORIGIN_POSTAL_CODE'
    | 'DEFAULT_TAX_CODE'
    | 'DEFAULT_TAX_BEHAVIOR'
  )[]
}
export type BillingConfigurationUpdateParams = {
  /** Lifecycle status for a parent-to-child organization billing configuration. */
  status?: 'ENABLED' | 'DISABLED'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  settlementCurrency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
}
export type BillingRevenueShareRuleUpdateParams = {
  /** Whether this rule is active. */
  enabled?: boolean
  /** Category of agreement that defines who is responsible for payment */
  agreementCategory?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** Type of agreement that defines the relationship between organizations */
  agreementType?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** How a parent organization revenue share amount is calculated. */
  revenueShareType?: 'PERCENTAGE' | 'FIXED_AMOUNT' | 'HYBRID'
  /** Percentage share (0-100) when type is PERCENTAGE or HYBRID. */
  percentage?: number
  /** Fixed amount in minor currency units when type is FIXED_AMOUNT or HYBRID. */
  fixedAmount?: number
  /** Public connected account ID of the administering org payee. */
  payeeConnectedAccountId?: string
  /** Optional start of rule validity. */
  effectiveFrom?: string
  /** Optional end of rule validity. */
  effectiveUntil?: string
  /** Optional ceiling on the percentage-derived share, in minor currency units. When set, percentage share is min(base × %, maxAmount). Null clears a previously set max. Does not apply to fixedAmount. */
  maxAmount?: number | null
}
export type UpdateAgreementProductRequest = {
  /** Billable quantity for flat-rate period fees and for volume tiers when tierQuantitySource is AGREEMENT_QUANTITY */
  quantity?: number
  /** Optional override for volume tier quantity source. When null, keeps the current assignment value. */
  tierQuantitySource?: 'ENTITY_COUNT' | 'AGREEMENT_QUANTITY' | 'USAGE'
  /** Optional billing level (CHARGER | CONNECTOR) for ENTITY_COUNT quantity. */
  entityCountLevel?: 'CHARGER' | 'CONNECTOR'
  /** ID of the price to assign */
  priceId?: string
  /** When the updated assignment becomes effective; defaults to now */
  effectiveFrom?: string
}
export type WorkplaceChargingSummaryModel = {
  /** The number of users who have enrolled in workplace charging. */
  workplaceUsers?: number
  organizationId?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** The start of the billing period. */
  periodStart?: string
  /** The end of the billing period. */
  periodEnd?: string
  /** The total revenue from all workplace charging activity for the current period. */
  currentPeriodWorkplaceChargingRevenue?: number
  /** Percentage change in revenue from the previous period. */
  workplaceChargingRevenueMoMChange?: number
  /** The total energy use from all workplace charging activity for the current period. */
  currentPeriodWorkplaceChargingEnergyUse?: number
  /** Percentage change in energy use from the previous period. */
  energyUseMoMChange?: number
  asOf?: string
  lastBillingPeriod?: WorkplaceChargingSummaryModel
  /** The status of the organization's billing abilities. */
  status?: 'RESTRICTED' | 'RESTRICTED_SOON' | 'PENDING' | 'ENABLED' | 'COMPLETE' | 'REJECTED' | 'UNKNOWN'
}
export type WorkplaceChargingModel = {
  workplaceUserId?: string
  organizationId?: string
  firstNm?: string
  lastNm?: string
  email?: string
  externalId?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  periodStart?: string
  periodEnd?: string
  status?:
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  statusAsOf?: string
  amount?: number
  usage?: number
  numberTransactions?: number
  asOf?: string
  approvedById?: string
  approvedByName?: string
  approvedOn?: string
  invoiceId?: string
  invoiceUrl?: string
}
export type WalletTransactionEntry = {
  /** Ledger row id (cbtxn_* or wallet_debit:<in_*>). */
  id?: string
  /** Types of balance transactions in the ledger */
  type?:
    | 'ADJUSTMENT'
    | 'ADVANCE'
    | 'ADVANCE_FUNDING'
    | 'ANTICIPATION_REPAYMENT'
    | 'APPLICATION_FEE'
    | 'APPLICATION_FEE_REFUND'
    | 'CHARGE'
    | 'CLIMATE_ORDER_PURCHASE'
    | 'CLIMATE_ORDER_REFUND'
    | 'CONNECT_COLLECTION_TRANSFER'
    | 'CONTRIBUTION'
    | 'ISSUING_AUTHORIZATION_HOLD'
    | 'ISSUING_AUTHORIZATION_RELEASE'
    | 'ISSUING_DISPUTE'
    | 'ISSUING_TRANSACTION'
    | 'OBLIGATION_OUTBOUND'
    | 'OBLIGATION_REVERSAL_INBOUND'
    | 'PAYMENT'
    | 'PAYMENT_FAILURE_REFUND'
    | 'PAYMENT_NETWORK_RESERVE_HOLD'
    | 'PAYMENT_NETWORK_RESERVE_RELEASE'
    | 'PAYMENT_REFUND'
    | 'PAYMENT_REVERSAL'
    | 'PAYMENT_UNRECONCILED'
    | 'PAYOUT'
    | 'PAYOUT_CANCEL'
    | 'PAYOUT_FAILURE'
    | 'PAYOUT_MINIMUM_BALANCE_HOLD'
    | 'PAYOUT_MINIMUM_BALANCE_RELEASE'
    | 'REFUND'
    | 'REFUND_FAILURE'
    | 'RESERVE_TRANSACTION'
    | 'RESERVED_FUNDS'
    | 'STRIPE_FEE'
    | 'STRIPE_FX_FEE'
    | 'TAX_FEE'
    | 'TOPUP'
    | 'TOPUP_REVERSAL'
    | 'TRANSFER'
    | 'TRANSFER_CANCEL'
    | 'TRANSFER_FAILURE'
    | 'TRANSFER_REFUND'
    | 'WALLET_CREDIT'
    | 'WALLET_DEBIT'
    | 'USAGE_DEBIT'
    | 'USAGE_REVERSAL'
    | 'OPENING_ADJUSTMENT'
    | 'SETTLEMENT_TRUE_UP'
    | 'SETTLEMENT_TRUE_UP_REVERSAL'
  /** Movement amount (positive; direction from type). */
  amount?: number
  /** Currency. */
  currency?: string
  /** When the movement occurred. */
  occurredAt?: string
  /** Canonical Synop invoice id (invoice_*). */
  synopInvoiceId?: string
  /** The invoice's human-facing number (the Invoice # shown in the Invoices table). Null when the invoice has no number yet. */
  invoiceNumber?: string
  /** Stripe invoice id (in_*). */
  stripeInvoiceId?: string
  /** Stripe customer balance transaction id (cbtxn_*), when available. */
  stripeCustomerBalanceTransactionId?: string
  /** Wallet balance after this movement. */
  runningBalance?: number
}
export type WalletBalanceSummary = {
  /** Agreement id (ag_*). */
  agreementId?: string
  /** Stripe customer holding the wallet balance. */
  customerId?: string
  /** Settlement currency. */
  currency?: string
  /** Whether wallet top-ups are enabled. */
  prepaymentEnabled?: boolean
  /** Amount collected per top-up (minor units). */
  topUpAmount?: number
  /** Effective-balance threshold that triggers a top-up (minor units). */
  topUpThreshold?: number
  /** Raw Stripe customer balance (negative = credit). */
  stripeBalance?: number
  /** Available wallet credit (minor units). */
  credit?: number
  /** Rated usage not yet settled by a paid invoice. */
  unbilledUsage?: number
  /** Balance the top-up gate acts on (may be negative): the authoritative wallet pot when balanceSource is LEDGER, else credit minus unbilled usage. */
  effectiveBalance?: number
  /** Source of the wallet effective balance */
  balanceSource?: 'LEDGER' | 'STRIPE_DERIVED'
}
export type TwilioChargerValidationResponse = {
  /** Is charger valid for public charging */
  isValid?: boolean
}
export type StripeTaxCode = {
  /** Stripe tax code identifier */
  id?: string
  /** Human-readable category name */
  name?: string
  /** Longer description of what the code covers */
  description?: string
}
export type ReaderMetadata = {
  /** Whether the reader was found and metadata is valid */
  found?: boolean
  /** Stripe Terminal reader ID */
  readerId?: string
  /** Serial number of the reader */
  serialNumber?: string
  /** Display label */
  label?: string
  /** Merchant organization ID */
  merchantOrganizationId?: string
  /** Synop site ID */
  siteId?: string
  /** Site display name */
  siteName?: string
  /** Charger ID */
  chargerId?: string
  /** Charger display name */
  chargerName?: string
  /** Connector IDs this terminal serves */
  connectorIds?: number[]
  /** Current type: AC or DC */
  currentType?: string
  /** Price per kWh in cents */
  currentPricePerKwh?: number
  /** Max power in kW */
  maxPower?: number
  /** Rate schedule as JSON string (deprecated when rateMappingId present; app fetches via charging-rates API) */
  rateSchedule?: string
  /** Legacy rate mapping id, or PUBLIC product id (prod_…), for GET /api/charging-rates/{rateMappingId}. When a product id is supplied the API projects the product into ChargingRateModel. */
  rateMappingId?: string
  /** Integration ID for ChargingIntent resolution */
  integrationId?: string
  /** Error message if metadata could not be retrieved */
  errorMessage?: string
}
export type PaymentStatus = {
  /** PaymentIntent ID */
  paymentIntentId?: string
  /** PaymentIntent status */
  status?: string
  /** Whether payment is ready (card collected successfully) */
  ready?: boolean
  /** Whether payment failed */
  failed?: boolean
  /** Amount in cents */
  amount?: number
  /** Error message if failed */
  errorMessage?: string
  /** Last 4 digits of card */
  cardLast4?: string
  /** Card brand */
  cardBrand?: string
}
export type StartAttempt = {
  transactionId?: string
  chargerId?: string
  connectorId?: number
  siteId?: string
  /** REQUESTED, REMOTE_START_ACCEPTED, STARTED, REJECTED, or NEVER_MATERIALIZED */
  outcome?: string
  /** KNOWN_USER, ANONYMOUS_WITH_EMAIL, or UNKNOWN */
  identityType?: string
  /** Synop user id who initiated the start, when known */
  userId?: string
  /** Driver display name, resolved stored-only when available */
  displayName?: string
  /** Driver contact email (receipt or customer-directory email), when known */
  email?: string
  authTag?: string
  /** When the start request was received */
  requestedAt?: string
  /** When the most recent lifecycle milestone was recorded */
  lastEventAt?: string
  /** Rejection / timeout context, when the attempt did not succeed */
  reason?: string
  /** Stable id linking retries with the same auth tag within a one-hour window; the first attempt's transaction id. */
  attemptGroupId?: string
  /** Number of attempts in this auth-tag group within the one-hour window. */
  attemptGroupSize?: number
  /** 1-based position of this attempt within its group, oldest first. */
  attemptGroupSequence?: number
  /** True when any attempt in the group reached STARTED. */
  attemptGroupResolved?: boolean
}
export type PagedResponseStartAttempt = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: StartAttempt[]
}
export type StartAttemptTimeseriesBucket = {
  /** UTC instant at the start of the bucket. */
  bucketStart?: string
  /** Attempts that materialized (STARTED) in this bucket. */
  succeeded?: number
  /** Attempts rejected or never materialized in this bucket. */
  failed?: number
  /** Attempts still in flight in this bucket. */
  pending?: number
  /** Total attempts in this bucket. */
  total?: number
}
export type StartAttemptTimeseries = {
  /** Bucket width used (HOUR, DAY, WEEK, or MONTH). */
  granularity?: string
  /** IANA time zone used to align bucket boundaries. */
  timezone?: string
  /** Ordered buckets, oldest first, zero-filled across the range. */
  buckets?: StartAttemptTimeseriesBucket[]
}
export type StartAttemptSummary = {
  /** Total attempts matching the filters. */
  total?: number
  /** Attempts that materialized into a real charging session (STARTED). */
  succeeded?: number
  /** Attempts that were rejected or never materialized. */
  failed?: number
  /** Attempts still in flight (REQUESTED or REMOTE_START_ACCEPTED). */
  pending?: number
  /** Raw count per SessionStartOutcome, keyed by outcome name. */
  byOutcome?: {
    [key: string]: number
  }
}
export type Summary = {
  transactionId?: string
  transactionPk?: number
  /** IN_PROGRESS, COMPLETED, FINALIZED, or NEVER_STARTED */
  status?: string
  currency?: string
  /** Total amount authorized across all holds, minor units */
  authorizedAmount?: number
  /** Total amount captured (charged), minor units */
  capturedAmount?: number
  /** Total unused authorization released, minor units */
  releasedAmount?: number
  /** Total amount refunded, minor units */
  refundedAmount?: number
  startedAt?: string
  stoppedAt?: string
  stopReason?: string
  invoiceId?: string
  chargerId?: string
  connectorId?: number
  siteId?: string
  /** Who initiated the session: KNOWN_USER, ANONYMOUS_WITH_EMAIL, or UNKNOWN */
  identityType?: string
  /** Synop user id who initiated the session, when known */
  userId?: string
  /** Display name of the driver, resolved stored-only when available */
  displayName?: string
  /** Contact email for the driver (receipt or customer-directory email), when known */
  email?: string
}
export type Step = {
  /** Type of settlement timeline step. */
  type?:
    | 'REQUEST_RECEIVED'
    | 'COMMAND_REJECTED'
    | 'REMOTE_START_SENT'
    | 'REMOTE_START_ACCEPTED'
    | 'REMOTE_START_REJECTED'
    | 'PRE_AUTH_REQUESTED'
    | 'PRE_AUTH_APPROVED'
    | 'PRE_AUTH_DECLINED'
    | 'INCREMENTAL_AUTH_REQUESTED'
    | 'INCREMENTAL_AUTH_APPROVED'
    | 'INCREMENTAL_AUTH_DECLINED'
    | 'SESSION_STARTED'
    | 'SESSION_STOPPED'
    | 'MATERIALIZATION_TIMEOUT'
    | 'HOLD_RELEASE_PENDING'
    | 'WALLET_TOP_UP'
    | 'INVOICE_ISSUED'
    | 'PAYMENT_CAPTURED'
    | 'PARENT_REVENUE_SHARE_TRANSFER'
    | 'PRE_AUTH_RELEASED'
    | 'PAYMENT_REFUNDED'
  /** Human-readable label for the step */
  label?: string
  /** Optional longer description / context */
  description?: string
  /** Outcome of a settlement timeline step. */
  status?: 'INFO' | 'PENDING' | 'SUCCEEDED' | 'FAILED'
  /** Amount associated with the step, minor units */
  amount?: number
  currency?: string
  /** When the step occurred */
  at?: string
  /** Provider payment intent id ({@code pi_*}) the step relates to */
  paymentIntentId?: string
  /** Provider charge id ({@code ch_*}) the step relates to */
  chargeId?: string
  /** Synop user who performed the action, for merchant-initiated operations */
  performedBy?: string
  /** Failure / decline reason when the step did not succeed */
  reason?: string
}
export type SettlementTimeline = {
  summary?: Summary
  steps?: Step[]
}
export type PublicReceiptTaxLine = {
  /** Display name of the rate, e.g. "PA Sales Tax". */
  name?: string
  /** How the rate is expressed: PERCENTAGE, PER_UNIT or FLAT. */
  type?: 'FLAT' | 'PERCENTAGE' | 'PER_UNIT'
  /** Rate value: a percentage for PERCENTAGE, otherwise an amount per unit or per session. */
  rate?: number
  /** Amount this rate was applied to, in major currency units. */
  taxableAmount?: number
  /** Tax contributed by this rate, in major currency units. */
  amount?: number
  /** Reason a line item was taxed (or not) */
  reason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
}
export type PublicReceiptSummaryDto = {
  transactionId?: string
  status?: string
  startTimestamp?: string
  stopTimestamp?: string
  durationSeconds?: number
  timezone?: string
  siteId?: string
  siteName?: string
  siteAddress?: string
  chargerId?: string
  chargerName?: string
  connectorId?: number
  connectorName?: string
  totalEnergyImported?: number
  maxPowerImport?: number
  transactionCost?: number
  subtotalAmount?: number
  taxAmount?: number
  /** Tax charged on this session, one entry per applied rate. */
  taxLines?: PublicReceiptTaxLine[]
  /** Reason a line item was taxed (or not) */
  taxReason?:
    | 'STANDARD_RATED'
    | 'REVERSE_CHARGE'
    | 'CUSTOMER_EXEMPT'
    | 'PRODUCT_EXEMPT'
    | 'ZERO_RATED'
    | 'NOT_COLLECTING'
    | 'EXCLUDED_TERRITORY'
  additionalFees?: number
  totalAmount?: number
  currency?: string
  stopReason?: string
  finalized?: boolean
  receiptUrl?: string
  invoiceUrl?: string
}
export type PublicReceiptMeterValueDto = {
  measuredAt?: string
  energyActiveImportRegister?: number
  energyActiveImportRegisterUnit?: string
  powerActiveImport?: number
  powerActiveImportUnit?: string
  voltage?: number
  voltageUnit?: string
  soc?: number
  socUnit?: string
}
export type PublicReceiptPayment = {
  /** ISO 4217 currency for all amount fields */
  currency?: string
  /** Amount pre-authorized (held) on the payment method, in minor units */
  authorizedAmount?: number
  /** Amount actually captured for the session, in minor units */
  capturedAmount?: number
  /** Portion of the hold released back to the payment method, in minor units */
  releasedAmount?: number
  /** Amount refunded after capture, in minor units */
  refundedAmount?: number
}
export type PublicReceiptLineItem = {
  /** Line item type (e.g. CHARGE, IDLE_FEE, DISCOUNT, CREDIT) */
  type?: string
  /** Line description */
  description?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Usage quantity billed */
  quantity?: number
  /** Usage quantity unit (e.g. KWH, MIN) */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Per-unit amount in minor units; may carry sub-cent (fractional minor unit) precision */
  unitAmount?: number
  /** Applied rate in major currency units per usage unit */
  appliedRate?: number
  /** Subtotal before tax/discount, in minor units */
  subtotal?: number
  /** Tax amount in minor units */
  tax?: number
  /** Discount amount in minor units */
  discount?: number
  /** Additional fees in minor units */
  fees?: number
  /** Line total in minor units */
  total?: number
  /** Per-rate-period breakdown ordered by period start; null when no rate-level detail exists */
  rateDetails?: RateDetail[]
  /** Aggregate telemetry stats keyed by measurand; null when unavailable */
  statistics?: {
    [key: string]: LineItemStatisticValue
  }
  signedMeterData?: SignedMeterData
  /** Amount saved by Peak Saver in minor units; null when Peak Saver did not apply or the save is zero */
  peakSaverCostSave?: number
}
export type PublicReceiptActivityEntry = {
  /** Machine-readable entry type (e.g. payment_started, payment_authorized, captured, refunded) */
  type?: string
  /** Human-readable description of the event */
  description?: string
  /** When the event occurred */
  at?: string
}
export type PublicReceiptInvoice = {
  /** Canonical Synop invoice id (invoice_*). Null when only a Stripe invoice URL is known. */
  invoiceId?: string
  /** Whether Synop close artifacts (branded PDF, CSVs, archive) are available for download. */
  artifactsAvailable?: boolean
  /** Stripe hosted invoice page URL, when a Stripe invoice backs this session. */
  stripeInvoiceUrl?: string
}
export type PublicReceiptDto = {
  summary?: PublicReceiptSummaryDto
  meterValues?: PublicReceiptMeterValueDto[]
  payment?: PublicReceiptPayment
  /** Invoice line items with per-rate-period breakdowns; null when no canonical invoice exists */
  lineItems?: PublicReceiptLineItem[]
  /** Chronological payment activity; null when no payment is linked */
  activity?: PublicReceiptActivityEntry[]
  invoice?: PublicReceiptInvoice
}
export type OfflineBankTransfer = {
  /** Always true when present. */
  enabled?: boolean
  /** Bankgiro number (domestic, Sweden). */
  bankgiro?: string
  /** Plusgiro number (domestic, Sweden). */
  plusgiro?: string
  /** IBAN, without spaces (international). */
  iban?: string
  /** BIC / SWIFT code of the IBAN account. */
  bic?: string
  /** Bank holding the IBAN account. */
  bankName?: string
  /** Holder of the account. */
  accountHolder?: string
  /** Which reference to quote: OCR or INVOICE_NUMBER. */
  referenceType?: 'OCR' | 'INVOICE_NUMBER'
  /** The reference the payor quotes on the transfer: the OCR number, else the invoice number, else its id. */
  reference?: string
  /** The merchant's note printed under the bank details. */
  note?: string
}
export type PublicInvoiceSummary = {
  /** Synop invoice id (invoice_*). */
  invoiceId?: string
  /** Invoice number, when assigned. */
  number?: string
  /** Invoice status. */
  status?:
    | 'APPROVED'
    | 'DRAFT'
    | 'ESTIMATE'
    | 'OPEN'
    | 'PAID'
    | 'PAST_DUE'
    | 'READY_FOR_REVIEW'
    | 'UNCOLLECTIBLE'
    | 'VOID'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
  /** Invoice description. */
  description?: string
  /** Display name of the payor (organization name or user name/email). */
  payorName?: string
  /** Display name of the merchant that issued the invoice. */
  merchantName?: string
  supplierAddress?: AddressModel
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Subtotal before tax, in minor units. */
  subtotal?: number
  /** Total tax, in minor units. */
  tax?: number
  /** Total discounts, in minor units. */
  discount?: number
  /** Total additional fees, in minor units. */
  fees?: number
  /** Invoice total, in minor units. */
  total?: number
  /** Amount paid, in minor units. */
  amountPaid?: number
  /** Amount remaining, in minor units. */
  amountRemaining?: number
  /** Billing period start. */
  periodStart?: string
  /** Billing period end. */
  periodEnd?: string
  /** Payment due date. */
  dueDate?: string
  /** When the invoice was finalized. */
  finalizedAt?: string
  /** Date of issue (VAT Directive Art. 226(1)). Fixed at issue, unlike finalizedAt which an internal resync can move. */
  issuedAt?: string
  /** Supplier tax registration number as at issue, for the country of supply. */
  supplierTaxId?: string
  /** Customer tax identifier as at issue; the basis for a reverse-charge supply. */
  customerTaxId?: string
  /** When the invoice was paid. */
  paidAt?: string
  /** When the invoice was created. */
  createdAt?: string
  /** Number of line items on the invoice. */
  lineItemCount?: number
  /** Whether the close artifacts (PDF, CSVs, archive) are available for download. */
  artifactsAvailable?: boolean
  /** Who runs the issued-invoice lifecycle for invoices Synop collects through this account. */
  invoicingMode?: 'STRIPE_INVOICING' | 'SYNOP_INVOICING'
  /** Whether the payor can pay this invoice on Synop's hosted page: Synop-owned, collected by Synop, OPEN or PAST_DUE, with a balance remaining, no payment in flight, and online payment offered (see payOnlineAvailable). Always false for Stripe-owned invoices. */
  payable?: boolean
  /** Whether a payment for this invoice is in flight (processing or awaiting customer action), so the page can show a pending state instead of a second pay button. */
  paymentProcessing?: boolean
  /** Online payment methods the payor can use on Synop's hosted page, narrowed to the invoice currency and the merchant's configured options. Present only while the invoice is payable. */
  paymentMethods?: ('CARD' | 'ACH_DEBIT' | 'US_BANK_ACCOUNT' | 'LINK' | 'SEPA_DEBIT' | 'CUSTOMER_BALANCE')[]
  /** Whether the page should offer a Pay online button: the invoice is payable, the merchant shows the Pay online link, and at least one online method remains. */
  payOnlineAvailable?: boolean
  offlineBankTransfer?: OfflineBankTransfer
}
export type PublicInvoiceLineItem = {
  /** Line item id */
  id?: string
  /** Line item type (e.g. CHARGE, IDLE_FEE, DISCOUNT, CREDIT) */
  type?: string
  /** Line description */
  description?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Types of EV charging products and services */
  productType?:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** Price description */
  priceDesc?: string
  /** Usage quantity billed */
  quantity?: number
  /** Usage quantity unit (e.g. KWH, MIN) */
  usageUnits?: 'KWH' | 'MIN' | 'MI' | 'KM' | 'NOT_APPLICABLE' | 'KW' | 'PC'
  /** Per-unit amount in minor units; may carry sub-cent (fractional minor unit) precision */
  unitAmount?: number
  /** Applied rate in major currency units per usage unit */
  appliedRate?: number
  /** Usage period start */
  usageStart?: string
  /** Usage period end */
  usageEnd?: string
  /** Site / depot name */
  siteName?: string
  /** Charger name */
  chargerName?: string
  /** Connector id */
  connectorId?: string
  /** Subtotal before tax/discount, in minor units */
  subtotal?: number
  /** Tax amount in minor units */
  tax?: number
  /** Discount amount in minor units */
  discount?: number
  /** Additional fees in minor units */
  fees?: number
  /** Line total in minor units */
  total?: number
  /** Per-rate-period breakdown ordered by period start; null when no rate-level detail exists */
  rateDetails?: RateDetail[]
}
export type PublicInvoice = {
  summary?: PublicInvoiceSummary
  /** Anonymized line items (no payor, vehicle, or fleet identifiers); null when none exist */
  lineItems?: PublicInvoiceLineItem[]
}
export type BlockingAgreementResponse = {
  /** Agreement id */
  id?: string
  /** Agreement name */
  name?: string
  status?: AgreementStatus
  /** Type of agreement that defines the relationship between organizations */
  type?: 'MARKETPLACE' | 'PRIVATE' | 'PUBLIC'
  /** Category of agreement that defines who is responsible for payment */
  category?: 'FLEET' | 'DRIVER' | 'INTEGRATION'
  /** The counterparty organization, or the integration id for an INTEGRATION agreement */
  payorOrganizationId?: string
  /** Display name for the payor, resolved as the agreements listing resolves it */
  payorOrganizationName?: string
}
export type PagedResponseV2Payment = {
  meta: Meta
  data: Payment[]
}
export type OcpiPartyRef = {
  countryCode?: string
  partyId?: string
  role?: string
}
export type HttpCall = {
  method?: string
  url?: string
  headers?: {
    [key: string]: string[]
  }
  body?: string
}
export type HttpCallResult = {
  statusCode?: number
  headers?: {
    [key: string]: string[]
  }
  body?: string
}
export type OcpiRequestLogEntry = {
  credentialId?: string
  requestId?: string
  module?: string
  direction?: string
  fromParty?: OcpiPartyRef
  toParty?: OcpiPartyRef
  request?: HttpCall
  response?: HttpCallResult
  error?: string
  timestamp?: string
}
export type PagedResponseV2OcpiRequestLogEntry = {
  meta: Meta
  data: OcpiRequestLogEntry[]
}
export type JsonNode = object
export type AgreementOcpiRecord = {
  /** Record row id from the OCPI store */
  id?: string
  /** When the record was last updated in the OCPI store */
  lastUpdatedAt?: string
  /** Synop's own id for the underlying record (e.g. transaction id), when known */
  internalId?: string
  /** Total energy in kWh (CDR total_energy / session kwh) */
  totalEnergyKwh?: number
  /** Total cost excluding VAT (total_cost.excl_vat, or the flat total_cost of older versions) */
  totalCost?: number
  /** ISO 4217 currency code of totalCost */
  currency?: string
  /** Charging period start (start_date_time) */
  startAt?: string
  /** Charging period end (end_date_time / stop_date_time) */
  endAt?: string
  /** Record status as reported by the payload (e.g. session ACTIVE/COMPLETED); null for CDRs */
  status?: string
  payload?: JsonNode
}
export type OcpiJoinableConnectionOwner = {
  /** Owner organization id */
  organizationId?: string
  /** Owner organization display name */
  organizationName?: string
  /** Whether the owner is the Synop root (platform operator) organization */
  synopRoot?: boolean
}
export type OcpiJoinableConnection = {
  /** Connection (credential) id */
  id?: string
  /** OCPI country code of the connection's local party */
  countryCode?: string
  /** OCPI party id of the connection's local party */
  partyId?: string
  /** Lifecycle status of an OCPI credential */
  status?: 'TEMPORARY' | 'PENDING' | 'VALID' | 'SUSPENDED' | 'REVOKED'
  /** ROAMING integration key the credential is anchored to; null for unanchored connections */
  integrationKey?: string
  owner?: OcpiJoinableConnectionOwner
}
export type PagedResponseV2OcpiJoinableConnection = {
  meta: Meta
  data: OcpiJoinableConnection[]
}
export type DriverPayoutAccountStatusModel = {
  /** Driver payout account readiness status */
  status: 'READY' | 'ACTION_REQUIRED' | 'PENDING'
  /** Whether Stripe has enabled payouts on the account */
  payoutsEnabled?: boolean
  /** Whether the driver has submitted onboarding details to Stripe */
  detailsSubmitted?: boolean
  requirements?: ConnectedAccountRequirements
}
export type PagedResponseSynopLineItem = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: SynopLineItem[]
}
export type PagedResponseV2MarketplaceSubscriptionRequest = {
  meta: Meta
  data: MarketplaceSubscriptionRequest[]
}
export type PlatformFeeStructure = {
  /** Platform fee rate as a decimal (e.g. 0.005 = 0.5%) */
  platformFeeRate?: number
  /** Human-readable description of the platform fee */
  platformFeeDescription?: string
  /** Maximum invoice processing fee in minor units */
  maxProcessingFeeMinor?: number
  /** Note about variable Stripe processing fees */
  processingFeeNote?: string
}
export type FeeEstimate = {
  /** Sample amount in minor units */
  sampleAmount?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Estimated platform fee in minor units */
  platformFee?: number
  /** Estimated invoice processing fee in minor units */
  estimatedProcessingFee?: number
  /** Estimated net to provider after platform fees */
  netToProvider?: number
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
}
export type MarketplaceFeePreview = {
  feeStructure?: PlatformFeeStructure
  exampleEstimate?: FeeEstimate
}
export type MarketplaceSitePricing = {
  /** Lowest currently applicable per-kWh energy rate, in minor currency units */
  energyRate?: number
  /** True when the energy price varies by time of use; energyRate is then the floor */
  touPricing?: boolean
  /** ISO 4217 currency of the rates */
  currency?: string
  /** Full tariff detail: time-of-use schedules, initiation fee, idle fees, reservation config, and restrictions */
  rates?: BillableTimeOfUseRate[]
}
export type MarketplaceSitePricingRead = {
  /** Lowest currently applicable per-kWh energy rate, in minor currency units */
  energyRate?: number
  /** True when the energy price varies by time of use; energyRate is then the floor */
  touPricing?: boolean
  /** ISO 4217 currency of the rates */
  currency?: string
  /** Full tariff detail: time-of-use schedules, initiation fee, idle fees, reservation config, and restrictions */
  rates?: BillableTimeOfUseRateRead[]
}
export type MarketplaceMapSite = {
  /** Synop site id */
  id?: string
  /** Site display name */
  name?: string
  /** Site latitude (WGS84) */
  latitude?: number
  /** Site longitude (WGS84) */
  longitude?: number
  /** Street address */
  address?: string
  /** City */
  city?: string
  /** Number of EVSEs at the site (REMOVED EVSEs excluded) */
  evseCount?: number
  /** Number of EVSEs currently in AVAILABLE status */
  availableEvseCount?: number
  /** Maximum connector power at the site, in kW */
  maxPowerKw?: number
  /** Number of connectors at the site (connectors on non-removed EVSEs) */
  connectorCount?: number
  /** Connector classes at the site (standard + power type with count and max power) */
  connectors?: MarketplaceConnectorClass[]
  /** Human-readable id of the offering that exposes the site (mpo_*); null for rows granted by a private (non-marketplace) agreement */
  offeringId?: string
  /** Offering display name; null for private-agreement rows */
  offeringName?: string
  /** Agreement id granting access for private (non-marketplace) coverage rows */
  agreementId?: string
  /** Agreement display name for private (non-marketplace) coverage rows */
  agreementName?: string
  /** ISO 4217 settlement currency of the offering (used for energy rate display) */
  settlementCurrency?: string
  /** Display name of the organization that owns the offering */
  organizationName?: string
  /** True when the caller's organization has a live agreement sourced from the offering */
  covered?: boolean
  /** When the site's infrastructure data was last updated (max EVSE/connector last-updated) */
  lastUpdatedAt?: string
  pricing?: MarketplaceSitePricing
  /** CPO-curated display name for driver-facing surfaces. Only present with expand=presentation */
  displayName?: string
  /** CPO-curated access notes / directions. Only present with expand=presentation */
  directions?: string
  /** CPO-curated opening hours text. Only present with expand=presentation */
  openingHoursText?: string
}
export type MarketplaceMapSiteRead = {
  /** Synop site id */
  id?: string
  /** Site display name */
  name?: string
  /** Site latitude (WGS84) */
  latitude?: number
  /** Site longitude (WGS84) */
  longitude?: number
  /** Street address */
  address?: string
  /** City */
  city?: string
  /** Number of EVSEs at the site (REMOVED EVSEs excluded) */
  evseCount?: number
  /** Number of EVSEs currently in AVAILABLE status */
  availableEvseCount?: number
  /** Maximum connector power at the site, in kW */
  maxPowerKw?: number
  /** Number of connectors at the site (connectors on non-removed EVSEs) */
  connectorCount?: number
  /** Connector classes at the site (standard + power type with count and max power) */
  connectors?: MarketplaceConnectorClass[]
  /** Human-readable id of the offering that exposes the site (mpo_*); null for rows granted by a private (non-marketplace) agreement */
  offeringId?: string
  /** Offering display name; null for private-agreement rows */
  offeringName?: string
  /** Agreement id granting access for private (non-marketplace) coverage rows */
  agreementId?: string
  /** Agreement display name for private (non-marketplace) coverage rows */
  agreementName?: string
  /** ISO 4217 settlement currency of the offering (used for energy rate display) */
  settlementCurrency?: string
  /** Display name of the organization that owns the offering */
  organizationName?: string
  /** True when the caller's organization has a live agreement sourced from the offering */
  covered?: boolean
  /** When the site's infrastructure data was last updated (max EVSE/connector last-updated) */
  lastUpdatedAt?: string
  pricing?: MarketplaceSitePricingRead
  /** CPO-curated display name for driver-facing surfaces. Only present with expand=presentation */
  displayName?: string
  /** CPO-curated access notes / directions. Only present with expand=presentation */
  directions?: string
  /** CPO-curated opening hours text. Only present with expand=presentation */
  openingHoursText?: string
}
export type MarketplaceAgreementBillingStatus = {
  /** Agreement public id */
  agreementId?: string
  /** Computed billing onboarding state for a marketplace agreement */
  billingSetupStatus?: 'NOT_REQUIRED' | 'PENDING_CONNECT' | 'PENDING_PAYMENT_METHOD' | 'READY'
  /** Synop customer directory id (customer_*) */
  synopCustomerId?: string
  /** Stripe customer id on the provider's connected account */
  stripeCustomerId?: string
  /** Whether the consumer has a payment method on file */
  hasPaymentMethod?: boolean
  /** Whether the provider's Connect account can accept charges */
  connectOnboardingComplete?: boolean
  /** Defines who, if anyone, collects payment for rated agreement usage. Billing cycle remains the cadence for usage aggregation. */
  collectionPolicy?: 'SYNOP_COLLECTS' | 'EXTERNAL_COLLECTS' | 'REPORTING_ONLY'
}
export type AttributeDescriptor = {
  /** Source object the attribute belongs to. */
  source?: 'AGREEMENT' | 'ORGANIZATION_PAYEE' | 'ORGANIZATION_PAYOR' | 'STRIPE_CUSTOMER' | 'USER' | 'INVOICE' | 'STATIC'
  /** Attribute key within the source. */
  path?: string
  /** Human-readable label for the picker. */
  label?: string
  /** Value type, for client-side formatting. */
  type?: 'STRING' | 'IMAGE_URL' | 'DATE' | 'CURRENCY' | 'NUMBER'
}
export type HardwarePrice = {
  /** Stripe price id */
  stripePriceId?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Unit amount as an integer in the currency's minor unit */
  unitAmount?: number
  /** Whether this price bills on a recurring interval */
  recurring?: boolean
  /** Recurring interval when recurring (e.g. month) */
  interval?: string
  /** Optional stable price component key from Stripe price metadata (synop_price_key), e.g. activation vs monthly on the cellular add-on */
  priceKey?: string
}
export type HardwareProduct = {
  /** Stable catalog key from Stripe product metadata (synop_key) */
  key?: string
  name?: string
  description?: string
  /** Product image URLs from the Stripe dashboard */
  images?: string[]
  /** Stripe product id */
  stripeProductId?: string
  prices?: HardwarePrice[]
}
export type HardwareOrderAddress = {
  name?: string
  line1?: string
  line2?: string
  city?: string
  state?: string
  postalCode?: string
  /** ISO 3166-1 alpha-2 country code */
  country?: string
}
export type HardwareOrderItem = {
  /** Public order item id */
  id?: string
  /** Hardware catalog product key */
  productKey?: string
  stripeProductId?: string
  stripePriceId?: string
  quantity?: number
  /** Unit amount as an integer in the order currency's minor unit */
  unitAmount?: number
  /** Whether this line bills on a recurring interval */
  recurring?: boolean
}
export type HardwareOrder = {
  /** Public order id */
  id?: string
  organizationId?: string
  requesterEmail?: string
  checkoutSessionId?: string
  /** Hardware order status */
  status?: 'PENDING' | 'PAID' | 'EXPIRED'
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Subtotal as an integer in the currency's minor unit */
  amountSubtotal?: number
  /** Total as an integer in the currency's minor unit */
  amountTotal?: number
  shipping?: HardwareOrderAddress
  billing?: HardwareOrderAddress
  items?: HardwareOrderItem[]
  created?: string
}
export type PagedResponseV2HardwareOrder = {
  meta: Meta
  data: HardwareOrder[]
}
export type PagedResponseCustomer = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: Customer[]
}
export type CustomerBalance = {
  /** Customer directory id. */
  customerId: string
  /** Underlying billed payor id (organization id or user id). */
  payorId: string
  /** ISO 4217 currency (uppercase) of outstandingBalance, creditBalance and currentBalance: the Stripe customer's currency when known, else the currency with the largest outstanding amount, else the platform default currency. */
  currency: string
  /** Sum still owed (amountRemaining, falling back to total) on this merchant's finalized OPEN / PAST_DUE invoices to this payor, in currency. Matches the local invoice list. */
  outstandingBalance: number
  /** Outstanding amount per ISO 4217 currency (uppercase). Only currencies with a non-zero outstanding amount are present. */
  outstandingByCurrency: {
    [key: string]: number
  }
  /** Credit held on the Stripe customer (always >= 0): the magnitude of a negative Stripe customer balance, else 0. 0 when stripeBalanceAvailable is false. */
  creditBalance: number
  /** Net position: outstandingBalance + the Stripe customer balance (positive = a debit pending on the next invoice, negative = credit). Positive means the customer owes this merchant net; negative means the customer holds net credit. Equals outstandingBalance when stripeBalanceAvailable is false. */
  currentBalance: number
  /** Whether the Stripe customer balance was read. False when the customer has no Stripe customer, the merchant has no connected account, or the Stripe lookup failed; creditBalance is then 0 and currentBalance equals outstandingBalance. */
  stripeBalanceAvailable: boolean
  /** Wallet balance the top-up gate acts on, in currency (positive = credit, may be negative): the authoritative wallet pot between this customer and the merchant when balanceSource is LEDGER, else creditBalance. */
  effectiveBalance: number
  /** Source of the wallet effective balance */
  balanceSource: 'LEDGER' | 'STRIPE_DERIVED'
}
export type WalletPotBalance = {
  /** ISO 4217 currency (uppercase) of the pot. */
  currency: string
  /** Signed ledger balance in minor units; positive = credit held for the customer. */
  amount: number
}
export type CustomerWalletBalance = {
  /** Customer directory id, as requested. */
  customerId: string
  /** Every seeded pot of the customer, sorted by currency. */
  balances: WalletPotBalance[]
}
export type CustomerWalletBalances = {
  /** One entry per customer that has at least one seeded pot. */
  items?: CustomerWalletBalance[]
}
export type SuggestedCapabilities = {
  /** Card payments (cards, Apple Pay, Google Pay). On by default; omit from requestedCapabilities to disable. */
  cardPayments: boolean
  /** Transfers (payouts to the connected account). On by default and typically required. */
  transfers: boolean
  /** Link (Stripe Link one-click checkout). */
  linkPayments: boolean
  /** US ACH direct debit (US bank account payments). */
  usBankAccountAchPayments: boolean
  /** US bank transfer / USD customer balance payments. */
  usBankTransferPayments: boolean
  /** SEPA direct debit (EU bank account payments). */
  sepaDebitPayments: boolean
  /** SEPA bank transfer / EUR customer balance payments. */
  sepaBankTransferPayments: boolean
  /** Pay by Bank (UK and other supported regions). */
  payByBankPayments: boolean
}
export type BalanceAmount = {
  /** ISO currency code (e.g. usd) */
  currency?: string
  /** Amount in cents */
  amountCents?: number
}
export type ConnectedAccountBalanceTile = {
  /** Available balance per currency (funds ready to pay out) */
  available?: BalanceAmount[]
  /** Pending balance per currency (funds not yet available) */
  pending?: BalanceAmount[]
}
export type PaymentSummaryTile = {
  /** Currency code (e.g. usd, eur). When null, amounts may be mixed across currencies (deprecated behavior). */
  currency?: string
  /** Start of the period (inclusive) */
  periodFrom?: string
  /** End of the period (inclusive) */
  periodTo?: string
  /** Total amount succeeded (captured) in cents */
  succeededCents?: number
  /** Total amount authorized but not yet captured in cents */
  uncapturedCents?: number
  /** Total amount refunded in cents */
  refundedCents?: number
  /** Total amount failed in cents */
  failedCents?: number
  /** Total amount blocked in cents */
  blockedCents?: number
  /** True if data was truncated due to pagination limits; totals may be incomplete */
  truncated?: boolean
}
export type OutstandingInvoicesTile = {
  /** Currency code (e.g. usd, eur). When null, amounts may be mixed across currencies (deprecated behavior). */
  currency?: string
  /** Amount not yet due, in the currency minor unit */
  notYetDue?: number
  /** Amount 1–30 days past due, in the currency minor unit */
  pastDue1To30?: number
  /** Amount 31–60 days past due, in the currency minor unit */
  pastDue31To60?: number
  /** Amount 61–90 days past due, in the currency minor unit */
  pastDue61To90?: number
  /** Amount 91–120 days past due, in the currency minor unit */
  pastDue91To120?: number
  /** Amount over 120 days past due, in the currency minor unit */
  pastDueOver120?: number
  /** Total outstanding amount, in the currency minor unit */
  total?: number
  /** True if data was truncated due to pagination limits; totals may be incomplete */
  truncated?: boolean
}
export type TopCustomerSpendEntry = {
  /** Synop customer directory id */
  customerId?: string
  /** Customer email */
  email?: string
  /** Customer display name (if available) */
  name?: string
  /** Total spend in the period (cents) */
  spendCents?: number
  /** Currency of spendCents (e.g. usd). Period-level primary invoice currency. */
  currency?: string
}
export type VolumeMetrics = {
  /** Primary currency for amounts (e.g. usd) */
  currency?: string
  /** Gross volume in cents (total succeeded) */
  grossCents?: number
  /** Net volume in cents (succeeded minus refunded) */
  netCents?: number
  /** Start of current period (inclusive) */
  periodFrom?: string
  /** End of current period (inclusive) */
  periodTo?: string
  /** Gross volume in cents for previous period (when compare=true) */
  previousGrossCents?: number
  /** Net volume in cents for previous period (when compare=true) */
  previousNetCents?: number
  /** Start of previous period (when compare=true) */
  previousPeriodFrom?: string
  /** End of previous period (when compare=true) */
  previousPeriodTo?: string
}
export type NewCustomersMetrics = {
  /** Number of distinct customers with first successful payment in the period */
  count?: number
  /** Count for previous period (when compare=true) */
  previousCount?: number
  /** Start of previous period (when compare=true) */
  previousPeriodFrom?: string
  /** End of previous period (when compare=true) */
  previousPeriodTo?: string
}
export type TimeSeriesBucket = {
  /** Start of the bucket (inclusive) */
  bucketStart?: string
  /** End of the bucket (exclusive) */
  bucketEnd?: string
  /** Value for the bucket (e.g. amount in cents or customer count) */
  value?: number
}
export type OverviewTimeSeries = {
  /** Bucket granularity */
  granularity?: 'DAILY' | 'WEEKLY' | 'MONTHLY'
  /** Buckets for the current period */
  buckets?: TimeSeriesBucket[]
  /** Buckets for the previous period (when compare=true); same count as buckets */
  previousBuckets?: TimeSeriesBucket[]
}
export type RecentFailedPaymentEntry = {
  /** Stripe PaymentIntent ID */
  paymentIntentId?: string
  /** Amount in the currency minor unit */
  amount?: number
  /** Currency code (e.g. usd) */
  currency?: string
  /** Creation time */
  created?: string
  /** Customer email (if available) */
  customerEmail?: string
  /** Status for display (e.g. FAILED) */
  status?: string
}
export type RecentInvoiceEntry = {
  /** Synop or Stripe invoice id */
  invoiceId?: string
  /** Amount due (open/draft) or amount paid (paid invoices), in the currency minor unit */
  amount?: number
  /** Currency code (e.g. usd) */
  currency?: string
  /** Creation time */
  created?: string
  /** Payor id: organization id or user id depending on payorType */
  payorId?: string
  /** Type of the payor */
  payorType?: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Display name of the payor (organization name or user name/email), resolved server-side. */
  payorName?: string
  /** Invoice description or memo, when set */
  description?: string
  /** Invoice status for display (e.g. PAID, DRAFT, OPEN) */
  status?: string
}
export type ConnectedAccountOverview = {
  /** Connected account id (account_xxx); null when none exists */
  accountId?: string
  balance?: ConnectedAccountBalanceTile
  /** Payments summary tiles for the requested period, grouped by currency */
  paymentsSummary?: PaymentSummaryTile[]
  /** Outstanding invoices tiles, bucketed by due status */
  outstandingInvoices?: OutstandingInvoicesTile[]
  /** Top customers by spend in the requested period */
  topCustomersBySpend?: TopCustomerSpendEntry[]
  /** True if top customers were truncated by pagination limits */
  topCustomersTruncated?: boolean
  volumeMetrics?: VolumeMetrics
  newCustomersMetrics?: NewCustomersMetrics
  timeSeriesPayments?: OverviewTimeSeries
  timeSeriesGrossVolume?: OverviewTimeSeries
  timeSeriesNetVolume?: OverviewTimeSeries
  timeSeriesNewCustomers?: OverviewTimeSeries
  /** Recent failed payments (limit 10) */
  recentFailedPayments?: RecentFailedPaymentEntry[]
  /** Recent invoices (limit 10) */
  recentInvoices?: RecentInvoiceEntry[]
}
export type BalanceTransactionFeedItem = {
  /** Provider balance transaction id (e.g. txn_...) */
  id?: string
  /** Provider transaction type (e.g. charge, refund, payout, stripe_fee) */
  type?: string
  /** Provider reporting category (e.g. charge, refund, payout) */
  reportingCategory?: string
  /** Gross amount in the currency's minor unit; positive for inflows, negative for outflows */
  amount?: number
  /** Total fee in the currency's minor unit */
  fee?: number
  /** Platform application fee portion of the fee, in the currency's minor unit */
  applicationFee?: number
  /** Stripe processing fee portion of the fee, in the currency's minor unit */
  processingFee?: number
  /** Net amount after fees, in the currency's minor unit */
  net?: number
  /** ISO 4217 currency code */
  currency?: string
  /** When the movement occurred at the provider */
  occurredAt?: string
  /** When the funds become available in the connected account's balance */
  availableOn?: string
  /** Linked canonical Synop invoice id, when attributable */
  synopInvoiceId?: string
  /** Payor this movement is attributed to: org id (ORGANIZATION) or user id (INDIVIDUAL) */
  payorId?: string
  /** Payor category */
  payorType?: 'INDIVIDUAL' | 'ORGANIZATION'
  /** Canonical Synop customer id, when attributable */
  customerId?: string
}
export type PagedResponseBalanceTransactionFeedItem = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: BalanceTransactionFeedItem[]
}
export type AssistantSessionSummary = {
  /** Session id (asstsess_*). */
  sessionId?: string
  /** Conversation id. */
  conversationId?: string
  /** User who ran the session. */
  userId?: string
  /** User email. */
  userEmail?: string
  /** Model used. */
  model?: string
  /** Number of turns in the session. */
  turnCount?: number
  /** Total input tokens. */
  inputTokens?: number
  /** Total output tokens. */
  outputTokens?: number
  /** Total cache-read tokens. */
  cacheReadTokens?: number
  /** Billed cost for the session (raw + markup), minor units. */
  billedCost?: number
  /** Currency. */
  currency?: string
  /** When the session started. */
  startedAt?: string
  /** Most recent activity in the session. */
  lastActivityAt?: string
}
export type PageAssistantSessionSummary = {
  totalElements?: number
  totalPages?: number
  size?: number
  content?: AssistantSessionSummary[]
  number?: number
  sort?: SortObject[]
  first?: boolean
  last?: boolean
  numberOfElements?: number
  pageable?: PageableObject
  empty?: boolean
}
export type AssistantGateResult = {
  /** True when the org may run another turn. */
  allowed?: boolean
  /** Machine-readable reason when not allowed (e.g. NOT_ENABLED, NO_CREDIT). */
  reason?: string
  /** Feature credit remaining this period, minor units. */
  featureCreditRemaining?: number
  /** Purchased workspace balance, minor units. */
  workspaceBalance?: number
}
export type AssistantCreditsSummary = {
  /** Organization the summary is for (the enabled org). */
  organizationId?: string
  /** Paying organization. */
  billableOrganizationId?: string
  /** Whether the assistant is enabled for the org. */
  enabled?: boolean
  /** Currency of all amounts. */
  currency?: string
  /** Current period key, YYYY-MM. */
  periodKey?: string
  /** Monthly feature-credit allotment, minor units. */
  monthlyFeatureCredit?: number
  /** Feature credit consumed this period, minor units. */
  featureCreditConsumed?: number
  /** Feature credit remaining this period, minor units. */
  featureCreditRemaining?: number
  /** Purchased workspace balance, minor units. */
  workspaceBalance?: number
  /** Whether auto-reload is enabled. */
  autoReloadEnabled?: boolean
  /** Auto-reload trigger threshold, minor units. */
  autoReloadThreshold?: number
  /** Auto-reload top-up amount, minor units. */
  autoReloadAmount?: number
}
export type Bucket = {
  /** Inclusive start date of the bucket. */
  periodStart?: string
  /** Billed cost drawn from the monthly feature grant, minor units. */
  featureGrantSpend?: number
  /** Billed cost drawn from purchased workspace balance, minor units. */
  workspaceBalanceSpend?: number
  /** Total billed cost in the bucket, minor units. */
  totalSpend?: number
}
export type AssistantSpendBreakdown = {
  /** Currency of all amounts. */
  currency?: string
  /** Total billed cost across the range, minor units. */
  totalBilledCost?: number
  /** Ordered spend buckets. */
  buckets?: Bucket[]
}
export type AgreementOcpiUsageSummary = {
  /** Number of OCPI sessions in the window */
  sessionCount?: number
  /** Number of OCPI CDRs in the window */
  cdrCount?: number
  /** Total energy in kWh summed over CDRs only (the settled record — sessions are excluded to avoid double counting); null when no CDR carried it */
  totalEnergyKwh?: number
  /** Total cost excluding VAT summed over CDRs only; null when no CDR carried it */
  totalCost?: number
  /** ISO 4217 currency code of totalCost — the first non-null currency seen on a CDR */
  currency?: string
  /** Effective window start (inclusive) */
  from?: string
  /** Effective window end (exclusive) */
  to?: string
}
export type PayoutModel = {
  /** Unique identifier for the payout */
  id?: string
  /** Amount of the payout in the currency's smallest unit */
  amount?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Estimated arrival date of the payout */
  arrivalDate?: string
  /** Current status of the payout */
  status?: string
  /** Type of payout */
  type?: string
  /** ID of the bank account or card the payout was sent to */
  bankAccount?: string
  /** Optional description that appears on your bank statement */
  description?: string
  /** Unique identifier for tracing this payout in Stripe logs */
  traceId?: string
}
export type CursorLinks = {
  current?: string
  next?: string
  prev?: string
}
export type CursorMeta = {
  total?: number
  pageSize?: number
  last?: boolean
}
export type CursorPagedResponsePayoutModel = {
  data?: PayoutModel[]
  links?: CursorLinks
  meta?: CursorMeta
}
export type CursorPagedResponseInvoiceModel = {
  data?: InvoiceModel[]
  links?: CursorLinks
  meta?: CursorMeta
}
export type PendingPayout = {
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Total pending amount in cents */
  amount?: number
  /** Earliest expected arrival date */
  expectedArrivalDate?: string
}
export type PayoutSummary = {
  /** Payout ID */
  id?: string
  /** Amount in cents */
  amount?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Payout status */
  status?: string
  /** Expected or actual arrival date */
  arrivalDate?: string
  /** Bank account last 4 digits */
  destinationLast4?: string
  /** Bank name */
  bankName?: string
}
export type PayoutsOverview = {
  /** Pending payout amounts grouped by currency */
  pendingByCurrency?: {
    [key: string]: PendingPayout
  }
  /** List of recent payouts */
  payouts?: PayoutSummary[]
  /** Whether there are more payouts available */
  hasMore?: boolean
}
export type PaymentSummary = {
  /** Payment intent or charge ID */
  id?: string
  /** Amount in cents */
  amount?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Payment status */
  status?: string
  /** Customer email */
  customerEmail?: string
  /** Customer name */
  customerName?: string
  /** Payment creation date */
  createdAt?: string
  /** Failure message if payment failed */
  failureMessage?: string
  /** Failure code if payment failed */
  failureCode?: string
}
export type PaymentsOverview = {
  /** List of recent payments */
  payments?: PaymentSummary[]
  /** Whether there are more payments available */
  hasMore?: boolean
}
export type CustomerSummary = {
  /** Stripe customer ID */
  id?: string
  /** Customer name */
  name?: string
  /** Customer email */
  email?: string
  /** Total historical spend in cents grouped by currency (sum of successful payments per currency) */
  spendByCurrency?: {
    [key: string]: number
  }
  /** Credit balance in cents (prepaid credit for future invoices, negative = credit) */
  creditBalance?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Customer creation date */
  createdAt?: string
}
export type CustomersOverview = {
  /** List of customers */
  customers?: CustomerSummary[]
  /** Whether there are more customers available */
  hasMore?: boolean
}
export type SeriesDataPoint = {
  /** Amount in cents */
  amount?: number
  /** Number of items in this period */
  count?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Start of period as Unix timestamp */
  startTimestamp?: number
  /** End of period as Unix timestamp */
  endTimestamp?: number
}
export type BillingOverviewChart = {
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Primary aggregate value for the period (in cents) */
  primaryValue?: number
  /** Percent change from comparison period */
  primaryValuePercentChange?: number
  /** Comparison period aggregate value (in cents) */
  secondaryValue?: number
  /** Time unit for series data points */
  unit?: string
  /** Time series data points */
  series?: SeriesDataPoint[]
}
export type OpenInvoiceDetail = {
  /** Invoice ID */
  invoiceId?: string
  /** Invoice number */
  invoiceNumber?: string
  /** Amount due on this invoice */
  amount?: number
  /** Currency code */
  currency?: string
  /** Due date of the invoice */
  dueDate?: string
  /** Invoice status */
  status?: 'DRAFT' | 'OPEN' | 'PAID' | 'UNCOLLECTIBLE' | 'VOID' | 'PAST_DUE'
  /** Whether the invoice is past due */
  isPastDue?: boolean
  /** URL to view/pay the invoice */
  invoiceUrl?: string
  /** PDF URL of the invoice */
  invoicePdfUrl?: string
}
export type PaymentMethodDetail = {
  /** Payment method type (e.g., 'card', 'us_bank_account') */
  type?: string
  /** Card brand (e.g., 'visa', 'mastercard', 'amex') */
  brand?: string
  /** Last 4 digits of the card or account */
  last4?: string
  /** Card expiry month (1-12) */
  expiryMonth?: number
  /** Card expiry year (e.g., 2026) */
  expiryYear?: number
  /** Payment method ID in payment system */
  paymentMethodId?: string
}
export type UserBalanceResponse = {
  /** User ID */
  userId?: string
  /** Whether the driver is responsible for payment (has DRIVER category agreements) */
  isDriverResponsibleForPayment?: boolean
  /** Account balance in settlement currency (positive = owed, negative = credit). Open invoices sum, else Stripe customer balance. */
  currentBalance?: number
  /** Whether user has any outstanding balance owed */
  hasOutstandingBalance?: boolean
  /** Three-letter ISO 4217 currency code (e.g., 'usd', 'eur', 'gbp'). This is the settlement currency of the Stripe account. */
  currency?: string
  /** List of open/unpaid invoices */
  openInvoices?: OpenInvoiceDetail[]
  defaultPaymentMethod?: PaymentMethodDetail
  billingAddress?: AddressModel
  /** Customer ID in payment system (Stripe) */
  customerId?: string
  /** Organization ID if using organization billing */
  organizationId?: string
}
export type Organization = {
  created?: string
  updated?: string
  createdBy?: string
  modifiedBy?: string
  logicalDeleteIn?: boolean
  id?: string
  organizationNm?: string
  organizationType?: string
  logoUrl?: string
  iconUrl?: string
  styleOverrides?: string
  hasOpsCenter?: boolean
  hasReporting?: boolean
  hasBilling?: boolean
  connectedAccountId?: string
  connectedBillingEnabled?: boolean
  hasCompeletedOnboarding?: boolean
  hasMarketplace?: boolean
  hasEnergyManagement?: boolean
  hasChargeManagement?: boolean
  hasFleetManagement?: boolean
  hasReimbursements?: boolean
  reimbursementsStatus?: 'NEVER_ENABLED' | 'ENABLED' | 'DISABLED'
  hasWorkplaceCharging?: boolean
  workplaceChargingStatus?: 'NEVER_ENABLED' | 'ENABLED' | 'DISABLED'
  hasFleetBilling?: boolean
  fleetBillingStatus?: 'NEVER_ENABLED' | 'ENABLED' | 'DISABLED'
  hasPublicCharging?: boolean
  publicChargingStatus?: 'NEVER_ENABLED' | 'ENABLED' | 'DISABLED'
  connectedAccountStatus?:
    | 'RESTRICTED'
    | 'RESTRICTED_SOON'
    | 'PENDING'
    | 'ENABLED'
    | 'COMPLETE'
    | 'REJECTED'
    | 'UNKNOWN'
  loginUrl?: string
  active?: boolean
  isCurrent?: boolean
}
export type ReimbursementsModelObject = {
  reimbursementId?: string
  reimbursementUserId?: string
  organizationId?: string
  firstNm?: string
  lastNm?: string
  email?: string
  /** Payee External ID (employee number, office code, ERP key). Same value as payee.externalId; invoice templates bind it as USER.externalId. */
  externalId?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  periodStart?: string
  periodEnd?: string
  settled?: string
  status?: string
  amount?: number
  usage?: number
  entityId?: string
  entityType?: string
  /** Canonical reimbursement invoice id (invoice_*), or null if not yet closed. */
  invoiceId?: string
  payee?: ReimbursementUser
  payer?: Organization
  asOf?: string
}
export type ReimbursementSummaryModel = {
  reimbursementUsers?: number
  organizationId?: string
  reimbursementAmount?: number
  reimbursementAmountMoMChange?: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  energyUseKwh?: number
  energyUseMoMChange?: number
  periodStart?: string
  periodEnd?: string
  asOf?: string
  lastBillingPeriod?: ReimbursementSummaryModel
}
export type QuotaEntry = {
  /** The date of the entry */
  date?: string
  /** The used quota for this entry */
  usedQuota?: number
  /** The remaining quota for this entry */
  remainingQuota?: number
}
export type ApiQuota = {
  /** The organization ID owning this key */
  organizationId?: string
  /** Describes if API key is active or disabled */
  active?: boolean
  /** The type of quota */
  quotaType?: 'API'
  /** The name of the API Key */
  apiKeyNm?: string
  /** The last 4 characters of the API Key */
  apiKeyLast4?: string
  /** The target maximum number of requests that can be made in a given time period. */
  quotaLimit?: number
  /** The number of requests subtracted from the quota limit for the given time period. */
  quotaRemaining?: number
  /** The time period in which the limit applies. */
  quotaPeriod?: 'DAY' | 'WEEK' | 'MONTH'
  /** The number of requests that is allowed concurrently. */
  burstLimit?: number
  /** The number of requests that is allowed per second. */
  rateLimit?: number
  /** Daily breakdown of API usage */
  quotaEntries?: QuotaEntry[]
}
export type AccountBalance = {
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Funds that aren't available in the balance yet. */
  pending?: number
  /** Available funds that you can transfer or pay out automatically by Stripe. */
  available?: number
  /** Funds that you can pay out using Instant Payouts. */
  issuingAvailable?: number
  /** Funds held due to negative balances on connected accounts. */
  connectReserved?: number
  /** Timestamp of the last payout from Stripe to your bank account. */
  lastPayout?: string
  /** Next scheduled payout from Stripe to your bank account. */
  nextPayout?: string
}
export type SignedMeterValueModel = {
  /** The measurand of the signed reading. */
  measurand?: string
  /** The signed meter value as reported by the charger (e.g. an OCMF blob). */
  value?: string
  /** The unit of the signed reading. */
  unit?: string
}
export type MeterValueModel = {
  /** Unique identifier for the meter value reading */
  id?: string
  /** Identifier of the charger that produced this meter value */
  chargerId?: string
  /** Connector ID on the charger */
  connectorId?: number
  /** Primary key of the transaction this meter value belongs to */
  transactionPk?: number
  /** Timestamp when this meter value was measured */
  measuredAt?: string
  /** Total energy imported during the transaction */
  energyActiveImportRegister?: number
  /** Unit of measurement for energy active import register */
  energyActiveImportRegisterUnit?: string
  /** Current power being imported by the EV */
  powerActiveImport?: number
  /** Unit of measurement for power active import */
  powerActiveImportUnit?: string
  /** Current being imported by the EV */
  currentImport?: number
  /** Unit of measurement for current import */
  currentImportUnit?: string
  /** Maximum current that could be offered to the EV */
  currentOffered?: number
  /** Unit of measurement for current offered */
  currentOfferedUnit?: string
  /** Maximum power that could be offered to the EV */
  powerOffered?: number
  /** Unit of measurement for power offered */
  powerOfferedUnit?: string
  /** Voltage level during charging */
  voltage?: number
  /** Unit of measurement for voltage */
  voltageUnit?: string
  /** State of Charge (battery level) of the EV */
  soc?: number
  /** Unit of measurement for state of charge */
  socUnit?: string
  /** OCPP reading context for this sample */
  context?: string
  /** Signed meter values for this timestamp; populated only when includeSignedData=true is requested */
  signedData?: SignedMeterValueModel[]
}
export type ResponseFormatListLocation = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: Location[]
  totalItems?: number
}
export type ResponseFormatListCdrDto = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: CdrDto[]
  totalItems?: number
}
export type ResponseFormatCdrDto = {
  statusCode: number
  statusMessage?: string
  timestamp: string
  data?: CdrDto
  totalItems?: number
}
export type DimensionValue = {
  dimension: string
  cost: number
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  usage: number
}
export type CostExplorerInterval = {
  interval?: string
  dimensions?: DimensionValue[]
  /** Total Peak Saver cost save across line items in this interval. Zero when Peak Saver did not apply. */
  peakSaverCostSave?: number
  /** Total spend across line items in this interval that have a positive Peak Saver cost save. Use with peakSaverCostSave for Peak Saver savings rate; excludes non-Peak-Saver charges. */
  peakSaverSpend?: number
}
export type CostExplorerResponse = {
  intervals?: CostExplorerInterval[]
}
export type OverrideRateStructureModelListRatePeriod = {
  /** The status of the rate. Can be ACTIVE or INACTIVE. */
  rateStatus?: 'ACTIVE' | 'INACTIVE'
  /** The name of the rate */
  rateNm: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Rate type: FLAT, VOLUME_BASED, or TIME_BASE. */
  rateType: 'FLAT' | 'TIER' | 'TIME_OF_USE' | 'TOU' | 'VOLUME_BASED'
  /** The structure of the rate. Can be a flat rate, a volume based rate or a time based rate. */
  rateStructure: RatePeriod[]
  OrganizationRateOverride?: OverrideRateStructureByOrganizationModelListRatePeriod
  /** The name of the last editing of the rate */
  lastModifiedByUserName?: string
  /** The ID of the last editing of the rate */
  lastModifiedByUserId?: string
  /** When this rate was last modified */
  lastModified?: string
  /** Optional idle fee after charging completes, before unplug. */
  idleFee?: number
  /** Idle fee step size in minutes. Multiplies idleFee by elapsed steps after session end. */
  idleStepSize?: number
  /** Base charge applied to every billed session under this rate. */
  flatFee?: number
  /** Max SoC for charging under this rate (percent). */
  maxSoc?: number
  /** Max charging session duration under this rate (minutes). */
  maxTime?: number
  /** When true, lock the TOU rate period at plug-in; when false, bill dynamically across periods. */
  lockRateAtPlugIn?: boolean
  /** The id of the rate mapping. This can be used as a reference to override this rate. */
  rateMappingId: string
  /** The id of the rate. This can be used as a reference to override this rate. */
  rateId?: string
  /** Product ID in stripe for this rate */
  productId?: string
  /** The target of the override. Can be a workplace, a charging point or a connector */
  overrideTargetType:
    | 'CHARGER'
    | 'FLEET'
    | 'HOME_CHARGING_USER'
    | 'NETWORK'
    | 'ORGANIZATION'
    | 'SITE'
    | 'USER'
    | 'VEHICLE'
  /** The id of the target of the override. Can be a SITE, CHARGER or ORGANIZATION */
  overrideTargetId: string
  /** Rate mapping id this override replaces */
  overridesMappingId: string
}
export type ChargingRateModelRateStructureModelListRatePeriod = {
  /** The id of the organization that is administering the charging rate. Defaults to the organization making the request. */
  administeringOrganizationId?: string
  /** The id of the organization that this rate should be applied to. */
  billedOrganizationId?: string
  /** Types of EV charging products and services */
  productType:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** The id of the site for which the rate is applicable. */
  siteId: string
  defaultRateStructure: CreateRateStructureModelListRatePeriod
  /** The ID of the mapping between a Site and a Rate. */
  rateMappingId: string
  /** Overrides for the default rate structure. */
  overrides?: OverrideRateStructureModelListRatePeriod[]
}
export type ChargingRateModel = {
  /** The id of the organization that is administering the charging rate. Defaults to the organization making the request. */
  administeringOrganizationId?: string
  /** The id of the organization that this rate should be applied to. */
  billedOrganizationId?: string
  /** Types of EV charging products and services */
  productType:
    | 'CHARGER_SUBSCRIPTION'
    | 'FLEET_CHARGING'
    | 'HOME_CHARGING'
    | 'OTHER'
    | 'PUBLIC_CHARGING'
    | 'VEHICLE_SUBSCRIPTION'
    | 'WORKPLACE_CHARGING'
    | 'RESERVATION'
    | 'CHARGING_ACCESS'
    | 'FLEET_MANAGEMENT'
    | 'INFRASTRUCTURE'
    | 'NETWORK_SERVICES'
    | 'SUPPORT_SERVICES'
  /** The id of the site for which the rate is applicable. */
  siteId: string
  defaultRateStructure: CreateRateStructureModelListRatePeriod
  /** The ID of the mapping between a Site and a Rate. */
  rateMappingId: string
  /** Overrides for the default rate structure. */
  overrides?: OverrideRateStructureModelListRatePeriod[]
}
export type Card = {
  /** Brand of the card */
  brand?: string
  /** Last 4 digits of the card */
  last4?: string
  /** Expiration month */
  expMonth?: number
  /** Expiration year */
  expYear?: number
  /** Funding type of the card */
  funding?: string
  /** Issuer of the card */
  issuer?: string
  /** Wallet type */
  wallet?: string
}
export type PaymentMethodDetails = {
  card?: Card
  /** Type of payment method */
  type?: string
}
export type ChargeModel = {
  /** Unique identifier of the charge */
  id?: string
  /** Amount of the charge in cents */
  amount?: number
  /** Amount captured in cents */
  amountCaptured?: number
  /** Amount refunded in cents */
  amountRefunded?: number
  /** ID of the application that created the charge */
  application?: string
  /** ID of the application fee */
  applicationFee?: string
  /** Amount of the application fee in cents */
  applicationFeeAmount?: number
  /** ID of the balance transaction */
  balanceTransaction?: string
  billingDetails?: BillingDetails
  /** ID of the charge that was refunded */
  charge?: string
  /** Three-letter ISO currency code */
  currency?: string
  /** ID of the customer */
  customer?: string
  /** An arbitrary string attached to the object */
  description?: string
  /** Whether the charge has been disputed */
  disputed?: boolean
  /** Error code if the charge failed */
  failureCode?: string
  /** Error message if the charge failed */
  failureMessage?: string
  /** ID of the invoice */
  invoice?: string
  /** Whether the charge is refundable */
  refundable?: boolean
  /** Whether the charge has been refunded */
  refunded?: boolean
  /** ID of the review */
  review?: string
  /** ID of the source */
  source?: string
  /** Status of the charge */
  status?: string
  /** Time at which the charge was created */
  created?: string
  /** Additional metadata for the charge */
  metadata?: {
    [key: string]: string
  }
  paymentMethodDetails?: PaymentMethodDetails
}
export type CursorPagedResponseChargeModel = {
  data?: ChargeModel[]
  links?: CursorLinks
  meta?: CursorMeta
}
export type BootEventSummary = {
  /** Start timestamp of the bucket in epoch milliseconds */
  timestamp?: number
  /** Number of boot events in this time bucket */
  count?: number
}
export type ChargerBootEvent = {
  /** Unique identifier of the charger */
  chargerId?: string
  /** Timestamp of the boot event in epoch milliseconds */
  timestamp?: number
  /** ID of the site where the charger is located */
  siteId?: string
  /** Vendor/manufacturer of the charge point */
  chargePointVendor?: string
  /** Model name/number of the charge point */
  chargePointModel?: string
  /** Serial number of the charge point */
  chargePointSerialNumber?: string
  /** Serial number of the charge box */
  chargeBoxSerialNumber?: string
  /** Version of the firmware installed */
  firmwareVersion?: string
  /** ICCID of the modem/SIM card */
  iccid?: string
  /** IMSI of the modem/SIM card */
  imsi?: string
  /** Type of meter installed */
  meterType?: string
  /** Serial number of the meter */
  meterSerialNumber?: string
  /** Version of OCPP protocol used */
  ocppVersion?: string
}
export type BootEventResponse = {
  /** Time bucket sizes for aggregating events */
  interval?: 'FIFTEEN_MINUTES' | 'THIRTY_MINUTES' | 'SIXTY_MINUTES'
  /** List of event counts aggregated by time bucket */
  summaries?: BootEventSummary[]
  /** Raw event data (only included when includeRawEvents=true) */
  events?: ChargerBootEvent[]
}
export type CustomerBillingModel = {
  /** Stripe customer ID */
  customerId?: string
  /** Customer's email address */
  email?: string
  /** Customer's full name */
  name?: string
  /** Customer's phone number */
  phone?: string
  /** Current account status */
  accountStatus?: string
  /** Supported currency codes for pricing and billing (ISO 4217) */
  currency: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'SEK' | 'PLN' | 'CHF' | 'NOK'
  /** Current balance in the specified currency */
  balance?: number
  /** List of payment methods associated with the customer */
  paymentMethods?: PaymentMethodModel[]
  billingAddress?: AddressModel
  /** Whether the customer has a default payment method set */
  hasDefaultPaymentMethod?: boolean
  /** ID of the default payment method */
  defaultPaymentMethodId?: string
  /** Customer's preferred currency */
  preferredCurrency?: string
  /** Customer's tax ID */
  taxId?: string
  /** Whether the account is delinquent */
  delinquent?: boolean
  /** Available credit balance in the specified currency */
  creditBalance?: number
  /** Prefix used for invoice numbers */
  invoicePrefix?: string
}
export const {
  useGetWorkplaceUserQuery,
  useLazyGetWorkplaceUserQuery,
  useUpdateWorkplaceUserMutation,
  useDeleteWorkplaceUserMutation,
  useUpdateTaxRateMutation,
  useGetUserTaxProfileQuery,
  useLazyGetUserTaxProfileQuery,
  useUpsertUserTaxProfileMutation,
  useGetOrganizationTaxProfileQuery,
  useLazyGetOrganizationTaxProfileQuery,
  useUpsertOrganizationTaxProfileMutation,
  useGetAgreementTaxOverrideQuery,
  useLazyGetAgreementTaxOverrideQuery,
  useUpsertAgreementTaxOverrideMutation,
  useListDecisionsQuery,
  useLazyListDecisionsQuery,
  useUpsertDecisionMutation,
  useGetProductQuery,
  useLazyGetProductQuery,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetVisibilityQuery,
  useLazyGetVisibilityQuery,
  useUpdateVisibilityMutation,
  useClearVisibilityMutation,
  useGetProfileQuery,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
  useUpdatePresentationMutation,
  useGetReservationConfigurationQuery,
  useLazyGetReservationConfigurationQuery,
  useUpdateReservationConfigurationMutation,
  useGetReservationQuery,
  useLazyGetReservationQuery,
  useUpdateReservationMutation,
  useCancelReservationMutation,
  useGetMeterQuery,
  useLazyGetMeterQuery,
  useUpdateMeterMutation,
  useDeleteMeterMutation,
  useGetOfferingQuery,
  useLazyGetOfferingQuery,
  useUpdateOfferingMutation,
  useGetInvoiceDetailQuery,
  useLazyGetInvoiceDetailQuery,
  useUpdateInvoiceMutation,
  useDeleteInvoiceMutation,
  useUpdateLineItemMutation,
  useDeleteLineItemMutation,
  useUpdateArtifactPickupMutation,
  useDeleteArtifactPickupMutation,
  useUpdateArtifactAccessAllowedSourcesMutation,
  useGetInvoicePaymentOptionsV1Query,
  useLazyGetInvoicePaymentOptionsV1Query,
  useUpdateInvoicePaymentOptionsV1Mutation,
  useUpdateAutoReloadV1Mutation,
  useGetAgreementQuery,
  useLazyGetAgreementQuery,
  useUpdateAgreementMutation,
  useUpdatePushNotificationMutation,
  useSetDefaultPaymentMethodMutation,
  useUpdateUserTagsMutation,
  useGetSessions1Query,
  useLazyGetSessions1Query,
  usePutChargingPreferencesMutation,
  useGetSessionQuery,
  useLazyGetSessionQuery,
  useUpdateSessionMutation,
  useGetLocationQuery,
  useLazyGetLocationQuery,
  useUpdateLocationMutation,
  useGetInvoiceQuery,
  useLazyGetInvoiceQuery,
  useUpdateInvoice1Mutation,
  useDeleteInvoice1Mutation,
  useGetWorkplaceUsersQuery,
  useLazyGetWorkplaceUsersQuery,
  useSaveWorkplaceUserMutation,
  useGetWorkplaceChargingConfigurationQuery,
  useLazyGetWorkplaceChargingConfigurationQuery,
  useSaveWorkplaceChargingConfigurationMutation,
  useRebaselineWalletMutation,
  useStartTwilioChargingSessionMutation,
  useBackfillTouRecurrenceMutation,
  useRepairTopUpLinksMutation,
  usePreviewTaxMutation,
  useListRegistrationsQuery,
  useLazyListRegistrationsQuery,
  useCreateRegistrationMutation,
  useListTaxRatesQuery,
  useLazyListTaxRatesQuery,
  useCreateTaxRateMutation,
  useListTaxApplicationsQuery,
  useLazyListTaxApplicationsQuery,
  useCreateTaxApplicationMutation,
  useHandleStripeWebhookMutation,
  useListTerminalsV1Query,
  useLazyListTerminalsV1Query,
  useRegisterTerminalV1Mutation,
  useRefreshTerminalV1Mutation,
  usePushRatesV1Mutation,
  useCancelReaderActionV1Mutation,
  useCreateConnectionTokenV1Mutation,
  useCollectPaymentV1Mutation,
  useCancelPaymentV1Mutation,
  useSyncStripeLedgerMutation,
  useListTransactionRedrivesQuery,
  useLazyListTransactionRedrivesQuery,
  useCreateTransactionRedriveMutation,
  useRedriveReimbursementsMutation,
  useCreatePublicCheckoutSessionMutation,
  useListProductsQuery,
  useLazyListProductsQuery,
  useCreateProductMutation,
  useUnarchiveProductMutation,
  useArchiveProductMutation,
  useRefundPaymentMutation,
  useCapturePaymentMutation,
  useCancelPaymentHoldMutation,
  useBackfillPaymentCustomerNamesMutation,
  useListConnectionsQuery,
  useLazyListConnectionsQuery,
  useCreateConnectionMutation,
  useCreateConnectionRequestMutation,
  useListReservationsQuery,
  useLazyListReservationsQuery,
  useCreateReservationMutation,
  useCreateMyPayoutOnboardingLinkMutation,
  useCreateHomeChargerMutation,
  useListChargingSchedulesQuery,
  useLazyListChargingSchedulesQuery,
  useCreateChargingScheduleMutation,
  useListMeters1Query,
  useLazyListMeters1Query,
  useCreateMeterMutation,
  useDenyMutation,
  useCancelMutation,
  useApproveMutation,
  useGetOfferingsQuery,
  useLazyGetOfferingsQuery,
  useCreateOfferingMutation,
  useCreateSubscriptionRequestMutation,
  useSubscribeToOfferingMutation,
  useRegenerateAccessCodeMutation,
  useRedeemAccessCodeMutation,
  useCreatePaymentSetupSessionMutation,
  useListInvoicesQuery,
  useLazyListInvoicesQuery,
  useCreateInvoiceMutation,
  useVoidInvoiceMutation,
  useSendInvoiceMutation,
  useReleaseInvoiceMutation,
  useMarkPaidMutation,
  useAddLineItemMutation,
  useFinalizeInvoiceMutation,
  useGetDraftInvoiceArtifactsQuery,
  useLazyGetDraftInvoiceArtifactsQuery,
  useGenerateDraftInvoiceArtifactsMutation,
  useCreateCheckoutSessionMutation,
  useBackfillInvoiceWalletAppliedMutation,
  useListTemplatesQuery,
  useLazyListTemplatesQuery,
  useCreateTemplateMutation,
  usePreviewTemplateMutation,
  useArchiveTemplateMutation,
  useBackfillInvoicesMutation,
  useCreateArtifactAccessKeyMutation,
  useDecommissionMutation,
  useBackfillMutation,
  useCreateCheckoutSession1Mutation,
  useBackfillCustomersMutation,
  useBackfillAddressesMutation,
  useListConnectedAccountsV1Query,
  useLazyListConnectedAccountsV1Query,
  useCreateConnectedAccountV1Mutation,
  useShareConnectedAccountWithOrganizationV1Mutation,
  useCreateLoginLinkV1Mutation,
  useCreateAccountLinkV1Mutation,
  useSyncConnectedAccountTypesMutation,
  useListRegistrations1Query,
  useLazyListRegistrations1Query,
  useCreateRegistration1Mutation,
  useCloseReimbursementsMutation,
  useBackfillChargeReceiptNumbersMutation,
  useCreateBillingConfigurationMutation,
  useCreateRevenueShareRuleMutation,
  useBackfillBalanceTransactionsMutation,
  useIngestUsageV1Mutation,
  useTopUpV1Mutation,
  useRefreshGrantsV1Mutation,
  useUpsertConfigV1Mutation,
  useGetAgreementsQuery,
  useLazyGetAgreementsQuery,
  useCreateAgreementMutation,
  useUnarchiveAgreementMutation,
  useAcknowledgeReconciliationExceptionMutation,
  useGetAgreementProductsQuery,
  useLazyGetAgreementProductsQuery,
  useAddAgreementProductMutation,
  useGetAuthorizedEntitiesQuery,
  useLazyGetAuthorizedEntitiesQuery,
  useAddAuthorizedEntityMutation,
  useArchiveAgreementMutation,
  useUpdateWorkplaceChargingRecordStatusesMutation,
  useGetReimbursementUsersQuery,
  useLazyGetReimbursementUsersQuery,
  useSaveReimbursementUserMutation,
  useGetReimbursementConfigurationQuery,
  useLazyGetReimbursementConfigurationQuery,
  useSaveReimbursementConfigurationMutation,
  useOnboardOrganizationToStripeMutation,
  useStopSessionMutation,
  useStartSessionMutation,
  useGetInvoicesQuery,
  useLazyGetInvoicesQuery,
  useCreateInvoice1Mutation,
  useVoidInvoice1Mutation,
  useSendInvoice1Mutation,
  useMarkInvoicePaidMutation,
  useEnrichLineItemsMutation,
  useEnrichLineItemsByPayoutMutation,
  useBulkUpdateReimbursementUsersMutation,
  useAuthorizePublicSessionMutation,
  useGetSettingsQuery,
  useLazyGetSettingsQuery,
  usePatchSettingsMutation,
  useDeleteTaxApplicationMutation,
  useUpdateTaxApplicationMutation,
  useGetTerminalV1Query,
  useLazyGetTerminalV1Query,
  useDeleteTerminalV1Mutation,
  useAssignTerminalV1Mutation,
  useUpdateMyGridEnrollmentMutation,
  useGetRequirementsQuery,
  useLazyGetRequirementsQuery,
  usePatchRequirementsMutation,
  useGetTemplateQuery,
  useLazyGetTemplateQuery,
  useUpdateTemplateMutation,
  useDeleteArtifactAccessKeyMutation,
  useUpdateArtifactAccessKeyMutation,
  useGetCustomerQuery,
  useLazyGetCustomerQuery,
  useUpdateCustomerMutation,
  useUpdateConnectedAccountV1Mutation,
  useSetDefaultConnectedAccountV1Mutation,
  useGetSyncQuery,
  useLazyGetSyncQuery,
  usePatchSyncMutation,
  useGetBillingConfigurationQuery,
  useLazyGetBillingConfigurationQuery,
  useUpdateBillingConfigurationMutation,
  useUpdateRevenueShareRuleMutation,
  useRemoveAgreementProductMutation,
  useUpdateAgreementProductMutation,
  useGetWorkplaceSummaryQuery,
  useLazyGetWorkplaceSummaryQuery,
  useGetWorkplaceChargingRecordsQuery,
  useLazyGetWorkplaceChargingRecordsQuery,
  useListWalletTransactionsV1Query,
  useLazyListWalletTransactionsV1Query,
  useGetWalletBalanceV1Query,
  useLazyGetWalletBalanceV1Query,
  useValidatePublicChargerQuery,
  useLazyValidatePublicChargerQuery,
  useGetTimeOfUseRateQuery,
  useLazyGetTimeOfUseRateQuery,
  useListTaxCodesQuery,
  useLazyListTaxCodesQuery,
  useGetReaderMetadataV1Query,
  useLazyGetReaderMetadataV1Query,
  useGetPaymentStatusV1Query,
  useLazyGetPaymentStatusV1Query,
  useListStartAttemptsQuery,
  useLazyListStartAttemptsQuery,
  useStartAttemptTimeseriesQuery,
  useLazyStartAttemptTimeseriesQuery,
  useSummarizeStartAttemptsQuery,
  useLazySummarizeStartAttemptsQuery,
  useGetTimelineQuery,
  useLazyGetTimelineQuery,
  useGetTransactionRedriveQuery,
  useLazyGetTransactionRedriveQuery,
  useGetReceiptQuery,
  useLazyGetReceiptQuery,
  useGetMeterValuesQuery,
  useLazyGetMeterValuesQuery,
  useDownloadMeterValuesQuery,
  useLazyDownloadMeterValuesQuery,
  useGetPublicInvoiceQuery,
  useLazyGetPublicInvoiceQuery,
  useDownloadPublicInvoicePdfQuery,
  useLazyDownloadPublicInvoicePdfQuery,
  useGetPublicInvoiceArtifactsQuery,
  useLazyGetPublicInvoiceArtifactsQuery,
  useDownloadPublicInvoiceArchiveQuery,
  useLazyDownloadPublicInvoiceArchiveQuery,
  useGetActiveAgreementsUsingProductQuery,
  useLazyGetActiveAgreementsUsingProductQuery,
  useListPaymentsQuery,
  useLazyListPaymentsQuery,
  useGetPaymentQuery,
  useLazyGetPaymentQuery,
  useListBillingConfigurationsQuery,
  useLazyListBillingConfigurationsQuery,
  useListLocationsQuery,
  useLazyListLocationsQuery,
  useGetConnectionQuery,
  useLazyGetConnectionQuery,
  useGetRequestLogsQuery,
  useLazyGetRequestLogsQuery,
  useGetRequestLogQuery,
  useLazyGetRequestLogQuery,
  useGetUsageSummaryQuery,
  useLazyGetUsageSummaryQuery,
  useGetSessionsQuery,
  useLazyGetSessionsQuery,
  useGetCdrsQuery,
  useLazyGetCdrsQuery,
  useListJoinableConnectionsQuery,
  useLazyListJoinableConnectionsQuery,
  useGetMyReimbursementUsersQuery,
  useLazyGetMyReimbursementUsersQuery,
  useGetMyPayoutAccountStatusQuery,
  useLazyGetMyPayoutAccountStatusQuery,
  useGetMyLineItemsQuery,
  useLazyGetMyLineItemsQuery,
  useListRequestsQuery,
  useLazyListRequestsQuery,
  useGetFeePreviewQuery,
  useLazyGetFeePreviewQuery,
  useGetMapSitesQuery,
  useLazyGetMapSitesQuery,
  useGetBillingStatusQuery,
  useLazyGetBillingStatusQuery,
  useDownloadInvoicePdfQuery,
  useLazyDownloadInvoicePdfQuery,
  useGetInvoiceArtifactsQuery,
  useLazyGetInvoiceArtifactsQuery,
  useDownloadInvoiceArchiveQuery,
  useLazyDownloadInvoiceArchiveQuery,
  useAttributeCatalogQuery,
  useLazyAttributeCatalogQuery,
  useGetArtifactStorageAccessQuery,
  useLazyGetArtifactStorageAccessQuery,
  useListLegacyRatesQuery,
  useLazyListLegacyRatesQuery,
  useListHardwareProductsQuery,
  useLazyListHardwareProductsQuery,
  useListHardwareOrdersQuery,
  useLazyListHardwareOrdersQuery,
  useGetHardwareOrderQuery,
  useLazyGetHardwareOrderQuery,
  useListCustomersQuery,
  useLazyListCustomersQuery,
  useGetCustomerBalanceQuery,
  useLazyGetCustomerBalanceQuery,
  useGetCustomerWalletBalancesQuery,
  useLazyGetCustomerWalletBalancesQuery,
  useGetSuggestedCapabilitiesV1Query,
  useLazyGetSuggestedCapabilitiesV1Query,
  useGetOverviewV1Query,
  useLazyGetOverviewV1Query,
  useListConnectedAccountsLinkedToOrganizationV1Query,
  useLazyListConnectedAccountsLinkedToOrganizationV1Query,
  useListBalanceTransactionsQuery,
  useLazyListBalanceTransactionsQuery,
  useListSessionsV1Query,
  useLazyListSessionsV1Query,
  useGateV1Query,
  useLazyGateV1Query,
  useGetCreditsV1Query,
  useLazyGetCreditsV1Query,
  useGetBreakdownV1Query,
  useLazyGetBreakdownV1Query,
  useGetReconciliationExceptionsQuery,
  useLazyGetReconciliationExceptionsQuery,
  useGetAgreementProductHistoryQuery,
  useLazyGetAgreementProductHistoryQuery,
  useGetOcpiUsageSummaryQuery,
  useLazyGetOcpiUsageSummaryQuery,
  useGetOcpiSessionsQuery,
  useLazyGetOcpiSessionsQuery,
  useGetOcpiCdrsQuery,
  useLazyGetOcpiCdrsQuery,
  useGetPayoutsByCursorQuery,
  useLazyGetPayoutsByCursorQuery,
  useGetPayoutByIdQuery,
  useLazyGetPayoutByIdQuery,
  useGetInvoicesByCursorQuery,
  useLazyGetInvoicesByCursorQuery,
  useGetInvoiceByIdQuery,
  useLazyGetInvoiceByIdQuery,
  useBillingOverviewGetPayoutsQuery,
  useLazyBillingOverviewGetPayoutsQuery,
  useBillingOverviewGetPaymentsQuery,
  useLazyBillingOverviewGetPaymentsQuery,
  useBillingOverviewGetInvoicesQuery,
  useLazyBillingOverviewGetInvoicesQuery,
  useBillingOverviewGetCustomersQuery,
  useLazyBillingOverviewGetCustomersQuery,
  useBillingOverviewGetVolumeChartQuery,
  useLazyBillingOverviewGetVolumeChartQuery,
  useBillingOverviewGetPaymentsChartQuery,
  useLazyBillingOverviewGetPaymentsChartQuery,
  useBillingOverviewGetCustomersChartQuery,
  useLazyBillingOverviewGetCustomersChartQuery,
  useGetStripeIntentDetailQuery,
  useLazyGetStripeIntentDetailQuery,
  useGetPaymentMethodQuery,
  useLazyGetPaymentMethodQuery,
  useGetPortalLoginQuery,
  useLazyGetPortalLoginQuery,
  useGetUserInvoicesQuery,
  useLazyGetUserInvoicesQuery,
  useGetCheckoutSessionQuery,
  useLazyGetCheckoutSessionQuery,
  useGetUserBalanceQuery,
  useLazyGetUserBalanceQuery,
  useGetReimbursementsQuery,
  useLazyGetReimbursementsQuery,
  useGetReimbursementUserQuery,
  useLazyGetReimbursementUserQuery,
  useDeleteReimbursementUserMutation,
  useGetReimbursementSummaryQuery,
  useLazyGetReimbursementSummaryQuery,
  useGetQuotasQuery,
  useLazyGetQuotasQuery,
  useGetReimbursements1Query,
  useLazyGetReimbursements1Query,
  useGetPortalQuery,
  useLazyGetPortalQuery,
  useGetLoginSessionQuery,
  useLazyGetLoginSessionQuery,
  useGetOrganizationBalanceQuery,
  useLazyGetOrganizationBalanceQuery,
  useGetMeterValues1Query,
  useLazyGetMeterValues1Query,
  useGetLocationsQuery,
  useLazyGetLocationsQuery,
  useGetEvseQuery,
  useLazyGetEvseQuery,
  useGetConnectorQuery,
  useLazyGetConnectorQuery,
  useGetCdrQuery,
  useLazyGetCdrQuery,
  useGetCdrByIdQuery,
  useLazyGetCdrByIdQuery,
  useGetLineItemsQuery,
  useLazyGetLineItemsQuery,
  useGetLineItemByIdQuery,
  useLazyGetLineItemByIdQuery,
  useGetCostExplorerQuery,
  useLazyGetCostExplorerQuery,
  useGetChargingRatesQuery,
  useLazyGetChargingRatesQuery,
  useGetChargingRateByIdQuery,
  useLazyGetChargingRateByIdQuery,
  useGetChargesForOrganizationQuery,
  useLazyGetChargesForOrganizationQuery,
  useGetBootEventsQuery,
  useLazyGetBootEventsQuery,
  useGetBalanceQuery,
  useLazyGetBalanceQuery,
  useDeleteRegistrationMutation,
  useDeleteDecisionMutation,
  useDisablePeakSaverMutation,
  useCancelChargingScheduleMutation,
  useDeleteRegistration1Mutation,
  useRemoveAuthorizedEntityMutation,
  useRemovePaymentMethodMutation
} = injectedRtkApi
